/* eslint-disable no-useless-escape */
/* eslint-disable max-len */

import Stripe from 'stripe';
import { IBuyDownOption } from '../components/Pages/Reports/types';
import { IAllViewed, IMostViewed, IRecentlyViewed } from '../hooks/userViews';

export interface INotificationItem {
  id: number;
  title: string;
  type: string;
  createdAt: string;
  description: string;
  referral?: string;
  link?: string;
}

export const REPORT_DATA = [{
  "id": "9db018d6-75f0-4581-9552-982c17323fae",
  "name": "Testing Report",
  "status": "draft",
  "userId": 29,
  "viewedAt": null,
  "editedAt": null,
  "approvedAt": null,
  "hoiquoteAt": null,
  "closingText": "<p>Testing Closing Text!</p>",
  "downPaymentPercentage": null,
  video: '<iframe width="560" height="315" src="https://www.youtube.com/embed/tgbNymZ7vqY?si=-qU-vzutlkZYM7zr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
  "loanPointsPercentage": null,
  "homeInsurancePercentage": null,
  "welcome_message": "<p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">Welcome! I'm thrilled you've chosen us to help you navigate the exciting journey of homeownership. We're dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">I'm happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We're here to support you and make your homeownership dream a reality.</span></p>",
  "settings_logo": null,
  "rentVsOwnValue": "800000",
  "createdAt": "2024-04-19T19:01:21.000Z",
  "updatedAt": "2024-05-27T11:28:02.000Z",
  "Loans": [
    {
      "id": 826,
      taxBenefitPerMonth: '1177',
      taxBenefitPerYear: '98',
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "purchasePrice": "1500000",
      "downPayment": "300000",
      "loanAmount": "1200000",
      "loanTerm": null,
      "interestRate": "7.5",
      "apr": "7.630",
      "loanPoints": null,
      "pmi": null,
      "hoaDues": "138",
      "propertyTaxes": "1982",
      "homeInsurance": "354.14",
      "principalInterest": "8391",
      "supplyTaxBill": "-11617.00",
      "closingCosts": "20000",
      "interestChange": "411",
      "total": "10865",
      "rentalValue": "4820",
      "address": "1583 Glencrest Dr;San Marcos, CA, 92078",
      "city": null,
      "country": null,
      "zipCode": "92078",
      "loanPeriodInYears": "30",
      "name": "Best Option",
      "loanDetails": "Best Option",
      "prepare": "3",
      "searchBid": "39",
      "close": "37",
      "startAt": "2024-04-19T12:01:42.000Z",
      "isToggled": false,
      "deposit_money_day": "1",
      "deposit_money_price": "30000",
      "order_home_inspection_day": "2",
      "order_home_inspection_price": "1500",
      "down_payment_day": "24",
      "down_payment_price": "288500",
      "close_of_escrow_day": "30",
      "taxBeretta": "14176.7535",
      "type": null,
      "aprRelatedClosingCost": "15000",
      "downPaymentPercentage": "20",
      "color": null,
      "fillingStatus": "27700",
      "taxRate": "32",
      "stateTaxRate": "5",
      "realEstateTaxes": "10000",
      "otherDeductions": "0",
      "mortgageInterest": "56015.55",
      "interestRateWithPoint": "7.5",
      "loanPointsPercentage": null,
      "homeInsurancePercentage": null,
      "currentInterestRate": "7.5",
      "totalLoanPoints": 6000,
      "totalCost": "20000",
      "recalculateTax": false,
      "zpid": "59308358",
      "rentcastData": "{\"id\":\"92078\",\"zipCode\":\"92078\",\"rentalData\":{\"averageRent\":3698,\"minRent\":1050,\"maxRent\":9500,\"totalListings\":141,\"lastUpdatedDate\":\"2024-04-19T00:00:00.000Z\",\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2269,\"minRent\":1100,\"maxRent\":3500,\"totalListings\":22},{\"bedrooms\":2,\"averageRent\":3354,\"minRent\":2658,\"maxRent\":4900,\"totalListings\":46},{\"bedrooms\":3,\"averageRent\":3920,\"minRent\":2795,\"maxRent\":5250,\"totalListings\":51},{\"bedrooms\":4,\"averageRent\":5503,\"minRent\":1500,\"maxRent\":9500,\"totalListings\":15},{\"bedrooms\":5,\"averageRent\":6418,\"minRent\":5200,\"maxRent\":9500,\"totalListings\":5}],\"history\":{\"2021-05\":{\"averageRent\":3194.16,\"minRent\":662,\"maxRent\":5400,\"totalListings\":44,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1776.4,\"minRent\":662,\"maxRent\":2327,\"totalListings\":5},{\"bedrooms\":1,\"averageRent\":2283.33,\"minRent\":750,\"maxRent\":3200,\"totalListings\":3},{\"bedrooms\":2,\"averageRent\":2674.19,\"minRent\":1775,\"maxRent\":4500,\"totalListings\":21},{\"bedrooms\":3,\"averageRent\":3057.73,\"minRent\":2595,\"maxRent\":3500,\"totalListings\":11},{\"bedrooms\":4,\"averageRent\":3973.33,\"minRent\":2995,\"maxRent\":4950,\"totalListings\":3},{\"bedrooms\":5,\"averageRent\":5400,\"minRent\":5400,\"maxRent\":5400,\"totalListings\":1}]},\"2021-06\":{\"averageRent\":2794.58,\"minRent\":662,\"maxRent\":4950,\"totalListings\":42,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1776.4,\"minRent\":662,\"maxRent\":2327,\"totalListings\":5},{\"bedrooms\":1,\"averageRent\":2283.33,\"minRent\":750,\"maxRent\":3200,\"totalListings\":3},{\"bedrooms\":2,\"averageRent\":2704.15,\"minRent\":1775,\"maxRent\":4500,\"totalListings\":20},{\"bedrooms\":3,\"averageRent\":3104,\"minRent\":2795,\"maxRent\":3500,\"totalListings\":10},{\"bedrooms\":4,\"averageRent\":4105,\"minRent\":2995,\"maxRent\":4950,\"totalListings\":4}]},\"2021-11\":{\"averageRent\":3176.12,\"minRent\":1350,\"maxRent\":6250,\"totalListings\":81,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1890.5,\"minRent\":1625,\"maxRent\":2156,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":1425,\"minRent\":1350,\"maxRent\":1500,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":2911.93,\"minRent\":1950,\"maxRent\":4300,\"totalListings\":28},{\"bedrooms\":3,\"averageRent\":3443.05,\"minRent\":2000,\"maxRent\":6200,\"totalListings\":37},{\"bedrooms\":4,\"averageRent\":4123.75,\"minRent\":3195,\"maxRent\":4500,\"totalListings\":8},{\"bedrooms\":5,\"averageRent\":5262.5,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":4}]},\"2021-12\":{\"averageRent\":3223.15,\"minRent\":1300,\"maxRent\":6250,\"totalListings\":100,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":2105.5,\"minRent\":2055,\"maxRent\":2156,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":1425,\"minRent\":1350,\"maxRent\":1500,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":2944.42,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":36},{\"bedrooms\":3,\"averageRent\":3401.98,\"minRent\":2000,\"maxRent\":5950,\"totalListings\":42},{\"bedrooms\":4,\"averageRent\":4178.67,\"minRent\":3195,\"maxRent\":5950,\"totalListings\":15},{\"bedrooms\":5,\"averageRent\":5283.33,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":3}]},\"2021-10\":{\"averageRent\":3258.1,\"minRent\":1300,\"maxRent\":6250,\"totalListings\":128,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":2070.33,\"minRent\":2000,\"maxRent\":2156,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2016.67,\"minRent\":1350,\"maxRent\":3200,\"totalListings\":3},{\"bedrooms\":2,\"averageRent\":2900.44,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":45},{\"bedrooms\":3,\"averageRent\":3345.58,\"minRent\":2000,\"maxRent\":5950,\"totalListings\":53},{\"bedrooms\":4,\"averageRent\":4023.89,\"minRent\":3195,\"maxRent\":4800,\"totalListings\":18},{\"bedrooms\":5,\"averageRent\":5191.67,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":6}]},\"2021-09\":{\"averageRent\":3270.08,\"minRent\":1300,\"maxRent\":6250,\"totalListings\":139,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":2070.33,\"minRent\":2000,\"maxRent\":2156,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2016.67,\"minRent\":1350,\"maxRent\":3200,\"totalListings\":3},{\"bedrooms\":2,\"averageRent\":2902.16,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":51},{\"bedrooms\":3,\"averageRent\":3345.64,\"minRent\":2000,\"maxRent\":5950,\"totalListings\":56},{\"bedrooms\":4,\"averageRent\":4094,\"minRent\":3195,\"maxRent\":4950,\"totalListings\":20},{\"bedrooms\":5,\"averageRent\":5191.67,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":6}]},\"2021-08\":{\"averageRent\":3267.7,\"minRent\":1300,\"maxRent\":6250,\"totalListings\":141,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":2070.33,\"minRent\":2000,\"maxRent\":2156,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2016.67,\"minRent\":1350,\"maxRent\":3200,\"totalListings\":3},{\"bedrooms\":2,\"averageRent\":2893.94,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":52},{\"bedrooms\":3,\"averageRent\":3339.58,\"minRent\":2000,\"maxRent\":5950,\"totalListings\":57},{\"bedrooms\":4,\"averageRent\":4094,\"minRent\":3195,\"maxRent\":4950,\"totalListings\":20},{\"bedrooms\":5,\"averageRent\":5191.67,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":6}]},\"2021-07\":{\"averageRent\":3314.82,\"minRent\":1300,\"maxRent\":6250,\"totalListings\":143,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":2070.33,\"minRent\":2000,\"maxRent\":2156,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2312.5,\"minRent\":1350,\"maxRent\":3200,\"totalListings\":4},{\"bedrooms\":2,\"averageRent\":2880.85,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":53},{\"bedrooms\":3,\"averageRent\":3339.58,\"minRent\":2000,\"maxRent\":5950,\"totalListings\":57},{\"bedrooms\":4,\"averageRent\":4094,\"minRent\":3195,\"maxRent\":4950,\"totalListings\":20},{\"bedrooms\":5,\"averageRent\":5191.67,\"minRent\":4600,\"maxRent\":6250,\"totalListings\":6}]},\"2022-01\":{\"averageRent\":3318.8,\"minRent\":1100,\"maxRent\":6250,\"totalListings\":107,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1779.75,\"minRent\":1100,\"maxRent\":3044,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2350,\"minRent\":1500,\"maxRent\":3200,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":2987.98,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":40},{\"bedrooms\":3,\"averageRent\":3349.22,\"minRent\":2000,\"maxRent\":5900,\"totalListings\":41},{\"bedrooms\":4,\"averageRent\":4095.88,\"minRent\":3000,\"maxRent\":5350,\"totalListings\":17},{\"bedrooms\":5,\"averageRent\":5350,\"minRent\":4800,\"maxRent\":6250,\"totalListings\":3}]},\"2022-02\":{\"averageRent\":3373.15,\"minRent\":1025,\"maxRent\":6250,\"totalListings\":108,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1736,\"minRent\":1025,\"maxRent\":3044,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2647.5,\"minRent\":2095,\"maxRent\":3200,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":3009.3,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":44},{\"bedrooms\":3,\"averageRent\":3373.26,\"minRent\":2000,\"maxRent\":5900,\"totalListings\":38},{\"bedrooms\":4,\"averageRent\":4086.56,\"minRent\":3000,\"maxRent\":5350,\"totalListings\":16},{\"bedrooms\":5,\"averageRent\":5386.25,\"minRent\":4800,\"maxRent\":6250,\"totalListings\":4}]},\"2022-03\":{\"averageRent\":3811.68,\"minRent\":1025,\"maxRent\":7200,\"totalListings\":116,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1683,\"minRent\":1025,\"maxRent\":2802,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2647.5,\"minRent\":2095,\"maxRent\":3200,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":3045.45,\"minRent\":1300,\"maxRent\":5500,\"totalListings\":53},{\"bedrooms\":3,\"averageRent\":3656.97,\"minRent\":2800,\"maxRent\":7200,\"totalListings\":35},{\"bedrooms\":4,\"averageRent\":4313.82,\"minRent\":3000,\"maxRent\":6250,\"totalListings\":17},{\"bedrooms\":5,\"averageRent\":5835,\"minRent\":4800,\"maxRent\":6795,\"totalListings\":4},{\"bedrooms\":6,\"averageRent\":5500,\"minRent\":5500,\"maxRent\":5500,\"totalListings\":1}]},\"2022-04\":{\"averageRent\":3913.57,\"minRent\":1025,\"maxRent\":7200,\"totalListings\":118,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1595,\"minRent\":1025,\"maxRent\":2450,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2647.5,\"minRent\":2095,\"maxRent\":3200,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":3133.44,\"minRent\":1819,\"maxRent\":5500,\"totalListings\":52},{\"bedrooms\":3,\"averageRent\":3634.34,\"minRent\":2800,\"maxRent\":7200,\"totalListings\":38},{\"bedrooms\":4,\"averageRent\":4549.71,\"minRent\":3000,\"maxRent\":6250,\"totalListings\":17},{\"bedrooms\":5,\"averageRent\":5835,\"minRent\":4800,\"maxRent\":6795,\"totalListings\":4},{\"bedrooms\":6,\"averageRent\":6000,\"minRent\":6000,\"maxRent\":6000,\"totalListings\":1}]},\"2022-05\":{\"averageRent\":3977.87,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":115,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1563.75,\"minRent\":1025,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2095,\"minRent\":2095,\"maxRent\":2095,\"totalListings\":1},{\"bedrooms\":2,\"averageRent\":3144.82,\"minRent\":2200,\"maxRent\":5500,\"totalListings\":56},{\"bedrooms\":3,\"averageRent\":3829.72,\"minRent\":2950,\"maxRent\":7200,\"totalListings\":36},{\"bedrooms\":4,\"averageRent\":4821.82,\"minRent\":3750,\"maxRent\":6250,\"totalListings\":11},{\"bedrooms\":5,\"averageRent\":6390,\"minRent\":4800,\"maxRent\":9000,\"totalListings\":6},{\"bedrooms\":6,\"averageRent\":6000,\"minRent\":6000,\"maxRent\":6000,\"totalListings\":1}]},\"2022-06\":{\"averageRent\":3995.58,\"minRent\":900,\"maxRent\":9000,\"totalListings\":121,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1565,\"minRent\":1025,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":1537.5,\"minRent\":900,\"maxRent\":2175,\"totalListings\":2},{\"bedrooms\":2,\"averageRent\":3167.72,\"minRent\":2200,\"maxRent\":5500,\"totalListings\":60},{\"bedrooms\":3,\"averageRent\":3935.66,\"minRent\":2995,\"maxRent\":7200,\"totalListings\":38},{\"bedrooms\":4,\"averageRent\":4964,\"minRent\":4100,\"maxRent\":6250,\"totalListings\":10},{\"bedrooms\":5,\"averageRent\":6799.17,\"minRent\":6000,\"maxRent\":9000,\"totalListings\":6},{\"bedrooms\":6,\"averageRent\":6000,\"minRent\":6000,\"maxRent\":6000,\"totalListings\":1}]},\"2022-07\":{\"averageRent\":3951.93,\"minRent\":900,\"maxRent\":9000,\"totalListings\":107,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1745,\"minRent\":1050,\"maxRent\":2350,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":1556.25,\"minRent\":900,\"maxRent\":2175,\"totalListings\":4},{\"bedrooms\":2,\"averageRent\":3182.72,\"minRent\":2400,\"maxRent\":5000,\"totalListings\":47},{\"bedrooms\":3,\"averageRent\":3871.26,\"minRent\":2995,\"maxRent\":5995,\"totalListings\":35},{\"bedrooms\":4,\"averageRent\":4809,\"minRent\":4100,\"maxRent\":6250,\"totalListings\":10},{\"bedrooms\":5,\"averageRent\":6499.29,\"minRent\":5500,\"maxRent\":9000,\"totalListings\":7},{\"bedrooms\":6,\"averageRent\":6000,\"minRent\":6000,\"maxRent\":6000,\"totalListings\":1}]},\"2022-08\":{\"averageRent\":3513.76,\"minRent\":1000,\"maxRent\":9000,\"totalListings\":115,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1727,\"minRent\":1050,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":1687.5,\"minRent\":1000,\"maxRent\":2800,\"totalListings\":6},{\"bedrooms\":2,\"averageRent\":3153.45,\"minRent\":2400,\"maxRent\":5000,\"totalListings\":49},{\"bedrooms\":3,\"averageRent\":3920.86,\"minRent\":2975,\"maxRent\":5995,\"totalListings\":35},{\"bedrooms\":4,\"averageRent\":4688.75,\"minRent\":4100,\"maxRent\":5375,\"totalListings\":12},{\"bedrooms\":5,\"averageRent\":5905,\"minRent\":4900,\"maxRent\":9000,\"totalListings\":9}]},\"2022-09\":{\"averageRent\":3739,\"minRent\":1000,\"maxRent\":9000,\"totalListings\":138,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1727,\"minRent\":1050,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":1687.5,\"minRent\":1000,\"maxRent\":2800,\"totalListings\":6},{\"bedrooms\":2,\"averageRent\":3226.73,\"minRent\":2400,\"maxRent\":5000,\"totalListings\":63},{\"bedrooms\":3,\"averageRent\":3937.82,\"minRent\":2975,\"maxRent\":6700,\"totalListings\":39},{\"bedrooms\":4,\"averageRent\":4960,\"minRent\":3800,\"maxRent\":5375,\"totalListings\":15},{\"bedrooms\":5,\"averageRent\":5863.64,\"minRent\":4600,\"maxRent\":9000,\"totalListings\":11}]},\"2022-10\":{\"averageRent\":3605,\"minRent\":1000,\"maxRent\":9000,\"totalListings\":139,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1519.33,\"minRent\":1050,\"maxRent\":1835,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2128.13,\"minRent\":1000,\"maxRent\":3450,\"totalListings\":8},{\"bedrooms\":2,\"averageRent\":3288.09,\"minRent\":2400,\"maxRent\":5000,\"totalListings\":58},{\"bedrooms\":3,\"averageRent\":3816.98,\"minRent\":2500,\"maxRent\":6700,\"totalListings\":43},{\"bedrooms\":4,\"averageRent\":4541,\"minRent\":3800,\"maxRent\":5375,\"totalListings\":17},{\"bedrooms\":5,\"averageRent\":5472.22,\"minRent\":4600,\"maxRent\":6750,\"totalListings\":9},{\"bedrooms\":6,\"averageRent\":5800,\"minRent\":5800,\"maxRent\":5800,\"totalListings\":1}]},\"2022-11\":{\"averageRent\":3570,\"minRent\":1000,\"maxRent\":9000,\"totalListings\":144,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1361.5,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2109.38,\"minRent\":1000,\"maxRent\":3450,\"totalListings\":8},{\"bedrooms\":2,\"averageRent\":3324.54,\"minRent\":2395,\"maxRent\":5000,\"totalListings\":61},{\"bedrooms\":3,\"averageRent\":3798.05,\"minRent\":2500,\"maxRent\":6700,\"totalListings\":40},{\"bedrooms\":4,\"averageRent\":4834,\"minRent\":3495,\"maxRent\":5375,\"totalListings\":23},{\"bedrooms\":5,\"averageRent\":4995,\"minRent\":1100,\"maxRent\":6750,\"totalListings\":10}]},\"2022-12\":{\"averageRent\":3673,\"minRent\":1000,\"maxRent\":9000,\"totalListings\":139,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249.33,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2196.43,\"minRent\":1000,\"maxRent\":3450,\"totalListings\":7},{\"bedrooms\":2,\"averageRent\":3329.36,\"minRent\":2200,\"maxRent\":5200,\"totalListings\":66},{\"bedrooms\":3,\"averageRent\":3775.22,\"minRent\":2500,\"maxRent\":6700,\"totalListings\":36},{\"bedrooms\":4,\"averageRent\":5217,\"minRent\":3495,\"maxRent\":5375,\"totalListings\":19},{\"bedrooms\":5,\"averageRent\":5012.5,\"minRent\":1100,\"maxRent\":6750,\"totalListings\":8}]},\"2023-01\":{\"averageRent\":3750,\"minRent\":1025,\"maxRent\":7900,\"totalListings\":138,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2515,\"minRent\":1500,\"maxRent\":3450,\"totalListings\":5},{\"bedrooms\":2,\"averageRent\":3309,\"minRent\":2000,\"maxRent\":5500,\"totalListings\":62},{\"bedrooms\":3,\"averageRent\":3600,\"minRent\":2000,\"maxRent\":6300,\"totalListings\":40},{\"bedrooms\":4,\"averageRent\":4986,\"minRent\":3495,\"maxRent\":7900,\"totalListings\":19},{\"bedrooms\":5,\"averageRent\":4788,\"minRent\":1100,\"maxRent\":6750,\"totalListings\":8},{\"bedrooms\":6,\"averageRent\":5800,\"minRent\":5800,\"maxRent\":5800,\"totalListings\":1}]},\"2023-02\":{\"averageRent\":3666,\"minRent\":1025,\"maxRent\":7900,\"totalListings\":139,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2400,\"minRent\":1500,\"maxRent\":3450,\"totalListings\":18},{\"bedrooms\":2,\"averageRent\":3270,\"minRent\":2000,\"maxRent\":5500,\"totalListings\":53},{\"bedrooms\":3,\"averageRent\":3620,\"minRent\":2000,\"maxRent\":6300,\"totalListings\":34},{\"bedrooms\":4,\"averageRent\":4789,\"minRent\":3445,\"maxRent\":7900,\"totalListings\":22},{\"bedrooms\":5,\"averageRent\":4831,\"minRent\":1100,\"maxRent\":6500,\"totalListings\":8},{\"bedrooms\":6,\"averageRent\":5500,\"minRent\":5500,\"maxRent\":5500,\"totalListings\":1}]},\"2023-03\":{\"averageRent\":3569,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":147,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2404,\"minRent\":1500,\"maxRent\":3450,\"totalListings\":21},{\"bedrooms\":2,\"averageRent\":3279,\"minRent\":2000,\"maxRent\":5500,\"totalListings\":52},{\"bedrooms\":3,\"averageRent\":3688,\"minRent\":2000,\"maxRent\":6300,\"totalListings\":37},{\"bedrooms\":4,\"averageRent\":4468,\"minRent\":2200,\"maxRent\":7200,\"totalListings\":25},{\"bedrooms\":5,\"averageRent\":5792,\"minRent\":4500,\"maxRent\":9000,\"totalListings\":8},{\"bedrooms\":6,\"averageRent\":5500,\"minRent\":5500,\"maxRent\":5500,\"totalListings\":1}]},\"2023-04\":{\"averageRent\":3610,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":155,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1524,\"minRent\":1025,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2341,\"minRent\":1500,\"maxRent\":3300,\"totalListings\":23},{\"bedrooms\":2,\"averageRent\":3302,\"minRent\":2000,\"maxRent\":5200,\"totalListings\":53},{\"bedrooms\":3,\"averageRent\":3642,\"minRent\":2000,\"maxRent\":6000,\"totalListings\":37},{\"bedrooms\":4,\"averageRent\":4544,\"minRent\":1600,\"maxRent\":7795,\"totalListings\":26},{\"bedrooms\":5,\"averageRent\":6026,\"minRent\":4500,\"maxRent\":9000,\"totalListings\":11},{\"bedrooms\":6,\"averageRent\":5500,\"minRent\":5500,\"maxRent\":5500,\"totalListings\":1}]},\"2023-05\":{\"averageRent\":3736,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":162,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1524,\"minRent\":1025,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2430,\"minRent\":1500,\"maxRent\":3500,\"totalListings\":24},{\"bedrooms\":2,\"averageRent\":3379,\"minRent\":2000,\"maxRent\":4995,\"totalListings\":54},{\"bedrooms\":3,\"averageRent\":3632,\"minRent\":2000,\"maxRent\":5200,\"totalListings\":37},{\"bedrooms\":4,\"averageRent\":4548,\"minRent\":1600,\"maxRent\":7795,\"totalListings\":28},{\"bedrooms\":5,\"averageRent\":6502,\"minRent\":4900,\"maxRent\":9000,\"totalListings\":14},{\"bedrooms\":6,\"averageRent\":5500,\"minRent\":5500,\"maxRent\":5500,\"totalListings\":1}]},\"2023-06\":{\"averageRent\":3876,\"minRent\":1050,\"maxRent\":9000,\"totalListings\":176,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1691,\"minRent\":1050,\"maxRent\":2350,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2465,\"minRent\":1500,\"maxRent\":3500,\"totalListings\":24},{\"bedrooms\":2,\"averageRent\":3410,\"minRent\":2460,\"maxRent\":4995,\"totalListings\":54},{\"bedrooms\":3,\"averageRent\":3740,\"minRent\":2500,\"maxRent\":5200,\"totalListings\":45},{\"bedrooms\":4,\"averageRent\":4838,\"minRent\":1600,\"maxRent\":7795,\"totalListings\":35},{\"bedrooms\":5,\"averageRent\":6456,\"minRent\":4900,\"maxRent\":9000,\"totalListings\":14},{\"bedrooms\":6,\"averageRent\":5800,\"minRent\":5800,\"maxRent\":5800,\"totalListings\":1}]},\"2023-07\":{\"averageRent\":3951,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":177,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1524,\"minRent\":1025,\"maxRent\":2350,\"totalListings\":4},{\"bedrooms\":1,\"averageRent\":2410,\"minRent\":1300,\"maxRent\":3500,\"totalListings\":25},{\"bedrooms\":2,\"averageRent\":3431,\"minRent\":2500,\"maxRent\":5200,\"totalListings\":48},{\"bedrooms\":3,\"averageRent\":3823,\"minRent\":2200,\"maxRent\":5750,\"totalListings\":49},{\"bedrooms\":4,\"averageRent\":5054,\"minRent\":1600,\"maxRent\":7795,\"totalListings\":33},{\"bedrooms\":5,\"averageRent\":6375,\"minRent\":4900,\"maxRent\":9000,\"totalListings\":17},{\"bedrooms\":6,\"averageRent\":5800,\"minRent\":5800,\"maxRent\":5800,\"totalListings\":1}]},\"2023-08\":{\"averageRent\":3894,\"minRent\":1025,\"maxRent\":9000,\"totalListings\":166,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2367,\"minRent\":1100,\"maxRent\":3350,\"totalListings\":24},{\"bedrooms\":2,\"averageRent\":3413,\"minRent\":2658,\"maxRent\":5200,\"totalListings\":50},{\"bedrooms\":3,\"averageRent\":3801,\"minRent\":2200,\"maxRent\":5395,\"totalListings\":46},{\"bedrooms\":4,\"averageRent\":5183,\"minRent\":3700,\"maxRent\":7795,\"totalListings\":28},{\"bedrooms\":5,\"averageRent\":6384,\"minRent\":4700,\"maxRent\":9000,\"totalListings\":14},{\"bedrooms\":6,\"averageRent\":5800,\"minRent\":5800,\"maxRent\":5800,\"totalListings\":1}]},\"2023-09\":{\"averageRent\":3880,\"minRent\":1025,\"maxRent\":7200,\"totalListings\":155,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2422,\"minRent\":1200,\"maxRent\":3850,\"totalListings\":20},{\"bedrooms\":2,\"averageRent\":3332,\"minRent\":2650,\"maxRent\":5200,\"totalListings\":46},{\"bedrooms\":3,\"averageRent\":3854,\"minRent\":2200,\"maxRent\":5395,\"totalListings\":46},{\"bedrooms\":4,\"averageRent\":5129,\"minRent\":3950,\"maxRent\":7200,\"totalListings\":27},{\"bedrooms\":5,\"averageRent\":6139,\"minRent\":4700,\"maxRent\":7000,\"totalListings\":11},{\"bedrooms\":6,\"averageRent\":6325,\"minRent\":5800,\"maxRent\":6850,\"totalListings\":2}]},\"2023-10\":{\"averageRent\":3781,\"minRent\":1025,\"maxRent\":7200,\"totalListings\":157,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1249,\"minRent\":1025,\"maxRent\":1673,\"totalListings\":3},{\"bedrooms\":1,\"averageRent\":2403,\"minRent\":1200,\"maxRent\":3850,\"totalListings\":23},{\"bedrooms\":2,\"averageRent\":3402,\"minRent\":2650,\"maxRent\":6000,\"totalListings\":48},{\"bedrooms\":3,\"averageRent\":3866,\"minRent\":2050,\"maxRent\":6400,\"totalListings\":49},{\"bedrooms\":4,\"averageRent\":5147,\"minRent\":3950,\"maxRent\":7200,\"totalListings\":26},{\"bedrooms\":5,\"averageRent\":5883,\"minRent\":4700,\"maxRent\":6500,\"totalListings\":7},{\"bedrooms\":6,\"averageRent\":6850,\"minRent\":6850,\"maxRent\":6850,\"totalListings\":1}]},\"2023-11\":{\"averageRent\":3704,\"minRent\":1050,\"maxRent\":6850,\"totalListings\":134,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2483,\"minRent\":1200,\"maxRent\":3850,\"totalListings\":17},{\"bedrooms\":2,\"averageRent\":3368,\"minRent\":2500,\"maxRent\":6000,\"totalListings\":44},{\"bedrooms\":3,\"averageRent\":3899,\"minRent\":2050,\"maxRent\":6200,\"totalListings\":50},{\"bedrooms\":4,\"averageRent\":4949,\"minRent\":3750,\"maxRent\":6500,\"totalListings\":17},{\"bedrooms\":5,\"averageRent\":5750,\"minRent\":4700,\"maxRent\":6300,\"totalListings\":3},{\"bedrooms\":6,\"averageRent\":6850,\"minRent\":6850,\"maxRent\":6850,\"totalListings\":1}]},\"2023-12\":{\"averageRent\":3693,\"minRent\":1050,\"maxRent\":8500,\"totalListings\":127,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2476,\"minRent\":1200,\"maxRent\":3850,\"totalListings\":15},{\"bedrooms\":2,\"averageRent\":3351,\"minRent\":2500,\"maxRent\":6000,\"totalListings\":45},{\"bedrooms\":3,\"averageRent\":3859,\"minRent\":2050,\"maxRent\":6200,\"totalListings\":46},{\"bedrooms\":4,\"averageRent\":5125,\"minRent\":3750,\"maxRent\":8500,\"totalListings\":16},{\"bedrooms\":5,\"averageRent\":6275,\"minRent\":6250,\"maxRent\":6300,\"totalListings\":2},{\"bedrooms\":6,\"averageRent\":6350,\"minRent\":6350,\"maxRent\":6350,\"totalListings\":1}]},\"2024-01\":{\"averageRent\":3726,\"minRent\":1050,\"maxRent\":8500,\"totalListings\":119,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2239,\"minRent\":1350,\"maxRent\":3500,\"totalListings\":13},{\"bedrooms\":2,\"averageRent\":3327,\"minRent\":2500,\"maxRent\":4800,\"totalListings\":41},{\"bedrooms\":3,\"averageRent\":3963,\"minRent\":2995,\"maxRent\":6200,\"totalListings\":45},{\"bedrooms\":4,\"averageRent\":5266,\"minRent\":3750,\"maxRent\":8500,\"totalListings\":15},{\"bedrooms\":5,\"averageRent\":5725,\"minRent\":5200,\"maxRent\":6250,\"totalListings\":2},{\"bedrooms\":6,\"averageRent\":6350,\"minRent\":6350,\"maxRent\":6350,\"totalListings\":1}]},\"2024-02\":{\"averageRent\":3709,\"minRent\":1050,\"maxRent\":8500,\"totalListings\":117,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2329,\"minRent\":1350,\"maxRent\":3500,\"totalListings\":14},{\"bedrooms\":2,\"averageRent\":3427,\"minRent\":2500,\"maxRent\":4900,\"totalListings\":40},{\"bedrooms\":3,\"averageRent\":3987,\"minRent\":2795,\"maxRent\":6200,\"totalListings\":46},{\"bedrooms\":4,\"averageRent\":5100,\"minRent\":1500,\"maxRent\":8500,\"totalListings\":12},{\"bedrooms\":5,\"averageRent\":5298,\"minRent\":5200,\"maxRent\":5395,\"totalListings\":2},{\"bedrooms\":6,\"averageRent\":6350,\"minRent\":6350,\"maxRent\":6350,\"totalListings\":1}]},\"2024-03\":{\"averageRent\":3708,\"minRent\":1050,\"maxRent\":9500,\"totalListings\":135,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2274,\"minRent\":1200,\"maxRent\":3500,\"totalListings\":20},{\"bedrooms\":2,\"averageRent\":3360,\"minRent\":2500,\"maxRent\":4900,\"totalListings\":45},{\"bedrooms\":3,\"averageRent\":3923,\"minRent\":2795,\"maxRent\":5500,\"totalListings\":50},{\"bedrooms\":4,\"averageRent\":5619,\"minRent\":1500,\"maxRent\":9500,\"totalListings\":13},{\"bedrooms\":5,\"averageRent\":6399,\"minRent\":5200,\"maxRent\":9500,\"totalListings\":4},{\"bedrooms\":6,\"averageRent\":6350,\"minRent\":6350,\"maxRent\":6350,\"totalListings\":1}]},\"2024-04\":{\"averageRent\":3698,\"minRent\":1050,\"maxRent\":9500,\"totalListings\":141,\"dataByBedrooms\":[{\"bedrooms\":0,\"averageRent\":1362,\"minRent\":1050,\"maxRent\":1673,\"totalListings\":2},{\"bedrooms\":1,\"averageRent\":2269,\"minRent\":1100,\"maxRent\":3500,\"totalListings\":22},{\"bedrooms\":2,\"averageRent\":3354,\"minRent\":2658,\"maxRent\":4900,\"totalListings\":46},{\"bedrooms\":3,\"averageRent\":3920,\"minRent\":2795,\"maxRent\":5250,\"totalListings\":51},{\"bedrooms\":4,\"averageRent\":5503,\"minRent\":1500,\"maxRent\":9500,\"totalListings\":15},{\"bedrooms\":5,\"averageRent\":6418,\"minRent\":5200,\"maxRent\":9500,\"totalListings\":5}]}}}}",
      "rentalParams": "\"[\\\"2BD\\\",\\\"3BD\\\"]\"",
      "order": "1",
      "isSegment": false,
      "addUip": false,
      "uip": "21000",
      "loanAmountWithUip": null,
      "interestRateWithoutPoints": "8",
      "suplimentalData": null,
      "interestOnly": false,
      "pmiNote": "0",
      "hoaNote": "0",
      "interestRateNote": "0",
      "closingCostNote": "0",
      "purchasePriceNote": null,
      "loanAmountNote": null,
      "loanPeriodInYearsNote": null,
      "aprNote": null,
      "loanPointsNote": null,
      "uipNote": null,
      "propertyTaxesNote": null,
      "homeInsuranceNote": null,
      "principalInterestNote": null,
      "supplyTaxBillNote": null,
      "interestChangeNote": null,
      "rentalValueNote": null,
      "totalNote": null,
      "createdAt": "2024-04-19T19:01:42.000Z",
      "updatedAt": "2024-05-27T11:28:02.000Z",
    },
    {
      "id": 827,
      taxBenefitPerMonth: '1400',
      taxBenefitPerYear: '120',
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "purchasePrice": "1500000",
      "downPayment": "75000",
      "loanAmount": "1425000",
      "loanTerm": null,
      "interestRate": "7.5",
      "apr": "7.608",
      "loanPoints": "14250",
      "pmi": null,
      "hoaDues": "138",
      "propertyTaxes": "1982",
      "homeInsurance": "354.14",
      "principalInterest": "9964",
      "supplyTaxBill": "-11617.00",
      "closingCosts": "20000",
      "interestChange": "488",
      "total": "12438",
      "rentalValue": "4820",
      "address": "1583 Glencrest Dr;San Marcos, CA, 92078",
      "city": null,
      "country": null,
      "zipCode": "92078",
      "loanPeriodInYears": "30",
      "name": "3rd best",
      "loanDetails": "3rd best",
      "prepare": "3",
      "searchBid": "30",
      "close": "21",
      "startAt": "2024-04-19T12:04:10.000Z",
      "isToggled": false,
      "deposit_money_day": "1",
      "deposit_money_price": null,
      "order_home_inspection_day": "2",
      "order_home_inspection_price": "1000",
      "down_payment_day": "19",
      "down_payment_price": null,
      "close_of_escrow_day": "21",
      "taxBeretta": "19276.8335",
      "type": null,
      "aprRelatedClosingCost": "15000",
      "downPaymentPercentage": "5",
      "color": null,
      "fillingStatus": "27700",
      "taxRate": "32",
      "stateTaxRate": "5",
      "realEstateTaxes": "23784",
      "otherDeductions": "0",
      "mortgageInterest": "56015.55",
      "interestRateWithPoint": "7.5",
      "loanPointsPercentage": "1",
      "homeInsurancePercentage": null,
      "currentInterestRate": "7.5",
      "totalLoanPoints": "5000",
      "totalCost": "20000",
      "recalculateTax": false,
      "zpid": "59308358",
      "rentcastData": null,
      "rentalParams": "\"[\\\"2BD\\\"]\"",
      "order": "3",
      "isSegment": false,
      "addUip": false,
      "uip": "24937.5",
      "loanAmountWithUip": null,
      "interestRateWithoutPoints": "9",
      "suplimentalData": null,
      "interestOnly": false,
      "pmiNote": "0",
      "hoaNote": "0",
      "interestRateNote": "0",
      "closingCostNote": "0",
      "purchasePriceNote": null,
      "loanAmountNote": null,
      "loanPeriodInYearsNote": null,
      "aprNote": null,
      "loanPointsNote": null,
      "uipNote": null,
      "propertyTaxesNote": null,
      "homeInsuranceNote": null,
      "principalInterestNote": null,
      "supplyTaxBillNote": null,
      "interestChangeNote": null,
      "rentalValueNote": null,
      "totalNote": null,
      "createdAt": "2024-04-19T19:04:10.000Z",
      "updatedAt": "2024-05-27T11:28:02.000Z"
    },
    {
      "id": 828,
      taxBenefitPerMonth: '2746',
      taxBenefitPerYear: '231',
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "purchasePrice": "1500000",
      "downPayment": "150000",
      "loanAmount": "1350000",
      "loanTerm": null,
      "interestRate": "7.5",
      "apr": "7.615",
      "loanPoints": "6750",
      "pmi": null,
      "hoaDues": "138",
      "propertyTaxes": "1982",
      "homeInsurance": "354.14",
      "principalInterest": "9439",
      "supplyTaxBill": "-11617.00",
      "closingCosts": "20000",
      "interestChange": "462",
      "total": "11913",
      "rentalValue": "4820",
      "address": "1583 Glencrest Dr;San Marcos, CA, 92078",
      "city": null,
      "country": null,
      "zipCode": "92078",
      "loanPeriodInYears": "30",
      "name": "4th",
      "loanDetails": "4th",
      "prepare": "3",
      "searchBid": "30",
      "close": "21",
      "startAt": "2024-04-19T12:04:22.000Z",
      "isToggled": false,
      "deposit_money_day": "1",
      "deposit_money_price": null,
      "order_home_inspection_day": "2",
      "order_home_inspection_price": "1000",
      "down_payment_day": "19",
      "down_payment_price": null,
      "close_of_escrow_day": "21",
      "taxBeretta": "19276.8335",
      "type": null,
      "aprRelatedClosingCost": "15000",
      "downPaymentPercentage": "10",
      "color": null,
      "fillingStatus": "27700",
      "taxRate": "32",
      "stateTaxRate": "5",
      "realEstateTaxes": "23784",
      "otherDeductions": "0",
      "mortgageInterest": "56015.55",
      "interestRateWithPoint": "7.5",
      "loanPointsPercentage": ".5",
      "homeInsurancePercentage": null,
      "currentInterestRate": "7.5",
      "totalLoanPoints": "6750",
      "totalCost": "20000",
      "recalculateTax": false,
      "zpid": "59308358",
      "rentcastData": null,
      "rentalParams": "\"[\\\"2BD\\\"]\"",
      "order": "4",
      "isSegment": false,
      "addUip": false,
      "uip": "23625",
      "loanAmountWithUip": null,
      "interestRateWithoutPoints": "5",
      "suplimentalData": null,
      "interestOnly": false,
      "pmiNote": "0",
      "hoaNote": "0",
      "interestRateNote": "0",
      "closingCostNote": "0",
      "purchasePriceNote": null,
      "loanAmountNote": null,
      "loanPeriodInYearsNote": null,
      "aprNote": null,
      "loanPointsNote": null,
      "uipNote": null,
      "propertyTaxesNote": null,
      "homeInsuranceNote": null,
      "principalInterestNote": null,
      "supplyTaxBillNote": null,
      "interestChangeNote": null,
      "rentalValueNote": null,
      "totalNote": null,
      "createdAt": "2024-04-19T19:04:22.000Z",
      "updatedAt": "2024-05-27T11:28:02.000Z"
    },
    {
      "id": 829,
      taxBenefitPerMonth: '3105',
      taxBenefitPerYear: '275',
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "purchasePrice": "1500000",
      "downPayment": "225000",
      "loanAmount": "1275000",
      "loanTerm": null,
      "interestRate": "7.5",
      "apr": "7.622",
      "loanPoints": "3187",
      "pmi": null,
      "hoaDues": "138",
      "propertyTaxes": "1982",
      "homeInsurance": "354.14",
      "principalInterest": "8915",
      "supplyTaxBill": "-11617.00",
      "closingCosts": "20000",
      "interestChange": "437",
      "total": "11389",
      "rentalValue": "4820",
      "address": "1583 Glencrest Dr;San Marcos, CA, 92078",
      "city": null,
      "country": null,
      "zipCode": "92078",
      "loanPeriodInYears": "30",
      "name": "2nd Best Testing Line wrapping",
      "loanDetails": "2nd Best Testing Line wrapping",
      "prepare": "3",
      "searchBid": "30",
      "close": "21",
      "startAt": "2024-04-19T12:04:22.000Z",
      "isToggled": false,
      "deposit_money_day": "1",
      "deposit_money_price": null,
      "order_home_inspection_day": "2",
      "order_home_inspection_price": "1000",
      "down_payment_day": "19",
      "down_payment_price": null,
      "close_of_escrow_day": "21",
      "taxBeretta": "19276.8335",
      "type": null,
      "aprRelatedClosingCost": "15000",
      "downPaymentPercentage": "15",
      "color": null,
      "fillingStatus": "27700",
      "taxRate": "32",
      "stateTaxRate": "5",
      "realEstateTaxes": "23784",
      "otherDeductions": "0",
      "mortgageInterest": "56015.55",
      "interestRateWithPoint": "7.5",
      "loanPointsPercentage": ".25",
      "homeInsurancePercentage": null,
      "currentInterestRate": "7.5",
      "totalLoanPoints": "3187",
      "totalCost": "20000",
      "recalculateTax": false,
      "zpid": "59308358",
      "rentcastData": null,
      "rentalParams": "\"[\\\"2BD\\\"]\"",
      "order": "2",
      "isSegment": false,
      "addUip": false,
      "uip": "22312.5",
      "loanAmountWithUip": null,
      "interestRateWithoutPoints": "4.5",
      "suplimentalData": null,
      "interestOnly": false,
      "pmiNote": "0",
      "hoaNote": "0",
      "interestRateNote": "0",
      "closingCostNote": "0",
      "purchasePriceNote": null,
      "loanAmountNote": null,
      "loanPeriodInYearsNote": null,
      "aprNote": null,
      "loanPointsNote": null,
      "uipNote": null,
      "propertyTaxesNote": null,
      "homeInsuranceNote": null,
      "principalInterestNote": null,
      "supplyTaxBillNote": null,
      "interestChangeNote": null,
      "rentalValueNote": null,
      "totalNote": null,
      "createdAt": "2024-04-19T19:04:22.000Z",
      "updatedAt": "2024-05-27T11:28:02.000Z"
    }
  ],
  "ReportSettings": [
    {
      "id": 9595,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Purchase Price",
      "order": 1,
      "active": true,
      "name": "purchasePrice",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9596,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Down Payment",
      "order": 2,
      "active": true,
      "name": "downPayment",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9597,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Loan Amount",
      "order": 3,
      "active": true,
      "name": "loanAmount",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9598,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Interest Rate",
      "order": 5,
      "active": true,
      "name": "interestRate",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9599,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "APR",
      "order": 6,
      "active": true,
      "name": "apr",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9600,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Principal and Interest",
      "order": 7,
      "active": true,
      "name": "principalInterest",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9601,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Loan Term",
      "order": 4,
      "active": true,
      "name": "loanPeriodInYears",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9602,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Property Taxes",
      "order": 8,
      "active": true,
      "name": "propertyTaxes",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9603,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Homeowners Insurance",
      "order": 9,
      "active": true,
      "name": "homeInsurance",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9604,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Mortgage Insurance",
      "order": 10,
      "active": true,
      "name": "pmi",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9605,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "HOA Dues",
      "order": 11,
      "active": true,
      "name": "hoaDues",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9606,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Total",
      "order": 12,
      "active": true,
      "name": "total",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9607,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Loan Points",
      "order": 13,
      "active": true,
      "name": "loanPoints",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9608,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Closing Costs",
      "order": 14,
      "active": true,
      "name": "closingCosts",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9609,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Upfront Ins. Premium",
      "order": 15,
      "active": true,
      "name": "uip",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9610,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Supplemental Tax Bill",
      "order": 16,
      "active": true,
      "name": "supplyTaxBill",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9611,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Rate Shift Impact",
      "order": 17,
      "active": true,
      "name": "interestChange",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9612,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Rental Value",
      "order": 18,
      "active": true,
      "name": "rentalValue",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9613,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Loan Details",
      "order": 19,
      "active": false,
      "name": "loanDetails",
      "type": "table_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9614,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Embed Video",
      "order": 1,
      "active": true,
      "name": "vidoeWalk",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9615,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Income Tax Advantage of Homeownership",
      "order": 2,
      "active": true,
      "name": "taxAdvantage",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9616,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Long-Term Investments Numbers",
      "order": 3,
      "active": true,
      "name": "longTermInvestmentsNumbers",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9617,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Closing Costs",
      "order": 4,
      "active": true,
      "name": "closingCostsEstimates",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9618,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Temporary Interest Rate Buydown",
      "order": 5,
      "active": true,
      "name": "buyDownCalculator",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9619,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Break-Even on Paying Loan Points",
      "order": 6,
      "active": true,
      "name": "breakEvenPoint",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9620,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Rent vs Own",
      "order": 7,
      "active": true,
      "name": "rentOrOwn",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9621,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Interest Savings for Biweekly Payments",
      "order": 8,
      "active": true,
      "name": "interestSavings",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9622,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Homebuying Timeline",
      "order": 9,
      "active": true,
      "name": "howLongTakeToBuy",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9623,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Rental Analysis",
      "order": 10,
      "active": true,
      "name": "rentalAnalysis",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9624,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Referral Link",
      "order": 11,
      "active": true,
      "name": "referral",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    },
    {
      "id": 9625,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "text": "Message",
      "order": 12,
      "active": true,
      "name": "closingText",
      "type": "report_view",
      "color": null,
      "createdAt": "2024-04-19T19:01:21.000Z",
      "updatedAt": "2024-04-19T19:58:50.000Z"
    }
  ],
  "ReportsShares": [],
  "Activities": [
    {
      "id": 466,
      "reportId": "9db018d6-75f0-4581-9552-982c17323fae",
      "type": "created",
      "date": "2024-04-19T19:01:22.000Z",
      "url": null,
      "createdAt": "2024-04-19T19:01:22.000Z",
      "updatedAt": "2024-04-19T19:01:22.000Z"
    }
  ],
  "User": {
    "id": 29,
    "firstName": "Shawn",
    "lastName": "Brown",
    "email": "Shawn@CLendingGroup.com",
    "password": "$2b$10$gy1/rXlJV0YjIDPIIlcEy.qyH6bFn1vMDTkrci1pE.f/IaCHdQlgK",
    "phoneNumber": "(949) 500-1289",
    "avatar": "https://user-123.s3.amazonaws.com/public/images/34e397f7-4b97-436f-bedd-c7515bb302e5.png",
    "companyName": "California Lending Group",
    "websiteLink": "CLendingGroup.com",
    "nmls": null,
    "address": "27201 Puerta Real Suite 300",
    "logo": "https://user-123.s3.amazonaws.com/public/images/a8f2e27f-b401-41fa-9ec2-164f6bcb0f96.png",
    "videoUrl": null,
    "planId": "price_1Ou95nAP5k49x0bIM4ZJ7MPh",
    "customerId": "cus_Pjh7aYNBRKciqy",
    "balance": 0,
    "userId": null,
    "subscriptionId": "sub_1OuDkeAP5k49x0bI8Vc8LR1a",
    "referral": null,
    "nmlsId": "1543608",
    "type": "admin",
    "reference": "2b3c4848-d47f-41a8-9996-0f1a4e993931",
    "forgotPasswordCode": null,
    "closingText": null,
    "isPremium": false,
    "isActive": true,
    "welcome_message": "<p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">Welcome! I'm thrilled you've chosen us to help you navigate the exciting journey of homeownership. We're dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">I'm happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class=\"ql-size-large\" style=\"color: rgb(29, 28, 29);\">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We're here to support you and make your homeownership dream a reality.</span></p>",
    "settings_logo": null,
    "permissions": "{\"1\":\"Unlimited reports\",\"2\":\"No property data integration*\",\"3\":\"Advanced option for you\",\"Breaking News\":\"true\",\"Content Scripts\":\"true\",\"Markets\":\"true\",\"Notifications\":\"true\",\"breaking_news\":\"true\",\"ceo_cell_phone\":\"true\",\"content_scripts\":\"true\",\"early_access_new_features\":\"true\",\"market_charts\":\"true\",\"market_rate_lock_alerts\":\"true\",\"mortgage_presentation_tools\":\"true\",\"premium_support\":\"true\",\"property_data_copilot\":\"true\",\"unlimited_reports\":\"true\"}",
    "createdAt": "2024-03-14T12:49:49.000Z",
    "updatedAt": "2024-04-09T06:21:27.000Z",
    "insurance": true
  }
}]

export const REPORT_TABLE_DATA = [
  {
    id: 'a44e160c-79fa-4a8c-86df-cb88af3d16a8',
    name: 'Brandee Diamond',
    status: 'completed',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: '<iframe width="560" height="315" src="https://www.youtube.com/embed/tgbNymZ7vqY?si=-qU-vzutlkZYM7zr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome Brandee!</span></p><p><br></p><p><br></p><p><span class="ql-size-large">Below, I\'ve outlined the two loan options you are considering in preparation for your upcoming home purchase. I\'ve compared both options side-by-side for your convenience. Our loan offer appears lower primarily because it involves a larger down payment. On an equal footing, however, the Citi Loan would actually be $200 less each month. Feel free to reorganize the numbers by adding additional columns as you see fit. Should you have any questions or require further assistance, please don\'t hesitate to contact me.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Best,</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Shawn Brown</span></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">949-500-1289</span></p>',
    settings_logo: null,
    rentVsOwnValue: '1550000',
    createdAt: '2024-05-06T17:38:51.000Z',
    updatedAt: '2024-05-22T19:56:26.000Z',
    Activities: [
      {
        id: 518,
        reportId: 'a44e160c-79fa-4a8c-86df-cb88af3d16a8',
        type: 'created',
        date: '2024-05-06T17:38:52.000Z',
        url: null,
        createdAt: '2024-05-06T17:38:52.000Z',
        updatedAt: '2024-05-06T17:38:52.000Z',
      },
      {
        id: 519,
        reportId: 'a44e160c-79fa-4a8c-86df-cb88af3d16a8',
        type: 'viewed',
        date: '2024-05-06T18:14:51.000Z',
        url: null,
        createdAt: '2024-05-06T18:14:51.000Z',
        updatedAt: '2024-05-06T18:14:51.000Z',
      },
      {
        id: 520,
        reportId: 'a44e160c-79fa-4a8c-86df-cb88af3d16a8',
        type: 'viewed',
        date: '2024-05-06T18:15:41.000Z',
        url: null,
        createdAt: '2024-05-06T18:15:41.000Z',
        updatedAt: '2024-05-06T18:15:41.000Z',
      },
    ],
  },
  {
    id: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
    name: 'Jordan and Alyssa Zurowski',
    status: 'completed',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Hi Jordan and Alyssa! </span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Your personalized mortgage report is ready! I included purchase prices from $900,000 up to $1.2 million. The last two columns show payment details for a $1.1 million purchase if you were to refinance at 6% and 5% in the future. </span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">We should also consider writing your offer to purchase your next property with a seller-paid rate buy-down. In this offer structure the seller would buy down your interest rate for the first couple of years drastically reducing your monthly mortgage payment. I included the buy down cost figures in the blow report. Let\'s jump on a call when you\'re ready to further explore this strategy. Talk soon! </span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-05-03T01:39:08.000Z',
    updatedAt: '2024-05-07T23:27:27.000Z',
    Activities: [
      {
        id: 496,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'created',
        date: '2024-05-03T01:39:09.000Z',
        url: null,
        createdAt: '2024-05-03T01:39:09.000Z',
        updatedAt: '2024-05-03T01:39:09.000Z',
      },
      {
        id: 497,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T02:43:52.000Z',
        url: null,
        createdAt: '2024-05-03T02:43:52.000Z',
        updatedAt: '2024-05-03T02:43:52.000Z',
      },
      {
        id: 498,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T02:58:48.000Z',
        url: null,
        createdAt: '2024-05-03T02:58:48.000Z',
        updatedAt: '2024-05-03T02:58:48.000Z',
      },
      {
        id: 499,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T03:01:04.000Z',
        url: null,
        createdAt: '2024-05-03T03:01:04.000Z',
        updatedAt: '2024-05-03T03:01:04.000Z',
      },
      {
        id: 500,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T03:02:27.000Z',
        url: null,
        createdAt: '2024-05-03T03:02:27.000Z',
        updatedAt: '2024-05-03T03:02:27.000Z',
      },
      {
        id: 501,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T03:04:30.000Z',
        url: null,
        createdAt: '2024-05-03T03:04:30.000Z',
        updatedAt: '2024-05-03T03:04:30.000Z',
      },
      {
        id: 502,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-03T04:32:26.000Z',
        url: null,
        createdAt: '2024-05-03T04:32:26.000Z',
        updatedAt: '2024-05-03T04:32:26.000Z',
      },
      {
        id: 523,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-11T21:08:50.000Z',
        url: null,
        createdAt: '2024-05-11T21:08:50.000Z',
        updatedAt: '2024-05-11T21:08:50.000Z',
      },
      {
        id: 524,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-11T22:07:41.000Z',
        url: null,
        createdAt: '2024-05-11T22:07:41.000Z',
        updatedAt: '2024-05-11T22:07:41.000Z',
      },
      {
        id: 525,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-11T22:12:55.000Z',
        url: null,
        createdAt: '2024-05-11T22:12:55.000Z',
        updatedAt: '2024-05-11T22:12:55.000Z',
      },
      {
        id: 526,
        reportId: '509c62ce-1783-4dc7-91d8-607fa69cfa58',
        type: 'viewed',
        date: '2024-05-11T23:31:12.000Z',
        url: null,
        createdAt: '2024-05-11T23:31:12.000Z',
        updatedAt: '2024-05-11T23:31:12.000Z',
      },
    ],
  },
  {
    id: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
    name: 'Tyler and Lisa Williams ',
    status: 'edited',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video:
      '<div style="position: relative; padding-bottom: 53.90625%; height: 0;"><iframe src="https://www.loom.com/embed/2822d70ffc0448ee91f5e0852d9ae2f8?sid=6d1fab5f-d329-4750-853c-6a1d0781f5d8" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>',
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '700000',
    createdAt: '2024-04-29T21:52:53.000Z',
    updatedAt: '2024-05-03T01:39:02.000Z',
    Activities: [
      {
        id: 481,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'created',
        date: '2024-04-29T21:52:54.000Z',
        url: null,
        createdAt: '2024-04-29T21:52:54.000Z',
        updatedAt: '2024-04-29T21:52:54.000Z',
      },
      {
        id: 485,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-04-30T18:58:08.000Z',
        url: null,
        createdAt: '2024-04-30T18:58:08.000Z',
        updatedAt: '2024-04-30T18:58:08.000Z',
      },
      {
        id: 486,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-04-30T19:07:05.000Z',
        url: null,
        createdAt: '2024-04-30T19:07:05.000Z',
        updatedAt: '2024-04-30T19:07:05.000Z',
      },
      {
        id: 487,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-04-30T21:46:08.000Z',
        url: null,
        createdAt: '2024-04-30T21:46:08.000Z',
        updatedAt: '2024-04-30T21:46:08.000Z',
      },
      {
        id: 488,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'edited',
        date: '2024-04-30T21:51:43.000Z',
        url: null,
        createdAt: '2024-04-30T21:51:43.000Z',
        updatedAt: '2024-04-30T21:51:43.000Z',
      },
      {
        id: 489,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'edited',
        date: '2024-04-30T21:56:38.000Z',
        url: null,
        createdAt: '2024-04-30T21:56:38.000Z',
        updatedAt: '2024-04-30T21:56:38.000Z',
      },
      {
        id: 490,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'edited',
        date: '2024-04-30T21:58:07.000Z',
        url: null,
        createdAt: '2024-04-30T21:58:07.000Z',
        updatedAt: '2024-04-30T21:58:07.000Z',
      },
      {
        id: 491,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'edited',
        date: '2024-04-30T21:58:40.000Z',
        url: null,
        createdAt: '2024-04-30T21:58:40.000Z',
        updatedAt: '2024-04-30T21:58:40.000Z',
      },
      {
        id: 492,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-04-30T22:02:27.000Z',
        url: null,
        createdAt: '2024-04-30T22:02:27.000Z',
        updatedAt: '2024-04-30T22:02:27.000Z',
      },
      {
        id: 493,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-05-01T18:59:38.000Z',
        url: null,
        createdAt: '2024-05-01T18:59:38.000Z',
        updatedAt: '2024-05-01T18:59:38.000Z',
      },
      {
        id: 494,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-05-01T19:20:04.000Z',
        url: null,
        createdAt: '2024-05-01T19:20:04.000Z',
        updatedAt: '2024-05-01T19:20:04.000Z',
      },
      {
        id: 495,
        reportId: '9ef74ea8-d8a5-494f-bd69-18c9593ee16f',
        type: 'viewed',
        date: '2024-05-02T19:59:41.000Z',
        url: null,
        createdAt: '2024-05-02T19:59:41.000Z',
        updatedAt: '2024-05-02T19:59:41.000Z',
      },
    ],
  },
  {
    id: '46c2adb8-05c6-464e-ae2e-dd878007524f',
    name: 'Robert & Wendy Duer',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><strong class="ql-size-large" style="color: rgb(29, 28, 29);"><u>Welcome Robert and Wendy! </u></strong></p><p><br></p><p><span style="color: rgb(29, 28, 29);" class="ql-size-large">I\'m t</span><em class="ql-size-large" style="color: rgb(29, 28, 29);">hrilled you\'ve chosen us to help y</em><span style="color: rgb(29, 28, 29);" class="ql-size-large">ou navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p><p><br></p><p><span style="color: rgb(29, 28, 29);" class="ql-size-large">Best,</span></p><p><span style="color: rgb(29, 28, 29);" class="ql-size-large">Shawn Brown</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-26T18:11:11.000Z',
    updatedAt: '2024-04-26T18:12:10.000Z',
    Activities: [
      {
        id: 473,
        reportId: '46c2adb8-05c6-464e-ae2e-dd878007524f',
        type: 'created',
        date: '2024-04-26T18:11:12.000Z',
        url: null,
        createdAt: '2024-04-26T18:11:12.000Z',
        updatedAt: '2024-04-26T18:11:12.000Z',
      },
    ],
  },
  {
    id: 'aaeadcd7-ae75-40b8-919c-e44631c626c9',
    name: 'John and Lisa',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-23T16:04:52.000Z',
    updatedAt: '2024-04-30T17:45:40.000Z',
    Activities: [
      {
        id: 470,
        reportId: 'aaeadcd7-ae75-40b8-919c-e44631c626c9',
        type: 'created',
        date: '2024-04-23T16:04:53.000Z',
        url: null,
        createdAt: '2024-04-23T16:04:53.000Z',
        updatedAt: '2024-04-23T16:04:53.000Z',
      },
    ],
  },
  {
    id: 'd70e1c18-8cd0-415a-9d4e-a6b8ffd62855',
    name: 'Will and Melissa Patton',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-23T16:03:12.000Z',
    updatedAt: '2024-04-30T17:46:02.000Z',
    Activities: [
      {
        id: 469,
        reportId: 'd70e1c18-8cd0-415a-9d4e-a6b8ffd62855',
        type: 'created',
        date: '2024-04-23T16:03:13.000Z',
        url: null,
        createdAt: '2024-04-23T16:03:13.000Z',
        updatedAt: '2024-04-23T16:03:13.000Z',
      },
    ],
  },
  {
    id: 'c2e5747f-1e43-4e34-89f5-8a94b47c6cfc',
    name: 'Rent VS Own',
    status: 'created',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-22T14:19:10.000Z',
    updatedAt: '2024-04-30T17:46:15.000Z',
    Activities: [
      {
        id: 467,
        reportId: 'c2e5747f-1e43-4e34-89f5-8a94b47c6cfc',
        type: 'created',
        date: '2024-04-22T14:19:11.000Z',
        url: null,
        createdAt: '2024-04-22T14:19:11.000Z',
        updatedAt: '2024-04-22T14:19:11.000Z',
      },
    ],
  },
  {
    id: '9db018d6-75f0-4581-9552-982c17323fae',
    name: 'Testing Report',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: '<p>Testing Closing Text!</p>',
    downPaymentPercentage: null,
    video: '<iframe width="560" height="315" src="https://www.youtube.com/embed/tgbNymZ7vqY?si=-qU-vzutlkZYM7zr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-19T19:01:21.000Z',
    updatedAt: '2024-04-22T19:18:04.000Z',
    Activities: [
      {
        id: 466,
        reportId: '9db018d6-75f0-4581-9552-982c17323fae',
        type: 'created',
        date: '2024-04-19T19:01:22.000Z',
        url: null,
        createdAt: '2024-04-19T19:01:22.000Z',
        updatedAt: '2024-04-19T19:01:22.000Z',
      },
    ],
  },
  {
    id: '3af1748e-9aed-40c1-befc-283c7bfbf989',
    name: 'Jack Williams ',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '1250000',
    createdAt: '2024-04-17T16:41:49.000Z',
    updatedAt: '2024-04-30T17:46:31.000Z',
    Activities: [
      {
        id: 453,
        reportId: '3af1748e-9aed-40c1-befc-283c7bfbf989',
        type: 'created',
        date: '2024-04-17T16:41:50.000Z',
        url: null,
        createdAt: '2024-04-17T16:41:50.000Z',
        updatedAt: '2024-04-17T16:41:50.000Z',
      },
    ],
  },
  {
    id: '8ee8f3ef-9c89-48a9-8c5c-0c876beaeaf4',
    name: 'Loan Term Investment Report',
    status: 'draft',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-16T16:57:20.000Z',
    updatedAt: '2024-04-30T17:46:47.000Z',
    Activities: [
      {
        id: 452,
        reportId: '8ee8f3ef-9c89-48a9-8c5c-0c876beaeaf4',
        type: 'created',
        date: '2024-04-16T16:57:21.000Z',
        url: null,
        createdAt: '2024-04-16T16:57:21.000Z',
        updatedAt: '2024-04-16T16:57:21.000Z',
      },
    ],
  },
  {
    id: '7ab37bb9-5fee-4d1c-ae4e-baf58b0733c0',
    name: 'Mike Caster ',
    status: 'created',
    viewedAt: null,
    editedAt: null,
    approvedAt: null,
    hoiquoteAt: null,
    closingText: null,
    downPaymentPercentage: null,
    video: null,
    loanPointsPercentage: null,
    homeInsurancePercentage: null,
    welcome_message:
      '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership. We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions about your mortgage.</span></p><p><br></p><p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time, whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in more detail. We\'re here to support you and make your homeownership dream a reality.</span></p>',
    settings_logo: null,
    rentVsOwnValue: '800000',
    createdAt: '2024-04-16T16:56:37.000Z',
    updatedAt: '2024-04-30T17:47:05.000Z',
    Activities: [
      {
        id: 451,
        reportId: '7ab37bb9-5fee-4d1c-ae4e-baf58b0733c0',
        type: 'created',
        date: '2024-04-16T16:56:38.000Z',
        url: null,
        createdAt: '2024-04-16T16:56:38.000Z',
        updatedAt: '2024-04-16T16:56:38.000Z',
      },
    ],
  },
];


export const SETTINGS_DATA_WITH_TYPE = {
  purchase: {
    "marketNotification": [
      {
        "id": 1217,
        "userId": 33,
        "text": "Mortgage Rates Notification",
        "order": 1,
        "active": true,
        "type": "market_rates_notification",
        "name": "mortgageRates",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      }
    ],
    "generalNotification": [
      {
        "id": 1218,
        "userId": 33,
        "text": "Notify when borrower open report",
        "order": 1,
        "active": true,
        "type": "general_notification",
        "name": "notifyOpenReport",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1219,
        "userId": 33,
        "text": "Notify when borrower edit report",
        "order": 2,
        "active": true,
        "type": "general_notification",
        "name": "notifyBorrowerEditOpenReport",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1221,
        "userId": 33,
        "text": "Request insurance",
        "order": 3,
        "active": true,
        "type": "general_notification",
        "name": "requestInsurance",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1220,
        "userId": 33,
        "text": "Email me when a new referral is received",
        "order": 4,
        "active": true,
        "type": "general_notification",
        "name": "referralIsReceived",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      }
    ],
    "tableView": [
      {
        "id": 1222,
        "userId": 33,
        "text": "Purchase Price",
        "order": 1,
        "active": true,
        "type": "table_view",
        "name": "purchasePrice",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1224,
        "userId": 33,
        "text": "Loan Amount",
        "order": 2,
        "active": true,
        "type": "table_view",
        "name": "loanAmount",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1223,
        "userId": 33,
        "text": "Down Payment",
        "order": 3,
        "active": true,
        "type": "table_view",
        "name": "downPayment",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1225,
        "userId": 33,
        "text": "Loan Term",
        "order": 4,
        "active": true,
        "type": "table_view",
        "name": "loanPeriodInYears",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1226,
        "userId": 33,
        "text": "Interest Rate",
        "order": 5,
        "active": true,
        "type": "table_view",
        "name": "interestRate",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1227,
        "userId": 33,
        "text": "APR",
        "order": 6,
        "active": true,
        "type": "table_view",
        "name": "apr",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1228,
        "userId": 33,
        "text": "Principal and Interest",
        "order": 7,
        "active": true,
        "type": "table_view",
        "name": "principalInterest",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1229,
        "userId": 33,
        "text": "Property Taxes",
        "order": 8,
        "active": true,
        "type": "table_view",
        "name": "propertyTaxes",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1230,
        "userId": 33,
        "text": "Homeowners Insurance",
        "order": 9,
        "active": true,
        "type": "table_view",
        "name": "homeInsurance",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1231,
        "userId": 33,
        "text": "Mortgage Insurance",
        "order": 10,
        "active": false,
        "type": "table_view",
        "name": "pmi",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1232,
        "userId": 33,
        "text": "HOA Dues",
        "order": 11,
        "active": true,
        "type": "table_view",
        "name": "hoaDues",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1233,
        "userId": 33,
        "text": "Total",
        "order": 12,
        "active": true,
        "type": "table_view",
        "name": "total",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1234,
        "userId": 33,
        "text": "Loan Points",
        "order": 13,
        "active": true,
        "type": "table_view",
        "name": "loanPoints",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1235,
        "userId": 33,
        "text": "Closing Costs",
        "order": 14,
        "active": true,
        "type": "table_view",
        "name": "closingCosts",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1236,
        "userId": 33,
        "text": "Upfront Ins. Premium",
        "order": 15,
        "active": false,
        "type": "table_view",
        "name": "uip",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1237,
        "userId": 33,
        "text": "Supplemental Tax Bill",
        "order": 16,
        "active": true,
        "type": "table_view",
        "name": "supplyTaxBill",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1238,
        "userId": 33,
        "text": "Rate Shift Impact",
        "order": 17,
        "active": true,
        "type": "table_view",
        "name": "interestChange",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1239,
        "userId": 33,
        "text": "Rental Value",
        "order": 18,
        "active": true,
        "type": "table_view",
        "name": "rentalValue",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1240,
        "userId": 33,
        "text": "Loan Details",
        "order": 19,
        "active": false,
        "type": "table_view",
        "name": "loanDetails",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1241,
        "userId": 33,
        "text": "Cash Out",
        "order": 20,
        "active": false,
        "type": "table_view",
        "name": "cashOut",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      }
    ],
    "reportView": [
      {
        "id": 1242,
        "userId": 33,
        "text": "Welcome Message",
        "order": 0,
        "active": false,
        "type": "report_view",
        "name": "welcome_message",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1243,
        "userId": 33,
        "text": "Video",
        "order": 1,
        "active": false,
        "type": "report_view",
        "name": "vidoeWalk",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1244,
        "userId": 33,
        "text": "Income Tax Advantage of Homeownership",
        "order": 2,
        "active": true,
        "type": "report_view",
        "name": "taxAdvantage",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1245,
        "userId": 33,
        "text": "Long-Term Investments Numbers",
        "order": 3,
        "active": true,
        "type": "report_view",
        "name": "longTermInvestmentsNumbers",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1251,
        "userId": 33,
        "text": "Savings for Increasing Monthly Mortgage Payment",
        "order": 4,
        "active": false,
        "type": "report_view",
        "name": "savingForIncreasing",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1246,
        "userId": 33,
        "text": "Closing Costs",
        "order": 5,
        "active": true,
        "type": "report_view",
        "name": "closingCostsEstimates",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1248,
        "userId": 33,
        "text": "Break-Even on Paying Loan Points",
        "order": 6,
        "active": true,
        "type": "report_view",
        "name": "breakEvenPoint",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1247,
        "userId": 33,
        "text": "Temporary Interest Rate Buydown",
        "order": 7,
        "active": true,
        "type": "report_view",
        "name": "buyDownCalculator",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1250,
        "userId": 33,
        "text": "Interest Savings for Biweekly Payments",
        "order": 8,
        "active": true,
        "type": "report_view",
        "name": "interestSavings",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1252,
        "userId": 33,
        "text": "Homebuying Timeline",
        "order": 9,
        "active": true,
        "type": "report_view",
        "name": "howLongTakeToBuy",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1253,
        "userId": 33,
        "text": "Rental Analysis",
        "order": 10,
        "active": true,
        "type": "report_view",
        "name": "rentalAnalysis",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1249,
        "userId": 33,
        "text": "Rent vs Own",
        "order": 11,
        "active": true,
        "type": "report_view",
        "name": "rentOrOwn",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1254,
        "userId": 33,
        "text": "Referral Link",
        "order": 12,
        "active": true,
        "type": "report_view",
        "name": "referral",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      },
      {
        "id": 1255,
        "userId": 33,
        "text": "Message",
        "order": 13,
        "active": false,
        "type": "report_view",
        "name": "closingText",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:36:30.000Z"
      }
    ]
  },
  refinance: {
    "marketNotification": [
      {
        "id": 1217,
        "userId": 33,
        "text": "Mortgage Rates Notification",
        "order": 1,
        "active": true,
        "type": "market_rates_notification",
        "name": "mortgageRates",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      }
    ],
    "generalNotification": [
      {
        "id": 1218,
        "userId": 33,
        "text": "Notify when borrower open report",
        "order": 1,
        "active": true,
        "type": "general_notification",
        "name": "notifyOpenReport",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1219,
        "userId": 33,
        "text": "Notify when borrower edit report",
        "order": 2,
        "active": true,
        "type": "general_notification",
        "name": "notifyBorrowerEditOpenReport",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1221,
        "userId": 33,
        "text": "Request insurance",
        "order": 3,
        "active": true,
        "type": "general_notification",
        "name": "requestInsurance",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      },
      {
        "id": 1220,
        "userId": 33,
        "text": "Email me when a new referral is received",
        "order": 4,
        "active": true,
        "type": "general_notification",
        "name": "referralIsReceived",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-21T15:48:31.000Z"
      }
    ],
    "tableView": [
      {
        "id": 1222,
        "userId": 33,
        "text": "Purchase Price",
        "order": 1,
        "active": false,
        "type": "table_view",
        "name": "purchasePrice",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1224,
        "userId": 33,
        "text": "Loan Amount",
        "order": 2,
        "active": true,
        "type": "table_view",
        "name": "loanAmount",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1223,
        "userId": 33,
        "text": "Down Payment",
        "order": 3,
        "active": false,
        "type": "table_view",
        "name": "downPayment",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1225,
        "userId": 33,
        "text": "Loan Term",
        "order": 4,
        "active": true,
        "type": "table_view",
        "name": "loanPeriodInYears",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1226,
        "userId": 33,
        "text": "Interest Rate",
        "order": 5,
        "active": true,
        "type": "table_view",
        "name": "interestRate",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1227,
        "userId": 33,
        "text": "APR",
        "order": 6,
        "active": true,
        "type": "table_view",
        "name": "apr",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1228,
        "userId": 33,
        "text": "Principal and Interest",
        "order": 7,
        "active": true,
        "type": "table_view",
        "name": "principalInterest",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1229,
        "userId": 33,
        "text": "Property Taxes",
        "order": 8,
        "active": true,
        "type": "table_view",
        "name": "propertyTaxes",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1230,
        "userId": 33,
        "text": "Homeowners Insurance",
        "order": 9,
        "active": true,
        "type": "table_view",
        "name": "homeInsurance",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1231,
        "userId": 33,
        "text": "Mortgage Insurance",
        "order": 10,
        "active": false,
        "type": "table_view",
        "name": "pmi",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1232,
        "userId": 33,
        "text": "HOA Dues",
        "order": 11,
        "active": true,
        "type": "table_view",
        "name": "hoaDues",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1233,
        "userId": 33,
        "text": "Total",
        "order": 12,
        "active": true,
        "type": "table_view",
        "name": "total",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1234,
        "userId": 33,
        "text": "Loan Points",
        "order": 13,
        "active": true,
        "type": "table_view",
        "name": "loanPoints",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1241,
        "userId": 33,
        "text": "Cash Out",
        "order": 14,
        "active": true,
        "type": "table_view",
        "name": "cashOut",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1235,
        "userId": 33,
        "text": "Closing Costs",
        "order": 15,
        "active": true,
        "type": "table_view",
        "name": "closingCosts",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1236,
        "userId": 33,
        "text": "Upfront Ins. Premium",
        "order": 16,
        "active": false,
        "type": "table_view",
        "name": "uip",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1237,
        "userId": 33,
        "text": "Supplemental Tax Bill",
        "order": 17,
        "active": false,
        "type": "table_view",
        "name": "supplyTaxBill",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1238,
        "userId": 33,
        "text": "Rate Shift Impact",
        "order": 18,
        "active": true,
        "type": "table_view",
        "name": "interestChange",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1239,
        "userId": 33,
        "text": "Rental Value",
        "order": 19,
        "active": false,
        "type": "table_view",
        "name": "rentalValue",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1240,
        "userId": 33,
        "text": "Loan Details",
        "order": 20,
        "active": false,
        "type": "table_view",
        "name": "loanDetails",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      }
    ],
    "reportView": [
      {
        "id": 1242,
        "userId": 33,
        "text": "Welcome Message",
        "order": 0,
        "active": false,
        "type": "report_view",
        "name": "welcome_message",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1243,
        "userId": 33,
        "text": "Video",
        "order": 1,
        "active": false,
        "type": "report_view",
        "name": "vidoeWalk",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1251,
        "userId": 33,
        "text": "Savings for Increasing Monthly Mortgage Payment",
        "order": 2,
        "active": true,
        "type": "report_view",
        "name": "savingForIncreasing",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1244,
        "userId": 33,
        "text": "Income Tax Advantage of Homeownership",
        "order": 3,
        "active": true,
        "type": "report_view",
        "name": "taxAdvantage",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1248,
        "userId": 33,
        "text": "Break-Even on Paying Loan Points",
        "order": 4,
        "active": true,
        "type": "report_view",
        "name": "breakEvenPoint",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1247,
        "userId": 33,
        "text": "Temporary Interest Rate Buydown",
        "order": 5,
        "active": true,
        "type": "report_view",
        "name": "buyDownCalculator",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1250,
        "userId": 33,
        "text": "Interest Savings for Biweekly Payments",
        "order": 6,
        "active": true,
        "type": "report_view",
        "name": "interestSavings",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1254,
        "userId": 33,
        "text": "Referral Link",
        "order": 12,
        "active": true,
        "type": "report_view",
        "name": "referral",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1245,
        "userId": 33,
        "text": "Long-Term Investments Numbers",
        "order": 13,
        "active": false,
        "type": "report_view",
        "name": "longTermInvestmentsNumbers",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1246,
        "userId": 33,
        "text": "Closing Costs",
        "order": 14,
        "active": false,
        "type": "report_view",
        "name": "closingCostsEstimates",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1252,
        "userId": 33,
        "text": "Homebuying Timeline",
        "order": 15,
        "active": false,
        "type": "report_view",
        "name": "howLongTakeToBuy",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1253,
        "userId": 33,
        "text": "Rental Analysis",
        "order": 16,
        "active": false,
        "type": "report_view",
        "name": "rentalAnalysis",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1249,
        "userId": 33,
        "text": "Rent vs Own",
        "order": 17,
        "active": false,
        "type": "report_view",
        "name": "rentOrOwn",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      },
      {
        "id": 1255,
        "userId": 33,
        "text": "Message",
        "order": 18,
        "active": false,
        "type": "report_view",
        "name": "closingText",
        "createdAt": "2024-08-15T09:20:29.000Z",
        "updatedAt": "2024-08-22T13:44:29.000Z"
      }
    ]
  }
}

export const NOTIFICATIONS_DATA: INotificationItem[] = [
  {
    id: 1,
    title: 'Notification',
    description: 'Your report ROBERT AND WENDY DUER has been viewed',
    type: 'report',
    createdAt: '2024-04-08T05:46:05.000Z',
  },
  {
    id: 2,
    title: 'Notification',
    description: 'Your report ROBERT AND WENDY DUER has been viewed',
    type: 'report',
    createdAt: '2024-04-08T05:46:14.000Z',
  },
  {
    id: 3,
    title: 'Notification',
    description: 'Your report ROBERT AND WENDY DUER has been viewed',
    type: 'activity',
    createdAt: '2024-04-08T05:46:50.000Z',
  },
  {
    id: 4,
    title: 'Notification',
    description: 'Your report ROBERT AND WENDY DUER has been viewed',
    type: 'system',
    createdAt: '2024-04-08T05:49:34.000Z',
  },
  {
    id: 5,
    title: 'Notification',
    description: 'Your report ROBERT AND WENDY DUER has been viewed',
    type: 'activity',
    createdAt: '2024-04-08T07:05:38.000Z',
  },
];

export const PLAN_DETAILS = {
  month: [
    {
      id: 'price_1Ou95nAP5k49x0bIM4ZJ7MPh',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 12900,
      amount_decimal: '12900',
      billing_scheme: 'per_unit',
      created: 1710402767,
      currency: 'usd',
      interval: 'month',
      interval_count: 1,
      livemode: true,
      metadata: {
        'Breaking News': 'true',
        'Content Scripts': 'true',
        Markets: 'true',
        Notifications: 'true',
        breaking_news: 'true',
        ceo_cell_phone: 'true',
        content_scripts: 'true',
        early_access_new_features: 'true',
        market_charts: 'true',
        market_rate_lock_alerts: 'true',
        mortgage_presentation_tools: 'true',
        premium_support: 'true',
        property_data_copilot: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Premium Intelligence Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
    {
      id: 'price_1Ou93uAP5k49x0bIbIfZIQO2',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 9900,
      amount_decimal: '9900',
      billing_scheme: 'per_unit',
      created: 1710402650,
      currency: 'usd',
      interval: 'month',
      interval_count: 1,
      livemode: true,
      metadata: {
        mortgage_presentation_tools: 'true',
        property_data_copilot: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Standard Insights Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
    {
      id: 'price_1Ou90fAP5k49x0bI9t3AssEB',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 4900,
      amount_decimal: '4900',
      billing_scheme: 'per_unit',
      created: 1710402449,
      currency: 'usd',
      interval: 'month',
      interval_count: 1,
      livemode: true,
      metadata: {
        mortgage_presentation_tools: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Basic Tools Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
  ],
  year: [
    {
      id: 'price_1Ou9GuAP5k49x0bIsdoDEcte',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 123840,
      amount_decimal: '123840',
      billing_scheme: 'per_unit',
      created: 1710403456,
      currency: 'usd',
      interval: 'year',
      interval_count: 1,
      livemode: true,
      metadata: {
        'Breaking News': 'true',
        'Content Scripts': 'true',
        Markets: 'true',
        Notifications: 'true',
        breaking_news: 'true',
        ceo_cell_phone: 'true',
        content_scripts: 'true',
        early_access_new_features: 'true',
        market_charts: 'true',
        market_rate_lock_alerts: 'true',
        mortgage_presentation_tools: 'true',
        premium_support: 'true',
        property_data_copilot: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Premium Intelligence Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
    {
      id: 'price_1Ou9BOAP5k49x0bI2zlKE1R1',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 95040,
      amount_decimal: '95040',
      billing_scheme: 'per_unit',
      created: 1710403114,
      currency: 'usd',
      interval: 'year',
      interval_count: 1,
      livemode: true,
      metadata: {
        mortgage_presentation_tools: 'true',
        property_data_copilot: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Standard Insights Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
    {
      id: 'price_1Ou99vAP5k49x0bIou4B0d2i',
      object: 'plan',
      active: true,
      aggregate_usage: null,
      amount: 47000,
      amount_decimal: '47000',
      billing_scheme: 'per_unit',
      created: 1710403023,
      currency: 'usd',
      interval: 'year',
      interval_count: 1,
      livemode: true,
      metadata: {
        mortgage_presentation_tools: 'true',
        unlimited_reports: 'true',
      },
      meter: null,
      nickname: 'Basic Tools Plan',
      product: 'prod_OtknQYc4sQa8j8',
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: 'licensed',
    },
  ],
};

export const SUBCRIPTION_DATA = {
  id: 'sub_1PGMPBAP5k49x0bIsEbUvMVN',
  object: 'subscription',
  application: null,
  application_fee_percent: null,
  automatic_tax: {
    enabled: false,
    liability: null,
  },
  billing_cycle_anchor: 1716906757,
  billing_cycle_anchor_config: null,
  billing_thresholds: null,
  cancel_at: null,
  cancel_at_period_end: false,
  canceled_at: null,
  cancellation_details: {
    comment: null,
    feedback: null,
    reason: null,
  },
  collection_method: 'charge_automatically',
  created: 1715697157,
  currency: 'usd',
  current_period_end: 1716906757,
  current_period_start: 1715697157,
  customer: 'cus_Q6ZWRLQ2m95YEw',
  days_until_due: null,
  default_payment_method: 'pm_1PGMP5AP5k49x0bI0MzQExZM',
  default_source: null,
  default_tax_rates: [],
  description: null,
  discount: null,
  discounts: [],
  ended_at: null,
  invoice_settings: {
    account_tax_ids: null,
    issuer: {
      type: 'self',
    },
  },
  items: {
    object: 'list',
    data: [
      {
        id: 'si_Q6ZYDXqqB4y3Lh',
        object: 'subscription_item',
        billing_thresholds: null,
        created: 1715697157,
        discounts: [],
        metadata: {},
        plan: {
          id: 'price_1NdwrcAP5k49x0bIDt9iupOA',
          object: 'plan',
          active: true,
          aggregate_usage: null,
          amount: 6900,
          amount_decimal: '99900',
          billing_scheme: 'per_unit',
          created: 1691766176,
          currency: 'usd',
          interval: 'month',
          interval_count: 1,
          livemode: false,
          metadata: {
            '1': 'Unlimited reports',
            '2': 'No property data integration*',
            '3': 'Advanced option for you',
            'Breaking News': 'true',
            'Content Scripts': 'true',
            Markets: 'true',
            Notifications: 'true',
            breaking_news: 'true',
            ceo_cell_phone: 'true',
            content_scripts: 'true',
            early_access_new_features: 'true',
            market_charts: 'true',
            market_rate_lock_alerts: 'true',
            mortgage_presentation_tools: 'true',
            premium_support: 'true',
            property_data_copilot: 'true',
            unlimited_reports: 'true',
          },
          meter: null,
          nickname: 'Monthly plan',
          product: 'prod_OQoU6UJ78Xq52G',
          tiers_mode: null,
          transform_usage: null,
          trial_period_days: null,
          usage_type: 'licensed',
        },
        price: {
          id: 'price_1NdwrcAP5k49x0bIDt9iupOA',
          object: 'price',
          active: true,
          billing_scheme: 'per_unit',
          created: 1691766176,
          currency: 'usd',
          custom_unit_amount: null,
          livemode: false,
          lookup_key: null,
          metadata: {
            '1': 'Unlimited reports',
            '2': 'No property data integration*',
            '3': 'Advanced option for you',
            'Breaking News': 'true',
            'Content Scripts': 'true',
            Markets: 'true',
            Notifications: 'true',
            breaking_news: 'true',
            ceo_cell_phone: 'true',
            content_scripts: 'true',
            early_access_new_features: 'true',
            market_charts: 'true',
            market_rate_lock_alerts: 'true',
            mortgage_presentation_tools: 'true',
            premium_support: 'true',
            property_data_copilot: 'true',
            unlimited_reports: 'true',
          },
          nickname: 'Monthly plan',
          product: 'prod_OQoU6UJ78Xq52G',
          recurring: {
            aggregate_usage: null,
            interval: 'month',
            interval_count: 1,
            meter: null,
            trial_period_days: null,
            usage_type: 'licensed',
          },
          tax_behavior: 'unspecified',
          tiers_mode: null,
          transform_quantity: null,
          type: 'recurring',
          unit_amount: 99900,
          unit_amount_decimal: '99900',
        },
        quantity: 1,
        subscription: 'sub_1PGMPBAP5k49x0bIsEbUvMVN',
        tax_rates: [],
      },
    ],
    has_more: false,
    total_count: 1,
    url: '/v1/subscription_items?subscription=sub_1PGMPBAP5k49x0bIsEbUvMVN',
  },
  latest_invoice: 'in_1PGMPBAP5k49x0bIszo7wGqW',
  livemode: false,
  metadata: {},
  next_pending_invoice_item_invoice: null,
  on_behalf_of: null,
  pause_collection: null,
  payment_settings: {
    payment_method_options: null,
    payment_method_types: null,
    save_default_payment_method: 'off',
  },
  pending_invoice_item_interval: null,
  pending_setup_intent: null,
  pending_update: null,
  plan: {
    id: 'price_1NdwrcAP5k49x0bIDt9iupOA',
    object: 'plan',
    active: true,
    aggregate_usage: null,
    amount: 6900,
    amount_decimal: '6900',
    billing_scheme: 'per_unit',
    created: 1691766176,
    currency: 'usd',
    interval: 'month',
    interval_count: 1,
    livemode: false,
    metadata: {
      '1': 'Unlimited reports',
      '2': 'No property data integration*',
      '3': 'Advanced option for you',
      'Breaking News': 'true',
      'Content Scripts': 'true',
      Markets: 'true',
      Notifications: 'true',
      breaking_news: 'true',
      ceo_cell_phone: 'true',
      content_scripts: 'true',
      early_access_new_features: 'true',
      market_charts: 'true',
      market_rate_lock_alerts: 'true',
      mortgage_presentation_tools: 'true',
      premium_support: 'true',
      property_data_copilot: 'true',
      unlimited_reports: 'true',
    },
    meter: null,
    nickname: 'Monthly Plan',
    product: 'prod_OQoU6UJ78Xq52G',
    tiers_mode: null,
    transform_usage: null,
    trial_period_days: null,
    usage_type: 'licensed',
  },
  quantity: 1,
  schedule: null,
  start_date: 1715697157,
  status: 'trialing',
  test_clock: null,
  transfer_data: null,
  trial_end: 1716906757,
  trial_settings: {
    end_behavior: {
      missing_payment_method: 'create_invoice',
    },
  },
  trial_start: 1715697157,
};

export const PAYMENT_METHOD: Stripe.PaymentMethod[] = [
  {
    id: 'pm_2OuDkXAP5k49x0bIGBZGF0gq',
    object: 'payment_method',
    billing_details: {
      address: {
        city: null,
        country: 'US',
        line1: null,
        line2: null,
        postal_code: '123312',
        state: null,
      },
      email: null,
      name: 'John Doe',
      phone: null,
    },
    card: {
      brand: 'visa',
      checks: {
        address_line1_check: null,
        address_postal_code_check: 'unchecked',
        cvc_check: 'unchecked',
      },
      country: 'US',
      exp_month: 8,
      exp_year: 2026,
      fingerprint: 'cYw3THOXIsTQ93mP',
      funding: 'credit',
      last4: '4242',
      networks: {
        available: ['visa'],
        preferred: null,
      },
      three_d_secure_usage: {
        supported: true,
      },
      wallet: null,
    },
    created: 1710420669,
    customer: 'cus_Pjh7aYNBRKciqy',
    livemode: true,
    metadata: {},
    radar_options: {},
    type: 'card',
  },
  {
    id: 'pm_1OuDkXAP5k49x0bIGBZGF0gq',
    object: 'payment_method',
    billing_details: {
      address: {
        city: null,
        country: 'US',
        line1: null,
        line2: null,
        postal_code: '321123',
        state: null,
      },
      email: null,
      name: 'John Doe',
      phone: null,
    },
    card: {
      brand: 'mastercard',
      checks: {
        address_line1_check: null,
        address_postal_code_check: 'unchecked',
        cvc_check: 'unchecked',
      },
      country: 'US',
      exp_month: 8,
      exp_year: 2026,
      fingerprint: 'cYw3THOXIsTQ93mP',
      funding: 'debit',
      last4: '2424',
      networks: {
        available: ['mastercard'],
        preferred: null,
      },
      three_d_secure_usage: {
        supported: true,
      },
      wallet: null,
    },
    created: 1710420669,
    customer: 'cus_Pjh7aYNBRKciqy',
    livemode: true,
    metadata: {},
    radar_options: {},
    type: 'card',
  },
];

export const PLANID_DATA: Stripe.Plan = {
  id: 'price_1NdwrcAP5k49x0bIDt9iupOA',
  object: 'plan',
  active: true,
  aggregate_usage: null,
  amount: 6900,
  amount_decimal: '69000',
  billing_scheme: 'per_unit',
  created: 1691766176,
  currency: 'usd',
  interval: 'month',
  interval_count: 1,
  livemode: false,
  metadata: {
    '1': 'Unlimited reports',
    '2': 'No property data integration*',
    '3': 'Advanced option for you',
    'Breaking News': 'true',
    'Content Scripts': 'true',
    Markets: 'true',
    Notifications: 'true',
    breaking_news: 'true',
    ceo_cell_phone: 'true',
    content_scripts: 'true',
    early_access_new_features: 'true',
    market_charts: 'true',
    market_rate_lock_alerts: 'true',
    mortgage_presentation_tools: 'true',
    premium_support: 'true',
    property_data_copilot: 'true',
    unlimited_reports: 'true',
  },
  nickname: 'Monthly plan',
  product: 'prod_OQoU6UJ78Xq52G',
  tiers_mode: null,
  transform_usage: null,
  trial_period_days: null,
  usage_type: 'licensed',
};

export const USER_DATA = {
  id: 84,
  firstName: 'John ',
  lastName: 'Doe',
  email: 'newUser@example.com',
  phoneNumber: '(012) 345-6789',
  avatar: null,
  companyName: 'John Company',
  websiteLink: 'www.example.com',
  nmls: null,
  address: '5814 Greenfelder Drive, Thustad, MT 43688',
  logo: null,
  videoUrl: null,
  planId: 'price_1Ou95nAP5k49x0bIM4ZJ7MPh',
  customerId: 'cus_Q8hmHpzyaf9GxM',
  balance: 0,
  userId: null,
  createdAt: '2024-05-20 07:10:45',
  updatedAt: '2024-05-20 07:14:12',
  subscriptionId: 'sub_1PIQNBAP5k49x0bIKiVSve5o',
  referral: null,
  reference: '7f70028b-f1aa-4ff8-95c3-62879e712851',
  nmlsId: '753453',
  forgotPasswordCode: null,
  closingText: null,
  type: 'loanOfficer',
  isPremium: 1,
  isActive: 1,
  welcome_message:
    '<p><span class="ql-size-large" style="color: rgb(29, 28, 29);">Welcome! I\'m thrilled you\'ve chosen us to help you navigate the exciting journey of homeownership.\n            We\'re dedicated to finding you the perfect mortgage that meets your unique needs and budget.</span>\n        </p>\n        <br />\n        <p>\n            <span class="ql-size-large" style="color: rgb(29, 28, 29);">I\'m happy to announce that your personalized mortgage report is\n                ready! This report is packed with valuable insights and information tailored specifically to your financial situation. It\n                outlines various loan options, potential interest rates, and estimated monthly payments, helping you make informed decisions\n                about your mortgage.</span>\n        </p>\n        <br />\n        <p>\n            <span class="ql-size-large" style="color: rgb(29, 28, 29);">Feel free to reach out at any time,\n                whether you have questions about the report, need assistance with specific elements, or simply want to discuss your options in\n                more detail. We\'re here to support you and make your homeownership dream a reality.</span>\n        </p>\n        ',
  settings_logo: null,
  premissions: null,
  permissions:
    '{"1":"Unlimited reports","2":"No property data integration*","3":"Advanced option for you","Breaking News":"true","Content Scripts":"true","Markets":"true","Notifications":"true","breaking_news":"true","ceo_cell_phone":"true","content_scripts":"true","early_access_new_features":"true","market_charts":"true","market_rate_lock_alerts":"true","mortgage_presentation_tools":"true","premium_support":"true","property_data_copilot":"true","unlimited_reports":"true"}',
};

export const REFERAL_DATA = [
  {
    id: 1,
    fullName: 'John Doe',
    email: 'john.doe@example.com',
    phoneNumber: '123-456-7890',
    comment: 'Looking forward to the report.',
    updatedAt: '2023-05-20T12:00:00Z',
    createdAt: '2023-05-18T08:00:00Z',
    Report: { name: 'Annual Report' },
    reportId: 1,
    status: 'new',
  },
  {
    id: 2,
    fullName: 'Jane Smith',
    email: 'jane.smith@example.com',
    phoneNumber: '098-765-4321',
    comment: 'Please send the report ASAP.',
    updatedAt: '2023-05-19T10:00:00Z',
    createdAt: '2023-05-17T09:00:00Z',
    Report: { name: 'Financial Report' },
    reportId: 2,
    status: 'contacted',
  },
  {
    id: 3,
    fullName: 'Alice Johnson',
    email: 'alice.johnson@example.com',
    phoneNumber: '234-567-8901',
    comment: 'When can I expect the report?',
    updatedAt: '2023-05-18T15:30:00Z',
    createdAt: '2023-05-16T07:45:00Z',
    Report: { name: 'Quarterly Report' },
    reportId: 3,
    status: 'new',
  },
  {
    id: 4,
    fullName: 'Bob Brown',
    email: 'bob.brown@example.com',
    phoneNumber: '345-678-9012',
    comment: 'I have some questions about the report.',
    updatedAt: '2023-05-17T14:20:00Z',
    createdAt: '2023-05-15T10:30:00Z',
    Report: { name: 'Monthly Report' },
    reportId: 4,
    status: 'contacted',
  },
];

export const MARKET_RATE_30 = [
  {
    "open": 110.8125,
    "high": 111.140625,
    "low": 110.8125,
    "close": 111.125,
    "priceDate": "2020-10-30T00:00:00-04:00",
    "ticks": 637396128000000000,
    "epochTime": 1604016000,
    "hasValue": true,
    "time": "2020-10-30"
  },
  {
    "open": 110.84375,
    "high": 110.84375,
    "low": 110.796875,
    "close": 110.8125,
    "priceDate": "2020-11-02T00:00:00-05:00",
    "ticks": 637398720000000000,
    "epochTime": 1604275200,
    "hasValue": true,
    "time": "2020-11-02"
  },
  {
    "open": 110.859375,
    "high": 110.890625,
    "low": 110.8125,
    "close": 110.859375,
    "priceDate": "2020-11-03T00:00:00-05:00",
    "ticks": 637399584000000000,
    "epochTime": 1604361600,
    "hasValue": true,
    "time": "2020-11-03"
  },
  {
    "open": 111.015625,
    "high": 111.0625,
    "low": 110.984375,
    "close": 111.015625,
    "priceDate": "2020-11-04T00:00:00-05:00",
    "ticks": 637400448000000000,
    "epochTime": 1604448000,
    "hasValue": true,
    "time": "2020-11-04"
  },
  {
    "open": 110.8125,
    "high": 111.046875,
    "low": 110.78125,
    "close": 111.015625,
    "priceDate": "2020-11-05T00:00:00-05:00",
    "ticks": 637401312000000000,
    "epochTime": 1604534400,
    "hasValue": true,
    "time": "2020-11-05"
  },
  {
    "open": 110.796875,
    "high": 110.828125,
    "low": 110.734375,
    "close": 110.796875,
    "priceDate": "2020-11-06T00:00:00-05:00",
    "ticks": 637402176000000000,
    "epochTime": 1604620800,
    "hasValue": true,
    "time": "2020-11-06"
  },
  {
    "open": 110.78125,
    "high": 111.234375,
    "low": 110.78125,
    "close": 111.21875,
    "priceDate": "2020-11-09T00:00:00-05:00",
    "ticks": 637404768000000000,
    "epochTime": 1604880000,
    "hasValue": true,
    "time": "2020-11-09"
  },
  {
    "open": 110.8125,
    "high": 110.828125,
    "low": 110.734375,
    "close": 110.75,
    "priceDate": "2020-11-10T00:00:00-05:00",
    "ticks": 637405632000000000,
    "epochTime": 1604966400,
    "hasValue": true,
    "time": "2020-11-10"
  },
  {
    "open": 110.921875,
    "high": 111,
    "low": 110.90625,
    "close": 110.921875,
    "priceDate": "2020-11-12T00:00:00-05:00",
    "ticks": 637407360000000000,
    "epochTime": 1605139200,
    "hasValue": true,
    "time": "2020-11-12"
  },
  {
    "open": 110.96875,
    "high": 111,
    "low": 110.921875,
    "close": 110.921875,
    "priceDate": "2020-11-13T00:00:00-05:00",
    "ticks": 637408224000000000,
    "epochTime": 1605225600,
    "hasValue": true,
    "time": "2020-11-13"
  },
  {
    "open": 111.46875,
    "high": 111.53125,
    "low": 111.390625,
    "close": 111.421875,
    "priceDate": "2020-11-16T00:00:00-05:00",
    "ticks": 637410816000000000,
    "epochTime": 1605484800,
    "hasValue": true,
    "time": "2020-11-16"
  },
  {
    "open": 111.03125,
    "high": 111.046875,
    "low": 110.78125,
    "close": 110.8125,
    "priceDate": "2020-11-17T00:00:00-05:00",
    "ticks": 637411680000000000,
    "epochTime": 1605571200,
    "hasValue": true,
    "time": "2020-11-17"
  },
  {
    "open": 111.09375,
    "high": 111.25,
    "low": 111,
    "close": 111.234375,
    "priceDate": "2020-11-18T00:00:00-05:00",
    "ticks": 637412544000000000,
    "epochTime": 1605657600,
    "hasValue": true,
    "time": "2020-11-18"
  },
  {
    "open": 111.0625,
    "high": 111.3125,
    "low": 111.0625,
    "close": 111.3125,
    "priceDate": "2020-11-19T00:00:00-05:00",
    "ticks": 637413408000000000,
    "epochTime": 1605744000,
    "hasValue": true,
    "time": "2020-11-19"
  },
  {
    "open": 111.28125,
    "high": 111.703125,
    "low": 111.234375,
    "close": 111.609375,
    "priceDate": "2020-11-20T00:00:00-05:00",
    "ticks": 637414272000000000,
    "epochTime": 1605830400,
    "hasValue": true,
    "time": "2020-11-20"
  },
  {
    "open": 111.25,
    "high": 111.515625,
    "low": 111.25,
    "close": 111.5,
    "priceDate": "2020-11-23T00:00:00-05:00",
    "ticks": 637416864000000000,
    "epochTime": 1606089600,
    "hasValue": true,
    "time": "2020-11-23"
  },
  {
    "open": 111.25,
    "high": 111.390625,
    "low": 111.25,
    "close": 111.375,
    "priceDate": "2020-11-24T00:00:00-05:00",
    "ticks": 637417728000000000,
    "epochTime": 1606176000,
    "hasValue": true,
    "time": "2020-11-24"
  },
  {
    "open": 111.25,
    "high": 111.6875,
    "low": 111.25,
    "close": 111.671875,
    "priceDate": "2020-11-25T00:00:00-05:00",
    "ticks": 637418592000000000,
    "epochTime": 1606262400,
    "hasValue": true,
    "time": "2020-11-25"
  },
  {
    "open": 111.25,
    "high": 111.90625,
    "low": 111.25,
    "close": 111.90625,
    "priceDate": "2020-11-27T00:00:00-05:00",
    "ticks": 637420320000000000,
    "epochTime": 1606435200,
    "hasValue": true,
    "time": "2020-11-27"
  },
  {
    "open": 111.6875,
    "high": 111.8125,
    "low": 111.6875,
    "close": 111.8125,
    "priceDate": "2020-11-30T00:00:00-05:00",
    "ticks": 637422912000000000,
    "epochTime": 1606694400,
    "hasValue": true,
    "time": "2020-11-30"
  },
  {
    "open": 111.71875,
    "high": 111.71875,
    "low": 111.546875,
    "close": 111.6875,
    "priceDate": "2020-12-01T00:00:00-05:00",
    "ticks": 637423776000000000,
    "epochTime": 1606780800,
    "hasValue": true,
    "time": "2020-12-01"
  },
  {
    "open": 111.703125,
    "high": 111.71875,
    "low": 111.625,
    "close": 111.6875,
    "priceDate": "2020-12-02T00:00:00-05:00",
    "ticks": 637424640000000000,
    "epochTime": 1606867200,
    "hasValue": true,
    "time": "2020-12-02"
  },
  {
    "open": 111.734375,
    "high": 111.796875,
    "low": 111.71875,
    "close": 111.78125,
    "priceDate": "2020-12-03T00:00:00-05:00",
    "ticks": 637425504000000000,
    "epochTime": 1606953600,
    "hasValue": true,
    "time": "2020-12-03"
  },
  {
    "open": 111.734375,
    "high": 111.765625,
    "low": 111.640625,
    "close": 111.6875,
    "priceDate": "2020-12-04T00:00:00-05:00",
    "ticks": 637426368000000000,
    "epochTime": 1607040000,
    "hasValue": true,
    "time": "2020-12-04"
  },
  {
    "open": 111.8125,
    "high": 111.828125,
    "low": 111.703125,
    "close": 111.71875,
    "priceDate": "2020-12-07T00:00:00-05:00",
    "ticks": 637428960000000000,
    "epochTime": 1607299200,
    "hasValue": true,
    "time": "2020-12-07"
  },
  {
    "open": 111.71875,
    "high": 111.78125,
    "low": 111.671875,
    "close": 111.71875,
    "priceDate": "2020-12-08T00:00:00-05:00",
    "ticks": 637429824000000000,
    "epochTime": 1607385600,
    "hasValue": true,
    "time": "2020-12-08"
  },
  {
    "open": 111.71875,
    "high": 111.8125,
    "low": 111.71875,
    "close": 111.734375,
    "priceDate": "2020-12-09T00:00:00-05:00",
    "ticks": 637430688000000000,
    "epochTime": 1607472000,
    "hasValue": true,
    "time": "2020-12-09"
  },
  {
    "open": 111.765625,
    "high": 111.78125,
    "low": 111.515625,
    "close": 111.53125,
    "priceDate": "2020-12-10T00:00:00-05:00",
    "ticks": 637431552000000000,
    "epochTime": 1607558400,
    "hasValue": true,
    "time": "2020-12-10"
  },
  {
    "open": 111.75,
    "high": 112.046875,
    "low": 111.75,
    "close": 112.015625,
    "priceDate": "2020-12-11T00:00:00-05:00",
    "ticks": 637432416000000000,
    "epochTime": 1607644800,
    "hasValue": true,
    "time": "2020-12-11"
  },
  {
    "open": 111.6875,
    "high": 111.765625,
    "low": 111.625,
    "close": 111.703125,
    "priceDate": "2020-12-14T00:00:00-05:00",
    "ticks": 637435008000000000,
    "epochTime": 1607904000,
    "hasValue": true,
    "time": "2020-12-14"
  },
  {
    "open": 111.703125,
    "high": 111.71875,
    "low": 111.6875,
    "close": 111.703125,
    "priceDate": "2020-12-15T00:00:00-05:00",
    "ticks": 637435872000000000,
    "epochTime": 1607990400,
    "hasValue": true,
    "time": "2020-12-15"
  },
  {
    "open": 111.6875,
    "high": 111.765625,
    "low": 111.6875,
    "close": 111.6875,
    "priceDate": "2020-12-16T00:00:00-05:00",
    "ticks": 637436736000000000,
    "epochTime": 1608076800,
    "hasValue": true,
    "time": "2020-12-16"
  },
  {
    "open": 111.734375,
    "high": 111.765625,
    "low": 111.578125,
    "close": 111.6875,
    "priceDate": "2020-12-17T00:00:00-05:00",
    "ticks": 637437600000000000,
    "epochTime": 1608163200,
    "hasValue": true,
    "time": "2020-12-17"
  },
  {
    "open": 111.78125,
    "high": 111.796875,
    "low": 111.6875,
    "close": 111.703125,
    "priceDate": "2020-12-18T00:00:00-05:00",
    "ticks": 637438464000000000,
    "epochTime": 1608249600,
    "hasValue": true,
    "time": "2020-12-18"
  },
  {
    "open": 111.71875,
    "high": 111.71875,
    "low": 111.59375,
    "close": 111.6875,
    "priceDate": "2020-12-21T00:00:00-05:00",
    "ticks": 637441056000000000,
    "epochTime": 1608508800,
    "hasValue": true,
    "time": "2020-12-21"
  },
  {
    "open": 111.75,
    "high": 111.765625,
    "low": 111.6875,
    "close": 111.765625,
    "priceDate": "2020-12-22T00:00:00-05:00",
    "ticks": 637441920000000000,
    "epochTime": 1608595200,
    "hasValue": true,
    "time": "2020-12-22"
  },
  {
    "open": 111.765625,
    "high": 111.796875,
    "low": 111.6875,
    "close": 111.796875,
    "priceDate": "2020-12-23T00:00:00-05:00",
    "ticks": 637442784000000000,
    "epochTime": 1608681600,
    "hasValue": true,
    "time": "2020-12-23"
  },
  {
    "open": 111.765625,
    "high": 111.78125,
    "low": 111.75,
    "close": 111.765625,
    "priceDate": "2020-12-24T00:00:00-05:00",
    "ticks": 637443648000000000,
    "epochTime": 1608768000,
    "hasValue": true,
    "time": "2020-12-24"
  },
  {
    "open": 111.78125,
    "high": 111.796875,
    "low": 111.46875,
    "close": 111.53125,
    "priceDate": "2020-12-28T00:00:00-05:00",
    "ticks": 637447104000000000,
    "epochTime": 1609113600,
    "hasValue": true,
    "time": "2020-12-28"
  },
  {
    "open": 111.765625,
    "high": 111.78125,
    "low": 111.375,
    "close": 111.375,
    "priceDate": "2020-12-29T00:00:00-05:00",
    "ticks": 637447968000000000,
    "epochTime": 1609200000,
    "hasValue": true,
    "time": "2020-12-29"
  },
  {
    "open": 111.8125,
    "high": 111.84375,
    "low": 111.6875,
    "close": 111.6875,
    "priceDate": "2020-12-30T00:00:00-05:00",
    "ticks": 637448832000000000,
    "epochTime": 1609286400,
    "hasValue": true,
    "time": "2020-12-30"
  },
  {
    "open": 111.796875,
    "high": 111.796875,
    "low": 111.6875,
    "close": 111.796875,
    "priceDate": "2020-12-31T00:00:00-05:00",
    "ticks": 637449696000000000,
    "epochTime": 1609372800,
    "hasValue": true,
    "time": "2020-12-31"
  },
  {
    "open": 111.8125,
    "high": 111.84375,
    "low": 111.484375,
    "close": 111.828125,
    "priceDate": "2021-01-04T00:00:00-05:00",
    "ticks": 637453152000000000,
    "epochTime": 1609718400,
    "hasValue": true,
    "time": "2021-01-04"
  },
  {
    "open": 111.8125,
    "high": 111.84375,
    "low": 111.6875,
    "close": 111.703125,
    "priceDate": "2021-01-05T00:00:00-05:00",
    "ticks": 637454016000000000,
    "epochTime": 1609804800,
    "hasValue": true,
    "time": "2021-01-05"
  },
  {
    "open": 111.796875,
    "high": 111.8125,
    "low": 111.5,
    "close": 111.5,
    "priceDate": "2021-01-06T00:00:00-05:00",
    "ticks": 637454880000000000,
    "epochTime": 1609891200,
    "hasValue": true,
    "time": "2021-01-06"
  },
  {
    "open": 111.71875,
    "high": 111.734375,
    "low": 111.328125,
    "close": 111.390625,
    "priceDate": "2021-01-07T00:00:00-05:00",
    "ticks": 637455744000000000,
    "epochTime": 1609977600,
    "hasValue": true,
    "time": "2021-01-07"
  },
  {
    "open": 111.71875,
    "high": 111.75,
    "low": 111.4375,
    "close": 111.5,
    "priceDate": "2021-01-08T00:00:00-05:00",
    "ticks": 637456608000000000,
    "epochTime": 1610064000,
    "hasValue": true,
    "time": "2021-01-08"
  },
  {
    "open": 111.703125,
    "high": 111.71875,
    "low": 111.25,
    "close": 111.28125,
    "priceDate": "2021-01-11T00:00:00-05:00",
    "ticks": 637459200000000000,
    "epochTime": 1610323200,
    "hasValue": true,
    "time": "2021-01-11"
  },
  {
    "open": 111.421875,
    "high": 111.484375,
    "low": 111.375,
    "close": 111.484375,
    "priceDate": "2021-01-12T00:00:00-05:00",
    "ticks": 637460064000000000,
    "epochTime": 1610409600,
    "hasValue": true,
    "time": "2021-01-12"
  },
  {
    "open": 111.5,
    "high": 111.609375,
    "low": 111.328125,
    "close": 111.609375,
    "priceDate": "2021-01-13T00:00:00-05:00",
    "ticks": 637460928000000000,
    "epochTime": 1610496000,
    "hasValue": true,
    "time": "2021-01-13"
  },
  {
    "open": 111.53125,
    "high": 111.546875,
    "low": 111.28125,
    "close": 111.53125,
    "priceDate": "2021-01-14T00:00:00-05:00",
    "ticks": 637461792000000000,
    "epochTime": 1610582400,
    "hasValue": true,
    "time": "2021-01-14"
  },
  {
    "open": 111.3125,
    "high": 111.34375,
    "low": 111.28125,
    "close": 111.3125,
    "priceDate": "2021-01-15T00:00:00-05:00",
    "ticks": 637462656000000000,
    "epochTime": 1610668800,
    "hasValue": true,
    "time": "2021-01-15"
  },
  {
    "open": 111.46875,
    "high": 111.546875,
    "low": 111.453125,
    "close": 111.515625,
    "priceDate": "2021-01-19T00:00:00-05:00",
    "ticks": 637466112000000000,
    "epochTime": 1611014400,
    "hasValue": true,
    "time": "2021-01-19"
  },
  {
    "open": 111.234375,
    "high": 111.25,
    "low": 111.15625,
    "close": 111.234375,
    "priceDate": "2021-01-20T00:00:00-05:00",
    "ticks": 637466976000000000,
    "epochTime": 1611100800,
    "hasValue": true,
    "time": "2021-01-20"
  },
  {
    "open": 111.359375,
    "high": 111.375,
    "low": 111.21875,
    "close": 111.28125,
    "priceDate": "2021-01-21T00:00:00-05:00",
    "ticks": 637467840000000000,
    "epochTime": 1611187200,
    "hasValue": true,
    "time": "2021-01-21"
  },
  {
    "open": 111.25,
    "high": 111.28125,
    "low": 111.171875,
    "close": 111.25,
    "priceDate": "2021-01-22T00:00:00-05:00",
    "ticks": 637468704000000000,
    "epochTime": 1611273600,
    "hasValue": true,
    "time": "2021-01-22"
  },
  {
    "open": 111.234375,
    "high": 111.296875,
    "low": 111.1875,
    "close": 111.234375,
    "priceDate": "2021-01-25T00:00:00-05:00",
    "ticks": 637471296000000000,
    "epochTime": 1611532800,
    "hasValue": true,
    "time": "2021-01-25"
  },
  {
    "open": 111.359375,
    "high": 111.375,
    "low": 111.234375,
    "close": 111.265625,
    "priceDate": "2021-01-26T00:00:00-05:00",
    "ticks": 637472160000000000,
    "epochTime": 1611619200,
    "hasValue": true,
    "time": "2021-01-26"
  },
  {
    "open": 111.359375,
    "high": 111.375,
    "low": 111.234375,
    "close": 111.25,
    "priceDate": "2021-01-27T00:00:00-05:00",
    "ticks": 637473024000000000,
    "epochTime": 1611705600,
    "hasValue": true,
    "time": "2021-01-27"
  },
  {
    "open": 111.8125,
    "high": 111.828125,
    "low": 111.3125,
    "close": 111.359375,
    "priceDate": "2021-01-28T00:00:00-05:00",
    "ticks": 637473888000000000,
    "epochTime": 1611792000,
    "hasValue": true,
    "time": "2021-01-28"
  },
  {
    "open": 111.359375,
    "high": 111.390625,
    "low": 111.234375,
    "close": 111.296875,
    "priceDate": "2021-01-29T00:00:00-05:00",
    "ticks": 637474752000000000,
    "epochTime": 1611878400,
    "hasValue": true,
    "time": "2021-01-29"
  },
  {
    "open": 111.25,
    "high": 111.328125,
    "low": 111.234375,
    "close": 111.3125,
    "priceDate": "2021-02-01T00:00:00-05:00",
    "ticks": 637477344000000000,
    "epochTime": 1612137600,
    "hasValue": true,
    "time": "2021-02-01"
  },
  {
    "open": 111.265625,
    "high": 111.296875,
    "low": 111.203125,
    "close": 111.234375,
    "priceDate": "2021-02-02T00:00:00-05:00",
    "ticks": 637478208000000000,
    "epochTime": 1612224000,
    "hasValue": true,
    "time": "2021-02-02"
  },
  {
    "open": 111.375,
    "high": 111.390625,
    "low": 111.359375,
    "close": 111.359375,
    "priceDate": "2021-02-03T00:00:00-05:00",
    "ticks": 637479072000000000,
    "epochTime": 1612310400,
    "hasValue": true,
    "time": "2021-02-03"
  },
  {
    "open": 111.359375,
    "high": 111.359375,
    "low": 111.21875,
    "close": 111.3125,
    "priceDate": "2021-02-04T00:00:00-05:00",
    "ticks": 637479936000000000,
    "epochTime": 1612396800,
    "hasValue": true,
    "time": "2021-02-04"
  },
  {
    "open": 111.375,
    "high": 111.4375,
    "low": 111.078125,
    "close": 111.09375,
    "priceDate": "2021-02-05T00:00:00-05:00",
    "ticks": 637480800000000000,
    "epochTime": 1612483200,
    "hasValue": true,
    "time": "2021-02-05"
  },
  {
    "open": 111.359375,
    "high": 111.84375,
    "low": 111.265625,
    "close": 111.265625,
    "priceDate": "2021-02-08T00:00:00-05:00",
    "ticks": 637483392000000000,
    "epochTime": 1612742400,
    "hasValue": true,
    "time": "2021-02-08"
  },
  {
    "open": 111.28125,
    "high": 111.328125,
    "low": 111.25,
    "close": 111.28125,
    "priceDate": "2021-02-09T00:00:00-05:00",
    "ticks": 637484256000000000,
    "epochTime": 1612828800,
    "hasValue": true,
    "time": "2021-02-09"
  },
  {
    "open": 111.65625,
    "high": 111.6875,
    "low": 111.640625,
    "close": 111.65625,
    "priceDate": "2021-02-10T00:00:00-05:00",
    "ticks": 637485120000000000,
    "epochTime": 1612915200,
    "hasValue": true,
    "time": "2021-02-10"
  },
  {
    "open": 111.640625,
    "high": 111.671875,
    "low": 111.15625,
    "close": 111.1875,
    "priceDate": "2021-02-11T00:00:00-05:00",
    "ticks": 637485984000000000,
    "epochTime": 1613001600,
    "hasValue": true,
    "time": "2021-02-11"
  },
  {
    "open": 111.65625,
    "high": 111.6875,
    "low": 111.65625,
    "close": 111.671875,
    "priceDate": "2021-02-12T00:00:00-05:00",
    "ticks": 637486848000000000,
    "epochTime": 1613088000,
    "hasValue": true,
    "time": "2021-02-12"
  },
  {
    "open": 111.65625,
    "high": 111.671875,
    "low": 111.625,
    "close": 111.640625,
    "priceDate": "2021-02-16T00:00:00-05:00",
    "ticks": 637490304000000000,
    "epochTime": 1613433600,
    "hasValue": true,
    "time": "2021-02-16"
  },
  {
    "open": 111.640625,
    "high": 111.671875,
    "low": 111.609375,
    "close": 111.65625,
    "priceDate": "2021-02-17T00:00:00-05:00",
    "ticks": 637491168000000000,
    "epochTime": 1613520000,
    "hasValue": true,
    "time": "2021-02-17"
  },
  {
    "open": 111.671875,
    "high": 111.6875,
    "low": 111.640625,
    "close": 111.671875,
    "priceDate": "2021-02-18T00:00:00-05:00",
    "ticks": 637492032000000000,
    "epochTime": 1613606400,
    "hasValue": true,
    "time": "2021-02-18"
  },
  {
    "open": 111.65625,
    "high": 111.6875,
    "low": 111.625,
    "close": 111.671875,
    "priceDate": "2021-02-19T00:00:00-05:00",
    "ticks": 637492896000000000,
    "epochTime": 1613692800,
    "hasValue": true,
    "time": "2021-02-19"
  },
  {
    "open": 111.6875,
    "high": 111.703125,
    "low": 111.609375,
    "close": 111.65625,
    "priceDate": "2021-02-22T00:00:00-05:00",
    "ticks": 637495488000000000,
    "epochTime": 1613952000,
    "hasValue": true,
    "time": "2021-02-22"
  },
  {
    "open": 111.6875,
    "high": 111.703125,
    "low": 111.640625,
    "close": 111.6875,
    "priceDate": "2021-02-23T00:00:00-05:00",
    "ticks": 637496352000000000,
    "epochTime": 1614038400,
    "hasValue": true,
    "time": "2021-02-23"
  },
  {
    "open": 111.65625,
    "high": 111.703125,
    "low": 111.640625,
    "close": 111.671875,
    "priceDate": "2021-02-24T00:00:00-05:00",
    "ticks": 637497216000000000,
    "epochTime": 1614124800,
    "hasValue": true,
    "time": "2021-02-24"
  },
  {
    "open": 111.484375,
    "high": 111.65625,
    "low": 111.453125,
    "close": 111.578125,
    "priceDate": "2021-02-25T00:00:00-05:00",
    "ticks": 637498080000000000,
    "epochTime": 1614211200,
    "hasValue": true,
    "time": "2021-02-25"
  },
  {
    "open": 111.578125,
    "high": 111.671875,
    "low": 111.5,
    "close": 111.609375,
    "priceDate": "2021-02-26T00:00:00-05:00",
    "ticks": 637498944000000000,
    "epochTime": 1614297600,
    "hasValue": true,
    "time": "2021-02-26"
  },
  {
    "open": 111.71875,
    "high": 111.765625,
    "low": 111.5625,
    "close": 111.640625,
    "priceDate": "2021-03-01T00:00:00-05:00",
    "ticks": 637501536000000000,
    "epochTime": 1614556800,
    "hasValue": true,
    "time": "2021-03-01"
  },
  {
    "open": 111.578125,
    "high": 111.59375,
    "low": 111.328125,
    "close": 111.34375,
    "priceDate": "2021-03-02T00:00:00-05:00",
    "ticks": 637502400000000000,
    "epochTime": 1614643200,
    "hasValue": true,
    "time": "2021-03-02"
  },
  {
    "open": 111.4375,
    "high": 111.625,
    "low": 111.3125,
    "close": 111.34375,
    "priceDate": "2021-03-03T00:00:00-05:00",
    "ticks": 637503264000000000,
    "epochTime": 1614729600,
    "hasValue": true,
    "time": "2021-03-03"
  },
  {
    "open": 111.328125,
    "high": 111.375,
    "low": 111.3125,
    "close": 111.328125,
    "priceDate": "2021-03-04T00:00:00-05:00",
    "ticks": 637504128000000000,
    "epochTime": 1614816000,
    "hasValue": true,
    "time": "2021-03-04"
  },
  {
    "open": 111.328125,
    "high": 111.375,
    "low": 111.296875,
    "close": 111.3125,
    "priceDate": "2021-03-05T00:00:00-05:00",
    "ticks": 637504992000000000,
    "epochTime": 1614902400,
    "hasValue": true,
    "time": "2021-03-05"
  },
  {
    "open": 111.3125,
    "high": 111.390625,
    "low": 111.234375,
    "close": 111.390625,
    "priceDate": "2021-03-08T00:00:00-05:00",
    "ticks": 637507584000000000,
    "epochTime": 1615161600,
    "hasValue": true,
    "time": "2021-03-08"
  },
  {
    "open": 111.234375,
    "high": 111.375,
    "low": 111.234375,
    "close": 111.375,
    "priceDate": "2021-03-09T00:00:00-05:00",
    "ticks": 637508448000000000,
    "epochTime": 1615248000,
    "hasValue": true,
    "time": "2021-03-09"
  },
  {
    "open": 111.390625,
    "high": 111.828125,
    "low": 111.390625,
    "close": 111.796875,
    "priceDate": "2021-03-10T00:00:00-05:00",
    "ticks": 637509312000000000,
    "epochTime": 1615334400,
    "hasValue": true,
    "time": "2021-03-10"
  },
  {
    "open": 111.515625,
    "high": 111.609375,
    "low": 111.40625,
    "close": 111.453125,
    "priceDate": "2021-03-11T00:00:00-05:00",
    "ticks": 637510176000000000,
    "epochTime": 1615420800,
    "hasValue": true,
    "time": "2021-03-11"
  },
  {
    "open": 111.46875,
    "high": 111.5,
    "low": 111.40625,
    "close": 111.46875,
    "priceDate": "2021-03-12T00:00:00-05:00",
    "ticks": 637511040000000000,
    "epochTime": 1615507200,
    "hasValue": true,
    "time": "2021-03-12"
  },
  {
    "open": 111.5,
    "high": 111.53125,
    "low": 111.46875,
    "close": 111.5,
    "priceDate": "2021-03-15T00:00:00-04:00",
    "ticks": 637513632000000000,
    "epochTime": 1615766400,
    "hasValue": true,
    "time": "2021-03-15"
  },
  {
    "open": 111.53125,
    "high": 111.546875,
    "low": 111.484375,
    "close": 111.5,
    "priceDate": "2021-03-16T00:00:00-04:00",
    "ticks": 637514496000000000,
    "epochTime": 1615852800,
    "hasValue": true,
    "time": "2021-03-16"
  },
  {
    "open": 111.515625,
    "high": 111.546875,
    "low": 111.453125,
    "close": 111.5,
    "priceDate": "2021-03-17T00:00:00-04:00",
    "ticks": 637515360000000000,
    "epochTime": 1615939200,
    "hasValue": true,
    "time": "2021-03-17"
  },
  {
    "open": 111.5,
    "high": 111.53125,
    "low": 111.453125,
    "close": 111.5,
    "priceDate": "2021-03-18T00:00:00-04:00",
    "ticks": 637516224000000000,
    "epochTime": 1616025600,
    "hasValue": true,
    "time": "2021-03-18"
  },
  {
    "open": 111.53125,
    "high": 111.578125,
    "low": 111.453125,
    "close": 111.515625,
    "priceDate": "2021-03-19T00:00:00-04:00",
    "ticks": 637517088000000000,
    "epochTime": 1616112000,
    "hasValue": true,
    "time": "2021-03-19"
  },
  {
    "open": 111.5,
    "high": 111.515625,
    "low": 111.484375,
    "close": 111.5,
    "priceDate": "2021-03-22T00:00:00-04:00",
    "ticks": 637519680000000000,
    "epochTime": 1616371200,
    "hasValue": true,
    "time": "2021-03-22"
  },
  {
    "open": 111.46875,
    "high": 111.546875,
    "low": 111.46875,
    "close": 111.5,
    "priceDate": "2021-03-23T00:00:00-04:00",
    "ticks": 637520544000000000,
    "epochTime": 1616457600,
    "hasValue": true,
    "time": "2021-03-23"
  },
  {
    "open": 111.484375,
    "high": 111.515625,
    "low": 111.4375,
    "close": 111.5,
    "priceDate": "2021-03-24T00:00:00-04:00",
    "ticks": 637521408000000000,
    "epochTime": 1616544000,
    "hasValue": true,
    "time": "2021-03-24"
  },
  {
    "open": 111.53125,
    "high": 111.5625,
    "low": 111.453125,
    "close": 111.484375,
    "priceDate": "2021-03-25T00:00:00-04:00",
    "ticks": 637522272000000000,
    "epochTime": 1616630400,
    "hasValue": true,
    "time": "2021-03-25"
  },
  {
    "open": 111.515625,
    "high": 111.578125,
    "low": 111.484375,
    "close": 111.484375,
    "priceDate": "2021-03-26T00:00:00-04:00",
    "ticks": 637523136000000000,
    "epochTime": 1616716800,
    "hasValue": true,
    "time": "2021-03-26"
  },
  {
    "open": 111.5,
    "high": 111.78125,
    "low": 111.4375,
    "close": 111.765625,
    "priceDate": "2021-03-29T00:00:00-04:00",
    "ticks": 637525728000000000,
    "epochTime": 1616976000,
    "hasValue": true,
    "time": "2021-03-29"
  },
  {
    "open": 111.515625,
    "high": 111.875,
    "low": 111.453125,
    "close": 111.875,
    "priceDate": "2021-03-30T00:00:00-04:00",
    "ticks": 637526592000000000,
    "epochTime": 1617062400,
    "hasValue": true,
    "time": "2021-03-30"
  },
  {
    "open": 111.453125,
    "high": 111.828125,
    "low": 111.453125,
    "close": 111.765625,
    "priceDate": "2021-03-31T00:00:00-04:00",
    "ticks": 637527456000000000,
    "epochTime": 1617148800,
    "hasValue": true,
    "time": "2021-03-31"
  },
  {
    "open": 111.25,
    "high": 111.796875,
    "low": 111.25,
    "close": 111.75,
    "priceDate": "2021-04-01T00:00:00-04:00",
    "ticks": 637528320000000000,
    "epochTime": 1617235200,
    "hasValue": true,
    "time": "2021-04-01"
  },
  {
    "open": 111.515625,
    "high": 111.53125,
    "low": 111.234375,
    "close": 111.34375,
    "priceDate": "2021-04-02T00:00:00-04:00",
    "ticks": 637529184000000000,
    "epochTime": 1617321600,
    "hasValue": true,
    "time": "2021-04-02"
  },
  {
    "open": 111.46875,
    "high": 111.796875,
    "low": 111.46875,
    "close": 111.71875,
    "priceDate": "2021-04-05T00:00:00-04:00",
    "ticks": 637531776000000000,
    "epochTime": 1617580800,
    "hasValue": true,
    "time": "2021-04-05"
  },
  {
    "open": 111.453125,
    "high": 111.6875,
    "low": 111.453125,
    "close": 111.625,
    "priceDate": "2021-04-06T00:00:00-04:00",
    "ticks": 637532640000000000,
    "epochTime": 1617667200,
    "hasValue": true,
    "time": "2021-04-06"
  },
  {
    "open": 111.421875,
    "high": 111.515625,
    "low": 111.421875,
    "close": 111.5,
    "priceDate": "2021-04-07T00:00:00-04:00",
    "ticks": 637533504000000000,
    "epochTime": 1617753600,
    "hasValue": true,
    "time": "2021-04-07"
  },
  {
    "open": 111.4375,
    "high": 111.5,
    "low": 111.421875,
    "close": 111.484375,
    "priceDate": "2021-04-08T00:00:00-04:00",
    "ticks": 637534368000000000,
    "epochTime": 1617840000,
    "hasValue": true,
    "time": "2021-04-08"
  },
  {
    "open": 111.4375,
    "high": 111.46875,
    "low": 111.390625,
    "close": 111.40625,
    "priceDate": "2021-04-09T00:00:00-04:00",
    "ticks": 637535232000000000,
    "epochTime": 1617926400,
    "hasValue": true,
    "time": "2021-04-09"
  },
  {
    "open": 111.359375,
    "high": 111.453125,
    "low": 111.359375,
    "close": 111.4375,
    "priceDate": "2021-04-12T00:00:00-04:00",
    "ticks": 637537824000000000,
    "epochTime": 1618185600,
    "hasValue": true,
    "time": "2021-04-12"
  },
  {
    "open": 111.375,
    "high": 111.515625,
    "low": 111.375,
    "close": 111.4375,
    "priceDate": "2021-04-13T00:00:00-04:00",
    "ticks": 637538688000000000,
    "epochTime": 1618272000,
    "hasValue": true,
    "time": "2021-04-13"
  },
  {
    "open": 111.359375,
    "high": 111.40625,
    "low": 111.25,
    "close": 111.28125,
    "priceDate": "2021-04-14T00:00:00-04:00",
    "ticks": 637539552000000000,
    "epochTime": 1618358400,
    "hasValue": true,
    "time": "2021-04-14"
  },
  {
    "open": 111.390625,
    "high": 111.4375,
    "low": 111.34375,
    "close": 111.375,
    "priceDate": "2021-04-15T00:00:00-04:00",
    "ticks": 637540416000000000,
    "epochTime": 1618444800,
    "hasValue": true,
    "time": "2021-04-15"
  },
  {
    "open": 111.375,
    "high": 111.40625,
    "low": 111.3125,
    "close": 111.34375,
    "priceDate": "2021-04-16T00:00:00-04:00",
    "ticks": 637541280000000000,
    "epochTime": 1618531200,
    "hasValue": true,
    "time": "2021-04-16"
  },
  {
    "open": 111.375,
    "high": 111.390625,
    "low": 111.3125,
    "close": 111.34375,
    "priceDate": "2021-04-19T00:00:00-04:00",
    "ticks": 637543872000000000,
    "epochTime": 1618790400,
    "hasValue": true,
    "time": "2021-04-19"
  },
  {
    "open": 111.375,
    "high": 111.421875,
    "low": 111.296875,
    "close": 111.359375,
    "priceDate": "2021-04-20T00:00:00-04:00",
    "ticks": 637544736000000000,
    "epochTime": 1618876800,
    "hasValue": true,
    "time": "2021-04-20"
  },
  {
    "open": 111.375,
    "high": 111.6875,
    "low": 111.359375,
    "close": 111.4375,
    "priceDate": "2021-04-21T00:00:00-04:00",
    "ticks": 637545600000000000,
    "epochTime": 1618963200,
    "hasValue": true,
    "time": "2021-04-21"
  },
  {
    "open": 111.34375,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.359375,
    "priceDate": "2021-04-22T00:00:00-04:00",
    "ticks": 637546464000000000,
    "epochTime": 1619049600,
    "hasValue": true,
    "time": "2021-04-22"
  },
  {
    "open": 111.375,
    "high": 111.40625,
    "low": 111.296875,
    "close": 111.34375,
    "priceDate": "2021-04-23T00:00:00-04:00",
    "ticks": 637547328000000000,
    "epochTime": 1619136000,
    "hasValue": true,
    "time": "2021-04-23"
  },
  {
    "open": 111.359375,
    "high": 111.875,
    "low": 111.34375,
    "close": 111.875,
    "priceDate": "2021-04-26T00:00:00-04:00",
    "ticks": 637549920000000000,
    "epochTime": 1619395200,
    "hasValue": true,
    "time": "2021-04-26"
  },
  {
    "open": 111.34375,
    "high": 111.890625,
    "low": 111.34375,
    "close": 111.828125,
    "priceDate": "2021-04-27T00:00:00-04:00",
    "ticks": 637550784000000000,
    "epochTime": 1619481600,
    "hasValue": true,
    "time": "2021-04-27"
  },
  {
    "open": 111.390625,
    "high": 111.9375,
    "low": 111.375,
    "close": 111.875,
    "priceDate": "2021-04-28T00:00:00-04:00",
    "ticks": 637551648000000000,
    "epochTime": 1619568000,
    "hasValue": true,
    "time": "2021-04-28"
  },
  {
    "open": 111.34375,
    "high": 111.453125,
    "low": 111.328125,
    "close": 111.375,
    "priceDate": "2021-04-29T00:00:00-04:00",
    "ticks": 637552512000000000,
    "epochTime": 1619654400,
    "hasValue": true,
    "time": "2021-04-29"
  },
  {
    "open": 111.390625,
    "high": 111.90625,
    "low": 111.34375,
    "close": 111.875,
    "priceDate": "2021-04-30T00:00:00-04:00",
    "ticks": 637553376000000000,
    "epochTime": 1619740800,
    "hasValue": true,
    "time": "2021-04-30"
  },
  {
    "open": 111.390625,
    "high": 111.4375,
    "low": 111.296875,
    "close": 111.3125,
    "priceDate": "2021-05-03T00:00:00-04:00",
    "ticks": 637555968000000000,
    "epochTime": 1620000000,
    "hasValue": true,
    "time": "2021-05-03"
  },
  {
    "open": 111.34375,
    "high": 111.375,
    "low": 111.234375,
    "close": 111.25,
    "priceDate": "2021-05-04T00:00:00-04:00",
    "ticks": 637556832000000000,
    "epochTime": 1620086400,
    "hasValue": true,
    "time": "2021-05-04"
  },
  {
    "open": 111.28125,
    "high": 111.578125,
    "low": 111.234375,
    "close": 111.25,
    "priceDate": "2021-05-05T00:00:00-04:00",
    "ticks": 637557696000000000,
    "epochTime": 1620172800,
    "hasValue": true,
    "time": "2021-05-05"
  },
  {
    "open": 111.28125,
    "high": 111.34375,
    "low": 111.234375,
    "close": 111.25,
    "priceDate": "2021-05-06T00:00:00-04:00",
    "ticks": 637558560000000000,
    "epochTime": 1620259200,
    "hasValue": true,
    "time": "2021-05-06"
  },
  {
    "open": 111.296875,
    "high": 111.453125,
    "low": 111.21875,
    "close": 111.21875,
    "priceDate": "2021-05-07T00:00:00-04:00",
    "ticks": 637559424000000000,
    "epochTime": 1620345600,
    "hasValue": true,
    "time": "2021-05-07"
  },
  {
    "open": 111.296875,
    "high": 111.453125,
    "low": 111.15625,
    "close": 111.15625,
    "priceDate": "2021-05-10T00:00:00-04:00",
    "ticks": 637562016000000000,
    "epochTime": 1620604800,
    "hasValue": true,
    "time": "2021-05-10"
  },
  {
    "open": 111.171875,
    "high": 111.21875,
    "low": 111.109375,
    "close": 111.171875,
    "priceDate": "2021-05-11T00:00:00-04:00",
    "ticks": 637562880000000000,
    "epochTime": 1620691200,
    "hasValue": true,
    "time": "2021-05-11"
  },
  {
    "open": 111.234375,
    "high": 111.25,
    "low": 111.15625,
    "close": 111.171875,
    "priceDate": "2021-05-12T00:00:00-04:00",
    "ticks": 637563744000000000,
    "epochTime": 1620777600,
    "hasValue": true,
    "time": "2021-05-12"
  },
  {
    "open": 111.21875,
    "high": 111.3125,
    "low": 111.1875,
    "close": 111.28125,
    "priceDate": "2021-05-13T00:00:00-04:00",
    "ticks": 637564608000000000,
    "epochTime": 1620864000,
    "hasValue": true,
    "time": "2021-05-13"
  },
  {
    "open": 111.203125,
    "high": 111.375,
    "low": 111.15625,
    "close": 111.359375,
    "priceDate": "2021-05-14T00:00:00-04:00",
    "ticks": 637565472000000000,
    "epochTime": 1620950400,
    "hasValue": true,
    "time": "2021-05-14"
  },
  {
    "open": 111.171875,
    "high": 111.203125,
    "low": 111.140625,
    "close": 111.1875,
    "priceDate": "2021-05-17T00:00:00-04:00",
    "ticks": 637568064000000000,
    "epochTime": 1621209600,
    "hasValue": true,
    "time": "2021-05-17"
  },
  {
    "open": 111.203125,
    "high": 111.203125,
    "low": 111.171875,
    "close": 111.1875,
    "priceDate": "2021-05-18T00:00:00-04:00",
    "ticks": 637568928000000000,
    "epochTime": 1621296000,
    "hasValue": true,
    "time": "2021-05-18"
  },
  {
    "open": 111.171875,
    "high": 111.40625,
    "low": 111.140625,
    "close": 111.1875,
    "priceDate": "2021-05-19T00:00:00-04:00",
    "ticks": 637569792000000000,
    "epochTime": 1621382400,
    "hasValue": true,
    "time": "2021-05-19"
  },
  {
    "open": 111.1875,
    "high": 111.21875,
    "low": 111.171875,
    "close": 111.1875,
    "priceDate": "2021-05-20T00:00:00-04:00",
    "ticks": 637570656000000000,
    "epochTime": 1621468800,
    "hasValue": true,
    "time": "2021-05-20"
  },
  {
    "open": 111.1875,
    "high": 111.21875,
    "low": 111.171875,
    "close": 111.203125,
    "priceDate": "2021-05-21T00:00:00-04:00",
    "ticks": 637571520000000000,
    "epochTime": 1621555200,
    "hasValue": true,
    "time": "2021-05-21"
  },
  {
    "open": 111.203125,
    "high": 111.375,
    "low": 111.171875,
    "close": 111.203125,
    "priceDate": "2021-05-24T00:00:00-04:00",
    "ticks": 637574112000000000,
    "epochTime": 1621814400,
    "hasValue": true,
    "time": "2021-05-24"
  },
  {
    "open": 111.203125,
    "high": 111.234375,
    "low": 111.1875,
    "close": 111.21875,
    "priceDate": "2021-05-25T00:00:00-04:00",
    "ticks": 637574976000000000,
    "epochTime": 1621900800,
    "hasValue": true,
    "time": "2021-05-25"
  },
  {
    "open": 111.203125,
    "high": 111.328125,
    "low": 111.171875,
    "close": 111.3125,
    "priceDate": "2021-05-26T00:00:00-04:00",
    "ticks": 637575840000000000,
    "epochTime": 1621987200,
    "hasValue": true,
    "time": "2021-05-26"
  },
  {
    "open": 111.03125,
    "high": 111.125,
    "low": 111.015625,
    "close": 111.078125,
    "priceDate": "2021-05-27T00:00:00-04:00",
    "ticks": 637576704000000000,
    "epochTime": 1622073600,
    "hasValue": true,
    "time": "2021-05-27"
  },
  {
    "open": 111.0625,
    "high": 111.109375,
    "low": 111.015625,
    "close": 111.109375,
    "priceDate": "2021-05-28T00:00:00-04:00",
    "ticks": 637577568000000000,
    "epochTime": 1622160000,
    "hasValue": true,
    "time": "2021-05-28"
  },
  {
    "open": 111.0625,
    "high": 111.109375,
    "low": 111.03125,
    "close": 111.09375,
    "priceDate": "2021-06-01T00:00:00-04:00",
    "ticks": 637581024000000000,
    "epochTime": 1622505600,
    "hasValue": true,
    "time": "2021-06-01"
  },
  {
    "open": 111.078125,
    "high": 111.328125,
    "low": 111.046875,
    "close": 111.09375,
    "priceDate": "2021-06-02T00:00:00-04:00",
    "ticks": 637581888000000000,
    "epochTime": 1622592000,
    "hasValue": true,
    "time": "2021-06-02"
  },
  {
    "open": 111.03125,
    "high": 111.078125,
    "low": 111,
    "close": 111.03125,
    "priceDate": "2021-06-03T00:00:00-04:00",
    "ticks": 637582752000000000,
    "epochTime": 1622678400,
    "hasValue": true,
    "time": "2021-06-03"
  },
  {
    "open": 111.078125,
    "high": 111.171875,
    "low": 111.0625,
    "close": 111.171875,
    "priceDate": "2021-06-04T00:00:00-04:00",
    "ticks": 637583616000000000,
    "epochTime": 1622764800,
    "hasValue": true,
    "time": "2021-06-04"
  },
  {
    "open": 111.109375,
    "high": 111.375,
    "low": 111.046875,
    "close": 111.375,
    "priceDate": "2021-06-07T00:00:00-04:00",
    "ticks": 637586208000000000,
    "epochTime": 1623024000,
    "hasValue": true,
    "time": "2021-06-07"
  },
  {
    "open": 111.078125,
    "high": 111.125,
    "low": 111.0625,
    "close": 111.09375,
    "priceDate": "2021-06-08T00:00:00-04:00",
    "ticks": 637587072000000000,
    "epochTime": 1623110400,
    "hasValue": true,
    "time": "2021-06-08"
  },
  {
    "open": 111.015625,
    "high": 111.09375,
    "low": 110.984375,
    "close": 111.03125,
    "priceDate": "2021-06-09T00:00:00-04:00",
    "ticks": 637587936000000000,
    "epochTime": 1623196800,
    "hasValue": true,
    "time": "2021-06-09"
  },
  {
    "open": 111.15625,
    "high": 111.296875,
    "low": 111.09375,
    "close": 111.296875,
    "priceDate": "2021-06-10T00:00:00-04:00",
    "ticks": 637588800000000000,
    "epochTime": 1623283200,
    "hasValue": true,
    "time": "2021-06-10"
  },
  {
    "open": 111.375,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.375,
    "priceDate": "2021-06-11T00:00:00-04:00",
    "ticks": 637589664000000000,
    "epochTime": 1623369600,
    "hasValue": true,
    "time": "2021-06-11"
  },
  {
    "open": 111.359375,
    "high": 111.390625,
    "low": 111.34375,
    "close": 111.359375,
    "priceDate": "2021-06-14T00:00:00-04:00",
    "ticks": 637592256000000000,
    "epochTime": 1623628800,
    "hasValue": true,
    "time": "2021-06-14"
  },
  {
    "open": 111.40625,
    "high": 111.421875,
    "low": 111.359375,
    "close": 111.390625,
    "priceDate": "2021-06-15T00:00:00-04:00",
    "ticks": 637593120000000000,
    "epochTime": 1623715200,
    "hasValue": true,
    "time": "2021-06-15"
  },
  {
    "open": 111.375,
    "high": 111.40625,
    "low": 111.25,
    "close": 111.28125,
    "priceDate": "2021-06-16T00:00:00-04:00",
    "ticks": 637593984000000000,
    "epochTime": 1623801600,
    "hasValue": true,
    "time": "2021-06-16"
  },
  {
    "open": 111.359375,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.375,
    "priceDate": "2021-06-17T00:00:00-04:00",
    "ticks": 637594848000000000,
    "epochTime": 1623888000,
    "hasValue": true,
    "time": "2021-06-17"
  },
  {
    "open": 111.421875,
    "high": 111.421875,
    "low": 111.09375,
    "close": 111.375,
    "priceDate": "2021-06-18T00:00:00-04:00",
    "ticks": 637595712000000000,
    "epochTime": 1623974400,
    "hasValue": true,
    "time": "2021-06-18"
  },
  {
    "open": 111.390625,
    "high": 111.4375,
    "low": 111.171875,
    "close": 111.1875,
    "priceDate": "2021-06-21T00:00:00-04:00",
    "ticks": 637598304000000000,
    "epochTime": 1624233600,
    "hasValue": true,
    "time": "2021-06-21"
  },
  {
    "open": 111.40625,
    "high": 111.421875,
    "low": 111.234375,
    "close": 111.25,
    "priceDate": "2021-06-22T00:00:00-04:00",
    "ticks": 637599168000000000,
    "epochTime": 1624320000,
    "hasValue": true,
    "time": "2021-06-22"
  },
  {
    "open": 111.40625,
    "high": 111.40625,
    "low": 111.328125,
    "close": 111.375,
    "priceDate": "2021-06-23T00:00:00-04:00",
    "ticks": 637600032000000000,
    "epochTime": 1624406400,
    "hasValue": true,
    "time": "2021-06-23"
  },
  {
    "open": 111.390625,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.359375,
    "priceDate": "2021-06-24T00:00:00-04:00",
    "ticks": 637600896000000000,
    "epochTime": 1624492800,
    "hasValue": true,
    "time": "2021-06-24"
  },
  {
    "open": 111.375,
    "high": 111.421875,
    "low": 111.328125,
    "close": 111.40625,
    "priceDate": "2021-06-25T00:00:00-04:00",
    "ticks": 637601760000000000,
    "epochTime": 1624579200,
    "hasValue": true,
    "time": "2021-06-25"
  },
  {
    "open": 111.46875,
    "high": 111.46875,
    "low": 111.375,
    "close": 111.40625,
    "priceDate": "2021-06-28T00:00:00-04:00",
    "ticks": 637604352000000000,
    "epochTime": 1624838400,
    "hasValue": true,
    "time": "2021-06-28"
  },
  {
    "open": 111.390625,
    "high": 111.421875,
    "low": 111.359375,
    "close": 111.375,
    "priceDate": "2021-06-29T00:00:00-04:00",
    "ticks": 637605216000000000,
    "epochTime": 1624924800,
    "hasValue": true,
    "time": "2021-06-29"
  },
  {
    "open": 111.453125,
    "high": 111.453125,
    "low": 111.375,
    "close": 111.375,
    "priceDate": "2021-06-30T00:00:00-04:00",
    "ticks": 637606080000000000,
    "epochTime": 1625011200,
    "hasValue": true,
    "time": "2021-06-30"
  },
  {
    "open": 111.390625,
    "high": 111.4375,
    "low": 111.328125,
    "close": 111.421875,
    "priceDate": "2021-07-01T00:00:00-04:00",
    "ticks": 637606944000000000,
    "epochTime": 1625097600,
    "hasValue": true,
    "time": "2021-07-01"
  },
  {
    "open": 111.375,
    "high": 111.4375,
    "low": 111.3125,
    "close": 111.40625,
    "priceDate": "2021-07-02T00:00:00-04:00",
    "ticks": 637607808000000000,
    "epochTime": 1625184000,
    "hasValue": true,
    "time": "2021-07-02"
  },
  {
    "open": 111.375,
    "high": 111.4375,
    "low": 111.359375,
    "close": 111.421875,
    "priceDate": "2021-07-06T00:00:00-04:00",
    "ticks": 637611264000000000,
    "epochTime": 1625529600,
    "hasValue": true,
    "time": "2021-07-06"
  },
  {
    "open": 111.40625,
    "high": 111.4375,
    "low": 111.328125,
    "close": 111.40625,
    "priceDate": "2021-07-07T00:00:00-04:00",
    "ticks": 637612128000000000,
    "epochTime": 1625616000,
    "hasValue": true,
    "time": "2021-07-07"
  },
  {
    "open": 111.375,
    "high": 111.4375,
    "low": 111.359375,
    "close": 111.40625,
    "priceDate": "2021-07-08T00:00:00-04:00",
    "ticks": 637612992000000000,
    "epochTime": 1625702400,
    "hasValue": true,
    "time": "2021-07-08"
  },
  {
    "open": 111.34375,
    "high": 111.390625,
    "low": 111.015625,
    "close": 111.359375,
    "priceDate": "2021-07-09T00:00:00-04:00",
    "ticks": 637613856000000000,
    "epochTime": 1625788800,
    "hasValue": true,
    "time": "2021-07-09"
  },
  {
    "open": 111.203125,
    "high": 111.328125,
    "low": 111.046875,
    "close": 111.109375,
    "priceDate": "2021-07-12T00:00:00-04:00",
    "ticks": 637616448000000000,
    "epochTime": 1626048000,
    "hasValue": true,
    "time": "2021-07-12"
  },
  {
    "open": 111.484375,
    "high": 111.484375,
    "low": 111.390625,
    "close": 111.40625,
    "priceDate": "2021-07-13T00:00:00-04:00",
    "ticks": 637617312000000000,
    "epochTime": 1626134400,
    "hasValue": true,
    "time": "2021-07-13"
  },
  {
    "open": 111.46875,
    "high": 111.515625,
    "low": 111.4375,
    "close": 111.484375,
    "priceDate": "2021-07-14T00:00:00-04:00",
    "ticks": 637618176000000000,
    "epochTime": 1626220800,
    "hasValue": true,
    "time": "2021-07-14"
  },
  {
    "open": 111.453125,
    "high": 111.5,
    "low": 111.40625,
    "close": 111.453125,
    "priceDate": "2021-07-15T00:00:00-04:00",
    "ticks": 637619040000000000,
    "epochTime": 1626307200,
    "hasValue": true,
    "time": "2021-07-15"
  },
  {
    "open": 111.4375,
    "high": 111.46875,
    "low": 111.390625,
    "close": 111.453125,
    "priceDate": "2021-07-16T00:00:00-04:00",
    "ticks": 637619904000000000,
    "epochTime": 1626393600,
    "hasValue": true,
    "time": "2021-07-16"
  },
  {
    "open": 111.453125,
    "high": 111.546875,
    "low": 111.453125,
    "close": 111.46875,
    "priceDate": "2021-07-19T00:00:00-04:00",
    "ticks": 637622496000000000,
    "epochTime": 1626652800,
    "hasValue": true,
    "time": "2021-07-19"
  },
  {
    "open": 111.46875,
    "high": 111.5,
    "low": 111.421875,
    "close": 111.453125,
    "priceDate": "2021-07-20T00:00:00-04:00",
    "ticks": 637623360000000000,
    "epochTime": 1626739200,
    "hasValue": true,
    "time": "2021-07-20"
  },
  {
    "open": 111.4375,
    "high": 111.46875,
    "low": 111.390625,
    "close": 111.40625,
    "priceDate": "2021-07-21T00:00:00-04:00",
    "ticks": 637624224000000000,
    "epochTime": 1626825600,
    "hasValue": true,
    "time": "2021-07-21"
  },
  {
    "open": 111.453125,
    "high": 111.5,
    "low": 111.390625,
    "close": 111.390625,
    "priceDate": "2021-07-22T00:00:00-04:00",
    "ticks": 637625088000000000,
    "epochTime": 1626912000,
    "hasValue": true,
    "time": "2021-07-22"
  },
  {
    "open": 111.453125,
    "high": 111.484375,
    "low": 111.390625,
    "close": 111.4375,
    "priceDate": "2021-07-23T00:00:00-04:00",
    "ticks": 637625952000000000,
    "epochTime": 1626998400,
    "hasValue": true,
    "time": "2021-07-23"
  },
  {
    "open": 111.546875,
    "high": 111.546875,
    "low": 111.421875,
    "close": 111.4375,
    "priceDate": "2021-07-26T00:00:00-04:00",
    "ticks": 637628544000000000,
    "epochTime": 1627257600,
    "hasValue": true,
    "time": "2021-07-26"
  },
  {
    "open": 111.515625,
    "high": 111.515625,
    "low": 111.40625,
    "close": 111.46875,
    "priceDate": "2021-07-27T00:00:00-04:00",
    "ticks": 637629408000000000,
    "epochTime": 1627344000,
    "hasValue": true,
    "time": "2021-07-27"
  },
  {
    "open": 111.4375,
    "high": 111.46875,
    "low": 111.390625,
    "close": 111.421875,
    "priceDate": "2021-07-28T00:00:00-04:00",
    "ticks": 637630272000000000,
    "epochTime": 1627430400,
    "hasValue": true,
    "time": "2021-07-28"
  },
  {
    "open": 111.46875,
    "high": 111.484375,
    "low": 111.421875,
    "close": 111.4375,
    "priceDate": "2021-07-29T00:00:00-04:00",
    "ticks": 637631136000000000,
    "epochTime": 1627516800,
    "hasValue": true,
    "time": "2021-07-29"
  },
  {
    "open": 111.453125,
    "high": 111.484375,
    "low": 111.4375,
    "close": 111.46875,
    "priceDate": "2021-07-30T00:00:00-04:00",
    "ticks": 637632000000000000,
    "epochTime": 1627603200,
    "hasValue": true,
    "time": "2021-07-30"
  },
  {
    "open": 111.453125,
    "high": 111.515625,
    "low": 111.4375,
    "close": 111.46875,
    "priceDate": "2021-08-02T00:00:00-04:00",
    "ticks": 637634592000000000,
    "epochTime": 1627862400,
    "hasValue": true,
    "time": "2021-08-02"
  },
  {
    "open": 111.46875,
    "high": 111.46875,
    "low": 111.421875,
    "close": 111.453125,
    "priceDate": "2021-08-03T00:00:00-04:00",
    "ticks": 637635456000000000,
    "epochTime": 1627948800,
    "hasValue": true,
    "time": "2021-08-03"
  },
  {
    "open": 111.46875,
    "high": 111.5,
    "low": 111.375,
    "close": 111.390625,
    "priceDate": "2021-08-04T00:00:00-04:00",
    "ticks": 637636320000000000,
    "epochTime": 1628035200,
    "hasValue": true,
    "time": "2021-08-04"
  },
  {
    "open": 111.4375,
    "high": 111.453125,
    "low": 111.375,
    "close": 111.390625,
    "priceDate": "2021-08-05T00:00:00-04:00",
    "ticks": 637637184000000000,
    "epochTime": 1628121600,
    "hasValue": true,
    "time": "2021-08-05"
  },
  {
    "open": 111.453125,
    "high": 111.46875,
    "low": 111.359375,
    "close": 111.4375,
    "priceDate": "2021-08-06T00:00:00-04:00",
    "ticks": 637638048000000000,
    "epochTime": 1628208000,
    "hasValue": true,
    "time": "2021-08-06"
  },
  {
    "open": 111.46875,
    "high": 111.484375,
    "low": 111.40625,
    "close": 111.421875,
    "priceDate": "2021-08-09T00:00:00-04:00",
    "ticks": 637640640000000000,
    "epochTime": 1628467200,
    "hasValue": true,
    "time": "2021-08-09"
  },
  {
    "open": 111.359375,
    "high": 111.59375,
    "low": 111.1875,
    "close": 111.203125,
    "priceDate": "2021-08-10T00:00:00-04:00",
    "ticks": 637641504000000000,
    "epochTime": 1628553600,
    "hasValue": true,
    "time": "2021-08-10"
  },
  {
    "open": 111.578125,
    "high": 111.71875,
    "low": 111.5625,
    "close": 111.625,
    "priceDate": "2021-08-11T00:00:00-04:00",
    "ticks": 637642368000000000,
    "epochTime": 1628640000,
    "hasValue": true,
    "time": "2021-08-11"
  },
  {
    "open": 111.59375,
    "high": 111.625,
    "low": 110.984375,
    "close": 111.59375,
    "priceDate": "2021-08-12T00:00:00-04:00",
    "ticks": 637643232000000000,
    "epochTime": 1628726400,
    "hasValue": true,
    "time": "2021-08-12"
  },
  {
    "open": 111.59375,
    "high": 111.6875,
    "low": 111.59375,
    "close": 111.65625,
    "priceDate": "2021-08-13T00:00:00-04:00",
    "ticks": 637644096000000000,
    "epochTime": 1628812800,
    "hasValue": true,
    "time": "2021-08-13"
  },
  {
    "open": 111.609375,
    "high": 111.640625,
    "low": 110.984375,
    "close": 111.46875,
    "priceDate": "2021-08-16T00:00:00-04:00",
    "ticks": 637646688000000000,
    "epochTime": 1629072000,
    "hasValue": true,
    "time": "2021-08-16"
  },
  {
    "open": 111.53125,
    "high": 111.640625,
    "low": 111.53125,
    "close": 111.578125,
    "priceDate": "2021-08-17T00:00:00-04:00",
    "ticks": 637647552000000000,
    "epochTime": 1629158400,
    "hasValue": true,
    "time": "2021-08-17"
  },
  {
    "open": 111.578125,
    "high": 111.625,
    "low": 111.53125,
    "close": 111.59375,
    "priceDate": "2021-08-18T00:00:00-04:00",
    "ticks": 637648416000000000,
    "epochTime": 1629244800,
    "hasValue": true,
    "time": "2021-08-18"
  },
  {
    "open": 111.609375,
    "high": 111.65625,
    "low": 111.546875,
    "close": 111.59375,
    "priceDate": "2021-08-19T00:00:00-04:00",
    "ticks": 637649280000000000,
    "epochTime": 1629331200,
    "hasValue": true,
    "time": "2021-08-19"
  },
  {
    "open": 111.609375,
    "high": 111.640625,
    "low": 111.578125,
    "close": 111.609375,
    "priceDate": "2021-08-20T00:00:00-04:00",
    "ticks": 637650144000000000,
    "epochTime": 1629417600,
    "hasValue": true,
    "time": "2021-08-20"
  },
  {
    "open": 111.5625,
    "high": 111.640625,
    "low": 111.5625,
    "close": 111.609375,
    "priceDate": "2021-08-23T00:00:00-04:00",
    "ticks": 637652736000000000,
    "epochTime": 1629676800,
    "hasValue": true,
    "time": "2021-08-23"
  },
  {
    "open": 111.578125,
    "high": 111.65625,
    "low": 111.546875,
    "close": 111.578125,
    "priceDate": "2021-08-24T00:00:00-04:00",
    "ticks": 637653600000000000,
    "epochTime": 1629763200,
    "hasValue": true,
    "time": "2021-08-24"
  },
  {
    "open": 111.5625,
    "high": 111.640625,
    "low": 111.546875,
    "close": 111.609375,
    "priceDate": "2021-08-25T00:00:00-04:00",
    "ticks": 637654464000000000,
    "epochTime": 1629849600,
    "hasValue": true,
    "time": "2021-08-25"
  },
  {
    "open": 111.5625,
    "high": 111.640625,
    "low": 111.546875,
    "close": 111.59375,
    "priceDate": "2021-08-26T00:00:00-04:00",
    "ticks": 637655328000000000,
    "epochTime": 1629936000,
    "hasValue": true,
    "time": "2021-08-26"
  },
  {
    "open": 111.59375,
    "high": 111.671875,
    "low": 111.546875,
    "close": 111.609375,
    "priceDate": "2021-08-27T00:00:00-04:00",
    "ticks": 637656192000000000,
    "epochTime": 1630022400,
    "hasValue": true,
    "time": "2021-08-27"
  },
  {
    "open": 111.609375,
    "high": 111.65625,
    "low": 111.59375,
    "close": 111.609375,
    "priceDate": "2021-08-30T00:00:00-04:00",
    "ticks": 637658784000000000,
    "epochTime": 1630281600,
    "hasValue": true,
    "time": "2021-08-30"
  },
  {
    "open": 111.328125,
    "high": 111.375,
    "low": 111.296875,
    "close": 111.34375,
    "priceDate": "2021-08-31T00:00:00-04:00",
    "ticks": 637659648000000000,
    "epochTime": 1630368000,
    "hasValue": true,
    "time": "2021-08-31"
  },
  {
    "open": 111.34375,
    "high": 111.390625,
    "low": 110.828125,
    "close": 110.875,
    "priceDate": "2021-09-01T00:00:00-04:00",
    "ticks": 637660512000000000,
    "epochTime": 1630454400,
    "hasValue": true,
    "time": "2021-09-01"
  },
  {
    "open": 110.890625,
    "high": 111.375,
    "low": 110.875,
    "close": 111.375,
    "priceDate": "2021-09-02T00:00:00-04:00",
    "ticks": 637661376000000000,
    "epochTime": 1630540800,
    "hasValue": true,
    "time": "2021-09-02"
  },
  {
    "open": 111.375,
    "high": 111.40625,
    "low": 111.28125,
    "close": 111.359375,
    "priceDate": "2021-09-03T00:00:00-04:00",
    "ticks": 637662240000000000,
    "epochTime": 1630627200,
    "hasValue": true,
    "time": "2021-09-03"
  },
  {
    "open": 111.265625,
    "high": 111.375,
    "low": 111.25,
    "close": 111.328125,
    "priceDate": "2021-09-07T00:00:00-04:00",
    "ticks": 637665696000000000,
    "epochTime": 1630972800,
    "hasValue": true,
    "time": "2021-09-07"
  },
  {
    "open": 111.375,
    "high": 111.390625,
    "low": 111.328125,
    "close": 111.359375,
    "priceDate": "2021-09-08T00:00:00-04:00",
    "ticks": 637666560000000000,
    "epochTime": 1631059200,
    "hasValue": true,
    "time": "2021-09-08"
  },
  {
    "open": 111.328125,
    "high": 111.390625,
    "low": 111.3125,
    "close": 111.34375,
    "priceDate": "2021-09-09T00:00:00-04:00",
    "ticks": 637667424000000000,
    "epochTime": 1631145600,
    "hasValue": true,
    "time": "2021-09-09"
  },
  {
    "open": 111.1875,
    "high": 111.3125,
    "low": 111.171875,
    "close": 111.296875,
    "priceDate": "2021-09-10T00:00:00-04:00",
    "ticks": 637668288000000000,
    "epochTime": 1631232000,
    "hasValue": true,
    "time": "2021-09-10"
  },
  {
    "open": 111.421875,
    "high": 111.453125,
    "low": 111.40625,
    "close": 111.421875,
    "priceDate": "2021-09-13T00:00:00-04:00",
    "ticks": 637670880000000000,
    "epochTime": 1631491200,
    "hasValue": true,
    "time": "2021-09-13"
  },
  {
    "open": 111.34375,
    "high": 111.578125,
    "low": 111.34375,
    "close": 111.421875,
    "priceDate": "2021-09-14T00:00:00-04:00",
    "ticks": 637671744000000000,
    "epochTime": 1631577600,
    "hasValue": true,
    "time": "2021-09-14"
  },
  {
    "open": 111.40625,
    "high": 111.4375,
    "low": 111.390625,
    "close": 111.40625,
    "priceDate": "2021-09-15T00:00:00-04:00",
    "ticks": 637672608000000000,
    "epochTime": 1631664000,
    "hasValue": true,
    "time": "2021-09-15"
  },
  {
    "open": 111.40625,
    "high": 111.421875,
    "low": 111.359375,
    "close": 111.375,
    "priceDate": "2021-09-16T00:00:00-04:00",
    "ticks": 637673472000000000,
    "epochTime": 1631750400,
    "hasValue": true,
    "time": "2021-09-16"
  },
  {
    "open": 111.390625,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.40625,
    "priceDate": "2021-09-17T00:00:00-04:00",
    "ticks": 637674336000000000,
    "epochTime": 1631836800,
    "hasValue": true,
    "time": "2021-09-17"
  },
  {
    "open": 111.4375,
    "high": 111.453125,
    "low": 111.359375,
    "close": 111.421875,
    "priceDate": "2021-09-20T00:00:00-04:00",
    "ticks": 637676928000000000,
    "epochTime": 1632096000,
    "hasValue": true,
    "time": "2021-09-20"
  },
  {
    "open": 111.421875,
    "high": 111.4375,
    "low": 111.390625,
    "close": 111.390625,
    "priceDate": "2021-09-21T00:00:00-04:00",
    "ticks": 637677792000000000,
    "epochTime": 1632182400,
    "hasValue": true,
    "time": "2021-09-21"
  },
  {
    "open": 111.421875,
    "high": 111.4375,
    "low": 111.328125,
    "close": 111.390625,
    "priceDate": "2021-09-22T00:00:00-04:00",
    "ticks": 637678656000000000,
    "epochTime": 1632268800,
    "hasValue": true,
    "time": "2021-09-22"
  },
  {
    "open": 111.421875,
    "high": 111.421875,
    "low": 111.109375,
    "close": 111.125,
    "priceDate": "2021-09-23T00:00:00-04:00",
    "ticks": 637679520000000000,
    "epochTime": 1632355200,
    "hasValue": true,
    "time": "2021-09-23"
  },
  {
    "open": 111.375,
    "high": 111.421875,
    "low": 111.34375,
    "close": 111.40625,
    "priceDate": "2021-09-24T00:00:00-04:00",
    "ticks": 637680384000000000,
    "epochTime": 1632441600,
    "hasValue": true,
    "time": "2021-09-24"
  },
  {
    "open": 111.40625,
    "high": 111.421875,
    "low": 111.375,
    "close": 111.40625,
    "priceDate": "2021-09-27T00:00:00-04:00",
    "ticks": 637682976000000000,
    "epochTime": 1632700800,
    "hasValue": true,
    "time": "2021-09-27"
  },
  {
    "open": 111.390625,
    "high": 111.78125,
    "low": 111.390625,
    "close": 111.6875,
    "priceDate": "2021-09-28T00:00:00-04:00",
    "ticks": 637683840000000000,
    "epochTime": 1632787200,
    "hasValue": true,
    "time": "2021-09-28"
  },
  {
    "open": 111.453125,
    "high": 111.65625,
    "low": 111.40625,
    "close": 111.640625,
    "priceDate": "2021-09-29T00:00:00-04:00",
    "ticks": 637684704000000000,
    "epochTime": 1632873600,
    "hasValue": true,
    "time": "2021-09-29"
  },
  {
    "open": 111.4375,
    "high": 111.78125,
    "low": 111.375,
    "close": 111.78125,
    "priceDate": "2021-09-30T00:00:00-04:00",
    "ticks": 637685568000000000,
    "epochTime": 1632960000,
    "hasValue": true,
    "time": "2021-09-30"
  },
  {
    "open": 111.546875,
    "high": 112.0625,
    "low": 111.484375,
    "close": 111.875,
    "priceDate": "2021-10-01T00:00:00-04:00",
    "ticks": 637686432000000000,
    "epochTime": 1633046400,
    "hasValue": true,
    "time": "2021-10-01"
  },
  {
    "open": 111.828125,
    "high": 111.890625,
    "low": 111.78125,
    "close": 111.875,
    "priceDate": "2021-10-04T00:00:00-04:00",
    "ticks": 637689024000000000,
    "epochTime": 1633305600,
    "hasValue": true,
    "time": "2021-10-04"
  },
  {
    "open": 111.8125,
    "high": 111.90625,
    "low": 111.796875,
    "close": 111.8125,
    "priceDate": "2021-10-05T00:00:00-04:00",
    "ticks": 637689888000000000,
    "epochTime": 1633392000,
    "hasValue": true,
    "time": "2021-10-05"
  },
  {
    "open": 111.59375,
    "high": 111.6875,
    "low": 111.546875,
    "close": 111.609375,
    "priceDate": "2021-10-06T00:00:00-04:00",
    "ticks": 637690752000000000,
    "epochTime": 1633478400,
    "hasValue": true,
    "time": "2021-10-06"
  },
  {
    "open": 111.578125,
    "high": 112.046875,
    "low": 111.578125,
    "close": 112.03125,
    "priceDate": "2021-10-07T00:00:00-04:00",
    "ticks": 637691616000000000,
    "epochTime": 1633564800,
    "hasValue": true,
    "time": "2021-10-07"
  },
  {
    "open": 112.046875,
    "high": 112.125,
    "low": 111.984375,
    "close": 112.015625,
    "priceDate": "2021-10-08T00:00:00-04:00",
    "ticks": 637692480000000000,
    "epochTime": 1633651200,
    "hasValue": true,
    "time": "2021-10-08"
  },
  {
    "open": 112.046875,
    "high": 112.109375,
    "low": 111.984375,
    "close": 112.046875,
    "priceDate": "2021-10-12T00:00:00-04:00",
    "ticks": 637695936000000000,
    "epochTime": 1633996800,
    "hasValue": true,
    "time": "2021-10-12"
  },
  {
    "open": 112.203125,
    "high": 112.21875,
    "low": 111.671875,
    "close": 111.734375,
    "priceDate": "2021-10-13T00:00:00-04:00",
    "ticks": 637696800000000000,
    "epochTime": 1634083200,
    "hasValue": true,
    "time": "2021-10-13"
  },
  {
    "open": 111.734375,
    "high": 111.8125,
    "low": 111.234375,
    "close": 111.765625,
    "priceDate": "2021-10-14T00:00:00-04:00",
    "ticks": 637697664000000000,
    "epochTime": 1634169600,
    "hasValue": true,
    "time": "2021-10-14"
  },
  {
    "open": 111.71875,
    "high": 111.75,
    "low": 111.140625,
    "close": 111.6875,
    "priceDate": "2021-10-15T00:00:00-04:00",
    "ticks": 637698528000000000,
    "epochTime": 1634256000,
    "hasValue": true,
    "time": "2021-10-15"
  },
  {
    "open": 111.875,
    "high": 111.890625,
    "low": 111.765625,
    "close": 111.8125,
    "priceDate": "2021-10-18T00:00:00-04:00",
    "ticks": 637701120000000000,
    "epochTime": 1634515200,
    "hasValue": true,
    "time": "2021-10-18"
  },
  {
    "open": 111.890625,
    "high": 111.921875,
    "low": 111.828125,
    "close": 111.859375,
    "priceDate": "2021-10-19T00:00:00-04:00",
    "ticks": 637701984000000000,
    "epochTime": 1634601600,
    "hasValue": true,
    "time": "2021-10-19"
  },
  {
    "open": 111.90625,
    "high": 111.90625,
    "low": 111.6875,
    "close": 111.734375,
    "priceDate": "2021-10-20T00:00:00-04:00",
    "ticks": 637702848000000000,
    "epochTime": 1634688000,
    "hasValue": true,
    "time": "2021-10-20"
  },
  {
    "open": 111.84375,
    "high": 111.90625,
    "low": 111.625,
    "close": 111.65625,
    "priceDate": "2021-10-21T00:00:00-04:00",
    "ticks": 637703712000000000,
    "epochTime": 1634774400,
    "hasValue": true,
    "time": "2021-10-21"
  },
  {
    "open": 111.6875,
    "high": 111.75,
    "low": 111,
    "close": 111.265625,
    "priceDate": "2021-10-22T00:00:00-04:00",
    "ticks": 637704576000000000,
    "epochTime": 1634860800,
    "hasValue": true,
    "time": "2021-10-22"
  },
  {
    "open": 111.796875,
    "high": 111.890625,
    "low": 111.734375,
    "close": 111.75,
    "priceDate": "2021-10-25T00:00:00-04:00",
    "ticks": 637707168000000000,
    "epochTime": 1635120000,
    "hasValue": true,
    "time": "2021-10-25"
  },
  {
    "open": 111.765625,
    "high": 111.90625,
    "low": 111.671875,
    "close": 111.890625,
    "priceDate": "2021-10-26T00:00:00-04:00",
    "ticks": 637708032000000000,
    "epochTime": 1635206400,
    "hasValue": true,
    "time": "2021-10-26"
  },
  {
    "open": 111.90625,
    "high": 111.90625,
    "low": 111.671875,
    "close": 111.75,
    "priceDate": "2021-10-27T00:00:00-04:00",
    "ticks": 637708896000000000,
    "epochTime": 1635292800,
    "hasValue": true,
    "time": "2021-10-27"
  },
  {
    "open": 111.734375,
    "high": 111.859375,
    "low": 111.65625,
    "close": 111.703125,
    "priceDate": "2021-10-28T00:00:00-04:00",
    "ticks": 637709760000000000,
    "epochTime": 1635379200,
    "hasValue": true,
    "time": "2021-10-28"
  },
  {
    "open": 111.84375,
    "high": 111.859375,
    "low": 111.4375,
    "close": 111.484375,
    "priceDate": "2021-10-29T00:00:00-04:00",
    "ticks": 637710624000000000,
    "epochTime": 1635465600,
    "hasValue": true,
    "time": "2021-10-29"
  },
  {
    "open": 111.359375,
    "high": 111.40625,
    "low": 110.671875,
    "close": 110.734375,
    "priceDate": "2021-11-01T00:00:00-04:00",
    "ticks": 637713216000000000,
    "epochTime": 1635724800,
    "hasValue": true,
    "time": "2021-11-01"
  },
  {
    "open": 110.78125,
    "high": 111.328125,
    "low": 110.609375,
    "close": 111.3125,
    "priceDate": "2021-11-02T00:00:00-04:00",
    "ticks": 637714080000000000,
    "epochTime": 1635811200,
    "hasValue": true,
    "time": "2021-11-02"
  },
  {
    "open": 111.4375,
    "high": 111.5,
    "low": 111.3125,
    "close": 111.359375,
    "priceDate": "2021-11-03T00:00:00-04:00",
    "ticks": 637714944000000000,
    "epochTime": 1635897600,
    "hasValue": true,
    "time": "2021-11-03"
  },
  {
    "open": 110.796875,
    "high": 111.3125,
    "low": 110.75,
    "close": 111.28125,
    "priceDate": "2021-11-04T00:00:00-04:00",
    "ticks": 637715808000000000,
    "epochTime": 1635984000,
    "hasValue": true,
    "time": "2021-11-04"
  },
  {
    "open": 111.3125,
    "high": 111.4375,
    "low": 110.6875,
    "close": 111.265625,
    "priceDate": "2021-11-05T00:00:00-04:00",
    "ticks": 637716672000000000,
    "epochTime": 1636070400,
    "hasValue": true,
    "time": "2021-11-05"
  },
  {
    "open": 111.21875,
    "high": 111.375,
    "low": 109.9375,
    "close": 111.21875,
    "priceDate": "2021-11-08T00:00:00-05:00",
    "ticks": 637719264000000000,
    "epochTime": 1636329600,
    "hasValue": true,
    "time": "2021-11-08"
  },
  {
    "open": 111.234375,
    "high": 111.3125,
    "low": 110.484375,
    "close": 110.515625,
    "priceDate": "2021-11-09T00:00:00-05:00",
    "ticks": 637720128000000000,
    "epochTime": 1636416000,
    "hasValue": true,
    "time": "2021-11-09"
  },
  {
    "open": 111.125,
    "high": 111.28125,
    "low": 110.34375,
    "close": 110.390625,
    "priceDate": "2021-11-10T00:00:00-05:00",
    "ticks": 637720992000000000,
    "epochTime": 1636502400,
    "hasValue": true,
    "time": "2021-11-10"
  },
  {
    "open": 110.46875,
    "high": 111.0625,
    "low": 109.953125,
    "close": 110.5,
    "priceDate": "2021-11-12T00:00:00-05:00",
    "ticks": 637722720000000000,
    "epochTime": 1636675200,
    "hasValue": true,
    "time": "2021-11-12"
  },
  {
    "open": 110.890625,
    "high": 110.90625,
    "low": 110.796875,
    "close": 110.84375,
    "priceDate": "2021-11-15T00:00:00-05:00",
    "ticks": 637725312000000000,
    "epochTime": 1636934400,
    "hasValue": true,
    "time": "2021-11-15"
  },
  {
    "open": 110.859375,
    "high": 110.859375,
    "low": 110.53125,
    "close": 110.59375,
    "priceDate": "2021-11-16T00:00:00-05:00",
    "ticks": 637726176000000000,
    "epochTime": 1637020800,
    "hasValue": true,
    "time": "2021-11-16"
  },
  {
    "open": 110.640625,
    "high": 110.703125,
    "low": 110.609375,
    "close": 110.609375,
    "priceDate": "2021-11-17T00:00:00-05:00",
    "ticks": 637727040000000000,
    "epochTime": 1637107200,
    "hasValue": true,
    "time": "2021-11-17"
  },
  {
    "open": 110.84375,
    "high": 110.90625,
    "low": 110.546875,
    "close": 110.578125,
    "priceDate": "2021-11-18T00:00:00-05:00",
    "ticks": 637727904000000000,
    "epochTime": 1637193600,
    "hasValue": true,
    "time": "2021-11-18"
  },
  {
    "open": 110.875,
    "high": 110.9375,
    "low": 110.765625,
    "close": 110.828125,
    "priceDate": "2021-11-19T00:00:00-05:00",
    "ticks": 637728768000000000,
    "epochTime": 1637280000,
    "hasValue": true,
    "time": "2021-11-19"
  },
  {
    "open": 110.546875,
    "high": 110.578125,
    "low": 110.46875,
    "close": 110.515625,
    "priceDate": "2021-11-22T00:00:00-05:00",
    "ticks": 637731360000000000,
    "epochTime": 1637539200,
    "hasValue": true,
    "time": "2021-11-22"
  },
  {
    "open": 110.484375,
    "high": 110.515625,
    "low": 110.28125,
    "close": 110.34375,
    "priceDate": "2021-11-23T00:00:00-05:00",
    "ticks": 637732224000000000,
    "epochTime": 1637625600,
    "hasValue": true,
    "time": "2021-11-23"
  },
  {
    "open": 110.546875,
    "high": 110.609375,
    "low": 110.203125,
    "close": 110.34375,
    "priceDate": "2021-11-24T00:00:00-05:00",
    "ticks": 637733088000000000,
    "epochTime": 1637712000,
    "hasValue": true,
    "time": "2021-11-24"
  },
  {
    "open": 110.671875,
    "high": 110.71875,
    "low": 110,
    "close": 110.3125,
    "priceDate": "2021-11-26T00:00:00-05:00",
    "ticks": 637734816000000000,
    "epochTime": 1637884800,
    "hasValue": true,
    "time": "2021-11-26"
  },
  {
    "open": 110.546875,
    "high": 110.640625,
    "low": 110.53125,
    "close": 110.640625,
    "priceDate": "2021-11-29T00:00:00-05:00",
    "ticks": 637737408000000000,
    "epochTime": 1638144000,
    "hasValue": true,
    "time": "2021-11-29"
  },
  {
    "open": 110.640625,
    "high": 110.703125,
    "low": 110.484375,
    "close": 110.5625,
    "priceDate": "2021-11-30T00:00:00-05:00",
    "ticks": 637738272000000000,
    "epochTime": 1638230400,
    "hasValue": true,
    "time": "2021-11-30"
  },
  {
    "open": 110.515625,
    "high": 110.609375,
    "low": 110.484375,
    "close": 110.59375,
    "priceDate": "2021-12-01T00:00:00-05:00",
    "ticks": 637739136000000000,
    "epochTime": 1638316800,
    "hasValue": true,
    "time": "2021-12-01"
  },
  {
    "open": 110.53125,
    "high": 110.609375,
    "low": 109.90625,
    "close": 109.953125,
    "priceDate": "2021-12-02T00:00:00-05:00",
    "ticks": 637740000000000000,
    "epochTime": 1638403200,
    "hasValue": true,
    "time": "2021-12-02"
  },
  {
    "open": 110.578125,
    "high": 110.6875,
    "low": 109.78125,
    "close": 109.921875,
    "priceDate": "2021-12-03T00:00:00-05:00",
    "ticks": 637740864000000000,
    "epochTime": 1638489600,
    "hasValue": true,
    "time": "2021-12-03"
  },
  {
    "open": 110.390625,
    "high": 110.578125,
    "low": 110.390625,
    "close": 110.53125,
    "priceDate": "2021-12-06T00:00:00-05:00",
    "ticks": 637743456000000000,
    "epochTime": 1638748800,
    "hasValue": true,
    "time": "2021-12-06"
  },
  {
    "open": 110.5625,
    "high": 110.578125,
    "low": 109.65625,
    "close": 110.4375,
    "priceDate": "2021-12-07T00:00:00-05:00",
    "ticks": 637744320000000000,
    "epochTime": 1638835200,
    "hasValue": true,
    "time": "2021-12-07"
  },
  {
    "open": 110.546875,
    "high": 110.5625,
    "low": 109.125,
    "close": 109.203125,
    "priceDate": "2021-12-08T00:00:00-05:00",
    "ticks": 637745184000000000,
    "epochTime": 1638921600,
    "hasValue": true,
    "time": "2021-12-08"
  },
  {
    "open": 110.5,
    "high": 110.515625,
    "low": 108.515625,
    "close": 108.53125,
    "priceDate": "2021-12-09T00:00:00-05:00",
    "ticks": 637746048000000000,
    "epochTime": 1639008000,
    "hasValue": true,
    "time": "2021-12-09"
  },
  {
    "open": 108.96875,
    "high": 109.09375,
    "low": 108.75,
    "close": 108.75,
    "priceDate": "2021-12-10T00:00:00-05:00",
    "ticks": 637746912000000000,
    "epochTime": 1639094400,
    "hasValue": true,
    "time": "2021-12-10"
  },
  {
    "open": 108.875,
    "high": 110.75,
    "low": 108.640625,
    "close": 110.71875,
    "priceDate": "2021-12-13T00:00:00-05:00",
    "ticks": 637749504000000000,
    "epochTime": 1639353600,
    "hasValue": true,
    "time": "2021-12-13"
  },
  {
    "open": 108.671875,
    "high": 110.609375,
    "low": 107.484375,
    "close": 108.65625,
    "priceDate": "2021-12-14T00:00:00-05:00",
    "ticks": 637750368000000000,
    "epochTime": 1639440000,
    "hasValue": true,
    "time": "2021-12-14"
  },
  {
    "open": 108.703125,
    "high": 110.59375,
    "low": 108.296875,
    "close": 108.359375,
    "priceDate": "2021-12-15T00:00:00-05:00",
    "ticks": 637751232000000000,
    "epochTime": 1639526400,
    "hasValue": true,
    "time": "2021-12-15"
  },
  {
    "open": 108.78125,
    "high": 110.671875,
    "low": 108.3125,
    "close": 108.375,
    "priceDate": "2021-12-16T00:00:00-05:00",
    "ticks": 637752096000000000,
    "epochTime": 1639612800,
    "hasValue": true,
    "time": "2021-12-16"
  },
  {
    "open": 108.765625,
    "high": 108.796875,
    "low": 108.25,
    "close": 108.296875,
    "priceDate": "2021-12-17T00:00:00-05:00",
    "ticks": 637752960000000000,
    "epochTime": 1639699200,
    "hasValue": true,
    "time": "2021-12-17"
  },
  {
    "open": 108.78125,
    "high": 110.578125,
    "low": 108.171875,
    "close": 108.1875,
    "priceDate": "2021-12-20T00:00:00-05:00",
    "ticks": 637755552000000000,
    "epochTime": 1639958400,
    "hasValue": true,
    "time": "2021-12-20"
  },
  {
    "open": 108.703125,
    "high": 110.5,
    "low": 108.09375,
    "close": 108.140625,
    "priceDate": "2021-12-21T00:00:00-05:00",
    "ticks": 637756416000000000,
    "epochTime": 1640044800,
    "hasValue": true,
    "time": "2021-12-21"
  },
  {
    "open": 108.734375,
    "high": 110.484375,
    "low": 108.171875,
    "close": 110.46875,
    "priceDate": "2021-12-22T00:00:00-05:00",
    "ticks": 637757280000000000,
    "epochTime": 1640131200,
    "hasValue": true,
    "time": "2021-12-22"
  },
  {
    "open": 108.71875,
    "high": 110.453125,
    "low": 108.6875,
    "close": 108.71875,
    "priceDate": "2021-12-23T00:00:00-05:00",
    "ticks": 637758144000000000,
    "epochTime": 1640217600,
    "hasValue": true,
    "time": "2021-12-23"
  },
  {
    "open": 108.734375,
    "high": 110.390625,
    "low": 108.203125,
    "close": 108.21875,
    "priceDate": "2021-12-27T00:00:00-05:00",
    "ticks": 637761600000000000,
    "epochTime": 1640563200,
    "hasValue": true,
    "time": "2021-12-27"
  },
  {
    "open": 108.734375,
    "high": 108.796875,
    "low": 108.71875,
    "close": 108.75,
    "priceDate": "2021-12-28T00:00:00-05:00",
    "ticks": 637762464000000000,
    "epochTime": 1640649600,
    "hasValue": true,
    "time": "2021-12-28"
  },
  {
    "open": 108.71875,
    "high": 110.34375,
    "low": 107.921875,
    "close": 107.953125,
    "priceDate": "2021-12-29T00:00:00-05:00",
    "ticks": 637763328000000000,
    "epochTime": 1640736000,
    "hasValue": true,
    "time": "2021-12-29"
  },
  {
    "open": 108.75,
    "high": 110.296875,
    "low": 108.71875,
    "close": 110.28125,
    "priceDate": "2021-12-30T00:00:00-05:00",
    "ticks": 637764192000000000,
    "epochTime": 1640822400,
    "hasValue": true,
    "time": "2021-12-30"
  },
  {
    "open": 108.796875,
    "high": 110.203125,
    "low": 108.71875,
    "close": 108.75,
    "priceDate": "2021-12-31T00:00:00-05:00",
    "ticks": 637765056000000000,
    "epochTime": 1640908800,
    "hasValue": true,
    "time": "2021-12-31"
  },
  {
    "open": 108.6875,
    "high": 110.140625,
    "low": 108.625,
    "close": 108.671875,
    "priceDate": "2022-01-03T00:00:00-05:00",
    "ticks": 637767648000000000,
    "epochTime": 1641168000,
    "hasValue": true,
    "time": "2022-01-03"
  },
  {
    "open": 108.734375,
    "high": 110.078125,
    "low": 108.0625,
    "close": 108.15625,
    "priceDate": "2022-01-04T00:00:00-05:00",
    "ticks": 637768512000000000,
    "epochTime": 1641254400,
    "hasValue": true,
    "time": "2022-01-04"
  },
  {
    "open": 108.75,
    "high": 110,
    "low": 108.078125,
    "close": 108.109375,
    "priceDate": "2022-01-05T00:00:00-05:00",
    "ticks": 637769376000000000,
    "epochTime": 1641340800,
    "hasValue": true,
    "time": "2022-01-05"
  },
  {
    "open": 108.71875,
    "high": 109.84375,
    "low": 108.03125,
    "close": 108.328125,
    "priceDate": "2022-01-06T00:00:00-05:00",
    "ticks": 637770240000000000,
    "epochTime": 1641427200,
    "hasValue": true,
    "time": "2022-01-06"
  },
  {
    "open": 108.125,
    "high": 109.734375,
    "low": 107.84375,
    "close": 107.90625,
    "priceDate": "2022-01-07T00:00:00-05:00",
    "ticks": 637771104000000000,
    "epochTime": 1641513600,
    "hasValue": true,
    "time": "2022-01-07"
  },
  {
    "open": 108.046875,
    "high": 109.703125,
    "low": 107.75,
    "close": 109.703125,
    "priceDate": "2022-01-10T00:00:00-05:00",
    "ticks": 637773696000000000,
    "epochTime": 1641772800,
    "hasValue": true,
    "time": "2022-01-10"
  },
  {
    "open": 107.078125,
    "high": 109.640625,
    "low": 107.0625,
    "close": 107.21875,
    "priceDate": "2022-01-11T00:00:00-05:00",
    "ticks": 637774560000000000,
    "epochTime": 1641859200,
    "hasValue": true,
    "time": "2022-01-11"
  },
  {
    "open": 108.859375,
    "high": 110.09375,
    "low": 107.28125,
    "close": 107.28125,
    "priceDate": "2022-01-12T00:00:00-05:00",
    "ticks": 637775424000000000,
    "epochTime": 1641945600,
    "hasValue": true,
    "time": "2022-01-12"
  },
  {
    "open": 107.46875,
    "high": 110.203125,
    "low": 107.4375,
    "close": 110.15625,
    "priceDate": "2022-01-13T00:00:00-05:00",
    "ticks": 637776288000000000,
    "epochTime": 1642032000,
    "hasValue": true,
    "time": "2022-01-13"
  },
  {
    "open": 108.828125,
    "high": 110.15625,
    "low": 108.703125,
    "close": 108.734375,
    "priceDate": "2022-01-14T00:00:00-05:00",
    "ticks": 637777152000000000,
    "epochTime": 1642118400,
    "hasValue": true,
    "time": "2022-01-14"
  },
  {
    "open": 108.734375,
    "high": 109.953125,
    "low": 107.265625,
    "close": 109.9375,
    "priceDate": "2022-01-18T00:00:00-05:00",
    "ticks": 637780608000000000,
    "epochTime": 1642464000,
    "hasValue": true,
    "time": "2022-01-18"
  },
  {
    "open": 108.8125,
    "high": 110.015625,
    "low": 107.140625,
    "close": 107.1875,
    "priceDate": "2022-01-19T00:00:00-05:00",
    "ticks": 637781472000000000,
    "epochTime": 1642550400,
    "hasValue": true,
    "time": "2022-01-19"
  },
  {
    "open": 108.8125,
    "high": 110.0625,
    "low": 107.171875,
    "close": 107.21875,
    "priceDate": "2022-01-20T00:00:00-05:00",
    "ticks": 637782336000000000,
    "epochTime": 1642636800,
    "hasValue": true,
    "time": "2022-01-20"
  },
  {
    "open": 108.875,
    "high": 108.890625,
    "low": 107.140625,
    "close": 107.234375,
    "priceDate": "2022-01-21T00:00:00-05:00",
    "ticks": 637783200000000000,
    "epochTime": 1642723200,
    "hasValue": true,
    "time": "2022-01-21"
  },
  {
    "open": 108.78125,
    "high": 110.171875,
    "low": 107.171875,
    "close": 107.203125,
    "priceDate": "2022-01-24T00:00:00-05:00",
    "ticks": 637785792000000000,
    "epochTime": 1642982400,
    "hasValue": true,
    "time": "2022-01-24"
  },
  {
    "open": 108.78125,
    "high": 110.109375,
    "low": 107.140625,
    "close": 107.203125,
    "priceDate": "2022-01-25T00:00:00-05:00",
    "ticks": 637786656000000000,
    "epochTime": 1643068800,
    "hasValue": true,
    "time": "2022-01-25"
  },
  {
    "open": 108.78125,
    "high": 108.828125,
    "low": 107.03125,
    "close": 107.078125,
    "priceDate": "2022-01-26T00:00:00-05:00",
    "ticks": 637787520000000000,
    "epochTime": 1643155200,
    "hasValue": true,
    "time": "2022-01-26"
  },
  {
    "open": 108.75,
    "high": 109.90625,
    "low": 107.03125,
    "close": 107.046875,
    "priceDate": "2022-01-27T00:00:00-05:00",
    "ticks": 637788384000000000,
    "epochTime": 1643241600,
    "hasValue": true,
    "time": "2022-01-27"
  },
  {
    "open": 108.78125,
    "high": 109.984375,
    "low": 107.109375,
    "close": 107.171875,
    "priceDate": "2022-01-28T00:00:00-05:00",
    "ticks": 637789248000000000,
    "epochTime": 1643328000,
    "hasValue": true,
    "time": "2022-01-28"
  },
  {
    "open": 108.78125,
    "high": 109.9375,
    "low": 107.0625,
    "close": 107.09375,
    "priceDate": "2022-01-31T00:00:00-05:00",
    "ticks": 637791840000000000,
    "epochTime": 1643587200,
    "hasValue": true,
    "time": "2022-01-31"
  },
  {
    "open": 108.828125,
    "high": 109.875,
    "low": 107.03125,
    "close": 107.109375,
    "priceDate": "2022-02-01T00:00:00-05:00",
    "ticks": 637792704000000000,
    "epochTime": 1643673600,
    "hasValue": true,
    "time": "2022-02-01"
  },
  {
    "open": 108.8125,
    "high": 108.890625,
    "low": 108.75,
    "close": 108.796875,
    "priceDate": "2022-02-02T00:00:00-05:00",
    "ticks": 637793568000000000,
    "epochTime": 1643760000,
    "hasValue": true,
    "time": "2022-02-02"
  },
  {
    "open": 108.796875,
    "high": 109.84375,
    "low": 107.03125,
    "close": 107.109375,
    "priceDate": "2022-02-03T00:00:00-05:00",
    "ticks": 637794432000000000,
    "epochTime": 1643846400,
    "hasValue": true,
    "time": "2022-02-03"
  },
  {
    "open": 108.796875,
    "high": 109.78125,
    "low": 106.96875,
    "close": 107.03125,
    "priceDate": "2022-02-04T00:00:00-05:00",
    "ticks": 637795296000000000,
    "epochTime": 1643932800,
    "hasValue": true,
    "time": "2022-02-04"
  },
  {
    "open": 108.828125,
    "high": 109.859375,
    "low": 107.03125,
    "close": 107.515625,
    "priceDate": "2022-02-07T00:00:00-05:00",
    "ticks": 637797888000000000,
    "epochTime": 1644192000,
    "hasValue": true,
    "time": "2022-02-07"
  },
  {
    "open": 107.25,
    "high": 109.765625,
    "low": 107.171875,
    "close": 107.203125,
    "priceDate": "2022-02-08T00:00:00-05:00",
    "ticks": 637798752000000000,
    "epochTime": 1644278400,
    "hasValue": true,
    "time": "2022-02-08"
  },
  {
    "open": 107.25,
    "high": 107.53125,
    "low": 107.203125,
    "close": 107.515625,
    "priceDate": "2022-02-09T00:00:00-05:00",
    "ticks": 637799616000000000,
    "epochTime": 1644364800,
    "hasValue": true,
    "time": "2022-02-09"
  },
  {
    "open": 107.234375,
    "high": 109.578125,
    "low": 106.984375,
    "close": 107.046875,
    "priceDate": "2022-02-10T00:00:00-05:00",
    "ticks": 637800480000000000,
    "epochTime": 1644451200,
    "hasValue": true,
    "time": "2022-02-10"
  },
  {
    "open": 107.203125,
    "high": 107.296875,
    "low": 107.109375,
    "close": 107.234375,
    "priceDate": "2022-02-11T00:00:00-05:00",
    "ticks": 637801344000000000,
    "epochTime": 1644537600,
    "hasValue": true,
    "time": "2022-02-11"
  },
  {
    "open": 107.140625,
    "high": 109.640625,
    "low": 107.0625,
    "close": 107.125,
    "priceDate": "2022-02-14T00:00:00-05:00",
    "ticks": 637803936000000000,
    "epochTime": 1644796800,
    "hasValue": true,
    "time": "2022-02-14"
  },
  {
    "open": 107.15625,
    "high": 109.65625,
    "low": 107.109375,
    "close": 107.15625,
    "priceDate": "2022-02-15T00:00:00-05:00",
    "ticks": 637804800000000000,
    "epochTime": 1644883200,
    "hasValue": true,
    "time": "2022-02-15"
  },
  {
    "open": 107.203125,
    "high": 107.25,
    "low": 107.140625,
    "close": 107.15625,
    "priceDate": "2022-02-16T00:00:00-05:00",
    "ticks": 637805664000000000,
    "epochTime": 1644969600,
    "hasValue": true,
    "time": "2022-02-16"
  },
  {
    "open": 107.21875,
    "high": 107.4375,
    "low": 107.171875,
    "close": 107.40625,
    "priceDate": "2022-02-17T00:00:00-05:00",
    "ticks": 637806528000000000,
    "epochTime": 1645056000,
    "hasValue": true,
    "time": "2022-02-17"
  },
  {
    "open": 107.421875,
    "high": 109.640625,
    "low": 107.296875,
    "close": 107.296875,
    "priceDate": "2022-02-18T00:00:00-05:00",
    "ticks": 637807392000000000,
    "epochTime": 1645142400,
    "hasValue": true,
    "time": "2022-02-18"
  },
  {
    "open": 107.140625,
    "high": 107.359375,
    "low": 107.09375,
    "close": 107.125,
    "priceDate": "2022-02-22T00:00:00-05:00",
    "ticks": 637810848000000000,
    "epochTime": 1645488000,
    "hasValue": true,
    "time": "2022-02-22"
  },
  {
    "open": 107.171875,
    "high": 109.640625,
    "low": 107.109375,
    "close": 107.15625,
    "priceDate": "2022-02-23T00:00:00-05:00",
    "ticks": 637811712000000000,
    "epochTime": 1645574400,
    "hasValue": true,
    "time": "2022-02-23"
  },
  {
    "open": 107.25,
    "high": 109.734375,
    "low": 107.15625,
    "close": 107.1875,
    "priceDate": "2022-02-24T00:00:00-05:00",
    "ticks": 637812576000000000,
    "epochTime": 1645660800,
    "hasValue": true,
    "time": "2022-02-24"
  },
  {
    "open": 107.109375,
    "high": 109.734375,
    "low": 107.09375,
    "close": 107.171875,
    "priceDate": "2022-02-25T00:00:00-05:00",
    "ticks": 637813440000000000,
    "epochTime": 1645747200,
    "hasValue": true,
    "time": "2022-02-25"
  },
  {
    "open": 107.265625,
    "high": 109.796875,
    "low": 107.21875,
    "close": 107.328125,
    "priceDate": "2022-02-28T00:00:00-05:00",
    "ticks": 637816032000000000,
    "epochTime": 1646006400,
    "hasValue": true,
    "time": "2022-02-28"
  },
  {
    "open": 107.265625,
    "high": 107.34375,
    "low": 107.234375,
    "close": 107.265625,
    "priceDate": "2022-03-01T00:00:00-05:00",
    "ticks": 637816896000000000,
    "epochTime": 1646092800,
    "hasValue": true,
    "time": "2022-03-01"
  },
  {
    "open": 107.1875,
    "high": 107.203125,
    "low": 107.046875,
    "close": 107.046875,
    "priceDate": "2022-03-02T00:00:00-05:00",
    "ticks": 637817760000000000,
    "epochTime": 1646179200,
    "hasValue": true,
    "time": "2022-03-02"
  },
  {
    "open": 107.203125,
    "high": 107.203125,
    "low": 107.15625,
    "close": 107.1875,
    "priceDate": "2022-03-03T00:00:00-05:00",
    "ticks": 637818624000000000,
    "epochTime": 1646265600,
    "hasValue": true,
    "time": "2022-03-03"
  },
  {
    "open": 107.234375,
    "high": 107.28125,
    "low": 107.1875,
    "close": 107.25,
    "priceDate": "2022-03-04T00:00:00-05:00",
    "ticks": 637819488000000000,
    "epochTime": 1646352000,
    "hasValue": true,
    "time": "2022-03-04"
  },
  {
    "open": 107.203125,
    "high": 109.71875,
    "low": 107.125,
    "close": 107.125,
    "priceDate": "2022-03-07T00:00:00-05:00",
    "ticks": 637822080000000000,
    "epochTime": 1646611200,
    "hasValue": true,
    "time": "2022-03-07"
  },
  {
    "open": 107.109375,
    "high": 107.15625,
    "low": 107.046875,
    "close": 107.109375,
    "priceDate": "2022-03-08T00:00:00-05:00",
    "ticks": 637822944000000000,
    "epochTime": 1646697600,
    "hasValue": true,
    "time": "2022-03-08"
  },
  {
    "open": 107.046875,
    "high": 109.546875,
    "low": 106.40625,
    "close": 106.40625,
    "priceDate": "2022-03-09T00:00:00-05:00",
    "ticks": 637823808000000000,
    "epochTime": 1646784000,
    "hasValue": true,
    "time": "2022-03-09"
  },
  {
    "open": 107.015625,
    "high": 109.453125,
    "low": 106.75,
    "close": 109.4375,
    "priceDate": "2022-03-10T00:00:00-05:00",
    "ticks": 637824672000000000,
    "epochTime": 1646870400,
    "hasValue": true,
    "time": "2022-03-10"
  },
  {
    "open": 106.921875,
    "high": 109.4375,
    "low": 106.515625,
    "close": 109.421875,
    "priceDate": "2022-03-11T00:00:00-05:00",
    "ticks": 637825536000000000,
    "epochTime": 1646956800,
    "hasValue": true,
    "time": "2022-03-11"
  },
  {
    "open": 106.796875,
    "high": 109.1875,
    "low": 106.40625,
    "close": 109.171875,
    "priceDate": "2022-03-14T00:00:00-04:00",
    "ticks": 637828128000000000,
    "epochTime": 1647216000,
    "hasValue": true,
    "time": "2022-03-14"
  },
  {
    "open": 106.59375,
    "high": 106.8125,
    "low": 106.484375,
    "close": 106.78125,
    "priceDate": "2022-03-15T00:00:00-04:00",
    "ticks": 637828992000000000,
    "epochTime": 1647302400,
    "hasValue": true,
    "time": "2022-03-15"
  },
  {
    "open": 106.53125,
    "high": 109.109375,
    "low": 105.6875,
    "close": 106.53125,
    "priceDate": "2022-03-16T00:00:00-04:00",
    "ticks": 637829856000000000,
    "epochTime": 1647388800,
    "hasValue": true,
    "time": "2022-03-16"
  },
  {
    "open": 106.515625,
    "high": 109.078125,
    "low": 106.484375,
    "close": 106.78125,
    "priceDate": "2022-03-17T00:00:00-04:00",
    "ticks": 637830720000000000,
    "epochTime": 1647475200,
    "hasValue": true,
    "time": "2022-03-17"
  },
  {
    "open": 105.828125,
    "high": 109.125,
    "low": 105.765625,
    "close": 106.625,
    "priceDate": "2022-03-18T00:00:00-04:00",
    "ticks": 637831584000000000,
    "epochTime": 1647561600,
    "hasValue": true,
    "time": "2022-03-18"
  },
  {
    "open": 106.5,
    "high": 108.890625,
    "low": 105.625,
    "close": 105.65625,
    "priceDate": "2022-03-21T00:00:00-04:00",
    "ticks": 637834176000000000,
    "epochTime": 1647820800,
    "hasValue": true,
    "time": "2022-03-21"
  },
  {
    "open": 106.4375,
    "high": 108.78125,
    "low": 106.359375,
    "close": 106.40625,
    "priceDate": "2022-03-22T00:00:00-04:00",
    "ticks": 637835040000000000,
    "epochTime": 1647907200,
    "hasValue": true,
    "time": "2022-03-22"
  },
  {
    "open": 106.453125,
    "high": 108.859375,
    "low": 106.1875,
    "close": 106.46875,
    "priceDate": "2022-03-23T00:00:00-04:00",
    "ticks": 637835904000000000,
    "epochTime": 1647993600,
    "hasValue": true,
    "time": "2022-03-23"
  },
  {
    "open": 106.453125,
    "high": 108.78125,
    "low": 104.015625,
    "close": 108.703125,
    "priceDate": "2022-03-24T00:00:00-04:00",
    "ticks": 637836768000000000,
    "epochTime": 1648080000,
    "hasValue": true,
    "time": "2022-03-24"
  },
  {
    "open": 106.34375,
    "high": 108.5625,
    "low": 103.703125,
    "close": 108.484375,
    "priceDate": "2022-03-25T00:00:00-04:00",
    "ticks": 637837632000000000,
    "epochTime": 1648166400,
    "hasValue": true,
    "time": "2022-03-25"
  },
  {
    "open": 106.203125,
    "high": 108.484375,
    "low": 103.859375,
    "close": 108.390625,
    "priceDate": "2022-03-28T00:00:00-04:00",
    "ticks": 637840224000000000,
    "epochTime": 1648425600,
    "hasValue": true,
    "time": "2022-03-28"
  },
  {
    "open": 105.46875,
    "high": 108.515625,
    "low": 105.4375,
    "close": 105.5625,
    "priceDate": "2022-03-29T00:00:00-04:00",
    "ticks": 637841088000000000,
    "epochTime": 1648512000,
    "hasValue": true,
    "time": "2022-03-29"
  },
  {
    "open": 105.53125,
    "high": 108.625,
    "low": 103.515625,
    "close": 108.5625,
    "priceDate": "2022-03-30T00:00:00-04:00",
    "ticks": 637841952000000000,
    "epochTime": 1648598400,
    "hasValue": true,
    "time": "2022-03-30"
  },
  {
    "open": 105.5625,
    "high": 108.65625,
    "low": 105.484375,
    "close": 105.515625,
    "priceDate": "2022-03-31T00:00:00-04:00",
    "ticks": 637842816000000000,
    "epochTime": 1648684800,
    "hasValue": true,
    "time": "2022-03-31"
  },
  {
    "open": 105.46875,
    "high": 108.453125,
    "low": 105.1875,
    "close": 105.25,
    "priceDate": "2022-04-01T00:00:00-04:00",
    "ticks": 637843680000000000,
    "epochTime": 1648771200,
    "hasValue": true,
    "time": "2022-04-01"
  },
  {
    "open": 105.4375,
    "high": 108.53125,
    "low": 103.859375,
    "close": 108.453125,
    "priceDate": "2022-04-04T00:00:00-04:00",
    "ticks": 637846272000000000,
    "epochTime": 1649030400,
    "hasValue": true,
    "time": "2022-04-04"
  },
  {
    "open": 105.3125,
    "high": 108.21875,
    "low": 103.84375,
    "close": 104,
    "priceDate": "2022-04-05T00:00:00-04:00",
    "ticks": 637847136000000000,
    "epochTime": 1649116800,
    "hasValue": true,
    "time": "2022-04-05"
  },
  {
    "open": 104.875,
    "high": 108.15625,
    "low": 103.96875,
    "close": 104.03125,
    "priceDate": "2022-04-06T00:00:00-04:00",
    "ticks": 637848000000000000,
    "epochTime": 1649203200,
    "hasValue": true,
    "time": "2022-04-06"
  },
  {
    "open": 105.03125,
    "high": 105.203125,
    "low": 104.890625,
    "close": 104.921875,
    "priceDate": "2022-04-07T00:00:00-04:00",
    "ticks": 637848864000000000,
    "epochTime": 1649289600,
    "hasValue": true,
    "time": "2022-04-07"
  },
  {
    "open": 104.890625,
    "high": 108.046875,
    "low": 103.71875,
    "close": 108,
    "priceDate": "2022-04-08T00:00:00-04:00",
    "ticks": 637849728000000000,
    "epochTime": 1649376000,
    "hasValue": true,
    "time": "2022-04-08"
  },
  {
    "open": 104.484375,
    "high": 104.5,
    "low": 104.34375,
    "close": 104.359375,
    "priceDate": "2022-04-11T00:00:00-04:00",
    "ticks": 637852320000000000,
    "epochTime": 1649635200,
    "hasValue": true,
    "time": "2022-04-11"
  },
  {
    "open": 104.203125,
    "high": 104.375,
    "low": 103.46875,
    "close": 103.515625,
    "priceDate": "2022-04-12T00:00:00-04:00",
    "ticks": 637853184000000000,
    "epochTime": 1649721600,
    "hasValue": true,
    "time": "2022-04-12"
  },
  {
    "open": 104.3125,
    "high": 104.390625,
    "low": 103.46875,
    "close": 103.5,
    "priceDate": "2022-04-13T00:00:00-04:00",
    "ticks": 637854048000000000,
    "epochTime": 1649808000,
    "hasValue": true,
    "time": "2022-04-13"
  },
  {
    "open": 104.59375,
    "high": 104.609375,
    "low": 103.8125,
    "close": 103.875,
    "priceDate": "2022-04-14T00:00:00-04:00",
    "ticks": 637854912000000000,
    "epochTime": 1649894400,
    "hasValue": true,
    "time": "2022-04-14"
  },
  {
    "open": 103.96875,
    "high": 108.171875,
    "low": 103.78125,
    "close": 108.109375,
    "priceDate": "2022-04-18T00:00:00-04:00",
    "ticks": 637858368000000000,
    "epochTime": 1650240000,
    "hasValue": true,
    "time": "2022-04-18"
  },
  {
    "open": 104.015625,
    "high": 104.03125,
    "low": 103.015625,
    "close": 103.046875,
    "priceDate": "2022-04-19T00:00:00-04:00",
    "ticks": 637859232000000000,
    "epochTime": 1650326400,
    "hasValue": true,
    "time": "2022-04-19"
  },
  {
    "open": 104.171875,
    "high": 107.953125,
    "low": 103.484375,
    "close": 107.90625,
    "priceDate": "2022-04-20T00:00:00-04:00",
    "ticks": 637860096000000000,
    "epochTime": 1650412800,
    "hasValue": true,
    "time": "2022-04-20"
  },
  {
    "open": 104.203125,
    "high": 107.75,
    "low": 103.328125,
    "close": 107.609375,
    "priceDate": "2022-04-21T00:00:00-04:00",
    "ticks": 637860960000000000,
    "epochTime": 1650499200,
    "hasValue": true,
    "time": "2022-04-21"
  },
  {
    "open": 103.984375,
    "high": 107.65625,
    "low": 103.484375,
    "close": 107.609375,
    "priceDate": "2022-04-22T00:00:00-04:00",
    "ticks": 637861824000000000,
    "epochTime": 1650585600,
    "hasValue": true,
    "time": "2022-04-22"
  },
  {
    "open": 104.3125,
    "high": 107.875,
    "low": 103.359375,
    "close": 107.796875,
    "priceDate": "2022-04-25T00:00:00-04:00",
    "ticks": 637864416000000000,
    "epochTime": 1650844800,
    "hasValue": true,
    "time": "2022-04-25"
  },
  {
    "open": 104.484375,
    "high": 108.171875,
    "low": 101.9375,
    "close": 108.09375,
    "priceDate": "2022-04-26T00:00:00-04:00",
    "ticks": 637865280000000000,
    "epochTime": 1650931200,
    "hasValue": true,
    "time": "2022-04-26"
  },
  {
    "open": 104.390625,
    "high": 104.5,
    "low": 101.96875,
    "close": 101.984375,
    "priceDate": "2022-04-27T00:00:00-04:00",
    "ticks": 637866144000000000,
    "epochTime": 1651017600,
    "hasValue": true,
    "time": "2022-04-27"
  },
  {
    "open": 104.28125,
    "high": 107.890625,
    "low": 101.90625,
    "close": 107.875,
    "priceDate": "2022-04-28T00:00:00-04:00",
    "ticks": 637867008000000000,
    "epochTime": 1651104000,
    "hasValue": true,
    "time": "2022-04-28"
  },
  {
    "open": 104.1875,
    "high": 107.625,
    "low": 103.46875,
    "close": 104.03125,
    "priceDate": "2022-04-29T00:00:00-04:00",
    "ticks": 637867872000000000,
    "epochTime": 1651190400,
    "hasValue": true,
    "time": "2022-04-29"
  },
  {
    "open": 104.078125,
    "high": 104.140625,
    "low": 103.890625,
    "close": 103.890625,
    "priceDate": "2022-05-02T00:00:00-04:00",
    "ticks": 637870464000000000,
    "epochTime": 1651449600,
    "hasValue": true,
    "time": "2022-05-02"
  },
  {
    "open": 103.9375,
    "high": 107.53125,
    "low": 103.796875,
    "close": 103.8125,
    "priceDate": "2022-05-03T00:00:00-04:00",
    "ticks": 637871328000000000,
    "epochTime": 1651536000,
    "hasValue": true,
    "time": "2022-05-03"
  },
  {
    "open": 103.96875,
    "high": 104.15625,
    "low": 103.765625,
    "close": 104.078125,
    "priceDate": "2022-05-04T00:00:00-04:00",
    "ticks": 637872192000000000,
    "epochTime": 1651622400,
    "hasValue": true,
    "time": "2022-05-04"
  },
  {
    "open": 104.34375,
    "high": 104.375,
    "low": 103.984375,
    "close": 104.0625,
    "priceDate": "2022-05-05T00:00:00-04:00",
    "ticks": 637873056000000000,
    "epochTime": 1651708800,
    "hasValue": true,
    "time": "2022-05-05"
  },
  {
    "open": 103.796875,
    "high": 103.921875,
    "low": 103.453125,
    "close": 103.46875,
    "priceDate": "2022-05-06T00:00:00-04:00",
    "ticks": 637873920000000000,
    "epochTime": 1651795200,
    "hasValue": true,
    "time": "2022-05-06"
  },
  {
    "open": 103.71875,
    "high": 103.84375,
    "low": 103.5,
    "close": 103.75,
    "priceDate": "2022-05-09T00:00:00-04:00",
    "ticks": 637876512000000000,
    "epochTime": 1652054400,
    "hasValue": true,
    "time": "2022-05-09"
  },
  {
    "open": 103.890625,
    "high": 104.078125,
    "low": 103.890625,
    "close": 103.9375,
    "priceDate": "2022-05-10T00:00:00-04:00",
    "ticks": 637877376000000000,
    "epochTime": 1652140800,
    "hasValue": true,
    "time": "2022-05-10"
  },
  {
    "open": 103.75,
    "high": 103.796875,
    "low": 103.21875,
    "close": 103.71875,
    "priceDate": "2022-05-11T00:00:00-04:00",
    "ticks": 637878240000000000,
    "epochTime": 1652227200,
    "hasValue": true,
    "time": "2022-05-11"
  },
  {
    "open": 103.921875,
    "high": 104.34375,
    "low": 103.78125,
    "close": 104.3125,
    "priceDate": "2022-05-12T00:00:00-04:00",
    "ticks": 637879104000000000,
    "epochTime": 1652313600,
    "hasValue": true,
    "time": "2022-05-12"
  },
  {
    "open": 103.75,
    "high": 103.828125,
    "low": 103.515625,
    "close": 103.6875,
    "priceDate": "2022-05-13T00:00:00-04:00",
    "ticks": 637879968000000000,
    "epochTime": 1652400000,
    "hasValue": true,
    "time": "2022-05-13"
  },
  {
    "open": 103.78125,
    "high": 104.03125,
    "low": 103.734375,
    "close": 103.859375,
    "priceDate": "2022-05-16T00:00:00-04:00",
    "ticks": 637882560000000000,
    "epochTime": 1652659200,
    "hasValue": true,
    "time": "2022-05-16"
  },
  {
    "open": 103.96875,
    "high": 103.984375,
    "low": 103.46875,
    "close": 103.765625,
    "priceDate": "2022-05-17T00:00:00-04:00",
    "ticks": 637883424000000000,
    "epochTime": 1652745600,
    "hasValue": true,
    "time": "2022-05-17"
  },
  {
    "open": 103.546875,
    "high": 103.65625,
    "low": 103.390625,
    "close": 103.59375,
    "priceDate": "2022-05-18T00:00:00-04:00",
    "ticks": 637884288000000000,
    "epochTime": 1652832000,
    "hasValue": true,
    "time": "2022-05-18"
  },
  {
    "open": 103.890625,
    "high": 104.0625,
    "low": 103.71875,
    "close": 103.765625,
    "priceDate": "2022-05-19T00:00:00-04:00",
    "ticks": 637885152000000000,
    "epochTime": 1652918400,
    "hasValue": true,
    "time": "2022-05-19"
  },
  {
    "open": 103.953125,
    "high": 104.125,
    "low": 103.828125,
    "close": 104.078125,
    "priceDate": "2022-05-20T00:00:00-04:00",
    "ticks": 637886016000000000,
    "epochTime": 1653004800,
    "hasValue": true,
    "time": "2022-05-20"
  },
  {
    "open": 104.03125,
    "high": 104.09375,
    "low": 103.90625,
    "close": 103.984375,
    "priceDate": "2022-05-23T00:00:00-04:00",
    "ticks": 637888608000000000,
    "epochTime": 1653264000,
    "hasValue": true,
    "time": "2022-05-23"
  },
  {
    "open": 104.078125,
    "high": 104.34375,
    "low": 103.953125,
    "close": 104,
    "priceDate": "2022-05-24T00:00:00-04:00",
    "ticks": 637889472000000000,
    "epochTime": 1653350400,
    "hasValue": true,
    "time": "2022-05-24"
  },
  {
    "open": 104.34375,
    "high": 104.390625,
    "low": 104.046875,
    "close": 104.109375,
    "priceDate": "2022-05-25T00:00:00-04:00",
    "ticks": 637890336000000000,
    "epochTime": 1653436800,
    "hasValue": true,
    "time": "2022-05-25"
  },
  {
    "open": 104.5,
    "high": 104.5625,
    "low": 104.09375,
    "close": 104.15625,
    "priceDate": "2022-05-26T00:00:00-04:00",
    "ticks": 637891200000000000,
    "epochTime": 1653523200,
    "hasValue": true,
    "time": "2022-05-26"
  },
  {
    "open": 104.5625,
    "high": 104.625,
    "low": 104.5,
    "close": 104.546875,
    "priceDate": "2022-05-27T00:00:00-04:00",
    "ticks": 637892064000000000,
    "epochTime": 1653609600,
    "hasValue": true,
    "time": "2022-05-27"
  },
  {
    "open": 104.390625,
    "high": 104.4375,
    "low": 103.96875,
    "close": 104.0625,
    "priceDate": "2022-05-31T00:00:00-04:00",
    "ticks": 637895520000000000,
    "epochTime": 1653955200,
    "hasValue": true,
    "time": "2022-05-31"
  },
  {
    "open": 104.1875,
    "high": 104.265625,
    "low": 103.9375,
    "close": 104.03125,
    "priceDate": "2022-06-01T00:00:00-04:00",
    "ticks": 637896384000000000,
    "epochTime": 1654041600,
    "hasValue": true,
    "time": "2022-06-01"
  },
  {
    "open": 103.921875,
    "high": 103.984375,
    "low": 103.703125,
    "close": 103.875,
    "priceDate": "2022-06-02T00:00:00-04:00",
    "ticks": 637897248000000000,
    "epochTime": 1654128000,
    "hasValue": true,
    "time": "2022-06-02"
  },
  {
    "open": 104.125,
    "high": 104.203125,
    "low": 103.96875,
    "close": 104.109375,
    "priceDate": "2022-06-03T00:00:00-04:00",
    "ticks": 637898112000000000,
    "epochTime": 1654214400,
    "hasValue": true,
    "time": "2022-06-03"
  },
  {
    "open": 104.0625,
    "high": 104.0625,
    "low": 103.609375,
    "close": 103.71875,
    "priceDate": "2022-06-06T00:00:00-04:00",
    "ticks": 637900704000000000,
    "epochTime": 1654473600,
    "hasValue": true,
    "time": "2022-06-06"
  },
  {
    "open": 103.625,
    "high": 103.953125,
    "low": 103.625,
    "close": 103.71875,
    "priceDate": "2022-06-07T00:00:00-04:00",
    "ticks": 637901568000000000,
    "epochTime": 1654560000,
    "hasValue": true,
    "time": "2022-06-07"
  },
  {
    "open": 103.65625,
    "high": 104.0625,
    "low": 103.453125,
    "close": 103.484375,
    "priceDate": "2022-06-08T00:00:00-04:00",
    "ticks": 637902432000000000,
    "epochTime": 1654646400,
    "hasValue": true,
    "time": "2022-06-08"
  },
  {
    "open": 103.5625,
    "high": 103.8125,
    "low": 103.34375,
    "close": 103.703125,
    "priceDate": "2022-06-09T00:00:00-04:00",
    "ticks": 637903296000000000,
    "epochTime": 1654732800,
    "hasValue": true,
    "time": "2022-06-09"
  },
  {
    "open": 103.1875,
    "high": 103.28125,
    "low": 102.59375,
    "close": 102.734375,
    "priceDate": "2022-06-10T00:00:00-04:00",
    "ticks": 637904160000000000,
    "epochTime": 1654819200,
    "hasValue": true,
    "time": "2022-06-10"
  },
  {
    "open": 102.28125,
    "high": 102.46875,
    "low": 101.609375,
    "close": 101.796875,
    "priceDate": "2022-06-13T00:00:00-04:00",
    "ticks": 637906752000000000,
    "epochTime": 1655078400,
    "hasValue": true,
    "time": "2022-06-13"
  },
  {
    "open": 101.921875,
    "high": 102.265625,
    "low": 101.734375,
    "close": 101.796875,
    "priceDate": "2022-06-14T00:00:00-04:00",
    "ticks": 637907616000000000,
    "epochTime": 1655164800,
    "hasValue": true,
    "time": "2022-06-14"
  },
  {
    "open": 102.171875,
    "high": 102.8125,
    "low": 101.75,
    "close": 102.6875,
    "priceDate": "2022-06-15T00:00:00-04:00",
    "ticks": 637908480000000000,
    "epochTime": 1655251200,
    "hasValue": true,
    "time": "2022-06-15"
  },
  {
    "open": 102.078125,
    "high": 103.03125,
    "low": 101.9375,
    "close": 102.625,
    "priceDate": "2022-06-16T00:00:00-04:00",
    "ticks": 637909344000000000,
    "epochTime": 1655337600,
    "hasValue": true,
    "time": "2022-06-16"
  },
  {
    "open": 102.71875,
    "high": 103.046875,
    "low": 102.234375,
    "close": 102.84375,
    "priceDate": "2022-06-17T00:00:00-04:00",
    "ticks": 637910208000000000,
    "epochTime": 1655424000,
    "hasValue": true,
    "time": "2022-06-17"
  },
  {
    "open": 102.546875,
    "high": 102.671875,
    "low": 102.34375,
    "close": 102.59375,
    "priceDate": "2022-06-21T00:00:00-04:00",
    "ticks": 637913664000000000,
    "epochTime": 1655769600,
    "hasValue": true,
    "time": "2022-06-21"
  },
  {
    "open": 102.890625,
    "high": 103.328125,
    "low": 102.796875,
    "close": 103.203125,
    "priceDate": "2022-06-22T00:00:00-04:00",
    "ticks": 637914528000000000,
    "epochTime": 1655856000,
    "hasValue": true,
    "time": "2022-06-22"
  },
  {
    "open": 103.125,
    "high": 103.734375,
    "low": 103.109375,
    "close": 103.359375,
    "priceDate": "2022-06-23T00:00:00-04:00",
    "ticks": 637915392000000000,
    "epochTime": 1655942400,
    "hasValue": true,
    "time": "2022-06-23"
  },
  {
    "open": 103.15625,
    "high": 103.484375,
    "low": 102.984375,
    "close": 103.125,
    "priceDate": "2022-06-24T00:00:00-04:00",
    "ticks": 637916256000000000,
    "epochTime": 1656028800,
    "hasValue": true,
    "time": "2022-06-24"
  },
  {
    "open": 102.90625,
    "high": 103.28125,
    "low": 102.78125,
    "close": 103.125,
    "priceDate": "2022-06-27T00:00:00-04:00",
    "ticks": 637918848000000000,
    "epochTime": 1656288000,
    "hasValue": true,
    "time": "2022-06-27"
  },
  {
    "open": 102.921875,
    "high": 103.15625,
    "low": 102.828125,
    "close": 103.125,
    "priceDate": "2022-06-28T00:00:00-04:00",
    "ticks": 637919712000000000,
    "epochTime": 1656374400,
    "hasValue": true,
    "time": "2022-06-28"
  },
  {
    "open": 103.03125,
    "high": 103.5,
    "low": 102.796875,
    "close": 103.484375,
    "priceDate": "2022-06-29T00:00:00-04:00",
    "ticks": 637920576000000000,
    "epochTime": 1656460800,
    "hasValue": true,
    "time": "2022-06-29"
  },
  {
    "open": 103.46875,
    "high": 103.84375,
    "low": 103.4375,
    "close": 103.703125,
    "priceDate": "2022-06-30T00:00:00-04:00",
    "ticks": 637921440000000000,
    "epochTime": 1656547200,
    "hasValue": true,
    "time": "2022-06-30"
  },
  {
    "open": 103.78125,
    "high": 104.296875,
    "low": 103.578125,
    "close": 103.75,
    "priceDate": "2022-07-01T00:00:00-04:00",
    "ticks": 637922304000000000,
    "epochTime": 1656633600,
    "hasValue": true,
    "time": "2022-07-01"
  },
  {
    "open": 103.828125,
    "high": 104.046875,
    "low": 103.5625,
    "close": 103.640625,
    "priceDate": "2022-07-05T00:00:00-04:00",
    "ticks": 637925760000000000,
    "epochTime": 1656979200,
    "hasValue": true,
    "time": "2022-07-05"
  },
  {
    "open": 103.890625,
    "high": 104.078125,
    "low": 103.09375,
    "close": 103.453125,
    "priceDate": "2022-07-06T00:00:00-04:00",
    "ticks": 637926624000000000,
    "epochTime": 1657065600,
    "hasValue": true,
    "time": "2022-07-06"
  },
  {
    "open": 103.171875,
    "high": 103.578125,
    "low": 102.96875,
    "close": 103.5625,
    "priceDate": "2022-07-07T00:00:00-04:00",
    "ticks": 637927488000000000,
    "epochTime": 1657152000,
    "hasValue": true,
    "time": "2022-07-07"
  },
  {
    "open": 103.328125,
    "high": 103.5,
    "low": 102.90625,
    "close": 103.46875,
    "priceDate": "2022-07-08T00:00:00-04:00",
    "ticks": 637928352000000000,
    "epochTime": 1657238400,
    "hasValue": true,
    "time": "2022-07-08"
  },
  {
    "open": 103.3125,
    "high": 103.734375,
    "low": 103.171875,
    "close": 103.34375,
    "priceDate": "2022-07-11T00:00:00-04:00",
    "ticks": 637930944000000000,
    "epochTime": 1657497600,
    "hasValue": true,
    "time": "2022-07-11"
  },
  {
    "open": 103.265625,
    "high": 103.4375,
    "low": 102.796875,
    "close": 103.078125,
    "priceDate": "2022-07-12T00:00:00-04:00",
    "ticks": 637931808000000000,
    "epochTime": 1657584000,
    "hasValue": true,
    "time": "2022-07-12"
  },
  {
    "open": 102.3125,
    "high": 102.59375,
    "low": 100.96875,
    "close": 102.421875,
    "priceDate": "2022-07-13T00:00:00-04:00",
    "ticks": 637932672000000000,
    "epochTime": 1657670400,
    "hasValue": true,
    "time": "2022-07-13"
  },
  {
    "open": 102.140625,
    "high": 102.3125,
    "low": 101.640625,
    "close": 101.921875,
    "priceDate": "2022-07-14T00:00:00-04:00",
    "ticks": 637933536000000000,
    "epochTime": 1657756800,
    "hasValue": true,
    "time": "2022-07-14"
  },
  {
    "open": 102.15625,
    "high": 102.546875,
    "low": 101.953125,
    "close": 102.453125,
    "priceDate": "2022-07-15T00:00:00-04:00",
    "ticks": 637934400000000000,
    "epochTime": 1657843200,
    "hasValue": true,
    "time": "2022-07-15"
  },
  {
    "open": 102.25,
    "high": 102.59375,
    "low": 102.03125,
    "close": 102.390625,
    "priceDate": "2022-07-18T00:00:00-04:00",
    "ticks": 637936992000000000,
    "epochTime": 1658102400,
    "hasValue": true,
    "time": "2022-07-18"
  },
  {
    "open": 102.265625,
    "high": 102.59375,
    "low": 102.171875,
    "close": 102.5,
    "priceDate": "2022-07-19T00:00:00-04:00",
    "ticks": 637937856000000000,
    "epochTime": 1658188800,
    "hasValue": true,
    "time": "2022-07-19"
  },
  {
    "open": 102.5,
    "high": 102.5625,
    "low": 102.28125,
    "close": 102.4375,
    "priceDate": "2022-07-20T00:00:00-04:00",
    "ticks": 637938720000000000,
    "epochTime": 1658275200,
    "hasValue": true,
    "time": "2022-07-20"
  },
  {
    "open": 102.109375,
    "high": 103,
    "low": 102.03125,
    "close": 102.875,
    "priceDate": "2022-07-21T00:00:00-04:00",
    "ticks": 637939584000000000,
    "epochTime": 1658361600,
    "hasValue": true,
    "time": "2022-07-21"
  },
  {
    "open": 102.953125,
    "high": 103.234375,
    "low": 102.59375,
    "close": 103.03125,
    "priceDate": "2022-07-22T00:00:00-04:00",
    "ticks": 637940448000000000,
    "epochTime": 1658448000,
    "hasValue": true,
    "time": "2022-07-22"
  },
  {
    "open": 102.75,
    "high": 103.0625,
    "low": 102.625,
    "close": 103.046875,
    "priceDate": "2022-07-25T00:00:00-04:00",
    "ticks": 637943040000000000,
    "epochTime": 1658707200,
    "hasValue": true,
    "time": "2022-07-25"
  },
  {
    "open": 103.046875,
    "high": 103.171875,
    "low": 102.59375,
    "close": 102.84375,
    "priceDate": "2022-07-26T00:00:00-04:00",
    "ticks": 637943904000000000,
    "epochTime": 1658793600,
    "hasValue": true,
    "time": "2022-07-26"
  },
  {
    "open": 102.671875,
    "high": 103.265625,
    "low": 102.578125,
    "close": 103.234375,
    "priceDate": "2022-07-27T00:00:00-04:00",
    "ticks": 637944768000000000,
    "epochTime": 1658880000,
    "hasValue": true,
    "time": "2022-07-27"
  },
  {
    "open": 102.984375,
    "high": 103.65625,
    "low": 102.921875,
    "close": 103.40625,
    "priceDate": "2022-07-28T00:00:00-04:00",
    "ticks": 637945632000000000,
    "epochTime": 1658966400,
    "hasValue": true,
    "time": "2022-07-28"
  },
  {
    "open": 103.265625,
    "high": 103.734375,
    "low": 103.15625,
    "close": 103.5,
    "priceDate": "2022-07-29T00:00:00-04:00",
    "ticks": 637946496000000000,
    "epochTime": 1659052800,
    "hasValue": true,
    "time": "2022-07-29"
  },
  {
    "open": 103.40625,
    "high": 103.625,
    "low": 103.125,
    "close": 103.53125,
    "priceDate": "2022-08-01T00:00:00-04:00",
    "ticks": 637949088000000000,
    "epochTime": 1659312000,
    "hasValue": true,
    "time": "2022-08-01"
  },
  {
    "open": 103.46875,
    "high": 103.5,
    "low": 102.671875,
    "close": 103.0625,
    "priceDate": "2022-08-02T00:00:00-04:00",
    "ticks": 637949952000000000,
    "epochTime": 1659398400,
    "hasValue": true,
    "time": "2022-08-02"
  },
  {
    "open": 102.703125,
    "high": 103.359375,
    "low": 102.546875,
    "close": 103.28125,
    "priceDate": "2022-08-03T00:00:00-04:00",
    "ticks": 637950816000000000,
    "epochTime": 1659484800,
    "hasValue": true,
    "time": "2022-08-03"
  },
  {
    "open": 103.171875,
    "high": 103.703125,
    "low": 103.03125,
    "close": 103.671875,
    "priceDate": "2022-08-04T00:00:00-04:00",
    "ticks": 637951680000000000,
    "epochTime": 1659571200,
    "hasValue": true,
    "time": "2022-08-04"
  },
  {
    "open": 103.1875,
    "high": 103.34375,
    "low": 102.71875,
    "close": 103.03125,
    "priceDate": "2022-08-05T00:00:00-04:00",
    "ticks": 637952544000000000,
    "epochTime": 1659657600,
    "hasValue": true,
    "time": "2022-08-05"
  },
  {
    "open": 102.984375,
    "high": 103.234375,
    "low": 102.828125,
    "close": 103.078125,
    "priceDate": "2022-08-08T00:00:00-04:00",
    "ticks": 637955136000000000,
    "epochTime": 1659916800,
    "hasValue": true,
    "time": "2022-08-08"
  },
  {
    "open": 102.703125,
    "high": 103.125,
    "low": 102.625,
    "close": 103.09375,
    "priceDate": "2022-08-09T00:00:00-04:00",
    "ticks": 637956000000000000,
    "epochTime": 1660003200,
    "hasValue": true,
    "time": "2022-08-09"
  },
  {
    "open": 102.4375,
    "high": 103.0625,
    "low": 102.40625,
    "close": 102.921875,
    "priceDate": "2022-08-10T00:00:00-04:00",
    "ticks": 637956864000000000,
    "epochTime": 1660089600,
    "hasValue": true,
    "time": "2022-08-10"
  },
  {
    "open": 102.796875,
    "high": 103.0625,
    "low": 102.640625,
    "close": 102.765625,
    "priceDate": "2022-08-11T00:00:00-04:00",
    "ticks": 637957728000000000,
    "epochTime": 1660176000,
    "hasValue": true,
    "time": "2022-08-11"
  },
  {
    "open": 102.71875,
    "high": 102.90625,
    "low": 102.625,
    "close": 102.78125,
    "priceDate": "2022-08-12T00:00:00-04:00",
    "ticks": 637958592000000000,
    "epochTime": 1660262400,
    "hasValue": true,
    "time": "2022-08-12"
  },
  {
    "open": 102.65625,
    "high": 102.90625,
    "low": 102.40625,
    "close": 102.828125,
    "priceDate": "2022-08-15T00:00:00-04:00",
    "ticks": 637961184000000000,
    "epochTime": 1660521600,
    "hasValue": true,
    "time": "2022-08-15"
  },
  {
    "open": 102.5625,
    "high": 102.875,
    "low": 102.421875,
    "close": 102.578125,
    "priceDate": "2022-08-16T00:00:00-04:00",
    "ticks": 637962048000000000,
    "epochTime": 1660608000,
    "hasValue": true,
    "time": "2022-08-16"
  },
  {
    "open": 102.375,
    "high": 102.6875,
    "low": 102.109375,
    "close": 102.609375,
    "priceDate": "2022-08-17T00:00:00-04:00",
    "ticks": 637962912000000000,
    "epochTime": 1660694400,
    "hasValue": true,
    "time": "2022-08-17"
  },
  {
    "open": 102.578125,
    "high": 102.71875,
    "low": 102.328125,
    "close": 102.6875,
    "priceDate": "2022-08-18T00:00:00-04:00",
    "ticks": 637963776000000000,
    "epochTime": 1660780800,
    "hasValue": true,
    "time": "2022-08-18"
  },
  {
    "open": 102.265625,
    "high": 102.546875,
    "low": 102.03125,
    "close": 102.46875,
    "priceDate": "2022-08-19T00:00:00-04:00",
    "ticks": 637964640000000000,
    "epochTime": 1660867200,
    "hasValue": true,
    "time": "2022-08-19"
  },
  {
    "open": 102.015625,
    "high": 102.453125,
    "low": 102,
    "close": 102.390625,
    "priceDate": "2022-08-22T00:00:00-04:00",
    "ticks": 637967232000000000,
    "epochTime": 1661126400,
    "hasValue": true,
    "time": "2022-08-22"
  },
  {
    "open": 101.96875,
    "high": 102.5625,
    "low": 101.953125,
    "close": 102.546875,
    "priceDate": "2022-08-23T00:00:00-04:00",
    "ticks": 637968096000000000,
    "epochTime": 1661212800,
    "hasValue": true,
    "time": "2022-08-23"
  },
  {
    "open": 102.15625,
    "high": 102.484375,
    "low": 102.046875,
    "close": 102.4375,
    "priceDate": "2022-08-24T00:00:00-04:00",
    "ticks": 637968960000000000,
    "epochTime": 1661299200,
    "hasValue": true,
    "time": "2022-08-24"
  },
  {
    "open": 102.1875,
    "high": 102.765625,
    "low": 101.96875,
    "close": 102.734375,
    "priceDate": "2022-08-25T00:00:00-04:00",
    "ticks": 637969824000000000,
    "epochTime": 1661385600,
    "hasValue": true,
    "time": "2022-08-25"
  },
  {
    "open": 102.328125,
    "high": 102.75,
    "low": 102.28125,
    "close": 102.5,
    "priceDate": "2022-08-26T00:00:00-04:00",
    "ticks": 637970688000000000,
    "epochTime": 1661472000,
    "hasValue": true,
    "time": "2022-08-26"
  },
  {
    "open": 101.96875,
    "high": 102.453125,
    "low": 101.9375,
    "close": 102.4375,
    "priceDate": "2022-08-29T00:00:00-04:00",
    "ticks": 637973280000000000,
    "epochTime": 1661731200,
    "hasValue": true,
    "time": "2022-08-29"
  },
  {
    "open": 102.15625,
    "high": 102.515625,
    "low": 101.984375,
    "close": 102.3125,
    "priceDate": "2022-08-30T00:00:00-04:00",
    "ticks": 637974144000000000,
    "epochTime": 1661817600,
    "hasValue": true,
    "time": "2022-08-30"
  },
  {
    "open": 102.140625,
    "high": 102.46875,
    "low": 101.96875,
    "close": 102.0625,
    "priceDate": "2022-08-31T00:00:00-04:00",
    "ticks": 637975008000000000,
    "epochTime": 1661904000,
    "hasValue": true,
    "time": "2022-08-31"
  },
  {
    "open": 101.96875,
    "high": 102.140625,
    "low": 101.53125,
    "close": 102.046875,
    "priceDate": "2022-09-01T00:00:00-04:00",
    "ticks": 637975872000000000,
    "epochTime": 1661990400,
    "hasValue": true,
    "time": "2022-09-01"
  },
  {
    "open": 101.9375,
    "high": 102.390625,
    "low": 101.609375,
    "close": 102.375,
    "priceDate": "2022-09-02T00:00:00-04:00",
    "ticks": 637976736000000000,
    "epochTime": 1662076800,
    "hasValue": true,
    "time": "2022-09-02"
  },
  {
    "open": 101.953125,
    "high": 102.203125,
    "low": 101.625,
    "close": 101.90625,
    "priceDate": "2022-09-06T00:00:00-04:00",
    "ticks": 637980192000000000,
    "epochTime": 1662422400,
    "hasValue": true,
    "time": "2022-09-06"
  },
  {
    "open": 101.734375,
    "high": 102.328125,
    "low": 101.59375,
    "close": 102.3125,
    "priceDate": "2022-09-07T00:00:00-04:00",
    "ticks": 637981056000000000,
    "epochTime": 1662508800,
    "hasValue": true,
    "time": "2022-09-07"
  },
  {
    "open": 102.0625,
    "high": 102.3125,
    "low": 101.828125,
    "close": 102.140625,
    "priceDate": "2022-09-08T00:00:00-04:00",
    "ticks": 637981920000000000,
    "epochTime": 1662595200,
    "hasValue": true,
    "time": "2022-09-08"
  },
  {
    "open": 102.203125,
    "high": 102.421875,
    "low": 101.796875,
    "close": 102.234375,
    "priceDate": "2022-09-09T00:00:00-04:00",
    "ticks": 637982784000000000,
    "epochTime": 1662681600,
    "hasValue": true,
    "time": "2022-09-09"
  },
  {
    "open": 101.96875,
    "high": 102.375,
    "low": 101.53125,
    "close": 102.078125,
    "priceDate": "2022-09-12T00:00:00-04:00",
    "ticks": 637985376000000000,
    "epochTime": 1662940800,
    "hasValue": true,
    "time": "2022-09-12"
  },
  {
    "open": 101.921875,
    "high": 101.921875,
    "low": 101.046875,
    "close": 101.46875,
    "priceDate": "2022-09-13T00:00:00-04:00",
    "ticks": 637986240000000000,
    "epochTime": 1663027200,
    "hasValue": true,
    "time": "2022-09-13"
  },
  {
    "open": 101.15625,
    "high": 101.515625,
    "low": 101.125,
    "close": 101.46875,
    "priceDate": "2022-09-14T00:00:00-04:00",
    "ticks": 637987104000000000,
    "epochTime": 1663113600,
    "hasValue": true,
    "time": "2022-09-14"
  },
  {
    "open": 101.03125,
    "high": 101.296875,
    "low": 100.984375,
    "close": 101.1875,
    "priceDate": "2022-09-15T00:00:00-04:00",
    "ticks": 637987968000000000,
    "epochTime": 1663200000,
    "hasValue": true,
    "time": "2022-09-15"
  },
  {
    "open": 101.03125,
    "high": 101.171875,
    "low": 100.640625,
    "close": 101.140625,
    "priceDate": "2022-09-16T00:00:00-04:00",
    "ticks": 637988832000000000,
    "epochTime": 1663286400,
    "hasValue": true,
    "time": "2022-09-16"
  },
  {
    "open": 100.65625,
    "high": 101.0625,
    "low": 100.59375,
    "close": 100.953125,
    "priceDate": "2022-09-19T00:00:00-04:00",
    "ticks": 637991424000000000,
    "epochTime": 1663545600,
    "hasValue": true,
    "time": "2022-09-19"
  },
  {
    "open": 100.484375,
    "high": 100.953125,
    "low": 100.4375,
    "close": 100.90625,
    "priceDate": "2022-09-20T00:00:00-04:00",
    "ticks": 637992288000000000,
    "epochTime": 1663632000,
    "hasValue": true,
    "time": "2022-09-20"
  },
  {
    "open": 100.75,
    "high": 101.09375,
    "low": 100.25,
    "close": 100.890625,
    "priceDate": "2022-09-21T00:00:00-04:00",
    "ticks": 637993152000000000,
    "epochTime": 1663718400,
    "hasValue": true,
    "time": "2022-09-21"
  },
  {
    "open": 100.71875,
    "high": 100.75,
    "low": 99.84375,
    "close": 99.90625,
    "priceDate": "2022-09-22T00:00:00-04:00",
    "ticks": 637994016000000000,
    "epochTime": 1663804800,
    "hasValue": true,
    "time": "2022-09-22"
  },
  {
    "open": 99.578125,
    "high": 100.203125,
    "low": 99.296875,
    "close": 99.9375,
    "priceDate": "2022-09-23T00:00:00-04:00",
    "ticks": 637994880000000000,
    "epochTime": 1663891200,
    "hasValue": true,
    "time": "2022-09-23"
  },
  {
    "open": 99.328125,
    "high": 99.671875,
    "low": 98.421875,
    "close": 98.453125,
    "priceDate": "2022-09-26T00:00:00-04:00",
    "ticks": 637997472000000000,
    "epochTime": 1664150400,
    "hasValue": true,
    "time": "2022-09-26"
  },
  {
    "open": 99.3125,
    "high": 99.453125,
    "low": 98.453125,
    "close": 99.203125,
    "priceDate": "2022-09-27T00:00:00-04:00",
    "ticks": 637998336000000000,
    "epochTime": 1664236800,
    "hasValue": true,
    "time": "2022-09-27"
  },
  {
    "open": 99,
    "high": 100.109375,
    "low": 98.984375,
    "close": 100.046875,
    "priceDate": "2022-09-28T00:00:00-04:00",
    "ticks": 637999200000000000,
    "epochTime": 1664323200,
    "hasValue": true,
    "time": "2022-09-28"
  },
  {
    "open": 99.234375,
    "high": 99.984375,
    "low": 99.1875,
    "close": 99.578125,
    "priceDate": "2022-09-29T00:00:00-04:00",
    "ticks": 638000064000000000,
    "epochTime": 1664409600,
    "hasValue": true,
    "time": "2022-09-29"
  },
  {
    "open": 99.484375,
    "high": 99.875,
    "low": 99.109375,
    "close": 99.34375,
    "priceDate": "2022-09-30T00:00:00-04:00",
    "ticks": 638000928000000000,
    "epochTime": 1664496000,
    "hasValue": true,
    "time": "2022-09-30"
  },
  {
    "open": 99.6875,
    "high": 100.359375,
    "low": 99.625,
    "close": 100.15625,
    "priceDate": "2022-10-03T00:00:00-04:00",
    "ticks": 638003520000000000,
    "epochTime": 1664755200,
    "hasValue": true,
    "time": "2022-10-03"
  },
  {
    "open": 100.390625,
    "high": 100.59375,
    "low": 100.09375,
    "close": 100.3125,
    "priceDate": "2022-10-04T00:00:00-04:00",
    "ticks": 638004384000000000,
    "epochTime": 1664841600,
    "hasValue": true,
    "time": "2022-10-04"
  },
  {
    "open": 99.96875,
    "high": 100.140625,
    "low": 99.609375,
    "close": 100,
    "priceDate": "2022-10-05T00:00:00-04:00",
    "ticks": 638005248000000000,
    "epochTime": 1664928000,
    "hasValue": true,
    "time": "2022-10-05"
  },
  {
    "open": 99.734375,
    "high": 100.171875,
    "low": 99.34375,
    "close": 99.421875,
    "priceDate": "2022-10-06T00:00:00-04:00",
    "ticks": 638006112000000000,
    "epochTime": 1665014400,
    "hasValue": true,
    "time": "2022-10-06"
  },
  {
    "open": 99.15625,
    "high": 99.40625,
    "low": 98.828125,
    "close": 99.140625,
    "priceDate": "2022-10-07T00:00:00-04:00",
    "ticks": 638006976000000000,
    "epochTime": 1665100800,
    "hasValue": true,
    "time": "2022-10-07"
  },
  {
    "open": 98.765625,
    "high": 99.234375,
    "low": 98.75,
    "close": 98.84375,
    "priceDate": "2022-10-11T00:00:00-04:00",
    "ticks": 638010432000000000,
    "epochTime": 1665446400,
    "hasValue": true,
    "time": "2022-10-11"
  },
  {
    "open": 98.5,
    "high": 98.828125,
    "low": 98.359375,
    "close": 98.6875,
    "priceDate": "2022-10-12T00:00:00-04:00",
    "ticks": 638011296000000000,
    "epochTime": 1665532800,
    "hasValue": true,
    "time": "2022-10-12"
  },
  {
    "open": 98.6875,
    "high": 98.859375,
    "low": 97.015625,
    "close": 98.609375,
    "priceDate": "2022-10-13T00:00:00-04:00",
    "ticks": 638012160000000000,
    "epochTime": 1665619200,
    "hasValue": true,
    "time": "2022-10-13"
  },
  {
    "open": 98.75,
    "high": 99.03125,
    "low": 97.890625,
    "close": 98.25,
    "priceDate": "2022-10-14T00:00:00-04:00",
    "ticks": 638013024000000000,
    "epochTime": 1665705600,
    "hasValue": true,
    "time": "2022-10-14"
  },
  {
    "open": 98.4375,
    "high": 98.78125,
    "low": 98.390625,
    "close": 98.484375,
    "priceDate": "2022-10-17T00:00:00-04:00",
    "ticks": 638015616000000000,
    "epochTime": 1665964800,
    "hasValue": true,
    "time": "2022-10-17"
  },
  {
    "open": 98.6875,
    "high": 98.921875,
    "low": 98.296875,
    "close": 98.671875,
    "priceDate": "2022-10-18T00:00:00-04:00",
    "ticks": 638016480000000000,
    "epochTime": 1666051200,
    "hasValue": true,
    "time": "2022-10-18"
  },
  {
    "open": 98.125,
    "high": 98.40625,
    "low": 97.890625,
    "close": 98,
    "priceDate": "2022-10-19T00:00:00-04:00",
    "ticks": 638017344000000000,
    "epochTime": 1666137600,
    "hasValue": true,
    "time": "2022-10-19"
  },
  {
    "open": 97.84375,
    "high": 98.015625,
    "low": 97.203125,
    "close": 97.484375,
    "priceDate": "2022-10-20T00:00:00-04:00",
    "ticks": 638018208000000000,
    "epochTime": 1666224000,
    "hasValue": true,
    "time": "2022-10-20"
  },
  {
    "open": 97.109375,
    "high": 97.96875,
    "low": 96.890625,
    "close": 97.84375,
    "priceDate": "2022-10-21T00:00:00-04:00",
    "ticks": 638019072000000000,
    "epochTime": 1666310400,
    "hasValue": true,
    "time": "2022-10-21"
  },
  {
    "open": 97.75,
    "high": 98.03125,
    "low": 97.40625,
    "close": 97.765625,
    "priceDate": "2022-10-24T00:00:00-04:00",
    "ticks": 638021664000000000,
    "epochTime": 1666569600,
    "hasValue": true,
    "time": "2022-10-24"
  },
  {
    "open": 97.796875,
    "high": 98.59375,
    "low": 97.765625,
    "close": 98.453125,
    "priceDate": "2022-10-25T00:00:00-04:00",
    "ticks": 638022528000000000,
    "epochTime": 1666656000,
    "hasValue": true,
    "time": "2022-10-25"
  },
  {
    "open": 98.328125,
    "high": 99.03125,
    "low": 98.328125,
    "close": 98.828125,
    "priceDate": "2022-10-26T00:00:00-04:00",
    "ticks": 638023392000000000,
    "epochTime": 1666742400,
    "hasValue": true,
    "time": "2022-10-26"
  },
  {
    "open": 98.3125,
    "high": 99.484375,
    "low": 98.28125,
    "close": 99.3125,
    "priceDate": "2022-10-27T00:00:00-04:00",
    "ticks": 638024256000000000,
    "epochTime": 1666828800,
    "hasValue": true,
    "time": "2022-10-27"
  },
  {
    "open": 98.78125,
    "high": 99.234375,
    "low": 98.65625,
    "close": 99.046875,
    "priceDate": "2022-10-28T00:00:00-04:00",
    "ticks": 638025120000000000,
    "epochTime": 1666915200,
    "hasValue": true,
    "time": "2022-10-28"
  },
  {
    "open": 98.625,
    "high": 98.828125,
    "low": 98.234375,
    "close": 98.71875,
    "priceDate": "2022-10-31T00:00:00-04:00",
    "ticks": 638027712000000000,
    "epochTime": 1667174400,
    "hasValue": true,
    "time": "2022-10-31"
  },
  {
    "open": 98.8125,
    "high": 99.265625,
    "low": 98.390625,
    "close": 98.8125,
    "priceDate": "2022-11-01T00:00:00-04:00",
    "ticks": 638028576000000000,
    "epochTime": 1667260800,
    "hasValue": true,
    "time": "2022-11-01"
  },
  {
    "open": 98.6875,
    "high": 99.21875,
    "low": 98.140625,
    "close": 98.15625,
    "priceDate": "2022-11-02T00:00:00-04:00",
    "ticks": 638029440000000000,
    "epochTime": 1667347200,
    "hasValue": true,
    "time": "2022-11-02"
  },
  {
    "open": 98.046875,
    "high": 98.40625,
    "low": 97.5625,
    "close": 98.15625,
    "priceDate": "2022-11-03T00:00:00-04:00",
    "ticks": 638030304000000000,
    "epochTime": 1667433600,
    "hasValue": true,
    "time": "2022-11-03"
  },
  {
    "open": 98,
    "high": 98.609375,
    "low": 97.71875,
    "close": 98.53125,
    "priceDate": "2022-11-04T00:00:00-04:00",
    "ticks": 638031168000000000,
    "epochTime": 1667520000,
    "hasValue": true,
    "time": "2022-11-04"
  },
  {
    "open": 98.234375,
    "high": 98.53125,
    "low": 98.125,
    "close": 98.328125,
    "priceDate": "2022-11-07T00:00:00-05:00",
    "ticks": 638033760000000000,
    "epochTime": 1667779200,
    "hasValue": true,
    "time": "2022-11-07"
  },
  {
    "open": 98.140625,
    "high": 98.859375,
    "low": 98.125,
    "close": 98.859375,
    "priceDate": "2022-11-08T00:00:00-05:00",
    "ticks": 638034624000000000,
    "epochTime": 1667865600,
    "hasValue": true,
    "time": "2022-11-08"
  },
  {
    "open": 98.515625,
    "high": 99.078125,
    "low": 98.484375,
    "close": 98.8125,
    "priceDate": "2022-11-09T00:00:00-05:00",
    "ticks": 638035488000000000,
    "epochTime": 1667952000,
    "hasValue": true,
    "time": "2022-11-09"
  },
  {
    "open": 98.75,
    "high": 100.75,
    "low": 98.734375,
    "close": 100.65625,
    "priceDate": "2022-11-10T00:00:00-05:00",
    "ticks": 638036352000000000,
    "epochTime": 1668038400,
    "hasValue": true,
    "time": "2022-11-10"
  },
  {
    "open": 100.078125,
    "high": 100.421875,
    "low": 100.03125,
    "close": 100.296875,
    "priceDate": "2022-11-14T00:00:00-05:00",
    "ticks": 638039808000000000,
    "epochTime": 1668384000,
    "hasValue": true,
    "time": "2022-11-14"
  },
  {
    "open": 100.5,
    "high": 100.84375,
    "low": 100.171875,
    "close": 100.5625,
    "priceDate": "2022-11-15T00:00:00-05:00",
    "ticks": 638040672000000000,
    "epochTime": 1668470400,
    "hasValue": true,
    "time": "2022-11-15"
  },
  {
    "open": 100.34375,
    "high": 100.875,
    "low": 100.140625,
    "close": 100.859375,
    "priceDate": "2022-11-16T00:00:00-05:00",
    "ticks": 638041536000000000,
    "epochTime": 1668556800,
    "hasValue": true,
    "time": "2022-11-16"
  },
  {
    "open": 100.296875,
    "high": 100.6875,
    "low": 100.125,
    "close": 100.625,
    "priceDate": "2022-11-17T00:00:00-05:00",
    "ticks": 638042400000000000,
    "epochTime": 1668643200,
    "hasValue": true,
    "time": "2022-11-17"
  },
  {
    "open": 100.25,
    "high": 100.703125,
    "low": 100.1875,
    "close": 100.453125,
    "priceDate": "2022-11-18T00:00:00-05:00",
    "ticks": 638043264000000000,
    "epochTime": 1668729600,
    "hasValue": true,
    "time": "2022-11-18"
  },
  {
    "open": 100.21875,
    "high": 100.6875,
    "low": 100.171875,
    "close": 100.21875,
    "priceDate": "2022-11-21T00:00:00-05:00",
    "ticks": 638045856000000000,
    "epochTime": 1668988800,
    "hasValue": true,
    "time": "2022-11-21"
  },
  {
    "open": 100.109375,
    "high": 100.625,
    "low": 100.09375,
    "close": 100.5625,
    "priceDate": "2022-11-22T00:00:00-05:00",
    "ticks": 638046720000000000,
    "epochTime": 1669075200,
    "hasValue": true,
    "time": "2022-11-22"
  },
  {
    "open": 100.1875,
    "high": 100.984375,
    "low": 100.171875,
    "close": 100.921875,
    "priceDate": "2022-11-23T00:00:00-05:00",
    "ticks": 638047584000000000,
    "epochTime": 1669161600,
    "hasValue": true,
    "time": "2022-11-23"
  },
  {
    "open": 100.671875,
    "high": 101.015625,
    "low": 100.484375,
    "close": 100.84375,
    "priceDate": "2022-11-25T00:00:00-05:00",
    "ticks": 638049312000000000,
    "epochTime": 1669334400,
    "hasValue": true,
    "time": "2022-11-25"
  },
  {
    "open": 100.921875,
    "high": 100.984375,
    "low": 100.453125,
    "close": 100.75,
    "priceDate": "2022-11-28T00:00:00-05:00",
    "ticks": 638051904000000000,
    "epochTime": 1669593600,
    "hasValue": true,
    "time": "2022-11-28"
  },
  {
    "open": 100.71875,
    "high": 100.71875,
    "low": 100.359375,
    "close": 100.5625,
    "priceDate": "2022-11-29T00:00:00-05:00",
    "ticks": 638052768000000000,
    "epochTime": 1669680000,
    "hasValue": true,
    "time": "2022-11-29"
  },
  {
    "open": 100.359375,
    "high": 101.46875,
    "low": 100.21875,
    "close": 101.34375,
    "priceDate": "2022-11-30T00:00:00-05:00",
    "ticks": 638053632000000000,
    "epochTime": 1669766400,
    "hasValue": true,
    "time": "2022-11-30"
  },
  {
    "open": 101.0625,
    "high": 101.6875,
    "low": 101.046875,
    "close": 101.625,
    "priceDate": "2022-12-01T00:00:00-05:00",
    "ticks": 638054496000000000,
    "epochTime": 1669852800,
    "hasValue": true,
    "time": "2022-12-01"
  },
  {
    "open": 101.578125,
    "high": 101.78125,
    "low": 100.734375,
    "close": 101.6875,
    "priceDate": "2022-12-02T00:00:00-05:00",
    "ticks": 638055360000000000,
    "epochTime": 1669939200,
    "hasValue": true,
    "time": "2022-12-02"
  },
  {
    "open": 101.25,
    "high": 101.484375,
    "low": 100.890625,
    "close": 101.0625,
    "priceDate": "2022-12-05T00:00:00-05:00",
    "ticks": 638057952000000000,
    "epochTime": 1670198400,
    "hasValue": true,
    "time": "2022-12-05"
  },
  {
    "open": 100.84375,
    "high": 101.171875,
    "low": 100.734375,
    "close": 101.125,
    "priceDate": "2022-12-06T00:00:00-05:00",
    "ticks": 638058816000000000,
    "epochTime": 1670284800,
    "hasValue": true,
    "time": "2022-12-06"
  },
  {
    "open": 101.015625,
    "high": 101.453125,
    "low": 100.890625,
    "close": 101.3125,
    "priceDate": "2022-12-07T00:00:00-05:00",
    "ticks": 638059680000000000,
    "epochTime": 1670371200,
    "hasValue": true,
    "time": "2022-12-07"
  },
  {
    "open": 101.046875,
    "high": 101.25,
    "low": 100.796875,
    "close": 101.03125,
    "priceDate": "2022-12-08T00:00:00-05:00",
    "ticks": 638060544000000000,
    "epochTime": 1670457600,
    "hasValue": true,
    "time": "2022-12-08"
  },
  {
    "open": 100.953125,
    "high": 101.140625,
    "low": 100.734375,
    "close": 100.8125,
    "priceDate": "2022-12-09T00:00:00-05:00",
    "ticks": 638061408000000000,
    "epochTime": 1670544000,
    "hasValue": true,
    "time": "2022-12-09"
  },
  {
    "open": 100.875,
    "high": 101,
    "low": 100.484375,
    "close": 100.734375,
    "priceDate": "2022-12-12T00:00:00-05:00",
    "ticks": 638064000000000000,
    "epochTime": 1670803200,
    "hasValue": true,
    "time": "2022-12-12"
  },
  {
    "open": 100.5625,
    "high": 101.65625,
    "low": 100.5,
    "close": 101.25,
    "priceDate": "2022-12-13T00:00:00-05:00",
    "ticks": 638064864000000000,
    "epochTime": 1670889600,
    "hasValue": true,
    "time": "2022-12-13"
  },
  {
    "open": 101.078125,
    "high": 101.5625,
    "low": 100.8125,
    "close": 101.46875,
    "priceDate": "2022-12-14T00:00:00-05:00",
    "ticks": 638065728000000000,
    "epochTime": 1670976000,
    "hasValue": true,
    "time": "2022-12-14"
  },
  {
    "open": 101.140625,
    "high": 101.609375,
    "low": 101,
    "close": 101.546875,
    "priceDate": "2022-12-15T00:00:00-05:00",
    "ticks": 638066592000000000,
    "epochTime": 1671062400,
    "hasValue": true,
    "time": "2022-12-15"
  },
  {
    "open": 101.328125,
    "high": 101.609375,
    "low": 100.9375,
    "close": 101.40625,
    "priceDate": "2022-12-16T00:00:00-05:00",
    "ticks": 638067456000000000,
    "epochTime": 1671148800,
    "hasValue": true,
    "time": "2022-12-16"
  },
  {
    "open": 101.140625,
    "high": 101.21875,
    "low": 100.953125,
    "close": 101.09375,
    "priceDate": "2022-12-19T00:00:00-05:00",
    "ticks": 638070048000000000,
    "epochTime": 1671408000,
    "hasValue": true,
    "time": "2022-12-19"
  },
  {
    "open": 100.671875,
    "high": 101.03125,
    "low": 100.625,
    "close": 100.90625,
    "priceDate": "2022-12-20T00:00:00-05:00",
    "ticks": 638070912000000000,
    "epochTime": 1671494400,
    "hasValue": true,
    "time": "2022-12-20"
  },
  {
    "open": 101.125,
    "high": 101.25,
    "low": 100.875,
    "close": 101.09375,
    "priceDate": "2022-12-21T00:00:00-05:00",
    "ticks": 638071776000000000,
    "epochTime": 1671580800,
    "hasValue": true,
    "time": "2022-12-21"
  },
  {
    "open": 101.03125,
    "high": 101.078125,
    "low": 100.703125,
    "close": 100.953125,
    "priceDate": "2022-12-22T00:00:00-05:00",
    "ticks": 638072640000000000,
    "epochTime": 1671667200,
    "hasValue": true,
    "time": "2022-12-22"
  },
  {
    "open": 100.71875,
    "high": 100.9375,
    "low": 100.484375,
    "close": 100.6875,
    "priceDate": "2022-12-23T00:00:00-05:00",
    "ticks": 638073504000000000,
    "epochTime": 1671753600,
    "hasValue": true,
    "time": "2022-12-23"
  },
  {
    "open": 100.5625,
    "high": 100.640625,
    "low": 100.34375,
    "close": 100.53125,
    "priceDate": "2022-12-27T00:00:00-05:00",
    "ticks": 638076960000000000,
    "epochTime": 1672099200,
    "hasValue": true,
    "time": "2022-12-27"
  },
  {
    "open": 100.53125,
    "high": 100.546875,
    "low": 100.1875,
    "close": 100.3125,
    "priceDate": "2022-12-28T00:00:00-05:00",
    "ticks": 638077824000000000,
    "epochTime": 1672185600,
    "hasValue": true,
    "time": "2022-12-28"
  },
  {
    "open": 100.125,
    "high": 100.640625,
    "low": 100.09375,
    "close": 100.609375,
    "priceDate": "2022-12-29T00:00:00-05:00",
    "ticks": 638078688000000000,
    "epochTime": 1672272000,
    "hasValue": true,
    "time": "2022-12-29"
  },
  {
    "open": 100.328125,
    "high": 100.5,
    "low": 100.078125,
    "close": 100.109375,
    "priceDate": "2022-12-30T00:00:00-05:00",
    "ticks": 638079552000000000,
    "epochTime": 1672358400,
    "hasValue": true,
    "time": "2022-12-30"
  },
  {
    "open": 100.609375,
    "high": 100.796875,
    "low": 100.15625,
    "close": 100.578125,
    "priceDate": "2023-01-03T00:00:00-05:00",
    "ticks": 638083008000000000,
    "epochTime": 1672704000,
    "hasValue": true,
    "time": "2023-01-03"
  },
  {
    "open": 100.53125,
    "high": 100.90625,
    "low": 100.515625,
    "close": 100.796875,
    "priceDate": "2023-01-04T00:00:00-05:00",
    "ticks": 638083872000000000,
    "epochTime": 1672790400,
    "hasValue": true,
    "time": "2023-01-04"
  },
  {
    "open": 100.5625,
    "high": 100.640625,
    "low": 100.3125,
    "close": 100.515625,
    "priceDate": "2023-01-05T00:00:00-05:00",
    "ticks": 638084736000000000,
    "epochTime": 1672876800,
    "hasValue": true,
    "time": "2023-01-05"
  },
  {
    "open": 100.15625,
    "high": 101.4375,
    "low": 100.109375,
    "close": 101.203125,
    "priceDate": "2023-01-06T00:00:00-05:00",
    "ticks": 638085600000000000,
    "epochTime": 1672963200,
    "hasValue": true,
    "time": "2023-01-06"
  },
  {
    "open": 101.171875,
    "high": 101.640625,
    "low": 101.15625,
    "close": 101.359375,
    "priceDate": "2023-01-09T00:00:00-05:00",
    "ticks": 638088192000000000,
    "epochTime": 1673222400,
    "hasValue": true,
    "time": "2023-01-09"
  },
  {
    "open": 100.984375,
    "high": 101.28125,
    "low": 100.9375,
    "close": 101.15625,
    "priceDate": "2023-01-10T00:00:00-05:00",
    "ticks": 638089056000000000,
    "epochTime": 1673308800,
    "hasValue": true,
    "time": "2023-01-10"
  },
  {
    "open": 101.171875,
    "high": 101.421875,
    "low": 101.03125,
    "close": 101.390625,
    "priceDate": "2023-01-11T00:00:00-05:00",
    "ticks": 638089920000000000,
    "epochTime": 1673395200,
    "hasValue": true,
    "time": "2023-01-11"
  },
  {
    "open": 101.359375,
    "high": 101.78125,
    "low": 100.890625,
    "close": 101.703125,
    "priceDate": "2023-01-12T00:00:00-05:00",
    "ticks": 638090784000000000,
    "epochTime": 1673481600,
    "hasValue": true,
    "time": "2023-01-12"
  },
  {
    "open": 101.328125,
    "high": 101.671875,
    "low": 101.28125,
    "close": 101.40625,
    "priceDate": "2023-01-13T00:00:00-05:00",
    "ticks": 638091648000000000,
    "epochTime": 1673568000,
    "hasValue": true,
    "time": "2023-01-13"
  },
  {
    "open": 101.125,
    "high": 101.453125,
    "low": 101.03125,
    "close": 101.234375,
    "priceDate": "2023-01-17T00:00:00-05:00",
    "ticks": 638095104000000000,
    "epochTime": 1673913600,
    "hasValue": true,
    "time": "2023-01-17"
  },
  {
    "open": 101.484375,
    "high": 101.71875,
    "low": 101.375,
    "close": 101.546875,
    "priceDate": "2023-01-18T00:00:00-05:00",
    "ticks": 638095968000000000,
    "epochTime": 1674000000,
    "hasValue": true,
    "time": "2023-01-18"
  },
  {
    "open": 101.4375,
    "high": 101.625,
    "low": 101.203125,
    "close": 101.515625,
    "priceDate": "2023-01-19T00:00:00-05:00",
    "ticks": 638096832000000000,
    "epochTime": 1674086400,
    "hasValue": true,
    "time": "2023-01-19"
  },
  {
    "open": 101.265625,
    "high": 101.46875,
    "low": 101.15625,
    "close": 101.34375,
    "priceDate": "2023-01-20T00:00:00-05:00",
    "ticks": 638097696000000000,
    "epochTime": 1674172800,
    "hasValue": true,
    "time": "2023-01-20"
  },
  {
    "open": 101.140625,
    "high": 101.390625,
    "low": 101.015625,
    "close": 101.25,
    "priceDate": "2023-01-23T00:00:00-05:00",
    "ticks": 638100288000000000,
    "epochTime": 1674432000,
    "hasValue": true,
    "time": "2023-01-23"
  },
  {
    "open": 101.15625,
    "high": 101.4375,
    "low": 100.96875,
    "close": 101.34375,
    "priceDate": "2023-01-24T00:00:00-05:00",
    "ticks": 638101152000000000,
    "epochTime": 1674518400,
    "hasValue": true,
    "time": "2023-01-24"
  },
  {
    "open": 101.390625,
    "high": 101.59375,
    "low": 101.171875,
    "close": 101.5625,
    "priceDate": "2023-01-25T00:00:00-05:00",
    "ticks": 638102016000000000,
    "epochTime": 1674604800,
    "hasValue": true,
    "time": "2023-01-25"
  },
  {
    "open": 101.375,
    "high": 101.5625,
    "low": 101.0625,
    "close": 101.34375,
    "priceDate": "2023-01-26T00:00:00-05:00",
    "ticks": 638102880000000000,
    "epochTime": 1674691200,
    "hasValue": true,
    "time": "2023-01-26"
  },
  {
    "open": 101.15625,
    "high": 101.546875,
    "low": 101.140625,
    "close": 101.5,
    "priceDate": "2023-01-27T00:00:00-05:00",
    "ticks": 638103744000000000,
    "epochTime": 1674777600,
    "hasValue": true,
    "time": "2023-01-27"
  },
  {
    "open": 101.25,
    "high": 101.40625,
    "low": 101.140625,
    "close": 101.359375,
    "priceDate": "2023-01-30T00:00:00-05:00",
    "ticks": 638106336000000000,
    "epochTime": 1675036800,
    "hasValue": true,
    "time": "2023-01-30"
  },
  {
    "open": 101.390625,
    "high": 101.609375,
    "low": 101.296875,
    "close": 101.4375,
    "priceDate": "2023-01-31T00:00:00-05:00",
    "ticks": 638107200000000000,
    "epochTime": 1675123200,
    "hasValue": true,
    "time": "2023-01-31"
  },
  {
    "open": 101.546875,
    "high": 101.921875,
    "low": 101.296875,
    "close": 101.734375,
    "priceDate": "2023-02-01T00:00:00-05:00",
    "ticks": 638108064000000000,
    "epochTime": 1675209600,
    "hasValue": true,
    "time": "2023-02-01"
  },
  {
    "open": 101.875,
    "high": 101.984375,
    "low": 101.578125,
    "close": 101.75,
    "priceDate": "2023-02-02T00:00:00-05:00",
    "ticks": 638108928000000000,
    "epochTime": 1675296000,
    "hasValue": true,
    "time": "2023-02-02"
  },
  {
    "open": 101.65625,
    "high": 101.765625,
    "low": 101.140625,
    "close": 101.3125,
    "priceDate": "2023-02-03T00:00:00-05:00",
    "ticks": 638109792000000000,
    "epochTime": 1675382400,
    "hasValue": true,
    "time": "2023-02-03"
  },
  {
    "open": 101,
    "high": 101.03125,
    "low": 100.6875,
    "close": 100.84375,
    "priceDate": "2023-02-06T00:00:00-05:00",
    "ticks": 638112384000000000,
    "epochTime": 1675641600,
    "hasValue": true,
    "time": "2023-02-06"
  },
  {
    "open": 100.765625,
    "high": 101.125,
    "low": 100.71875,
    "close": 100.90625,
    "priceDate": "2023-02-07T00:00:00-05:00",
    "ticks": 638113248000000000,
    "epochTime": 1675728000,
    "hasValue": true,
    "time": "2023-02-07"
  },
  {
    "open": 100.875,
    "high": 101.09375,
    "low": 100.765625,
    "close": 101.09375,
    "priceDate": "2023-02-08T00:00:00-05:00",
    "ticks": 638114112000000000,
    "epochTime": 1675814400,
    "hasValue": true,
    "time": "2023-02-08"
  },
  {
    "open": 101.015625,
    "high": 101.171875,
    "low": 100.59375,
    "close": 100.734375,
    "priceDate": "2023-02-09T00:00:00-05:00",
    "ticks": 638114976000000000,
    "epochTime": 1675900800,
    "hasValue": true,
    "time": "2023-02-09"
  },
  {
    "open": 100.421875,
    "high": 100.640625,
    "low": 100.203125,
    "close": 100.34375,
    "priceDate": "2023-02-10T00:00:00-05:00",
    "ticks": 638115840000000000,
    "epochTime": 1675987200,
    "hasValue": true,
    "time": "2023-02-10"
  },
  {
    "open": 100.25,
    "high": 100.484375,
    "low": 100.140625,
    "close": 100.4375,
    "priceDate": "2023-02-13T00:00:00-05:00",
    "ticks": 638118432000000000,
    "epochTime": 1676246400,
    "hasValue": true,
    "time": "2023-02-13"
  },
  {
    "open": 100.546875,
    "high": 100.59375,
    "low": 100.046875,
    "close": 100.234375,
    "priceDate": "2023-02-14T00:00:00-05:00",
    "ticks": 638119296000000000,
    "epochTime": 1676332800,
    "hasValue": true,
    "time": "2023-02-14"
  },
  {
    "open": 100.0625,
    "high": 100.28125,
    "low": 99.953125,
    "close": 100.15625,
    "priceDate": "2023-02-15T00:00:00-05:00",
    "ticks": 638120160000000000,
    "epochTime": 1676419200,
    "hasValue": true,
    "time": "2023-02-15"
  },
  {
    "open": 100.21875,
    "high": 100.28125,
    "low": 99.90625,
    "close": 100.078125,
    "priceDate": "2023-02-16T00:00:00-05:00",
    "ticks": 638121024000000000,
    "epochTime": 1676505600,
    "hasValue": true,
    "time": "2023-02-16"
  },
  {
    "open": 99.828125,
    "high": 100.21875,
    "low": 99.8125,
    "close": 100.203125,
    "priceDate": "2023-02-17T00:00:00-05:00",
    "ticks": 638121888000000000,
    "epochTime": 1676592000,
    "hasValue": true,
    "time": "2023-02-17"
  },
  {
    "open": 99.796875,
    "high": 99.875,
    "low": 99.4375,
    "close": 99.546875,
    "priceDate": "2023-02-21T00:00:00-05:00",
    "ticks": 638125344000000000,
    "epochTime": 1676937600,
    "hasValue": true,
    "time": "2023-02-21"
  },
  {
    "open": 99.5,
    "high": 99.921875,
    "low": 99.484375,
    "close": 99.8125,
    "priceDate": "2023-02-22T00:00:00-05:00",
    "ticks": 638126208000000000,
    "epochTime": 1677024000,
    "hasValue": true,
    "time": "2023-02-22"
  },
  {
    "open": 99.65625,
    "high": 100.046875,
    "low": 99.453125,
    "close": 100,
    "priceDate": "2023-02-23T00:00:00-05:00",
    "ticks": 638127072000000000,
    "epochTime": 1677110400,
    "hasValue": true,
    "time": "2023-02-23"
  },
  {
    "open": 99.796875,
    "high": 99.8125,
    "low": 99.390625,
    "close": 99.59375,
    "priceDate": "2023-02-24T00:00:00-05:00",
    "ticks": 638127936000000000,
    "epochTime": 1677196800,
    "hasValue": true,
    "time": "2023-02-24"
  },
  {
    "open": 99.421875,
    "high": 99.875,
    "low": 99.40625,
    "close": 99.8125,
    "priceDate": "2023-02-27T00:00:00-05:00",
    "ticks": 638130528000000000,
    "epochTime": 1677456000,
    "hasValue": true,
    "time": "2023-02-27"
  },
  {
    "open": 99.71875,
    "high": 99.859375,
    "low": 99.5,
    "close": 99.71875,
    "priceDate": "2023-02-28T00:00:00-05:00",
    "ticks": 638131392000000000,
    "epochTime": 1677542400,
    "hasValue": true,
    "time": "2023-02-28"
  },
  {
    "open": 99.546875,
    "high": 99.609375,
    "low": 99.21875,
    "close": 99.375,
    "priceDate": "2023-03-01T00:00:00-05:00",
    "ticks": 638132256000000000,
    "epochTime": 1677628800,
    "hasValue": true,
    "time": "2023-03-01"
  },
  {
    "open": 99.171875,
    "high": 99.21875,
    "low": 98.90625,
    "close": 99.21875,
    "priceDate": "2023-03-02T00:00:00-05:00",
    "ticks": 638133120000000000,
    "epochTime": 1677715200,
    "hasValue": true,
    "time": "2023-03-02"
  },
  {
    "open": 99.1875,
    "high": 99.6875,
    "low": 99.1875,
    "close": 99.65625,
    "priceDate": "2023-03-03T00:00:00-05:00",
    "ticks": 638133984000000000,
    "epochTime": 1677801600,
    "hasValue": true,
    "time": "2023-03-03"
  },
  {
    "open": 99.8125,
    "high": 99.875,
    "low": 99.46875,
    "close": 99.609375,
    "priceDate": "2023-03-06T00:00:00-05:00",
    "ticks": 638136576000000000,
    "epochTime": 1678060800,
    "hasValue": true,
    "time": "2023-03-06"
  },
  {
    "open": 99.671875,
    "high": 99.78125,
    "low": 99.09375,
    "close": 99.328125,
    "priceDate": "2023-03-07T00:00:00-05:00",
    "ticks": 638137440000000000,
    "epochTime": 1678147200,
    "hasValue": true,
    "time": "2023-03-07"
  },
  {
    "open": 99.34375,
    "high": 99.546875,
    "low": 98.921875,
    "close": 99.125,
    "priceDate": "2023-03-08T00:00:00-05:00",
    "ticks": 638138304000000000,
    "epochTime": 1678233600,
    "hasValue": true,
    "time": "2023-03-08"
  },
  {
    "open": 99,
    "high": 99.71875,
    "low": 98.90625,
    "close": 99.703125,
    "priceDate": "2023-03-09T00:00:00-05:00",
    "ticks": 638139168000000000,
    "epochTime": 1678320000,
    "hasValue": true,
    "time": "2023-03-09"
  },
  {
    "open": 99.765625,
    "high": 100.328125,
    "low": 99.6875,
    "close": 99.703125,
    "priceDate": "2023-03-10T00:00:00-05:00",
    "ticks": 638140032000000000,
    "epochTime": 1678406400,
    "hasValue": true,
    "time": "2023-03-10"
  },
  {
    "open": 100.6875,
    "high": 100.953125,
    "low": 100.25,
    "close": 100.3125,
    "priceDate": "2023-03-13T00:00:00-04:00",
    "ticks": 638142624000000000,
    "epochTime": 1678665600,
    "hasValue": true,
    "time": "2023-03-13"
  },
  {
    "open": 100.1875,
    "high": 100.484375,
    "low": 99.953125,
    "close": 100.109375,
    "priceDate": "2023-03-14T00:00:00-04:00",
    "ticks": 638143488000000000,
    "epochTime": 1678752000,
    "hasValue": true,
    "time": "2023-03-14"
  },
  {
    "open": 100.609375,
    "high": 100.953125,
    "low": 100.34375,
    "close": 100.734375,
    "priceDate": "2023-03-15T00:00:00-04:00",
    "ticks": 638144352000000000,
    "epochTime": 1678838400,
    "hasValue": true,
    "time": "2023-03-15"
  },
  {
    "open": 100.640625,
    "high": 100.9375,
    "low": 100.234375,
    "close": 100.40625,
    "priceDate": "2023-03-16T00:00:00-04:00",
    "ticks": 638145216000000000,
    "epochTime": 1678924800,
    "hasValue": true,
    "time": "2023-03-16"
  },
  {
    "open": 100.5,
    "high": 100.9375,
    "low": 100.46875,
    "close": 100.890625,
    "priceDate": "2023-03-17T00:00:00-04:00",
    "ticks": 638146080000000000,
    "epochTime": 1679011200,
    "hasValue": true,
    "time": "2023-03-17"
  },
  {
    "open": 100.875,
    "high": 101.03125,
    "low": 100.40625,
    "close": 100.5625,
    "priceDate": "2023-03-20T00:00:00-04:00",
    "ticks": 638148672000000000,
    "epochTime": 1679270400,
    "hasValue": true,
    "time": "2023-03-20"
  },
  {
    "open": 100.1875,
    "high": 100.53125,
    "low": 100.078125,
    "close": 100.375,
    "priceDate": "2023-03-21T00:00:00-04:00",
    "ticks": 638149536000000000,
    "epochTime": 1679356800,
    "hasValue": true,
    "time": "2023-03-21"
  },
  {
    "open": 100.234375,
    "high": 101.15625,
    "low": 100.171875,
    "close": 101.015625,
    "priceDate": "2023-03-22T00:00:00-04:00",
    "ticks": 638150400000000000,
    "epochTime": 1679443200,
    "hasValue": true,
    "time": "2023-03-22"
  },
  {
    "open": 100.90625,
    "high": 101.296875,
    "low": 100.78125,
    "close": 100.984375,
    "priceDate": "2023-03-23T00:00:00-04:00",
    "ticks": 638151264000000000,
    "epochTime": 1679529600,
    "hasValue": true,
    "time": "2023-03-23"
  },
  {
    "open": 101.296875,
    "high": 101.359375,
    "low": 100.96875,
    "close": 101.171875,
    "priceDate": "2023-03-24T00:00:00-04:00",
    "ticks": 638152128000000000,
    "epochTime": 1679616000,
    "hasValue": true,
    "time": "2023-03-24"
  },
  {
    "open": 100.8125,
    "high": 100.921875,
    "low": 100.640625,
    "close": 100.78125,
    "priceDate": "2023-03-27T00:00:00-04:00",
    "ticks": 638154720000000000,
    "epochTime": 1679875200,
    "hasValue": true,
    "time": "2023-03-27"
  },
  {
    "open": 100.625,
    "high": 100.828125,
    "low": 100.5,
    "close": 100.609375,
    "priceDate": "2023-03-28T00:00:00-04:00",
    "ticks": 638155584000000000,
    "epochTime": 1679961600,
    "hasValue": true,
    "time": "2023-03-28"
  },
  {
    "open": 100.640625,
    "high": 100.8125,
    "low": 100.375,
    "close": 100.765625,
    "priceDate": "2023-03-29T00:00:00-04:00",
    "ticks": 638156448000000000,
    "epochTime": 1680048000,
    "hasValue": true,
    "time": "2023-03-29"
  },
  {
    "open": 100.703125,
    "high": 100.859375,
    "low": 100.390625,
    "close": 100.75,
    "priceDate": "2023-03-30T00:00:00-04:00",
    "ticks": 638157312000000000,
    "epochTime": 1680134400,
    "hasValue": true,
    "time": "2023-03-30"
  },
  {
    "open": 100.625,
    "high": 101.046875,
    "low": 100.59375,
    "close": 101.015625,
    "priceDate": "2023-03-31T00:00:00-04:00",
    "ticks": 638158176000000000,
    "epochTime": 1680220800,
    "hasValue": true,
    "time": "2023-03-31"
  },
  {
    "open": 100.703125,
    "high": 101.21875,
    "low": 100.6875,
    "close": 101.140625,
    "priceDate": "2023-04-03T00:00:00-04:00",
    "ticks": 638160768000000000,
    "epochTime": 1680480000,
    "hasValue": true,
    "time": "2023-04-03"
  },
  {
    "open": 100.9375,
    "high": 101.4375,
    "low": 100.8125,
    "close": 101.3125,
    "priceDate": "2023-04-04T00:00:00-04:00",
    "ticks": 638161632000000000,
    "epochTime": 1680566400,
    "hasValue": true,
    "time": "2023-04-04"
  },
  {
    "open": 101.234375,
    "high": 101.5625,
    "low": 101.140625,
    "close": 101.3125,
    "priceDate": "2023-04-05T00:00:00-04:00",
    "ticks": 638162496000000000,
    "epochTime": 1680652800,
    "hasValue": true,
    "time": "2023-04-05"
  },
  {
    "open": 101.359375,
    "high": 101.46875,
    "low": 101.125,
    "close": 101.171875,
    "priceDate": "2023-04-06T00:00:00-04:00",
    "ticks": 638163360000000000,
    "epochTime": 1680739200,
    "hasValue": true,
    "time": "2023-04-06"
  },
  {
    "open": 101.09375,
    "high": 101.171875,
    "low": 100.6875,
    "close": 100.75,
    "priceDate": "2023-04-07T00:00:00-04:00",
    "ticks": 638164224000000000,
    "epochTime": 1680825600,
    "hasValue": true,
    "time": "2023-04-07"
  },
  {
    "open": 100.90625,
    "high": 100.96875,
    "low": 100.59375,
    "close": 100.703125,
    "priceDate": "2023-04-10T00:00:00-04:00",
    "ticks": 638166816000000000,
    "epochTime": 1681084800,
    "hasValue": true,
    "time": "2023-04-10"
  },
  {
    "open": 100.609375,
    "high": 100.859375,
    "low": 100.46875,
    "close": 100.828125,
    "priceDate": "2023-04-11T00:00:00-04:00",
    "ticks": 638167680000000000,
    "epochTime": 1681171200,
    "hasValue": true,
    "time": "2023-04-11"
  },
  {
    "open": 100.71875,
    "high": 101.25,
    "low": 100.53125,
    "close": 101.046875,
    "priceDate": "2023-04-12T00:00:00-04:00",
    "ticks": 638168544000000000,
    "epochTime": 1681257600,
    "hasValue": true,
    "time": "2023-04-12"
  },
  {
    "open": 100.796875,
    "high": 101.203125,
    "low": 100.78125,
    "close": 100.984375,
    "priceDate": "2023-04-13T00:00:00-04:00",
    "ticks": 638169408000000000,
    "epochTime": 1681344000,
    "hasValue": true,
    "time": "2023-04-13"
  },
  {
    "open": 100.859375,
    "high": 100.921875,
    "low": 100.453125,
    "close": 100.65625,
    "priceDate": "2023-04-14T00:00:00-04:00",
    "ticks": 638170272000000000,
    "epochTime": 1681430400,
    "hasValue": true,
    "time": "2023-04-14"
  },
  {
    "open": 100.328125,
    "high": 100.578125,
    "low": 100.21875,
    "close": 100.328125,
    "priceDate": "2023-04-17T00:00:00-04:00",
    "ticks": 638172864000000000,
    "epochTime": 1681689600,
    "hasValue": true,
    "time": "2023-04-17"
  },
  {
    "open": 100.28125,
    "high": 100.421875,
    "low": 100.21875,
    "close": 100.234375,
    "priceDate": "2023-04-18T00:00:00-04:00",
    "ticks": 638173728000000000,
    "epochTime": 1681776000,
    "hasValue": true,
    "time": "2023-04-18"
  },
  {
    "open": 100.0625,
    "high": 100.359375,
    "low": 99.9375,
    "close": 100.328125,
    "priceDate": "2023-04-19T00:00:00-04:00",
    "ticks": 638174592000000000,
    "epochTime": 1681862400,
    "hasValue": true,
    "time": "2023-04-19"
  },
  {
    "open": 100.34375,
    "high": 100.578125,
    "low": 100.21875,
    "close": 100.546875,
    "priceDate": "2023-04-20T00:00:00-04:00",
    "ticks": 638175456000000000,
    "epochTime": 1681948800,
    "hasValue": true,
    "time": "2023-04-20"
  },
  {
    "open": 100.46875,
    "high": 100.75,
    "low": 100.359375,
    "close": 100.5625,
    "priceDate": "2023-04-21T00:00:00-04:00",
    "ticks": 638176320000000000,
    "epochTime": 1682035200,
    "hasValue": true,
    "time": "2023-04-21"
  },
  {
    "open": 100.53125,
    "high": 100.765625,
    "low": 100.484375,
    "close": 100.609375,
    "priceDate": "2023-04-24T00:00:00-04:00",
    "ticks": 638178912000000000,
    "epochTime": 1682294400,
    "hasValue": true,
    "time": "2023-04-24"
  },
  {
    "open": 100.796875,
    "high": 101,
    "low": 100.734375,
    "close": 100.890625,
    "priceDate": "2023-04-25T00:00:00-04:00",
    "ticks": 638179776000000000,
    "epochTime": 1682380800,
    "hasValue": true,
    "time": "2023-04-25"
  },
  {
    "open": 100.8125,
    "high": 100.859375,
    "low": 100.515625,
    "close": 100.640625,
    "priceDate": "2023-04-26T00:00:00-04:00",
    "ticks": 638180640000000000,
    "epochTime": 1682467200,
    "hasValue": true,
    "time": "2023-04-26"
  },
  {
    "open": 100.609375,
    "high": 100.671875,
    "low": 100.40625,
    "close": 100.546875,
    "priceDate": "2023-04-27T00:00:00-04:00",
    "ticks": 638181504000000000,
    "epochTime": 1682553600,
    "hasValue": true,
    "time": "2023-04-27"
  },
  {
    "open": 100.5625,
    "high": 100.859375,
    "low": 100.484375,
    "close": 100.78125,
    "priceDate": "2023-04-28T00:00:00-04:00",
    "ticks": 638182368000000000,
    "epochTime": 1682640000,
    "hasValue": true,
    "time": "2023-04-28"
  },
  {
    "open": 100.515625,
    "high": 100.75,
    "low": 100.296875,
    "close": 100.4375,
    "priceDate": "2023-05-01T00:00:00-04:00",
    "ticks": 638184960000000000,
    "epochTime": 1682899200,
    "hasValue": true,
    "time": "2023-05-01"
  },
  {
    "open": 100.390625,
    "high": 100.9375,
    "low": 100.328125,
    "close": 100.65625,
    "priceDate": "2023-05-02T00:00:00-04:00",
    "ticks": 638185824000000000,
    "epochTime": 1682985600,
    "hasValue": true,
    "time": "2023-05-02"
  },
  {
    "open": 100.828125,
    "high": 101.140625,
    "low": 100.765625,
    "close": 101.109375,
    "priceDate": "2023-05-03T00:00:00-04:00",
    "ticks": 638186688000000000,
    "epochTime": 1683072000,
    "hasValue": true,
    "time": "2023-05-03"
  },
  {
    "open": 101.046875,
    "high": 101.3125,
    "low": 100.78125,
    "close": 101,
    "priceDate": "2023-05-04T00:00:00-04:00",
    "ticks": 638187552000000000,
    "epochTime": 1683158400,
    "hasValue": true,
    "time": "2023-05-04"
  },
  {
    "open": 100.921875,
    "high": 100.984375,
    "low": 100.609375,
    "close": 100.875,
    "priceDate": "2023-05-05T00:00:00-04:00",
    "ticks": 638188416000000000,
    "epochTime": 1683244800,
    "hasValue": true,
    "time": "2023-05-05"
  },
  {
    "open": 100.625,
    "high": 100.78125,
    "low": 100.484375,
    "close": 100.640625,
    "priceDate": "2023-05-08T00:00:00-04:00",
    "ticks": 638191008000000000,
    "epochTime": 1683504000,
    "hasValue": true,
    "time": "2023-05-08"
  },
  {
    "open": 100.609375,
    "high": 100.671875,
    "low": 100.4375,
    "close": 100.515625,
    "priceDate": "2023-05-09T00:00:00-04:00",
    "ticks": 638191872000000000,
    "epochTime": 1683590400,
    "hasValue": true,
    "time": "2023-05-09"
  },
  {
    "open": 100.40625,
    "high": 100.890625,
    "low": 100.40625,
    "close": 100.859375,
    "priceDate": "2023-05-10T00:00:00-04:00",
    "ticks": 638192736000000000,
    "epochTime": 1683676800,
    "hasValue": true,
    "time": "2023-05-10"
  },
  {
    "open": 100.875,
    "high": 101.078125,
    "low": 100.75,
    "close": 100.96875,
    "priceDate": "2023-05-11T00:00:00-04:00",
    "ticks": 638193600000000000,
    "epochTime": 1683763200,
    "hasValue": true,
    "time": "2023-05-11"
  },
  {
    "open": 100.78125,
    "high": 101.109375,
    "low": 100.46875,
    "close": 100.578125,
    "priceDate": "2023-05-12T00:00:00-04:00",
    "ticks": 638194464000000000,
    "epochTime": 1683849600,
    "hasValue": true,
    "time": "2023-05-12"
  },
  {
    "open": 100.359375,
    "high": 100.578125,
    "low": 100.296875,
    "close": 100.53125,
    "priceDate": "2023-05-15T00:00:00-04:00",
    "ticks": 638197056000000000,
    "epochTime": 1684108800,
    "hasValue": true,
    "time": "2023-05-15"
  },
  {
    "open": 100.46875,
    "high": 100.53125,
    "low": 99.984375,
    "close": 100.421875,
    "priceDate": "2023-05-16T00:00:00-04:00",
    "ticks": 638197920000000000,
    "epochTime": 1684195200,
    "hasValue": true,
    "time": "2023-05-16"
  },
  {
    "open": 100.328125,
    "high": 100.5,
    "low": 100.296875,
    "close": 100.40625,
    "priceDate": "2023-05-17T00:00:00-04:00",
    "ticks": 638198784000000000,
    "epochTime": 1684281600,
    "hasValue": true,
    "time": "2023-05-17"
  },
  {
    "open": 100.203125,
    "high": 100.28125,
    "low": 100,
    "close": 100.15625,
    "priceDate": "2023-05-18T00:00:00-04:00",
    "ticks": 638199648000000000,
    "epochTime": 1684368000,
    "hasValue": true,
    "time": "2023-05-18"
  },
  {
    "open": 100,
    "high": 100.109375,
    "low": 99.859375,
    "close": 100.03125,
    "priceDate": "2023-05-19T00:00:00-04:00",
    "ticks": 638200512000000000,
    "epochTime": 1684454400,
    "hasValue": true,
    "time": "2023-05-19"
  },
  {
    "open": 99.875,
    "high": 99.984375,
    "low": 99.75,
    "close": 99.828125,
    "priceDate": "2023-05-22T00:00:00-04:00",
    "ticks": 638203104000000000,
    "epochTime": 1684713600,
    "hasValue": true,
    "time": "2023-05-22"
  },
  {
    "open": 99.671875,
    "high": 99.875,
    "low": 99.5625,
    "close": 99.84375,
    "priceDate": "2023-05-23T00:00:00-04:00",
    "ticks": 638203968000000000,
    "epochTime": 1684800000,
    "hasValue": true,
    "time": "2023-05-23"
  },
  {
    "open": 99.765625,
    "high": 99.859375,
    "low": 99.328125,
    "close": 99.484375,
    "priceDate": "2023-05-24T00:00:00-04:00",
    "ticks": 638204832000000000,
    "epochTime": 1684886400,
    "hasValue": true,
    "time": "2023-05-24"
  },
  {
    "open": 99.40625,
    "high": 99.40625,
    "low": 98.953125,
    "close": 99.09375,
    "priceDate": "2023-05-25T00:00:00-04:00",
    "ticks": 638205696000000000,
    "epochTime": 1684972800,
    "hasValue": true,
    "time": "2023-05-25"
  },
  {
    "open": 99.109375,
    "high": 99.125,
    "low": 98.78125,
    "close": 99.0625,
    "priceDate": "2023-05-26T00:00:00-04:00",
    "ticks": 638206560000000000,
    "epochTime": 1685059200,
    "hasValue": true,
    "time": "2023-05-26"
  },
  {
    "open": 99.28125,
    "high": 99.65625,
    "low": 99.28125,
    "close": 99.625,
    "priceDate": "2023-05-30T00:00:00-04:00",
    "ticks": 638210016000000000,
    "epochTime": 1685404800,
    "hasValue": true,
    "time": "2023-05-30"
  },
  {
    "open": 99.65625,
    "high": 100.015625,
    "low": 99.515625,
    "close": 99.875,
    "priceDate": "2023-05-31T00:00:00-04:00",
    "ticks": 638210880000000000,
    "epochTime": 1685491200,
    "hasValue": true,
    "time": "2023-05-31"
  },
  {
    "open": 99.75,
    "high": 100.21875,
    "low": 99.671875,
    "close": 100.1875,
    "priceDate": "2023-06-01T00:00:00-04:00",
    "ticks": 638211744000000000,
    "epochTime": 1685577600,
    "hasValue": true,
    "time": "2023-06-01"
  },
  {
    "open": 100.046875,
    "high": 100.171875,
    "low": 99.734375,
    "close": 99.8125,
    "priceDate": "2023-06-02T00:00:00-04:00",
    "ticks": 638212608000000000,
    "epochTime": 1685664000,
    "hasValue": true,
    "time": "2023-06-02"
  },
  {
    "open": 99.5,
    "high": 99.921875,
    "low": 99.484375,
    "close": 99.875,
    "priceDate": "2023-06-05T00:00:00-04:00",
    "ticks": 638215200000000000,
    "epochTime": 1685923200,
    "hasValue": true,
    "time": "2023-06-05"
  },
  {
    "open": 99.75,
    "high": 100.078125,
    "low": 99.59375,
    "close": 100.078125,
    "priceDate": "2023-06-06T00:00:00-04:00",
    "ticks": 638216064000000000,
    "epochTime": 1686009600,
    "hasValue": true,
    "time": "2023-06-06"
  },
  {
    "open": 99.890625,
    "high": 99.984375,
    "low": 99.546875,
    "close": 99.65625,
    "priceDate": "2023-06-07T00:00:00-04:00",
    "ticks": 638216928000000000,
    "epochTime": 1686096000,
    "hasValue": true,
    "time": "2023-06-07"
  },
  {
    "open": 99.484375,
    "high": 100.078125,
    "low": 99.46875,
    "close": 100.015625,
    "priceDate": "2023-06-08T00:00:00-04:00",
    "ticks": 638217792000000000,
    "epochTime": 1686182400,
    "hasValue": true,
    "time": "2023-06-08"
  },
  {
    "open": 99.765625,
    "high": 100.03125,
    "low": 99.546875,
    "close": 100,
    "priceDate": "2023-06-09T00:00:00-04:00",
    "ticks": 638218656000000000,
    "epochTime": 1686268800,
    "hasValue": true,
    "time": "2023-06-09"
  },
  {
    "open": 99.875,
    "high": 100.140625,
    "low": 99.640625,
    "close": 100.09375,
    "priceDate": "2023-06-12T00:00:00-04:00",
    "ticks": 638221248000000000,
    "epochTime": 1686528000,
    "hasValue": true,
    "time": "2023-06-12"
  },
  {
    "open": 100.125,
    "high": 100.359375,
    "low": 99.703125,
    "close": 99.828125,
    "priceDate": "2023-06-13T00:00:00-04:00",
    "ticks": 638222112000000000,
    "epochTime": 1686614400,
    "hasValue": true,
    "time": "2023-06-13"
  },
  {
    "open": 99.796875,
    "high": 99.953125,
    "low": 99.390625,
    "close": 99.828125,
    "priceDate": "2023-06-14T00:00:00-04:00",
    "ticks": 638222976000000000,
    "epochTime": 1686700800,
    "hasValue": true,
    "time": "2023-06-14"
  },
  {
    "open": 99.546875,
    "high": 100.234375,
    "low": 99.484375,
    "close": 100.234375,
    "priceDate": "2023-06-15T00:00:00-04:00",
    "ticks": 638223840000000000,
    "epochTime": 1686787200,
    "hasValue": true,
    "time": "2023-06-15"
  },
  {
    "open": 100.015625,
    "high": 100.125,
    "low": 99.765625,
    "close": 100.078125,
    "priceDate": "2023-06-16T00:00:00-04:00",
    "ticks": 638224704000000000,
    "epochTime": 1686873600,
    "hasValue": true,
    "time": "2023-06-16"
  },
  {
    "open": 100.078125,
    "high": 100.234375,
    "low": 99.796875,
    "close": 100.015625,
    "priceDate": "2023-06-20T00:00:00-04:00",
    "ticks": 638228160000000000,
    "epochTime": 1687219200,
    "hasValue": true,
    "time": "2023-06-20"
  },
  {
    "open": 99.828125,
    "high": 100.140625,
    "low": 99.734375,
    "close": 100.109375,
    "priceDate": "2023-06-21T00:00:00-04:00",
    "ticks": 638229024000000000,
    "epochTime": 1687305600,
    "hasValue": true,
    "time": "2023-06-21"
  },
  {
    "open": 99.953125,
    "high": 100.0625,
    "low": 99.625,
    "close": 99.671875,
    "priceDate": "2023-06-22T00:00:00-04:00",
    "ticks": 638229888000000000,
    "epochTime": 1687392000,
    "hasValue": true,
    "time": "2023-06-22"
  },
  {
    "open": 99.8125,
    "high": 99.984375,
    "low": 99.703125,
    "close": 99.890625,
    "priceDate": "2023-06-23T00:00:00-04:00",
    "ticks": 638230752000000000,
    "epochTime": 1687478400,
    "hasValue": true,
    "time": "2023-06-23"
  },
  {
    "open": 99.84375,
    "high": 100.0625,
    "low": 99.734375,
    "close": 99.9375,
    "priceDate": "2023-06-26T00:00:00-04:00",
    "ticks": 638233344000000000,
    "epochTime": 1687737600,
    "hasValue": true,
    "time": "2023-06-26"
  },
  {
    "open": 99.8125,
    "high": 100.0625,
    "low": 99.71875,
    "close": 99.796875,
    "priceDate": "2023-06-27T00:00:00-04:00",
    "ticks": 638234208000000000,
    "epochTime": 1687824000,
    "hasValue": true,
    "time": "2023-06-27"
  },
  {
    "open": 99.828125,
    "high": 100.03125,
    "low": 99.71875,
    "close": 99.984375,
    "priceDate": "2023-06-28T00:00:00-04:00",
    "ticks": 638235072000000000,
    "epochTime": 1687910400,
    "hasValue": true,
    "time": "2023-06-28"
  },
  {
    "open": 99.734375,
    "high": 99.78125,
    "low": 99.203125,
    "close": 99.390625,
    "priceDate": "2023-06-29T00:00:00-04:00",
    "ticks": 638235936000000000,
    "epochTime": 1687996800,
    "hasValue": true,
    "time": "2023-06-29"
  },
  {
    "open": 99.21875,
    "high": 99.578125,
    "low": 99.171875,
    "close": 99.453125,
    "priceDate": "2023-06-30T00:00:00-04:00",
    "ticks": 638236800000000000,
    "epochTime": 1688083200,
    "hasValue": true,
    "time": "2023-06-30"
  },
  {
    "open": 99.234375,
    "high": 99.578125,
    "low": 99.15625,
    "close": 99.171875,
    "priceDate": "2023-07-03T00:00:00-04:00",
    "ticks": 638239392000000000,
    "epochTime": 1688342400,
    "hasValue": true,
    "time": "2023-07-03"
  },
  {
    "open": 99.109375,
    "high": 99.28125,
    "low": 98.8125,
    "close": 98.921875,
    "priceDate": "2023-07-05T00:00:00-04:00",
    "ticks": 638241120000000000,
    "epochTime": 1688515200,
    "hasValue": true,
    "time": "2023-07-05"
  },
  {
    "open": 98.625,
    "high": 98.65625,
    "low": 97.96875,
    "close": 98.453125,
    "priceDate": "2023-07-06T00:00:00-04:00",
    "ticks": 638241984000000000,
    "epochTime": 1688601600,
    "hasValue": true,
    "time": "2023-07-06"
  },
  {
    "open": 98.234375,
    "high": 98.71875,
    "low": 98.109375,
    "close": 98.328125,
    "priceDate": "2023-07-07T00:00:00-04:00",
    "ticks": 638242848000000000,
    "epochTime": 1688688000,
    "hasValue": true,
    "time": "2023-07-07"
  },
  {
    "open": 98.453125,
    "high": 98.875,
    "low": 98.34375,
    "close": 98.78125,
    "priceDate": "2023-07-10T00:00:00-04:00",
    "ticks": 638245440000000000,
    "epochTime": 1688947200,
    "hasValue": true,
    "time": "2023-07-10"
  },
  {
    "open": 98.734375,
    "high": 98.875,
    "low": 98.625,
    "close": 98.84375,
    "priceDate": "2023-07-11T00:00:00-04:00",
    "ticks": 638246304000000000,
    "epochTime": 1689033600,
    "hasValue": true,
    "time": "2023-07-11"
  },
  {
    "open": 98.828125,
    "high": 99.65625,
    "low": 98.796875,
    "close": 99.609375,
    "priceDate": "2023-07-12T00:00:00-04:00",
    "ticks": 638247168000000000,
    "epochTime": 1689120000,
    "hasValue": true,
    "time": "2023-07-12"
  },
  {
    "open": 99.828125,
    "high": 100.09375,
    "low": 99.703125,
    "close": 100.015625,
    "priceDate": "2023-07-13T00:00:00-04:00",
    "ticks": 638248032000000000,
    "epochTime": 1689206400,
    "hasValue": true,
    "time": "2023-07-13"
  },
  {
    "open": 99.84375,
    "high": 99.96875,
    "low": 99.453125,
    "close": 99.609375,
    "priceDate": "2023-07-14T00:00:00-04:00",
    "ticks": 638248896000000000,
    "epochTime": 1689292800,
    "hasValue": true,
    "time": "2023-07-14"
  },
  {
    "open": 99.71875,
    "high": 99.8125,
    "low": 99.4375,
    "close": 99.734375,
    "priceDate": "2023-07-17T00:00:00-04:00",
    "ticks": 638251488000000000,
    "epochTime": 1689552000,
    "hasValue": true,
    "time": "2023-07-17"
  },
  {
    "open": 99.890625,
    "high": 100,
    "low": 99.671875,
    "close": 99.734375,
    "priceDate": "2023-07-18T00:00:00-04:00",
    "ticks": 638252352000000000,
    "epochTime": 1689638400,
    "hasValue": true,
    "time": "2023-07-18"
  },
  {
    "open": 99.875,
    "high": 100,
    "low": 99.5625,
    "close": 99.8125,
    "priceDate": "2023-07-19T00:00:00-04:00",
    "ticks": 638253216000000000,
    "epochTime": 1689724800,
    "hasValue": true,
    "time": "2023-07-19"
  },
  {
    "open": 99.484375,
    "high": 99.546875,
    "low": 99.15625,
    "close": 99.46875,
    "priceDate": "2023-07-20T00:00:00-04:00",
    "ticks": 638254080000000000,
    "epochTime": 1689811200,
    "hasValue": true,
    "time": "2023-07-20"
  },
  {
    "open": 99.4375,
    "high": 99.65625,
    "low": 99.328125,
    "close": 99.5,
    "priceDate": "2023-07-21T00:00:00-04:00",
    "ticks": 638254944000000000,
    "epochTime": 1689897600,
    "hasValue": true,
    "time": "2023-07-21"
  },
  {
    "open": 99.5,
    "high": 99.65625,
    "low": 99.328125,
    "close": 99.40625,
    "priceDate": "2023-07-24T00:00:00-04:00",
    "ticks": 638257536000000000,
    "epochTime": 1690156800,
    "hasValue": true,
    "time": "2023-07-24"
  },
  {
    "open": 99.21875,
    "high": 99.390625,
    "low": 99.171875,
    "close": 99.359375,
    "priceDate": "2023-07-25T00:00:00-04:00",
    "ticks": 638258400000000000,
    "epochTime": 1690243200,
    "hasValue": true,
    "time": "2023-07-25"
  },
  {
    "open": 99.25,
    "high": 99.640625,
    "low": 99.1875,
    "close": 99.5,
    "priceDate": "2023-07-26T00:00:00-04:00",
    "ticks": 638259264000000000,
    "epochTime": 1690329600,
    "hasValue": true,
    "time": "2023-07-26"
  },
  {
    "open": 99.421875,
    "high": 99.59375,
    "low": 98.75,
    "close": 98.9375,
    "priceDate": "2023-07-27T00:00:00-04:00",
    "ticks": 638260128000000000,
    "epochTime": 1690416000,
    "hasValue": true,
    "time": "2023-07-27"
  },
  {
    "open": 99.09375,
    "high": 99.3125,
    "low": 99.046875,
    "close": 99.3125,
    "priceDate": "2023-07-28T00:00:00-04:00",
    "ticks": 638260992000000000,
    "epochTime": 1690502400,
    "hasValue": true,
    "time": "2023-07-28"
  },
  {
    "open": 99.140625,
    "high": 99.421875,
    "low": 99.125,
    "close": 99.25,
    "priceDate": "2023-07-31T00:00:00-04:00",
    "ticks": 638263584000000000,
    "epochTime": 1690761600,
    "hasValue": true,
    "time": "2023-07-31"
  },
  {
    "open": 99,
    "high": 99.03125,
    "low": 98.71875,
    "close": 98.90625,
    "priceDate": "2023-08-01T00:00:00-04:00",
    "ticks": 638264448000000000,
    "epochTime": 1690848000,
    "hasValue": true,
    "time": "2023-08-01"
  },
  {
    "open": 98.84375,
    "high": 98.90625,
    "low": 98.21875,
    "close": 98.6875,
    "priceDate": "2023-08-02T00:00:00-04:00",
    "ticks": 638265312000000000,
    "epochTime": 1690934400,
    "hasValue": true,
    "time": "2023-08-02"
  },
  {
    "open": 98.390625,
    "high": 98.421875,
    "low": 98.125,
    "close": 98.359375,
    "priceDate": "2023-08-03T00:00:00-04:00",
    "ticks": 638266176000000000,
    "epochTime": 1691020800,
    "hasValue": true,
    "time": "2023-08-03"
  },
  {
    "open": 98.21875,
    "high": 99.0625,
    "low": 98.09375,
    "close": 99.0625,
    "priceDate": "2023-08-04T00:00:00-04:00",
    "ticks": 638267040000000000,
    "epochTime": 1691107200,
    "hasValue": true,
    "time": "2023-08-04"
  },
  {
    "open": 98.671875,
    "high": 99.0625,
    "low": 98.609375,
    "close": 98.90625,
    "priceDate": "2023-08-07T00:00:00-04:00",
    "ticks": 638269632000000000,
    "epochTime": 1691366400,
    "hasValue": true,
    "time": "2023-08-07"
  },
  {
    "open": 99.140625,
    "high": 99.203125,
    "low": 98.734375,
    "close": 98.96875,
    "priceDate": "2023-08-08T00:00:00-04:00",
    "ticks": 638270496000000000,
    "epochTime": 1691452800,
    "hasValue": true,
    "time": "2023-08-08"
  },
  {
    "open": 98.84375,
    "high": 99.140625,
    "low": 98.78125,
    "close": 99.078125,
    "priceDate": "2023-08-09T00:00:00-04:00",
    "ticks": 638271360000000000,
    "epochTime": 1691539200,
    "hasValue": true,
    "time": "2023-08-09"
  },
  {
    "open": 99.203125,
    "high": 99.296875,
    "low": 98.5,
    "close": 98.578125,
    "priceDate": "2023-08-10T00:00:00-04:00",
    "ticks": 638272224000000000,
    "epochTime": 1691625600,
    "hasValue": true,
    "time": "2023-08-10"
  },
  {
    "open": 98.609375,
    "high": 98.609375,
    "low": 98.09375,
    "close": 98.359375,
    "priceDate": "2023-08-11T00:00:00-04:00",
    "ticks": 638273088000000000,
    "epochTime": 1691712000,
    "hasValue": true,
    "time": "2023-08-11"
  },
  {
    "open": 98.234375,
    "high": 98.296875,
    "low": 97.75,
    "close": 98.0625,
    "priceDate": "2023-08-14T00:00:00-04:00",
    "ticks": 638275680000000000,
    "epochTime": 1691971200,
    "hasValue": true,
    "time": "2023-08-14"
  },
  {
    "open": 97.78125,
    "high": 98.1875,
    "low": 97.59375,
    "close": 97.90625,
    "priceDate": "2023-08-15T00:00:00-04:00",
    "ticks": 638276544000000000,
    "epochTime": 1692057600,
    "hasValue": true,
    "time": "2023-08-15"
  },
  {
    "open": 97.921875,
    "high": 98.109375,
    "low": 97.515625,
    "close": 97.75,
    "priceDate": "2023-08-16T00:00:00-04:00",
    "ticks": 638277408000000000,
    "epochTime": 1692144000,
    "hasValue": true,
    "time": "2023-08-16"
  },
  {
    "open": 97.578125,
    "high": 97.765625,
    "low": 97.3125,
    "close": 97.703125,
    "priceDate": "2023-08-17T00:00:00-04:00",
    "ticks": 638278272000000000,
    "epochTime": 1692230400,
    "hasValue": true,
    "time": "2023-08-17"
  },
  {
    "open": 97.78125,
    "high": 97.859375,
    "low": 97.53125,
    "close": 97.640625,
    "priceDate": "2023-08-18T00:00:00-04:00",
    "ticks": 638279136000000000,
    "epochTime": 1692316800,
    "hasValue": true,
    "time": "2023-08-18"
  },
  {
    "open": 97.375,
    "high": 97.453125,
    "low": 97.109375,
    "close": 97.328125,
    "priceDate": "2023-08-21T00:00:00-04:00",
    "ticks": 638281728000000000,
    "epochTime": 1692576000,
    "hasValue": true,
    "time": "2023-08-21"
  },
  {
    "open": 97.328125,
    "high": 97.46875,
    "low": 97.078125,
    "close": 97.390625,
    "priceDate": "2023-08-22T00:00:00-04:00",
    "ticks": 638282592000000000,
    "epochTime": 1692662400,
    "hasValue": true,
    "time": "2023-08-22"
  },
  {
    "open": 97.453125,
    "high": 98.078125,
    "low": 97.453125,
    "close": 98.046875,
    "priceDate": "2023-08-23T00:00:00-04:00",
    "ticks": 638283456000000000,
    "epochTime": 1692748800,
    "hasValue": true,
    "time": "2023-08-23"
  },
  {
    "open": 97.859375,
    "high": 97.953125,
    "low": 97.71875,
    "close": 97.8125,
    "priceDate": "2023-08-24T00:00:00-04:00",
    "ticks": 638284320000000000,
    "epochTime": 1692835200,
    "hasValue": true,
    "time": "2023-08-24"
  },
  {
    "open": 97.703125,
    "high": 97.953125,
    "low": 97.375,
    "close": 97.90625,
    "priceDate": "2023-08-25T00:00:00-04:00",
    "ticks": 638285184000000000,
    "epochTime": 1692921600,
    "hasValue": true,
    "time": "2023-08-25"
  },
  {
    "open": 97.96875,
    "high": 98.1875,
    "low": 97.859375,
    "close": 98.1875,
    "priceDate": "2023-08-28T00:00:00-04:00",
    "ticks": 638287776000000000,
    "epochTime": 1693180800,
    "hasValue": true,
    "time": "2023-08-28"
  },
  {
    "open": 98,
    "high": 98.734375,
    "low": 97.90625,
    "close": 98.65625,
    "priceDate": "2023-08-29T00:00:00-04:00",
    "ticks": 638288640000000000,
    "epochTime": 1693267200,
    "hasValue": true,
    "time": "2023-08-29"
  },
  {
    "open": 98.484375,
    "high": 98.859375,
    "low": 98.40625,
    "close": 98.640625,
    "priceDate": "2023-08-30T00:00:00-04:00",
    "ticks": 638289504000000000,
    "epochTime": 1693353600,
    "hasValue": true,
    "time": "2023-08-30"
  },
  {
    "open": 98.734375,
    "high": 98.859375,
    "low": 98.625,
    "close": 98.734375,
    "priceDate": "2023-08-31T00:00:00-04:00",
    "ticks": 638290368000000000,
    "epochTime": 1693440000,
    "hasValue": true,
    "time": "2023-08-31"
  },
  {
    "open": 98.75,
    "high": 99,
    "low": 98.296875,
    "close": 98.625,
    "priceDate": "2023-09-01T00:00:00-04:00",
    "ticks": 638291232000000000,
    "epochTime": 1693526400,
    "hasValue": true,
    "time": "2023-09-01"
  },
  {
    "open": 98.59375,
    "high": 98.59375,
    "low": 98.09375,
    "close": 98.125,
    "priceDate": "2023-09-05T00:00:00-04:00",
    "ticks": 638294688000000000,
    "epochTime": 1693872000,
    "hasValue": true,
    "time": "2023-09-05"
  },
  {
    "open": 98.15625,
    "high": 98.203125,
    "low": 97.796875,
    "close": 98,
    "priceDate": "2023-09-06T00:00:00-04:00",
    "ticks": 638295552000000000,
    "epochTime": 1693958400,
    "hasValue": true,
    "time": "2023-09-06"
  },
  {
    "open": 97.96875,
    "high": 98.3125,
    "low": 97.90625,
    "close": 98.296875,
    "priceDate": "2023-09-07T00:00:00-04:00",
    "ticks": 638296416000000000,
    "epochTime": 1694044800,
    "hasValue": true,
    "time": "2023-09-07"
  },
  {
    "open": 98.296875,
    "high": 98.4375,
    "low": 98.203125,
    "close": 98.234375,
    "priceDate": "2023-09-08T00:00:00-04:00",
    "ticks": 638297280000000000,
    "epochTime": 1694131200,
    "hasValue": true,
    "time": "2023-09-08"
  },
  {
    "open": 98.078125,
    "high": 98.234375,
    "low": 98,
    "close": 98.171875,
    "priceDate": "2023-09-11T00:00:00-04:00",
    "ticks": 638299872000000000,
    "epochTime": 1694390400,
    "hasValue": true,
    "time": "2023-09-11"
  },
  {
    "open": 97.921875,
    "high": 98.25,
    "low": 97.921875,
    "close": 98.171875,
    "priceDate": "2023-09-12T00:00:00-04:00",
    "ticks": 638300736000000000,
    "epochTime": 1694476800,
    "hasValue": true,
    "time": "2023-09-12"
  },
  {
    "open": 97.96875,
    "high": 98.453125,
    "low": 97.6875,
    "close": 98.453125,
    "priceDate": "2023-09-13T00:00:00-04:00",
    "ticks": 638301600000000000,
    "epochTime": 1694563200,
    "hasValue": true,
    "time": "2023-09-13"
  },
  {
    "open": 98.375,
    "high": 98.59375,
    "low": 98.046875,
    "close": 98.296875,
    "priceDate": "2023-09-14T00:00:00-04:00",
    "ticks": 638302464000000000,
    "epochTime": 1694649600,
    "hasValue": true,
    "time": "2023-09-14"
  },
  {
    "open": 98.078125,
    "high": 98.171875,
    "low": 97.875,
    "close": 98,
    "priceDate": "2023-09-15T00:00:00-04:00",
    "ticks": 638303328000000000,
    "epochTime": 1694736000,
    "hasValue": true,
    "time": "2023-09-15"
  },
  {
    "open": 97.859375,
    "high": 98.21875,
    "low": 97.75,
    "close": 98.1875,
    "priceDate": "2023-09-18T00:00:00-04:00",
    "ticks": 638305920000000000,
    "epochTime": 1694995200,
    "hasValue": true,
    "time": "2023-09-18"
  },
  {
    "open": 98.015625,
    "high": 98.09375,
    "low": 97.765625,
    "close": 97.9375,
    "priceDate": "2023-09-19T00:00:00-04:00",
    "ticks": 638306784000000000,
    "epochTime": 1695081600,
    "hasValue": true,
    "time": "2023-09-19"
  },
  {
    "open": 97.875,
    "high": 98.171875,
    "low": 97.421875,
    "close": 97.5,
    "priceDate": "2023-09-20T00:00:00-04:00",
    "ticks": 638307648000000000,
    "epochTime": 1695168000,
    "hasValue": true,
    "time": "2023-09-20"
  },
  {
    "open": 97.265625,
    "high": 97.375,
    "low": 97.03125,
    "close": 97.171875,
    "priceDate": "2023-09-21T00:00:00-04:00",
    "ticks": 638308512000000000,
    "epochTime": 1695254400,
    "hasValue": true,
    "time": "2023-09-21"
  },
  {
    "open": 97.171875,
    "high": 97.625,
    "low": 97.171875,
    "close": 97.53125,
    "priceDate": "2023-09-22T00:00:00-04:00",
    "ticks": 638309376000000000,
    "epochTime": 1695340800,
    "hasValue": true,
    "time": "2023-09-22"
  },
  {
    "open": 97.171875,
    "high": 97.203125,
    "low": 96.703125,
    "close": 96.984375,
    "priceDate": "2023-09-25T00:00:00-04:00",
    "ticks": 638311968000000000,
    "epochTime": 1695600000,
    "hasValue": true,
    "time": "2023-09-25"
  },
  {
    "open": 97.0625,
    "high": 97.15625,
    "low": 96.59375,
    "close": 96.875,
    "priceDate": "2023-09-26T00:00:00-04:00",
    "ticks": 638312832000000000,
    "epochTime": 1695686400,
    "hasValue": true,
    "time": "2023-09-26"
  },
  {
    "open": 96.875,
    "high": 97.078125,
    "low": 96.125,
    "close": 96.359375,
    "priceDate": "2023-09-27T00:00:00-04:00",
    "ticks": 638313696000000000,
    "epochTime": 1695772800,
    "hasValue": true,
    "time": "2023-09-27"
  },
  {
    "open": 96.234375,
    "high": 96.734375,
    "low": 95.875,
    "close": 96.734375,
    "priceDate": "2023-09-28T00:00:00-04:00",
    "ticks": 638314560000000000,
    "epochTime": 1695859200,
    "hasValue": true,
    "time": "2023-09-28"
  },
  {
    "open": 96.71875,
    "high": 97.09375,
    "low": 96.484375,
    "close": 96.5625,
    "priceDate": "2023-09-29T00:00:00-04:00",
    "ticks": 638315424000000000,
    "epochTime": 1695945600,
    "hasValue": true,
    "time": "2023-09-29"
  },
  {
    "open": 96.234375,
    "high": 96.296875,
    "low": 95.890625,
    "close": 95.96875,
    "priceDate": "2023-10-02T00:00:00-04:00",
    "ticks": 638318016000000000,
    "epochTime": 1696204800,
    "hasValue": true,
    "time": "2023-10-02"
  },
  {
    "open": 95.515625,
    "high": 95.84375,
    "low": 95.015625,
    "close": 95.21875,
    "priceDate": "2023-10-03T00:00:00-04:00",
    "ticks": 638318880000000000,
    "epochTime": 1696291200,
    "hasValue": true,
    "time": "2023-10-03"
  },
  {
    "open": 95.375,
    "high": 95.84375,
    "low": 95.171875,
    "close": 95.671875,
    "priceDate": "2023-10-04T00:00:00-04:00",
    "ticks": 638319744000000000,
    "epochTime": 1696377600,
    "hasValue": true,
    "time": "2023-10-04"
  },
  {
    "open": 95.65625,
    "high": 95.84375,
    "low": 95.328125,
    "close": 95.78125,
    "priceDate": "2023-10-05T00:00:00-04:00",
    "ticks": 638320608000000000,
    "epochTime": 1696464000,
    "hasValue": true,
    "time": "2023-10-05"
  },
  {
    "open": 95.5625,
    "high": 95.578125,
    "low": 94.734375,
    "close": 95.390625,
    "priceDate": "2023-10-06T00:00:00-04:00",
    "ticks": 638321472000000000,
    "epochTime": 1696550400,
    "hasValue": true,
    "time": "2023-10-06"
  },
  {
    "open": 95.859375,
    "high": 96.3125,
    "low": 95.84375,
    "close": 96.046875,
    "priceDate": "2023-10-10T00:00:00-04:00",
    "ticks": 638324928000000000,
    "epochTime": 1696896000,
    "hasValue": true,
    "time": "2023-10-10"
  },
  {
    "open": 96.328125,
    "high": 96.515625,
    "low": 96.09375,
    "close": 96.515625,
    "priceDate": "2023-10-11T00:00:00-04:00",
    "ticks": 638325792000000000,
    "epochTime": 1696982400,
    "hasValue": true,
    "time": "2023-10-11"
  },
  {
    "open": 96.421875,
    "high": 96.484375,
    "low": 95.53125,
    "close": 95.765625,
    "priceDate": "2023-10-12T00:00:00-04:00",
    "ticks": 638326656000000000,
    "epochTime": 1697068800,
    "hasValue": true,
    "time": "2023-10-12"
  },
  {
    "open": 96.0625,
    "high": 96.234375,
    "low": 95.84375,
    "close": 96.03125,
    "priceDate": "2023-10-13T00:00:00-04:00",
    "ticks": 638327520000000000,
    "epochTime": 1697155200,
    "hasValue": true,
    "time": "2023-10-13"
  },
  {
    "open": 95.59375,
    "high": 95.78125,
    "low": 95.390625,
    "close": 95.5625,
    "priceDate": "2023-10-16T00:00:00-04:00",
    "ticks": 638330112000000000,
    "epochTime": 1697414400,
    "hasValue": true,
    "time": "2023-10-16"
  },
  {
    "open": 95.09375,
    "high": 95.171875,
    "low": 94.609375,
    "close": 94.84375,
    "priceDate": "2023-10-17T00:00:00-04:00",
    "ticks": 638330976000000000,
    "epochTime": 1697500800,
    "hasValue": true,
    "time": "2023-10-17"
  },
  {
    "open": 94.734375,
    "high": 94.828125,
    "low": 94.234375,
    "close": 94.359375,
    "priceDate": "2023-10-18T00:00:00-04:00",
    "ticks": 638331840000000000,
    "epochTime": 1697587200,
    "hasValue": true,
    "time": "2023-10-18"
  },
  {
    "open": 93.96875,
    "high": 94.328125,
    "low": 93.875,
    "close": 93.96875,
    "priceDate": "2023-10-19T00:00:00-04:00",
    "ticks": 638332704000000000,
    "epochTime": 1697673600,
    "hasValue": true,
    "time": "2023-10-19"
  },
  {
    "open": 94.03125,
    "high": 94.4375,
    "low": 93.921875,
    "close": 94.203125,
    "priceDate": "2023-10-20T00:00:00-04:00",
    "ticks": 638333568000000000,
    "epochTime": 1697760000,
    "hasValue": true,
    "time": "2023-10-20"
  },
  {
    "open": 93.59375,
    "high": 94.578125,
    "low": 93.578125,
    "close": 94.515625,
    "priceDate": "2023-10-23T00:00:00-04:00",
    "ticks": 638336160000000000,
    "epochTime": 1698019200,
    "hasValue": true,
    "time": "2023-10-23"
  },
  {
    "open": 94.28125,
    "high": 94.875,
    "low": 94.265625,
    "close": 94.84375,
    "priceDate": "2023-10-24T00:00:00-04:00",
    "ticks": 638337024000000000,
    "epochTime": 1698105600,
    "hasValue": true,
    "time": "2023-10-24"
  },
  {
    "open": 94.59375,
    "high": 94.65625,
    "low": 93.9375,
    "close": 94.0625,
    "priceDate": "2023-10-25T00:00:00-04:00",
    "ticks": 638337888000000000,
    "epochTime": 1698192000,
    "hasValue": true,
    "time": "2023-10-25"
  },
  {
    "open": 93.9375,
    "high": 94.8125,
    "low": 93.84375,
    "close": 94.734375,
    "priceDate": "2023-10-26T00:00:00-04:00",
    "ticks": 638338752000000000,
    "epochTime": 1698278400,
    "hasValue": true,
    "time": "2023-10-26"
  },
  {
    "open": 94.578125,
    "high": 94.84375,
    "low": 94.53125,
    "close": 94.765625,
    "priceDate": "2023-10-27T00:00:00-04:00",
    "ticks": 638339616000000000,
    "epochTime": 1698364800,
    "hasValue": true,
    "time": "2023-10-27"
  },
  {
    "open": 94.453125,
    "high": 94.859375,
    "low": 94.421875,
    "close": 94.734375,
    "priceDate": "2023-10-30T00:00:00-04:00",
    "ticks": 638342208000000000,
    "epochTime": 1698624000,
    "hasValue": true,
    "time": "2023-10-30"
  },
  {
    "open": 94.9375,
    "high": 95.125,
    "low": 94.515625,
    "close": 94.5625,
    "priceDate": "2023-10-31T00:00:00-04:00",
    "ticks": 638343072000000000,
    "epochTime": 1698710400,
    "hasValue": true,
    "time": "2023-10-31"
  },
  {
    "open": 94.859375,
    "high": 96,
    "low": 94.859375,
    "close": 95.921875,
    "priceDate": "2023-11-01T00:00:00-04:00",
    "ticks": 638343936000000000,
    "epochTime": 1698796800,
    "hasValue": true,
    "time": "2023-11-01"
  },
  {
    "open": 96.109375,
    "high": 96.59375,
    "low": 96,
    "close": 96.28125,
    "priceDate": "2023-11-02T00:00:00-04:00",
    "ticks": 638344800000000000,
    "epochTime": 1698883200,
    "hasValue": true,
    "time": "2023-11-02"
  },
  {
    "open": 96.25,
    "high": 97.390625,
    "low": 96.25,
    "close": 97.046875,
    "priceDate": "2023-11-03T00:00:00-04:00",
    "ticks": 638345664000000000,
    "epochTime": 1698969600,
    "hasValue": true,
    "time": "2023-11-03"
  },
  {
    "open": 96.65625,
    "high": 96.84375,
    "low": 96.46875,
    "close": 96.578125,
    "priceDate": "2023-11-06T00:00:00-05:00",
    "ticks": 638348256000000000,
    "epochTime": 1699228800,
    "hasValue": true,
    "time": "2023-11-06"
  },
  {
    "open": 96.75,
    "high": 97.0625,
    "low": 96.609375,
    "close": 96.90625,
    "priceDate": "2023-11-07T00:00:00-05:00",
    "ticks": 638349120000000000,
    "epochTime": 1699315200,
    "hasValue": true,
    "time": "2023-11-07"
  },
  {
    "open": 96.890625,
    "high": 97.3125,
    "low": 96.71875,
    "close": 97.265625,
    "priceDate": "2023-11-08T00:00:00-05:00",
    "ticks": 638349984000000000,
    "epochTime": 1699401600,
    "hasValue": true,
    "time": "2023-11-08"
  },
  {
    "open": 96.953125,
    "high": 97.171875,
    "low": 96.40625,
    "close": 96.609375,
    "priceDate": "2023-11-09T00:00:00-05:00",
    "ticks": 638350848000000000,
    "epochTime": 1699488000,
    "hasValue": true,
    "time": "2023-11-09"
  },
  {
    "open": 96.6875,
    "high": 96.9375,
    "low": 96.25,
    "close": 96.359375,
    "priceDate": "2023-11-10T00:00:00-05:00",
    "ticks": 638351712000000000,
    "epochTime": 1699574400,
    "hasValue": true,
    "time": "2023-11-10"
  },
  {
    "open": 96.4375,
    "high": 96.625,
    "low": 96,
    "close": 96.59375,
    "priceDate": "2023-11-13T00:00:00-05:00",
    "ticks": 638354304000000000,
    "epochTime": 1699833600,
    "hasValue": true,
    "time": "2023-11-13"
  },
  {
    "open": 96.625,
    "high": 97.828125,
    "low": 96.5625,
    "close": 97.65625,
    "priceDate": "2023-11-14T00:00:00-05:00",
    "ticks": 638355168000000000,
    "epochTime": 1699920000,
    "hasValue": true,
    "time": "2023-11-14"
  },
  {
    "open": 97.5,
    "high": 97.59375,
    "low": 97.09375,
    "close": 97.28125,
    "priceDate": "2023-11-15T00:00:00-05:00",
    "ticks": 638356032000000000,
    "epochTime": 1700006400,
    "hasValue": true,
    "time": "2023-11-15"
  },
  {
    "open": 97.5625,
    "high": 97.859375,
    "low": 97.46875,
    "close": 97.84375,
    "priceDate": "2023-11-16T00:00:00-05:00",
    "ticks": 638356896000000000,
    "epochTime": 1700092800,
    "hasValue": true,
    "time": "2023-11-16"
  },
  {
    "open": 97.9375,
    "high": 98,
    "low": 97.640625,
    "close": 97.90625,
    "priceDate": "2023-11-17T00:00:00-05:00",
    "ticks": 638357760000000000,
    "epochTime": 1700179200,
    "hasValue": true,
    "time": "2023-11-17"
  },
  {
    "open": 97.671875,
    "high": 97.921875,
    "low": 97.640625,
    "close": 97.859375,
    "priceDate": "2023-11-20T00:00:00-05:00",
    "ticks": 638360352000000000,
    "epochTime": 1700438400,
    "hasValue": true,
    "time": "2023-11-20"
  },
  {
    "open": 97.9375,
    "high": 98.15625,
    "low": 97.78125,
    "close": 98.15625,
    "priceDate": "2023-11-21T00:00:00-05:00",
    "ticks": 638361216000000000,
    "epochTime": 1700524800,
    "hasValue": true,
    "time": "2023-11-21"
  },
  {
    "open": 98.234375,
    "high": 98.265625,
    "low": 97.78125,
    "close": 97.953125,
    "priceDate": "2023-11-22T00:00:00-05:00",
    "ticks": 638362080000000000,
    "epochTime": 1700611200,
    "hasValue": true,
    "time": "2023-11-22"
  },
  {
    "open": 97.671875,
    "high": 97.6875,
    "low": 97.5,
    "close": 97.671875,
    "priceDate": "2023-11-24T00:00:00-05:00",
    "ticks": 638363808000000000,
    "epochTime": 1700784000,
    "hasValue": true,
    "time": "2023-11-24"
  },
  {
    "open": 97.734375,
    "high": 98.15625,
    "low": 97.703125,
    "close": 98.078125,
    "priceDate": "2023-11-27T00:00:00-05:00",
    "ticks": 638366400000000000,
    "epochTime": 1701043200,
    "hasValue": true,
    "time": "2023-11-27"
  },
  {
    "open": 97.953125,
    "high": 98.578125,
    "low": 97.859375,
    "close": 98.546875,
    "priceDate": "2023-11-28T00:00:00-05:00",
    "ticks": 638367264000000000,
    "epochTime": 1701129600,
    "hasValue": true,
    "time": "2023-11-28"
  },
  {
    "open": 98.734375,
    "high": 98.921875,
    "low": 98.625,
    "close": 98.921875,
    "priceDate": "2023-11-29T00:00:00-05:00",
    "ticks": 638368128000000000,
    "epochTime": 1701216000,
    "hasValue": true,
    "time": "2023-11-29"
  },
  {
    "open": 98.765625,
    "high": 98.796875,
    "low": 98.328125,
    "close": 98.640625,
    "priceDate": "2023-11-30T00:00:00-05:00",
    "ticks": 638368992000000000,
    "epochTime": 1701302400,
    "hasValue": true,
    "time": "2023-11-30"
  },
  {
    "open": 98.578125,
    "high": 99.265625,
    "low": 98.5,
    "close": 99.25,
    "priceDate": "2023-12-01T00:00:00-05:00",
    "ticks": 638369856000000000,
    "epochTime": 1701388800,
    "hasValue": true,
    "time": "2023-12-01"
  },
  {
    "open": 98.984375,
    "high": 99.0625,
    "low": 98.71875,
    "close": 98.9375,
    "priceDate": "2023-12-04T00:00:00-05:00",
    "ticks": 638372448000000000,
    "epochTime": 1701648000,
    "hasValue": true,
    "time": "2023-12-04"
  },
  {
    "open": 98.9375,
    "high": 99.296875,
    "low": 98.921875,
    "close": 99.296875,
    "priceDate": "2023-12-05T00:00:00-05:00",
    "ticks": 638373312000000000,
    "epochTime": 1701734400,
    "hasValue": true,
    "time": "2023-12-05"
  },
  {
    "open": 99.140625,
    "high": 99.53125,
    "low": 98.984375,
    "close": 99.515625,
    "priceDate": "2023-12-06T00:00:00-05:00",
    "ticks": 638374176000000000,
    "epochTime": 1701820800,
    "hasValue": true,
    "time": "2023-12-06"
  },
  {
    "open": 99.25,
    "high": 99.5,
    "low": 99.15625,
    "close": 99.375,
    "priceDate": "2023-12-07T00:00:00-05:00",
    "ticks": 638375040000000000,
    "epochTime": 1701907200,
    "hasValue": true,
    "time": "2023-12-07"
  },
  {
    "open": 98.96875,
    "high": 99.140625,
    "low": 98.6875,
    "close": 99.125,
    "priceDate": "2023-12-08T00:00:00-05:00",
    "ticks": 638375904000000000,
    "epochTime": 1701993600,
    "hasValue": true,
    "time": "2023-12-08"
  },
  {
    "open": 98.921875,
    "high": 99.046875,
    "low": 98.765625,
    "close": 99.03125,
    "priceDate": "2023-12-11T00:00:00-05:00",
    "ticks": 638378496000000000,
    "epochTime": 1702252800,
    "hasValue": true,
    "time": "2023-12-11"
  },
  {
    "open": 99.1875,
    "high": 99.296875,
    "low": 98.921875,
    "close": 99.25,
    "priceDate": "2023-12-12T00:00:00-05:00",
    "ticks": 638379360000000000,
    "epochTime": 1702339200,
    "hasValue": true,
    "time": "2023-12-12"
  },
  {
    "open": 99.3125,
    "high": 100.1875,
    "low": 99.234375,
    "close": 100.171875,
    "priceDate": "2023-12-13T00:00:00-05:00",
    "ticks": 638380224000000000,
    "epochTime": 1702425600,
    "hasValue": true,
    "time": "2023-12-13"
  },
  {
    "open": 100.515625,
    "high": 100.59375,
    "low": 100.234375,
    "close": 100.3125,
    "priceDate": "2023-12-14T00:00:00-05:00",
    "ticks": 638381088000000000,
    "epochTime": 1702512000,
    "hasValue": true,
    "time": "2023-12-14"
  },
  {
    "open": 100.125,
    "high": 100.390625,
    "low": 99.84375,
    "close": 100.25,
    "priceDate": "2023-12-15T00:00:00-05:00",
    "ticks": 638381952000000000,
    "epochTime": 1702598400,
    "hasValue": true,
    "time": "2023-12-15"
  },
  {
    "open": 100.25,
    "high": 100.28125,
    "low": 100.015625,
    "close": 100.203125,
    "priceDate": "2023-12-18T00:00:00-05:00",
    "ticks": 638384544000000000,
    "epochTime": 1702857600,
    "hasValue": true,
    "time": "2023-12-18"
  },
  {
    "open": 100.09375,
    "high": 100.375,
    "low": 100.09375,
    "close": 100.234375,
    "priceDate": "2023-12-19T00:00:00-05:00",
    "ticks": 638385408000000000,
    "epochTime": 1702944000,
    "hasValue": true,
    "time": "2023-12-19"
  },
  {
    "open": 100.296875,
    "high": 100.46875,
    "low": 100.25,
    "close": 100.421875,
    "priceDate": "2023-12-20T00:00:00-05:00",
    "ticks": 638386272000000000,
    "epochTime": 1703030400,
    "hasValue": true,
    "time": "2023-12-20"
  },
  {
    "open": 100.203125,
    "high": 100.515625,
    "low": 100.140625,
    "close": 100.265625,
    "priceDate": "2023-12-21T00:00:00-05:00",
    "ticks": 638387136000000000,
    "epochTime": 1703116800,
    "hasValue": true,
    "time": "2023-12-21"
  },
  {
    "open": 100.375,
    "high": 100.421875,
    "low": 100.15625,
    "close": 100.328125,
    "priceDate": "2023-12-22T00:00:00-05:00",
    "ticks": 638388000000000000,
    "epochTime": 1703203200,
    "hasValue": true,
    "time": "2023-12-22"
  },
  {
    "open": 100.078125,
    "high": 100.4375,
    "low": 100.0625,
    "close": 100.34375,
    "priceDate": "2023-12-26T00:00:00-05:00",
    "ticks": 638391456000000000,
    "epochTime": 1703548800,
    "hasValue": true,
    "time": "2023-12-26"
  },
  {
    "open": 100.4375,
    "high": 100.78125,
    "low": 100.4375,
    "close": 100.671875,
    "priceDate": "2023-12-27T00:00:00-05:00",
    "ticks": 638392320000000000,
    "epochTime": 1703635200,
    "hasValue": true,
    "time": "2023-12-27"
  },
  {
    "open": 100.40625,
    "high": 100.640625,
    "low": 100.40625,
    "close": 100.484375,
    "priceDate": "2023-12-28T00:00:00-05:00",
    "ticks": 638393184000000000,
    "epochTime": 1703721600,
    "hasValue": true,
    "time": "2023-12-28"
  },
  {
    "open": 100.21875,
    "high": 100.53125,
    "low": 100.171875,
    "close": 100.421875,
    "priceDate": "2023-12-29T00:00:00-05:00",
    "ticks": 638394048000000000,
    "epochTime": 1703808000,
    "hasValue": true,
    "time": "2023-12-29"
  },
  {
    "open": 100.109375,
    "high": 100.21875,
    "low": 100.046875,
    "close": 100.15625,
    "priceDate": "2024-01-02T00:00:00-05:00",
    "ticks": 638397504000000000,
    "epochTime": 1704153600,
    "hasValue": true,
    "time": "2024-01-02"
  },
  {
    "open": 99.875,
    "high": 100.234375,
    "low": 99.71875,
    "close": 100.1875,
    "priceDate": "2024-01-03T00:00:00-05:00",
    "ticks": 638398368000000000,
    "epochTime": 1704240000,
    "hasValue": true,
    "time": "2024-01-03"
  },
  {
    "open": 99.953125,
    "high": 100.03125,
    "low": 99.796875,
    "close": 99.859375,
    "priceDate": "2024-01-04T00:00:00-05:00",
    "ticks": 638399232000000000,
    "epochTime": 1704326400,
    "hasValue": true,
    "time": "2024-01-04"
  },
  {
    "open": 99.640625,
    "high": 100.046875,
    "low": 99.34375,
    "close": 99.875,
    "priceDate": "2024-01-05T00:00:00-05:00",
    "ticks": 638400096000000000,
    "epochTime": 1704412800,
    "hasValue": true,
    "time": "2024-01-05"
  },
  {
    "open": 99.765625,
    "high": 100.171875,
    "low": 99.734375,
    "close": 99.90625,
    "priceDate": "2024-01-08T00:00:00-05:00",
    "ticks": 638402688000000000,
    "epochTime": 1704672000,
    "hasValue": true,
    "time": "2024-01-08"
  },
  {
    "open": 99.859375,
    "high": 100,
    "low": 99.59375,
    "close": 99.890625,
    "priceDate": "2024-01-09T00:00:00-05:00",
    "ticks": 638403552000000000,
    "epochTime": 1704758400,
    "hasValue": true,
    "time": "2024-01-09"
  },
  {
    "open": 99.8125,
    "high": 100.140625,
    "low": 99.78125,
    "close": 99.921875,
    "priceDate": "2024-01-10T00:00:00-05:00",
    "ticks": 638404416000000000,
    "epochTime": 1704844800,
    "hasValue": true,
    "time": "2024-01-10"
  },
  {
    "open": 99.90625,
    "high": 100.390625,
    "low": 99.671875,
    "close": 100.34375,
    "priceDate": "2024-01-11T00:00:00-05:00",
    "ticks": 638405280000000000,
    "epochTime": 1704931200,
    "hasValue": true,
    "time": "2024-01-11"
  },
  {
    "open": 100.1875,
    "high": 100.625,
    "low": 99.96875,
    "close": 100.546875,
    "priceDate": "2024-01-12T00:00:00-05:00",
    "ticks": 638406144000000000,
    "epochTime": 1705017600,
    "hasValue": true,
    "time": "2024-01-12"
  },
  {
    "open": 100.15625,
    "high": 100.390625,
    "low": 99.9375,
    "close": 100.09375,
    "priceDate": "2024-01-16T00:00:00-05:00",
    "ticks": 638409600000000000,
    "epochTime": 1705363200,
    "hasValue": true,
    "time": "2024-01-16"
  },
  {
    "open": 99.84375,
    "high": 99.84375,
    "low": 99.59375,
    "close": 99.78125,
    "priceDate": "2024-01-17T00:00:00-05:00",
    "ticks": 638410464000000000,
    "epochTime": 1705449600,
    "hasValue": true,
    "time": "2024-01-17"
  },
  {
    "open": 99.75,
    "high": 99.84375,
    "low": 99.546875,
    "close": 99.65625,
    "priceDate": "2024-01-18T00:00:00-05:00",
    "ticks": 638411328000000000,
    "epochTime": 1705536000,
    "hasValue": true,
    "time": "2024-01-18"
  },
  {
    "open": 99.640625,
    "high": 99.75,
    "low": 99.484375,
    "close": 99.625,
    "priceDate": "2024-01-19T00:00:00-05:00",
    "ticks": 638412192000000000,
    "epochTime": 1705622400,
    "hasValue": true,
    "time": "2024-01-19"
  },
  {
    "open": 99.8125,
    "high": 99.921875,
    "low": 99.671875,
    "close": 99.75,
    "priceDate": "2024-01-22T00:00:00-05:00",
    "ticks": 638414784000000000,
    "epochTime": 1705881600,
    "hasValue": true,
    "time": "2024-01-22"
  },
  {
    "open": 99.5625,
    "high": 99.671875,
    "low": 99.515625,
    "close": 99.65625,
    "priceDate": "2024-01-23T00:00:00-05:00",
    "ticks": 638415648000000000,
    "epochTime": 1705968000,
    "hasValue": true,
    "time": "2024-01-23"
  },
  {
    "open": 99.75,
    "high": 99.890625,
    "low": 99.40625,
    "close": 99.46875,
    "priceDate": "2024-01-24T00:00:00-05:00",
    "ticks": 638416512000000000,
    "epochTime": 1706054400,
    "hasValue": true,
    "time": "2024-01-24"
  },
  {
    "open": 99.484375,
    "high": 99.859375,
    "low": 99.328125,
    "close": 99.859375,
    "priceDate": "2024-01-25T00:00:00-05:00",
    "ticks": 638417376000000000,
    "epochTime": 1706140800,
    "hasValue": true,
    "time": "2024-01-25"
  },
  {
    "open": 99.90625,
    "high": 100,
    "low": 99.640625,
    "close": 99.765625,
    "priceDate": "2024-01-26T00:00:00-05:00",
    "ticks": 638418240000000000,
    "epochTime": 1706227200,
    "hasValue": true,
    "time": "2024-01-26"
  },
  {
    "open": 99.8125,
    "high": 100.015625,
    "low": 99.796875,
    "close": 99.984375,
    "priceDate": "2024-01-29T00:00:00-05:00",
    "ticks": 638420832000000000,
    "epochTime": 1706486400,
    "hasValue": true,
    "time": "2024-01-29"
  },
  {
    "open": 99.9375,
    "high": 100.109375,
    "low": 99.78125,
    "close": 100.109375,
    "priceDate": "2024-01-30T00:00:00-05:00",
    "ticks": 638421696000000000,
    "epochTime": 1706572800,
    "hasValue": true,
    "time": "2024-01-30"
  },
  {
    "open": 100.109375,
    "high": 100.453125,
    "low": 99.875,
    "close": 100.453125,
    "priceDate": "2024-01-31T00:00:00-05:00",
    "ticks": 638422560000000000,
    "epochTime": 1706659200,
    "hasValue": true,
    "time": "2024-01-31"
  },
  {
    "open": 100.375,
    "high": 100.671875,
    "low": 100.34375,
    "close": 100.421875,
    "priceDate": "2024-02-01T00:00:00-05:00",
    "ticks": 638423424000000000,
    "epochTime": 1706745600,
    "hasValue": true,
    "time": "2024-02-01"
  },
  {
    "open": 100.34375,
    "high": 100.34375,
    "low": 99.71875,
    "close": 99.859375,
    "priceDate": "2024-02-02T00:00:00-05:00",
    "ticks": 638424288000000000,
    "epochTime": 1706832000,
    "hasValue": true,
    "time": "2024-02-02"
  },
  {
    "open": 99.421875,
    "high": 99.5,
    "low": 99.203125,
    "close": 99.375,
    "priceDate": "2024-02-05T00:00:00-05:00",
    "ticks": 638426880000000000,
    "epochTime": 1707091200,
    "hasValue": true,
    "time": "2024-02-05"
  },
  {
    "open": 99.40625,
    "high": 99.734375,
    "low": 99.375,
    "close": 99.671875,
    "priceDate": "2024-02-06T00:00:00-05:00",
    "ticks": 638427744000000000,
    "epochTime": 1707177600,
    "hasValue": true,
    "time": "2024-02-06"
  },
  {
    "open": 99.59375,
    "high": 99.8125,
    "low": 99.5,
    "close": 99.515625,
    "priceDate": "2024-02-07T00:00:00-05:00",
    "ticks": 638428608000000000,
    "epochTime": 1707264000,
    "hasValue": true,
    "time": "2024-02-07"
  },
  {
    "open": 99.421875,
    "high": 99.515625,
    "low": 99.34375,
    "close": 99.390625,
    "priceDate": "2024-02-08T00:00:00-05:00",
    "ticks": 638429472000000000,
    "epochTime": 1707350400,
    "hasValue": true,
    "time": "2024-02-08"
  },
  {
    "open": 99.265625,
    "high": 99.46875,
    "low": 99.203125,
    "close": 99.34375,
    "priceDate": "2024-02-09T00:00:00-05:00",
    "ticks": 638430336000000000,
    "epochTime": 1707436800,
    "hasValue": true,
    "time": "2024-02-09"
  },
  {
    "open": 99.40625,
    "high": 99.453125,
    "low": 99.234375,
    "close": 99.25,
    "priceDate": "2024-02-12T00:00:00-05:00",
    "ticks": 638432928000000000,
    "epochTime": 1707696000,
    "hasValue": true,
    "time": "2024-02-12"
  },
  {
    "open": 99.296875,
    "high": 99.359375,
    "low": 98.40625,
    "close": 98.515625,
    "priceDate": "2024-02-13T00:00:00-05:00",
    "ticks": 638433792000000000,
    "epochTime": 1707782400,
    "hasValue": true,
    "time": "2024-02-13"
  },
  {
    "open": 98.5625,
    "high": 98.875,
    "low": 98.40625,
    "close": 98.828125,
    "priceDate": "2024-02-14T00:00:00-05:00",
    "ticks": 638434656000000000,
    "epochTime": 1707868800,
    "hasValue": true,
    "time": "2024-02-14"
  },
  {
    "open": 98.890625,
    "high": 99.125,
    "low": 98.71875,
    "close": 99.03125,
    "priceDate": "2024-02-15T00:00:00-05:00",
    "ticks": 638435520000000000,
    "epochTime": 1707955200,
    "hasValue": true,
    "time": "2024-02-15"
  },
  {
    "open": 98.8125,
    "high": 98.8125,
    "low": 98.4375,
    "close": 98.703125,
    "priceDate": "2024-02-16T00:00:00-05:00",
    "ticks": 638436384000000000,
    "epochTime": 1708041600,
    "hasValue": true,
    "time": "2024-02-16"
  },
  {
    "open": 98.71875,
    "high": 98.9375,
    "low": 98.671875,
    "close": 98.71875,
    "priceDate": "2024-02-20T00:00:00-05:00",
    "ticks": 638439840000000000,
    "epochTime": 1708387200,
    "hasValue": true,
    "time": "2024-02-20"
  },
  {
    "open": 98.796875,
    "high": 98.90625,
    "low": 98.453125,
    "close": 98.515625,
    "priceDate": "2024-02-21T00:00:00-05:00",
    "ticks": 638440704000000000,
    "epochTime": 1708473600,
    "hasValue": true,
    "time": "2024-02-21"
  },
  {
    "open": 98.375,
    "high": 98.578125,
    "low": 98.28125,
    "close": 98.546875,
    "priceDate": "2024-02-22T00:00:00-05:00",
    "ticks": 638441568000000000,
    "epochTime": 1708560000,
    "hasValue": true,
    "time": "2024-02-22"
  },
  {
    "open": 98.640625,
    "high": 98.921875,
    "low": 98.515625,
    "close": 98.796875,
    "priceDate": "2024-02-23T00:00:00-05:00",
    "ticks": 638442432000000000,
    "epochTime": 1708646400,
    "hasValue": true,
    "time": "2024-02-23"
  },
  {
    "open": 98.875,
    "high": 98.921875,
    "low": 98.53125,
    "close": 98.671875,
    "priceDate": "2024-02-26T00:00:00-05:00",
    "ticks": 638445024000000000,
    "epochTime": 1708905600,
    "hasValue": true,
    "time": "2024-02-26"
  },
  {
    "open": 98.703125,
    "high": 98.75,
    "low": 98.46875,
    "close": 98.578125,
    "priceDate": "2024-02-27T00:00:00-05:00",
    "ticks": 638445888000000000,
    "epochTime": 1708992000,
    "hasValue": true,
    "time": "2024-02-27"
  },
  {
    "open": 98.421875,
    "high": 98.84375,
    "low": 98.421875,
    "close": 98.828125,
    "priceDate": "2024-02-28T00:00:00-05:00",
    "ticks": 638446752000000000,
    "epochTime": 1709078400,
    "hasValue": true,
    "time": "2024-02-28"
  },
  {
    "open": 98.578125,
    "high": 99.03125,
    "low": 98.546875,
    "close": 98.875,
    "priceDate": "2024-02-29T00:00:00-05:00",
    "ticks": 638447616000000000,
    "epochTime": 1709164800,
    "hasValue": true,
    "time": "2024-02-29"
  },
  {
    "open": 98.828125,
    "high": 99.1875,
    "low": 98.6875,
    "close": 99.1875,
    "priceDate": "2024-03-01T00:00:00-05:00",
    "ticks": 638448480000000000,
    "epochTime": 1709251200,
    "hasValue": true,
    "time": "2024-03-01"
  },
  {
    "open": 98.96875,
    "high": 99.109375,
    "low": 98.890625,
    "close": 99.015625,
    "priceDate": "2024-03-04T00:00:00-05:00",
    "ticks": 638451072000000000,
    "epochTime": 1709510400,
    "hasValue": true,
    "time": "2024-03-04"
  },
  {
    "open": 99.125,
    "high": 99.359375,
    "low": 99.125,
    "close": 99.234375,
    "priceDate": "2024-03-05T00:00:00-05:00",
    "ticks": 638451936000000000,
    "epochTime": 1709596800,
    "hasValue": true,
    "time": "2024-03-05"
  },
  {
    "open": 99.234375,
    "high": 99.578125,
    "low": 99.21875,
    "close": 99.53125,
    "priceDate": "2024-03-06T00:00:00-05:00",
    "ticks": 638452800000000000,
    "epochTime": 1709683200,
    "hasValue": true,
    "time": "2024-03-06"
  },
  {
    "open": 99.53125,
    "high": 99.734375,
    "low": 99.46875,
    "close": 99.71875,
    "priceDate": "2024-03-07T00:00:00-05:00",
    "ticks": 638453664000000000,
    "epochTime": 1709769600,
    "hasValue": true,
    "time": "2024-03-07"
  },
  {
    "open": 99.71875,
    "high": 99.96875,
    "low": 99.703125,
    "close": 99.84375,
    "priceDate": "2024-03-08T00:00:00-05:00",
    "ticks": 638454528000000000,
    "epochTime": 1709856000,
    "hasValue": true,
    "time": "2024-03-08"
  },
  {
    "open": 99.75,
    "high": 99.796875,
    "low": 99.5,
    "close": 99.71875,
    "priceDate": "2024-03-11T00:00:00-04:00",
    "ticks": 638457120000000000,
    "epochTime": 1710115200,
    "hasValue": true,
    "time": "2024-03-11"
  },
  {
    "open": 99.671875,
    "high": 99.796875,
    "low": 99.40625,
    "close": 99.5625,
    "priceDate": "2024-03-12T00:00:00-04:00",
    "ticks": 638457984000000000,
    "epochTime": 1710201600,
    "hasValue": true,
    "time": "2024-03-12"
  },
  {
    "open": 99.359375,
    "high": 99.546875,
    "low": 99.359375,
    "close": 99.453125,
    "priceDate": "2024-03-13T00:00:00-04:00",
    "ticks": 638458848000000000,
    "epochTime": 1710288000,
    "hasValue": true,
    "time": "2024-03-13"
  },
  {
    "open": 99.40625,
    "high": 99.421875,
    "low": 98.890625,
    "close": 99,
    "priceDate": "2024-03-14T00:00:00-04:00",
    "ticks": 638459712000000000,
    "epochTime": 1710374400,
    "hasValue": true,
    "time": "2024-03-14"
  },
  {
    "open": 98.9375,
    "high": 98.96875,
    "low": 98.71875,
    "close": 98.8125,
    "priceDate": "2024-03-15T00:00:00-04:00",
    "ticks": 638460576000000000,
    "epochTime": 1710460800,
    "hasValue": true,
    "time": "2024-03-15"
  },
  {
    "open": 98.75,
    "high": 98.796875,
    "low": 98.609375,
    "close": 98.734375,
    "priceDate": "2024-03-18T00:00:00-04:00",
    "ticks": 638463168000000000,
    "epochTime": 1710720000,
    "hasValue": true,
    "time": "2024-03-18"
  },
  {
    "open": 98.734375,
    "high": 99.015625,
    "low": 98.65625,
    "close": 98.984375,
    "priceDate": "2024-03-19T00:00:00-04:00",
    "ticks": 638464032000000000,
    "epochTime": 1710806400,
    "hasValue": true,
    "time": "2024-03-19"
  },
  {
    "open": 99.03125,
    "high": 99.28125,
    "low": 98.9375,
    "close": 99.25,
    "priceDate": "2024-03-20T00:00:00-04:00",
    "ticks": 638464896000000000,
    "epochTime": 1710892800,
    "hasValue": true,
    "time": "2024-03-20"
  },
  {
    "open": 99.453125,
    "high": 99.46875,
    "low": 99.1875,
    "close": 99.28125,
    "priceDate": "2024-03-21T00:00:00-04:00",
    "ticks": 638465760000000000,
    "epochTime": 1710979200,
    "hasValue": true,
    "time": "2024-03-21"
  },
  {
    "open": 99.4375,
    "high": 99.546875,
    "low": 99.390625,
    "close": 99.546875,
    "priceDate": "2024-03-22T00:00:00-04:00",
    "ticks": 638466624000000000,
    "epochTime": 1711065600,
    "hasValue": true,
    "time": "2024-03-22"
  },
  {
    "open": 99.328125,
    "high": 99.484375,
    "low": 99.328125,
    "close": 99.484375,
    "priceDate": "2024-03-25T00:00:00-04:00",
    "ticks": 638469216000000000,
    "epochTime": 1711324800,
    "hasValue": true,
    "time": "2024-03-25"
  },
  {
    "open": 99.453125,
    "high": 99.5625,
    "low": 99.359375,
    "close": 99.53125,
    "priceDate": "2024-03-26T00:00:00-04:00",
    "ticks": 638470080000000000,
    "epochTime": 1711411200,
    "hasValue": true,
    "time": "2024-03-26"
  },
  {
    "open": 99.53125,
    "high": 99.6875,
    "low": 99.484375,
    "close": 99.640625,
    "priceDate": "2024-03-27T00:00:00-04:00",
    "ticks": 638470944000000000,
    "epochTime": 1711497600,
    "hasValue": true,
    "time": "2024-03-27"
  },
  {
    "open": 99.4928997812142,
    "high": 99.6785310017903,
    "low": 99.4276267386973,
    "close": 99.484375,
    "priceDate": "2024-03-28T00:00:00-04:00",
    "ticks": 638471808000000000,
    "epochTime": 1711584000,
    "hasValue": true,
    "time": "2024-03-28"
  },
  {
    "open": 99.4711631355744,
    "high": 99.6093380206661,
    "low": 98.9125782480785,
    "close": 99.0455475280062,
    "priceDate": "2024-04-01T00:00:00-04:00",
    "ticks": 638475264000000000,
    "epochTime": 1711929600,
    "hasValue": true,
    "time": "2024-04-01"
  },
  {
    "open": 99.0025057601054,
    "high": 99.109375,
    "low": 98.734375,
    "close": 99.1015553066238,
    "priceDate": "2024-04-02T00:00:00-04:00",
    "ticks": 638476128000000000,
    "epochTime": 1712016000,
    "hasValue": true,
    "time": "2024-04-02"
  },
  {
    "open": 99.0461377348448,
    "high": 99.125,
    "low": 98.7049294473846,
    "close": 99.09375,
    "priceDate": "2024-04-03T00:00:00-04:00",
    "ticks": 638476992000000000,
    "epochTime": 1712102400,
    "hasValue": true,
    "time": "2024-04-03"
  },
  {
    "open": 98.9682136406165,
    "high": 99.3111075357326,
    "low": 98.9446214986566,
    "close": 99.2226917851861,
    "priceDate": "2024-04-04T00:00:00-04:00",
    "ticks": 638477856000000000,
    "epochTime": 1712188800,
    "hasValue": true,
    "time": "2024-04-04"
  },
  {
    "open": 99.2051747902934,
    "high": 99.2736098469325,
    "low": 98.8344789870488,
    "close": 98.868380576067,
    "priceDate": "2024-04-05T00:00:00-04:00",
    "ticks": 638478720000000000,
    "epochTime": 1712275200,
    "hasValue": true,
    "time": "2024-04-05"
  },
  {
    "open": 98.5956569571656,
    "high": 98.8199156078317,
    "low": 98.5564785052498,
    "close": 98.7480909411882,
    "priceDate": "2024-04-08T00:00:00-04:00",
    "ticks": 638481312000000000,
    "epochTime": 1712534400,
    "hasValue": true,
    "time": "2024-04-08"
  },
  {
    "open": 98.9219949339729,
    "high": 99.015625,
    "low": 98.8559052834463,
    "close": 98.9571019002344,
    "priceDate": "2024-04-09T00:00:00-04:00",
    "ticks": 638482176000000000,
    "epochTime": 1712620800,
    "hasValue": true,
    "time": "2024-04-09"
  },
  {
    "open": 99.0411015469956,
    "high": 99.0754730253372,
    "low": 97.816406,
    "close": 97.8520991939104,
    "priceDate": "2024-04-10T00:00:00-04:00",
    "ticks": 638483040000000000,
    "epochTime": 1712707200,
    "hasValue": true,
    "time": "2024-04-10"
  },
  {
    "open": 97.8086066838262,
    "high": 98.046875,
    "low": 97.640625,
    "close": 97.7127916875295,
    "priceDate": "2024-04-11T00:00:00-04:00",
    "ticks": 638483904000000000,
    "epochTime": 1712793600,
    "hasValue": true,
    "time": "2024-04-11"
  },
  {
    "open": 98.0449393636386,
    "high": 98.2353960618842,
    "low": 97.9444535555006,
    "close": 97.9444535555006,
    "priceDate": "2024-04-12T00:00:00-04:00",
    "ticks": 638484768000000000,
    "epochTime": 1712880000,
    "hasValue": true,
    "time": "2024-04-12"
  },
  {
    "open": 97.702546975168,
    "high": 97.7396098431479,
    "low": 97.2447822787699,
    "close": 97.430268639391,
    "priceDate": "2024-04-15T00:00:00-04:00",
    "ticks": 638487360000000000,
    "epochTime": 1713139200,
    "hasValue": true,
    "time": "2024-04-15"
  },
  {
    "open": 97.2398593470476,
    "high": 97.2937756289759,
    "low": 96.9432867147503,
    "close": 97.0742218129916,
    "priceDate": "2024-04-16T00:00:00-04:00",
    "ticks": 638488224000000000,
    "epochTime": 1713225600,
    "hasValue": true,
    "time": "2024-04-16"
  },
  {
    "open": 97.1990993491478,
    "high": 97.6570206564547,
    "low": 97.1635816153938,
    "close": 97.62886380905,
    "priceDate": "2024-04-17T00:00:00-04:00",
    "ticks": 638489088000000000,
    "epochTime": 1713312000,
    "hasValue": true,
    "time": "2024-04-17"
  },
  {
    "open": 97.5510279330869,
    "high": 97.613374314124,
    "low": 97.1861891685504,
    "close": 97.2949906672475,
    "priceDate": "2024-04-18T00:00:00-04:00",
    "ticks": 638489952000000000,
    "epochTime": 1713398400,
    "hasValue": true,
    "time": "2024-04-18"
  },
  {
    "open": 97.4635317356469,
    "high": 97.4898318517994,
    "low": 97.2133762319196,
    "close": 97.3169662182465,
    "priceDate": "2024-04-19T00:00:00-04:00",
    "ticks": 638490816000000000,
    "epochTime": 1713484800,
    "hasValue": true,
    "time": "2024-04-19"
  },
  {
    "open": 97.2121735768166,
    "high": 97.5325569004052,
    "low": 97.2121735768166,
    "close": 97.4767350647595,
    "priceDate": "2024-04-22T00:00:00-04:00",
    "ticks": 638493408000000000,
    "epochTime": 1713744000,
    "hasValue": true,
    "time": "2024-04-22"
  },
  {
    "open": 97.304687,
    "high": 97.804687,
    "low": 97.304687,
    "close": 97.6562500340685,
    "priceDate": "2024-04-23T00:00:00-04:00",
    "ticks": 638494272000000000,
    "epochTime": 1713830400,
    "hasValue": true,
    "time": "2024-04-23"
  },
  {
    "open": 97.4972998548433,
    "high": 97.5809557653766,
    "low": 97.31826772674,
    "close": 97.4492181564794,
    "priceDate": "2024-04-24T00:00:00-04:00",
    "ticks": 638495136000000000,
    "epochTime": 1713916800,
    "hasValue": true,
    "time": "2024-04-24"
  },
  {
    "open": 97.4575282371205,
    "high": 97.5077653445095,
    "low": 96.8265799005618,
    "close": 97.0122975303015,
    "priceDate": "2024-04-25T00:00:00-04:00",
    "ticks": 638496000000000000,
    "epochTime": 1714003200,
    "hasValue": true,
    "time": "2024-04-25"
  },
  {
    "open": 97.0613536594944,
    "high": 97.4003340856224,
    "low": 97.04989976951,
    "close": 97.3627079031995,
    "priceDate": "2024-04-26T00:00:00-04:00",
    "ticks": 638496864000000000,
    "epochTime": 1714089600,
    "hasValue": true,
    "time": "2024-04-26"
  },
  {
    "open": 97.5306953100451,
    "high": 97.6185117934125,
    "low": 97.4348527121006,
    "close": 97.5072381288982,
    "priceDate": "2024-04-29T00:00:00-04:00",
    "ticks": 638499456000000000,
    "epochTime": 1714348800,
    "hasValue": true,
    "time": "2024-04-29"
  },
  {
    "open": 97.4526242291906,
    "high": 97.5351262948687,
    "low": 97.0389605042929,
    "close": 97.0775387154632,
    "priceDate": "2024-04-30T00:00:00-04:00",
    "ticks": 638500320000000000,
    "epochTime": 1714435200,
    "hasValue": true,
    "time": "2024-04-30"
  },
  {
    "open": 97.1386241170601,
    "high": 97.727755533708,
    "low": 97.1016672955765,
    "close": 97.4960246797212,
    "priceDate": "2024-05-01T00:00:00-04:00",
    "ticks": 638501184000000000,
    "epochTime": 1714521600,
    "hasValue": true,
    "time": "2024-05-01"
  },
  {
    "open": 97.6105443630726,
    "high": 97.925300358515,
    "low": 97.5094788952872,
    "close": 97.858178458979,
    "priceDate": "2024-05-02T00:00:00-04:00",
    "ticks": 638502048000000000,
    "epochTime": 1714608000,
    "hasValue": true,
    "time": "2024-05-02"
  },
  {
    "open": 97.983059473267,
    "high": 98.618859414421,
    "low": 97.9817739021883,
    "close": 98.2945619715953,
    "priceDate": "2024-05-03T00:00:00-04:00",
    "ticks": 638502912000000000,
    "epochTime": 1714694400,
    "hasValue": true,
    "time": "2024-05-03"
  },
  {
    "open": 98.392381297194,
    "high": 98.473003118427,
    "low": 98.253906,
    "close": 98.309136158998,
    "priceDate": "2024-05-06T00:00:00-04:00",
    "ticks": 638505504000000000,
    "epochTime": 1714953600,
    "hasValue": true,
    "time": "2024-05-06"
  },
  {
    "open": 98.3763356866506,
    "high": 98.703125,
    "low": 98.3659476018,
    "close": 98.5473663460786,
    "priceDate": "2024-05-07T00:00:00-04:00",
    "ticks": 638506368000000000,
    "epochTime": 1715040000,
    "hasValue": true,
    "time": "2024-05-07"
  },
  {
    "open": 98.411392901939,
    "high": 98.5246730143896,
    "low": 98.2577682343433,
    "close": 98.2694796128283,
    "priceDate": "2024-05-08T00:00:00-04:00",
    "ticks": 638507232000000000,
    "epochTime": 1715126400,
    "hasValue": true,
    "time": "2024-05-08"
  },
  {
    "open": 98.2166731241083,
    "high": 98.605782181358,
    "low": 98.183593,
    "close": 98.5540929858294,
    "priceDate": "2024-05-09T00:00:00-04:00",
    "ticks": 638508096000000000,
    "epochTime": 1715212800,
    "hasValue": true,
    "time": "2024-05-09"
  },
  {
    "open": 98.4893770320708,
    "high": 98.529915319227,
    "low": 98.2930241199363,
    "close": 98.397103850707,
    "priceDate": "2024-05-10T00:00:00-04:00",
    "ticks": 638508960000000000,
    "epochTime": 1715299200,
    "hasValue": true,
    "time": "2024-05-10"
  },
  {
    "open": 98.4741655277773,
    "high": 98.59375,
    "low": 98.3881042390907,
    "close": 98.4582695861717,
    "priceDate": "2024-05-13T00:00:00-04:00",
    "ticks": 638511552000000000,
    "epochTime": 1715558400,
    "hasValue": true,
    "time": "2024-05-13"
  },
  {
    "open": 98.5419942826683,
    "high": 98.7907507279664,
    "low": 98.4749285338847,
    "close": 98.7900077229668,
    "priceDate": "2024-05-14T00:00:00-04:00",
    "ticks": 638512416000000000,
    "epochTime": 1715644800,
    "hasValue": true,
    "time": "2024-05-14"
  },
  {
    "open": 98.920457787285,
    "high": 99.36535208417,
    "low": 98.912722511181,
    "close": 99.3148243594193,
    "priceDate": "2024-05-15T00:00:00-04:00",
    "ticks": 638513280000000000,
    "epochTime": 1715731200,
    "hasValue": true,
    "time": "2024-05-15"
  },
  {
    "open": 99.3202886621123,
    "high": 99.383053701521,
    "low": 98.9825870349597,
    "close": 99.0208414389013,
    "priceDate": "2024-05-16T00:00:00-04:00",
    "ticks": 638514144000000000,
    "epochTime": 1715817600,
    "hasValue": true,
    "time": "2024-05-16"
  },
  {
    "open": 98.9791917079706,
    "high": 98.9791917079706,
    "low": 98.7608669840397,
    "close": 98.785859301402,
    "priceDate": "2024-05-17T00:00:00-04:00",
    "ticks": 638515008000000000,
    "epochTime": 1715904000,
    "hasValue": true,
    "time": "2024-05-17"
  },
  {
    "open": 98.788551979671,
    "high": 98.788551979671,
    "low": 98.6288730369353,
    "close": 98.6864244723836,
    "priceDate": "2024-05-20T00:00:00-04:00",
    "ticks": 638517600000000000,
    "epochTime": 1716163200,
    "hasValue": true,
    "time": "2024-05-20"
  },
  {
    "open": 98.7419725886184,
    "high": 98.960937,
    "low": 98.735432678004,
    "close": 98.92715582781,
    "priceDate": "2024-05-21T00:00:00-04:00",
    "ticks": 638518464000000000,
    "epochTime": 1716249600,
    "hasValue": true,
    "time": "2024-05-21"
  },
  {
    "open": 98.724780854557,
    "high": 98.907060344314,
    "low": 98.649720734325,
    "close": 98.7401681259634,
    "priceDate": "2024-05-22T00:00:00-04:00",
    "ticks": 638519328000000000,
    "epochTime": 1716336000,
    "hasValue": true,
    "time": "2024-05-22"
  },
  {
    "open": 98.7532985973717,
    "high": 98.8516271543003,
    "low": 98.3240813263967,
    "close": 98.4148354638266,
    "priceDate": "2024-05-23T00:00:00-04:00",
    "ticks": 638520192000000000,
    "epochTime": 1716422400,
    "hasValue": true,
    "time": "2024-05-23"
  },
  {
    "open": 98.36901972591,
    "high": 98.5365802154427,
    "low": 98.2627368861216,
    "close": 98.496595159815,
    "priceDate": "2024-05-24T00:00:00-04:00",
    "ticks": 638521056000000000,
    "epochTime": 1716508800,
    "hasValue": true,
    "time": "2024-05-24"
  },
  {
    "open": 98.598648972544,
    "high": 98.675137459777,
    "low": 98.03125,
    "close": 98.046875,
    "priceDate": "2024-05-28T00:00:00-04:00",
    "ticks": 638524512000000000,
    "epochTime": 1716854400,
    "hasValue": true,
    "time": "2024-05-28"
  },
  {
    "open": 98.1254344957466,
    "high": 98.1339924751836,
    "low": 97.6609875711347,
    "close": 97.7864553641644,
    "priceDate": "2024-05-29T00:00:00-04:00",
    "ticks": 638525376000000000,
    "epochTime": 1716940800,
    "hasValue": true,
    "time": "2024-05-29"
  },
  {
    "open": 97.8853807962454,
    "high": 98.2110778278496,
    "low": 97.8527646280004,
    "close": 98.171875,
    "priceDate": "2024-05-30T00:00:00-04:00",
    "ticks": 638526240000000000,
    "epochTime": 1717027200,
    "hasValue": true,
    "time": "2024-05-30"
  },
  {
    "open": 98.1230867550096,
    "high": 98.46875,
    "low": 98.1191096674059,
    "close": 98.3614429749225,
    "priceDate": "2024-05-31T00:00:00-04:00",
    "ticks": 638527104000000000,
    "epochTime": 1717113600,
    "hasValue": true,
    "time": "2024-05-31"
  },
  {
    "open": 98.498077040298,
    "high": 98.84375,
    "low": 98.4640560783699,
    "close": 98.8294625791393,
    "priceDate": "2024-06-03T00:00:00-04:00",
    "ticks": 638529696000000000,
    "epochTime": 1717372800,
    "hasValue": true,
    "time": "2024-06-03"
  },
  {
    "open": 98.9053449131956,
    "high": 99.09375,
    "low": 98.8119053356416,
    "close": 99.043597986304,
    "priceDate": "2024-06-04T00:00:00-04:00",
    "ticks": 638530560000000000,
    "epochTime": 1717459200,
    "hasValue": true,
    "time": "2024-06-04"
  },
  {
    "open": 99.046875,
    "high": 99.294286618729,
    "low": 98.945312,
    "close": 99.2480584541546,
    "priceDate": "2024-06-05T00:00:00-04:00",
    "ticks": 638531424000000000,
    "epochTime": 1717545600,
    "hasValue": true,
    "time": "2024-06-05"
  },
  {
    "open": 99.146766726537,
    "high": 99.246176991717,
    "low": 99.083385252432,
    "close": 99.1932215514584,
    "priceDate": "2024-06-06T00:00:00-04:00",
    "ticks": 638532288000000000,
    "epochTime": 1717632000,
    "hasValue": true,
    "time": "2024-06-06"
  },
  {
    "open": 99.1464445561864,
    "high": 99.21875,
    "low": 98.515625,
    "close": 98.5983047868323,
    "priceDate": "2024-06-07T00:00:00-04:00",
    "ticks": 638533152000000000,
    "epochTime": 1717718400,
    "hasValue": true,
    "time": "2024-06-07"
  },
  {
    "open": 98.5558179444157,
    "high": 98.5892723555403,
    "low": 98.3580444346476,
    "close": 98.4546591875826,
    "priceDate": "2024-06-10T00:00:00-04:00",
    "ticks": 638535744000000000,
    "epochTime": 1717977600,
    "hasValue": true,
    "time": "2024-06-10"
  },
  {
    "open": 98.8585384372763,
    "high": 98.8600321440246,
    "low": 98.462976125559,
    "close": 98.6858616086473,
    "priceDate": "2024-06-11T00:00:00-04:00",
    "ticks": 638536608000000000,
    "epochTime": 1718064000,
    "hasValue": true,
    "time": "2024-06-11"
  },
  {
    "open": 98.736623995479,
    "high": 99.5032179667303,
    "low": 98.736623995479,
    "close": 99.1569959636246,
    "priceDate": "2024-06-12T00:00:00-04:00",
    "ticks": 638537472000000000,
    "epochTime": 1718150400,
    "hasValue": true,
    "time": "2024-06-12"
  },
  {
    "open": 99.1765402075416,
    "high": 99.5802794353717,
    "low": 99.171875,
    "close": 99.3241098383053,
    "priceDate": "2024-06-13T00:00:00-04:00",
    "ticks": 638538336000000000,
    "epochTime": 1718236800,
    "hasValue": true,
    "time": "2024-06-13"
  },
  {
    "open": 99.4956167815156,
    "high": 99.520679550852,
    "low": 99.257812,
    "close": 99.3087429347476,
    "priceDate": "2024-06-14T00:00:00-04:00",
    "ticks": 638539200000000000,
    "epochTime": 1718323200,
    "hasValue": true,
    "time": "2024-06-14"
  },
  {
    "open": 99.147211890557,
    "high": 99.219348184531,
    "low": 99.027343,
    "close": 99.048666718072,
    "priceDate": "2024-06-17T00:00:00-04:00",
    "ticks": 638541792000000000,
    "epochTime": 1718582400,
    "hasValue": true,
    "time": "2024-06-17"
  },
  {
    "open": 98.980364504771,
    "high": 99.375,
    "low": 98.980364504771,
    "close": 99.303365351875,
    "priceDate": "2024-06-18T00:00:00-04:00",
    "ticks": 638542656000000000,
    "epochTime": 1718668800,
    "hasValue": true,
    "time": "2024-06-18"
  },
  {
    "open": 99.2485524654294,
    "high": 99.320312,
    "low": 99.109375,
    "close": 99.1538670897536,
    "priceDate": "2024-06-20T00:00:00-04:00",
    "ticks": 638544384000000000,
    "epochTime": 1718841600,
    "hasValue": true,
    "time": "2024-06-20"
  },
  {
    "open": 99.362144413649,
    "high": 99.3819250768746,
    "low": 99.1004769994627,
    "close": 99.1812589885767,
    "priceDate": "2024-06-21T00:00:00-04:00",
    "ticks": 638545248000000000,
    "epochTime": 1718928000,
    "hasValue": true,
    "time": "2024-06-21"
  },
  {
    "open": 99.146808053381,
    "high": 99.2662231720737,
    "low": 99.126132076024,
    "close": 99.2018100850526,
    "priceDate": "2024-06-24T00:00:00-04:00",
    "ticks": 638547840000000000,
    "epochTime": 1719187200,
    "hasValue": true,
    "time": "2024-06-24"
  },
  {
    "open": 99.2750444092717,
    "high": 99.3006585534054,
    "low": 99.0635061373203,
    "close": 99.063734184849,
    "priceDate": "2024-06-25T00:00:00-04:00",
    "ticks": 638548704000000000,
    "epochTime": 1719273600,
    "hasValue": true,
    "time": "2024-06-25"
  },
  {
    "open": 98.9504390906033,
    "high": 99.015625,
    "low": 98.7831031209313,
    "close": 98.7974369623783,
    "priceDate": "2024-06-26T00:00:00-04:00",
    "ticks": 638549568000000000,
    "epochTime": 1719360000,
    "hasValue": true,
    "time": "2024-06-26"
  },
  {
    "open": 98.8320927201893,
    "high": 99.03125,
    "low": 98.7967528539582,
    "close": 98.9451892015999,
    "priceDate": "2024-06-27T00:00:00-04:00",
    "ticks": 638550432000000000,
    "epochTime": 1719446400,
    "hasValue": true,
    "time": "2024-06-27"
  },
  {
    "open": 98.93241686257,
    "high": 99.1465691052448,
    "low": 98.4752137154311,
    "close": 98.5214682400813,
    "priceDate": "2024-06-28T00:00:00-04:00",
    "ticks": 638551296000000000,
    "epochTime": 1719532800,
    "hasValue": true,
    "time": "2024-06-28"
  },
  {
    "open": 98.4185321860418,
    "high": 98.4185321860418,
    "low": 98.078125,
    "close": 98.1855842274686,
    "priceDate": "2024-07-01T00:00:00-04:00",
    "ticks": 638553888000000000,
    "epochTime": 1719792000,
    "hasValue": true,
    "time": "2024-07-01"
  },
  {
    "open": 98.353395008674,
    "high": 98.53125,
    "low": 98.30664,
    "close": 98.4518074234274,
    "priceDate": "2024-07-02T00:00:00-04:00",
    "ticks": 638554752000000000,
    "epochTime": 1719878400,
    "hasValue": true,
    "time": "2024-07-02"
  },
  {
    "open": 98.3900051379523,
    "high": 98.875593640394,
    "low": 98.3618457805301,
    "close": 98.7167195646345,
    "priceDate": "2024-07-03T00:00:00-04:00",
    "ticks": 638555616000000000,
    "epochTime": 1719964800,
    "hasValue": true,
    "time": "2024-07-03"
  },
  {
    "open": 98.874357705354,
    "high": 99.2144436727323,
    "low": 98.8528457076836,
    "close": 99.147042339686,
    "priceDate": "2024-07-05T00:00:00-04:00",
    "ticks": 638557344000000000,
    "epochTime": 1720137600,
    "hasValue": true,
    "time": "2024-07-05"
  },
  {
    "open": 98.9778329657274,
    "high": 99.181702564612,
    "low": 98.9653450264249,
    "close": 99.068304041454,
    "priceDate": "2024-07-08T00:00:00-04:00",
    "ticks": 638559936000000000,
    "epochTime": 1720396800,
    "hasValue": true,
    "time": "2024-07-08"
  },
  {
    "open": 99.0244612980897,
    "high": 99.1974667096516,
    "low": 98.9702168967136,
    "close": 99.1296897562839,
    "priceDate": "2024-07-09T00:00:00-04:00",
    "ticks": 638560800000000000,
    "epochTime": 1720483200,
    "hasValue": true,
    "time": "2024-07-09"
  },
  {
    "open": 99.2501349388306,
    "high": 99.285200890617,
    "low": 99.0961406826946,
    "close": 99.255952915026,
    "priceDate": "2024-07-10T00:00:00-04:00",
    "ticks": 638561664000000000,
    "epochTime": 1720569600,
    "hasValue": true,
    "time": "2024-07-10"
  },
  {
    "open": 99.236328,
    "high": 99.9595302869213,
    "low": 99.179687,
    "close": 99.5394383962913,
    "priceDate": "2024-07-11T00:00:00-04:00",
    "ticks": 638562528000000000,
    "epochTime": 1720656000,
    "hasValue": true,
    "time": "2024-07-11"
  },
  {
    "open": 99.5367460818593,
    "high": 99.816406,
    "low": 99.4356963316823,
    "close": 99.7780704224903,
    "priceDate": "2024-07-12T00:00:00-04:00",
    "ticks": 638563392000000000,
    "epochTime": 1720742400,
    "hasValue": true,
    "time": "2024-07-12"
  },
  {
    "open": 99.648271941393,
    "high": 99.738219257239,
    "low": 99.527343,
    "close": 99.5574715640496,
    "priceDate": "2024-07-15T00:00:00-04:00",
    "ticks": 638565984000000000,
    "epochTime": 1721001600,
    "hasValue": true,
    "time": "2024-07-15"
  },
  {
    "open": 99.7689257603814,
    "high": 99.8125,
    "low": 99.483626580231,
    "close": 99.7713427035986,
    "priceDate": "2024-07-16T00:00:00-04:00",
    "ticks": 638566848000000000,
    "epochTime": 1721088000,
    "hasValue": true,
    "time": "2024-07-16"
  },
  {
    "open": 99.6116841907134,
    "high": 99.820312,
    "low": 99.546369639465,
    "close": 99.757812,
    "priceDate": "2024-07-17T00:00:00-04:00",
    "ticks": 638567712000000000,
    "epochTime": 1721174400,
    "hasValue": true,
    "time": "2024-07-17"
  },
  {
    "open": 99.6583480654116,
    "high": 99.8304669208793,
    "low": 99.53125,
    "close": 99.5625,
    "priceDate": "2024-07-18T00:00:00-04:00",
    "ticks": 638568576000000000,
    "epochTime": 1721260800,
    "hasValue": true,
    "time": "2024-07-18"
  },
  {
    "open": 99.453125,
    "high": 99.45327425014,
    "low": 99.327527233613,
    "close": 99.395703734545,
    "priceDate": "2024-07-19T00:00:00-04:00",
    "ticks": 638569440000000000,
    "epochTime": 1721347200,
    "hasValue": true,
    "time": "2024-07-19"
  },
  {
    "open": 99.4361946232357,
    "high": 99.491700341401,
    "low": 99.272094602278,
    "close": 99.3806702996943,
    "priceDate": "2024-07-22T00:00:00-04:00",
    "ticks": 638572032000000000,
    "epochTime": 1721606400,
    "hasValue": true,
    "time": "2024-07-22"
  },
  {
    "open": 99.440279362269,
    "high": 99.53125,
    "low": 99.3533991809607,
    "close": 99.3800799124793,
    "priceDate": "2024-07-23T00:00:00-04:00",
    "ticks": 638572896000000000,
    "epochTime": 1721692800,
    "hasValue": true,
    "time": "2024-07-23"
  },
  {
    "open": 99.5046395786083,
    "high": 99.5634813559044,
    "low": 99.2120521067556,
    "close": 99.2140649982516,
    "priceDate": "2024-07-24T00:00:00-04:00",
    "ticks": 638573760000000000,
    "epochTime": 1721779200,
    "hasValue": true,
    "time": "2024-07-24"
  },
  {
    "open": 99.634180186141,
    "high": 99.6941197048582,
    "low": 99.2681038271425,
    "close": 99.409493140776,
    "priceDate": "2024-07-25T00:00:00-04:00",
    "ticks": 638574624000000000,
    "epochTime": 1721865600,
    "hasValue": true,
    "time": "2024-07-25"
  },
  {
    "open": 99.3918144830258,
    "high": 99.6913768045107,
    "low": 99.3314394235425,
    "close": 99.6302465528347,
    "priceDate": "2024-07-26T00:00:00-04:00",
    "ticks": 638575488000000000,
    "epochTime": 1721952000,
    "hasValue": true,
    "time": "2024-07-26"
  },
  {
    "open": 99.8203563869876,
    "high": 99.828125,
    "low": 99.6249608975328,
    "close": 99.6880965035702,
    "priceDate": "2024-07-29T00:00:00-04:00",
    "ticks": 638578080000000000,
    "epochTime": 1722211200,
    "hasValue": true,
    "time": "2024-07-29"
  },
  {
    "open": 99.6749679291851,
    "high": 99.859375,
    "low": 99.606601530885,
    "close": 99.8210195605294,
    "priceDate": "2024-07-30T00:00:00-04:00",
    "ticks": 638578944000000000,
    "epochTime": 1722297600,
    "hasValue": true,
    "time": "2024-07-30"
  },
  {
    "open": 99.8125,
    "high": 100.22071123619,
    "low": 99.8020295815064,
    "close": 100.186153469262,
    "priceDate": "2024-07-31T00:00:00-04:00",
    "ticks": 638579808000000000,
    "epochTime": 1722384000,
    "hasValue": true,
    "time": "2024-07-31"
  },
  {
    "open": 100.08337533155,
    "high": 100.448671431771,
    "low": 100.074367573945,
    "close": 100.380255836967,
    "priceDate": "2024-08-01T00:00:00-04:00",
    "ticks": 638580672000000000,
    "epochTime": 1722470400,
    "hasValue": true,
    "time": "2024-08-01"
  },
  {
    "open": 100.507628244678,
    "high": 101.502958797351,
    "low": 100.503846924778,
    "close": 100.905157530228,
    "priceDate": "2024-08-02T00:00:00-04:00",
    "ticks": 638581536000000000,
    "epochTime": 1722556800,
    "hasValue": true,
    "time": "2024-08-02"
  },
  {
    "open": 101.386986899942,
    "high": 101.474601110625,
    "low": 100.637807556412,
    "close": 100.690125283955,
    "priceDate": "2024-08-05T00:00:00-04:00",
    "ticks": 638584128000000000,
    "epochTime": 1722816000,
    "hasValue": true,
    "time": "2024-08-05"
  },
  {
    "open": 100.565759066231,
    "high": 100.739138550613,
    "low": 100.434274880128,
    "close": 100.471276617943,
    "priceDate": "2024-08-06T00:00:00-04:00",
    "ticks": 638584992000000000,
    "epochTime": 1722902400,
    "hasValue": true,
    "time": "2024-08-06"
  },
  {
    "open": 100.334147047689,
    "high": 100.546875,
    "low": 100.3125,
    "close": 100.420510785698,
    "priceDate": "2024-08-07T00:00:00-04:00",
    "ticks": 638585856000000000,
    "epochTime": 1722988800,
    "hasValue": true,
    "time": "2024-08-07"
  },
  {
    "open": 100.481504146012,
    "high": 100.569743994243,
    "low": 100.141215204231,
    "close": 100.295515458239,
    "priceDate": "2024-08-08T00:00:00-04:00",
    "ticks": 638586720000000000,
    "epochTime": 1723075200,
    "hasValue": true,
    "time": "2024-08-08"
  },
  {
    "open": 100.311137257144,
    "high": 100.589388020431,
    "low": 100.302052776699,
    "close": 100.370515994888,
    "priceDate": "2024-08-09T00:00:00-04:00",
    "ticks": 638587584000000000,
    "epochTime": 1723161600,
    "hasValue": true,
    "time": "2024-08-09"
  },
  {
    "open": 100.411964749649,
    "high": 100.495607717282,
    "low": 100.291277450251,
    "close": 100.410952662653,
    "priceDate": "2024-08-12T00:00:00-04:00",
    "ticks": 638590176000000000,
    "epochTime": 1723420800,
    "hasValue": true,
    "time": "2024-08-12"
  }
]

export const MARKET_RATE_10 = [
  {
    "open": 0.8215,
    "high": 0.8771,
    "low": 0.8164,
    "close": 0.8754,
    "priceDate": "2020-10-30T00:00:00-04:00",
    "ticks": 637396128000000000,
    "epochTime": 1604016000,
    "hasValue": true,
    "time": "2020-10-30"
  },
  {
    "open": 0.8535,
    "high": 0.8586,
    "low": 0.8282,
    "close": 0.8468,
    "priceDate": "2020-11-02T00:00:00-05:00",
    "ticks": 637398720000000000,
    "epochTime": 1604275200,
    "hasValue": true,
    "time": "2020-11-02"
  },
  {
    "open": 0.8688,
    "high": 0.901,
    "low": 0.8688,
    "close": 0.901,
    "priceDate": "2020-11-03T00:00:00-05:00",
    "ticks": 637399584000000000,
    "epochTime": 1604361600,
    "hasValue": true,
    "time": "2020-11-03"
  },
  {
    "open": 0.7947,
    "high": 0.8014,
    "low": 0.7562,
    "close": 0.7662,
    "priceDate": "2020-11-04T00:00:00-05:00",
    "ticks": 637400448000000000,
    "epochTime": 1604448000,
    "hasValue": true,
    "time": "2020-11-04"
  },
  {
    "open": 0.7579,
    "high": 0.7897,
    "low": 0.7479,
    "close": 0.7612,
    "priceDate": "2020-11-05T00:00:00-05:00",
    "ticks": 637401312000000000,
    "epochTime": 1604534400,
    "hasValue": true,
    "time": "2020-11-05"
  },
  {
    "open": 0.7781,
    "high": 0.837,
    "low": 0.7748,
    "close": 0.8235,
    "priceDate": "2020-11-06T00:00:00-05:00",
    "ticks": 637402176000000000,
    "epochTime": 1604620800,
    "hasValue": true,
    "time": "2020-11-06"
  },
  {
    "open": 0.9235,
    "high": 0.975,
    "low": 0.9031,
    "close": 0.9252,
    "priceDate": "2020-11-09T00:00:00-05:00",
    "ticks": 637404768000000000,
    "epochTime": 1604880000,
    "hasValue": true,
    "time": "2020-11-09"
  },
  {
    "open": 0.953,
    "high": 0.9732,
    "low": 0.939,
    "close": 0.963,
    "priceDate": "2020-11-10T00:00:00-05:00",
    "ticks": 637405632000000000,
    "epochTime": 1604966400,
    "hasValue": true,
    "time": "2020-11-10"
  },
  {
    "open": 0.934,
    "high": 0.9374,
    "low": 0.878,
    "close": 0.8799,
    "priceDate": "2020-11-12T00:00:00-05:00",
    "ticks": 637407360000000000,
    "epochTime": 1605139200,
    "hasValue": true,
    "time": "2020-11-12"
  },
  {
    "open": 0.882,
    "high": 0.903,
    "low": 0.8717,
    "close": 0.9012,
    "priceDate": "2020-11-13T00:00:00-05:00",
    "ticks": 637408224000000000,
    "epochTime": 1605225600,
    "hasValue": true,
    "time": "2020-11-13"
  },
  {
    "open": 0.918,
    "high": 0.921,
    "low": 0.896,
    "close": 0.9061,
    "priceDate": "2020-11-16T00:00:00-05:00",
    "ticks": 637410816000000000,
    "epochTime": 1605484800,
    "hasValue": true,
    "time": "2020-11-16"
  },
  {
    "open": 0.882,
    "high": 0.885,
    "low": 0.8586,
    "close": 0.8586,
    "priceDate": "2020-11-17T00:00:00-05:00",
    "ticks": 637411680000000000,
    "epochTime": 1605571200,
    "hasValue": true,
    "time": "2020-11-17"
  },
  {
    "open": 0.862,
    "high": 0.893,
    "low": 0.85,
    "close": 0.8734,
    "priceDate": "2020-11-18T00:00:00-05:00",
    "ticks": 637412544000000000,
    "epochTime": 1605657600,
    "hasValue": true,
    "time": "2020-11-18"
  },
  {
    "open": 0.855,
    "high": 0.8652,
    "low": 0.8309,
    "close": 0.8309,
    "priceDate": "2020-11-19T00:00:00-05:00",
    "ticks": 637413408000000000,
    "epochTime": 1605744000,
    "hasValue": true,
    "time": "2020-11-19"
  },
  {
    "open": 0.834,
    "high": 0.8504,
    "low": 0.821,
    "close": 0.826,
    "priceDate": "2020-11-20T00:00:00-05:00",
    "ticks": 637414272000000000,
    "epochTime": 1605830400,
    "hasValue": true,
    "time": "2020-11-20"
  },
  {
    "open": 0.854,
    "high": 0.862,
    "low": 0.8455,
    "close": 0.8553,
    "priceDate": "2020-11-23T00:00:00-05:00",
    "ticks": 637416864000000000,
    "epochTime": 1606089600,
    "hasValue": true,
    "time": "2020-11-23"
  },
  {
    "open": 0.87,
    "high": 0.8881,
    "low": 0.865,
    "close": 0.8816,
    "priceDate": "2020-11-24T00:00:00-05:00",
    "ticks": 637417728000000000,
    "epochTime": 1606176000,
    "hasValue": true,
    "time": "2020-11-24"
  },
  {
    "open": 0.878,
    "high": 0.8865,
    "low": 0.855,
    "close": 0.8832,
    "priceDate": "2020-11-25T00:00:00-05:00",
    "ticks": 637418592000000000,
    "epochTime": 1606262400,
    "hasValue": true,
    "time": "2020-11-25"
  },
  {
    "open": 0.857,
    "high": 0.864,
    "low": 0.837,
    "close": 0.8422,
    "priceDate": "2020-11-27T00:00:00-05:00",
    "ticks": 637420320000000000,
    "epochTime": 1606435200,
    "hasValue": true,
    "time": "2020-11-27"
  },
  {
    "open": 0.849,
    "high": 0.859,
    "low": 0.837,
    "close": 0.8406,
    "priceDate": "2020-11-30T00:00:00-05:00",
    "ticks": 637422912000000000,
    "epochTime": 1606694400,
    "hasValue": true,
    "time": "2020-11-30"
  },
  {
    "open": 0.859,
    "high": 0.938,
    "low": 0.855,
    "close": 0.9293,
    "priceDate": "2020-12-01T00:00:00-05:00",
    "ticks": 637423776000000000,
    "epochTime": 1606780800,
    "hasValue": true,
    "time": "2020-12-01"
  },
  {
    "open": 0.928,
    "high": 0.966,
    "low": 0.919,
    "close": 0.9376,
    "priceDate": "2020-12-02T00:00:00-05:00",
    "ticks": 637424640000000000,
    "epochTime": 1606867200,
    "hasValue": true,
    "time": "2020-12-02"
  },
  {
    "open": 0.941,
    "high": 0.943,
    "low": 0.901,
    "close": 0.9079,
    "priceDate": "2020-12-03T00:00:00-05:00",
    "ticks": 637425504000000000,
    "epochTime": 1606953600,
    "hasValue": true,
    "time": "2020-12-03"
  },
  {
    "open": 0.924,
    "high": 0.986,
    "low": 0.901,
    "close": 0.9692,
    "priceDate": "2020-12-04T00:00:00-05:00",
    "ticks": 637426368000000000,
    "epochTime": 1607040000,
    "hasValue": true,
    "time": "2020-12-04"
  },
  {
    "open": 0.946,
    "high": 0.948,
    "low": 0.924,
    "close": 0.9245,
    "priceDate": "2020-12-07T00:00:00-05:00",
    "ticks": 637428960000000000,
    "epochTime": 1607299200,
    "hasValue": true,
    "time": "2020-12-07"
  },
  {
    "open": 0.924,
    "high": 0.928,
    "low": 0.893,
    "close": 0.921,
    "priceDate": "2020-12-08T00:00:00-05:00",
    "ticks": 637429824000000000,
    "epochTime": 1607385600,
    "hasValue": true,
    "time": "2020-12-08"
  },
  {
    "open": 0.941,
    "high": 0.9593,
    "low": 0.924,
    "close": 0.9361,
    "priceDate": "2020-12-09T00:00:00-05:00",
    "ticks": 637430688000000000,
    "epochTime": 1607472000,
    "hasValue": true,
    "time": "2020-12-09"
  },
  {
    "open": 0.929,
    "high": 0.9411,
    "low": 0.9047,
    "close": 0.9096,
    "priceDate": "2020-12-10T00:00:00-05:00",
    "ticks": 637431552000000000,
    "epochTime": 1607558400,
    "hasValue": true,
    "time": "2020-12-10"
  },
  {
    "open": 0.891,
    "high": 0.9014,
    "low": 0.873,
    "close": 0.8997,
    "priceDate": "2020-12-11T00:00:00-05:00",
    "ticks": 637432416000000000,
    "epochTime": 1607644800,
    "hasValue": true,
    "time": "2020-12-11"
  },
  {
    "open": 0.936,
    "high": 0.938,
    "low": 0.888,
    "close": 0.8948,
    "priceDate": "2020-12-14T00:00:00-05:00",
    "ticks": 637435008000000000,
    "epochTime": 1607904000,
    "hasValue": true,
    "time": "2020-12-14"
  },
  {
    "open": 0.898,
    "high": 0.925,
    "low": 0.898,
    "close": 0.911,
    "priceDate": "2020-12-15T00:00:00-05:00",
    "ticks": 637435872000000000,
    "epochTime": 1607990400,
    "hasValue": true,
    "time": "2020-12-15"
  },
  {
    "open": 0.925,
    "high": 0.9545,
    "low": 0.908,
    "close": 0.92,
    "priceDate": "2020-12-16T00:00:00-05:00",
    "ticks": 637436736000000000,
    "epochTime": 1608076800,
    "hasValue": true,
    "time": "2020-12-16"
  },
  {
    "open": 0.92,
    "high": 0.945,
    "low": 0.891,
    "close": 0.9379,
    "priceDate": "2020-12-17T00:00:00-05:00",
    "ticks": 637437600000000000,
    "epochTime": 1608163200,
    "hasValue": true,
    "time": "2020-12-17"
  },
  {
    "open": 0.928,
    "high": 0.9512,
    "low": 0.918,
    "close": 0.9512,
    "priceDate": "2020-12-18T00:00:00-05:00",
    "ticks": 637438464000000000,
    "epochTime": 1608249600,
    "hasValue": true,
    "time": "2020-12-18"
  },
  {
    "open": 0.898,
    "high": 0.948,
    "low": 0.8948,
    "close": 0.9363,
    "priceDate": "2020-12-21T00:00:00-05:00",
    "ticks": 637441056000000000,
    "epochTime": 1608508800,
    "hasValue": true,
    "time": "2020-12-21"
  },
  {
    "open": 0.93,
    "high": 0.935,
    "low": 0.9147,
    "close": 0.9197,
    "priceDate": "2020-12-22T00:00:00-05:00",
    "ticks": 637441920000000000,
    "epochTime": 1608595200,
    "hasValue": true,
    "time": "2020-12-22"
  },
  {
    "open": 0.925,
    "high": 0.973,
    "low": 0.918,
    "close": 0.9446,
    "priceDate": "2020-12-23T00:00:00-05:00",
    "ticks": 637442784000000000,
    "epochTime": 1608681600,
    "hasValue": true,
    "time": "2020-12-23"
  },
  {
    "open": 0.94,
    "high": 0.9414,
    "low": 0.921,
    "close": 0.926,
    "priceDate": "2020-12-24T00:00:00-05:00",
    "ticks": 637443648000000000,
    "epochTime": 1608768000,
    "hasValue": true,
    "time": "2020-12-24"
  },
  {
    "open": 0.958,
    "high": 0.9581,
    "low": 0.923,
    "close": 0.9264,
    "priceDate": "2020-12-28T00:00:00-05:00",
    "ticks": 637447104000000000,
    "epochTime": 1609113600,
    "hasValue": true,
    "time": "2020-12-28"
  },
  {
    "open": 0.948,
    "high": 0.9514,
    "low": 0.928,
    "close": 0.9397,
    "priceDate": "2020-12-29T00:00:00-05:00",
    "ticks": 637447968000000000,
    "epochTime": 1609200000,
    "hasValue": true,
    "time": "2020-12-29"
  },
  {
    "open": 0.945,
    "high": 0.945,
    "low": 0.923,
    "close": 0.9248,
    "priceDate": "2020-12-30T00:00:00-05:00",
    "ticks": 637448832000000000,
    "epochTime": 1609286400,
    "hasValue": true,
    "time": "2020-12-30"
  },
  {
    "open": 0.928,
    "high": 0.9365,
    "low": 0.9115,
    "close": 0.9165,
    "priceDate": "2020-12-31T00:00:00-05:00",
    "ticks": 637449696000000000,
    "epochTime": 1609372800,
    "hasValue": true,
    "time": "2020-12-31"
  },
  {
    "open": 0.935,
    "high": 0.9532,
    "low": 0.9065,
    "close": 0.9148,
    "priceDate": "2021-01-04T00:00:00-05:00",
    "ticks": 637453152000000000,
    "epochTime": 1609718400,
    "hasValue": true,
    "time": "2021-01-04"
  },
  {
    "open": 0.933,
    "high": 0.9632,
    "low": 0.9265,
    "close": 0.96,
    "priceDate": "2021-01-05T00:00:00-05:00",
    "ticks": 637454016000000000,
    "epochTime": 1609804800,
    "hasValue": true,
    "time": "2021-01-05"
  },
  {
    "open": 1.012,
    "high": 1.0541,
    "low": 0.998,
    "close": 1.042,
    "priceDate": "2021-01-06T00:00:00-05:00",
    "ticks": 637454880000000000,
    "epochTime": 1609891200,
    "hasValue": true,
    "time": "2021-01-06"
  },
  {
    "open": 1.056,
    "high": 1.088,
    "low": 1.054,
    "close": 1.0829,
    "priceDate": "2021-01-07T00:00:00-05:00",
    "ticks": 637455744000000000,
    "epochTime": 1609977600,
    "hasValue": true,
    "time": "2021-01-07"
  },
  {
    "open": 1.09,
    "high": 1.126,
    "low": 1.0746,
    "close": 1.117,
    "priceDate": "2021-01-08T00:00:00-05:00",
    "ticks": 637456608000000000,
    "epochTime": 1610064000,
    "hasValue": true,
    "time": "2021-01-08"
  },
  {
    "open": 1.11,
    "high": 1.1495,
    "low": 1.1,
    "close": 1.1495,
    "priceDate": "2021-01-11T00:00:00-05:00",
    "ticks": 637459200000000000,
    "epochTime": 1610323200,
    "hasValue": true,
    "time": "2021-01-11"
  },
  {
    "open": 1.172,
    "high": 1.1872,
    "low": 1.129,
    "close": 1.1291,
    "priceDate": "2021-01-12T00:00:00-05:00",
    "ticks": 637460064000000000,
    "epochTime": 1610409600,
    "hasValue": true,
    "time": "2021-01-12"
  },
  {
    "open": 1.127,
    "high": 1.1342,
    "low": 1.071,
    "close": 1.0849,
    "priceDate": "2021-01-13T00:00:00-05:00",
    "ticks": 637460928000000000,
    "epochTime": 1610496000,
    "hasValue": true,
    "time": "2021-01-13"
  },
  {
    "open": 1.107,
    "high": 1.138,
    "low": 1.0866,
    "close": 1.1309,
    "priceDate": "2021-01-14T00:00:00-05:00",
    "ticks": 637461792000000000,
    "epochTime": 1610582400,
    "hasValue": true,
    "time": "2021-01-14"
  },
  {
    "open": 1.1,
    "high": 1.1192,
    "low": 1.083,
    "close": 1.0852,
    "priceDate": "2021-01-15T00:00:00-05:00",
    "ticks": 637462656000000000,
    "epochTime": 1610668800,
    "hasValue": true,
    "time": "2021-01-15"
  },
  {
    "open": 1.116,
    "high": 1.1193,
    "low": 1.0869,
    "close": 1.0886,
    "priceDate": "2021-01-19T00:00:00-05:00",
    "ticks": 637466112000000000,
    "epochTime": 1611014400,
    "hasValue": true,
    "time": "2021-01-19"
  },
  {
    "open": 1.104,
    "high": 1.1074,
    "low": 1.075,
    "close": 1.0802,
    "priceDate": "2021-01-20T00:00:00-05:00",
    "ticks": 637466976000000000,
    "epochTime": 1611100800,
    "hasValue": true,
    "time": "2021-01-20"
  },
  {
    "open": 1.097,
    "high": 1.123,
    "low": 1.0956,
    "close": 1.1092,
    "priceDate": "2021-01-21T00:00:00-05:00",
    "ticks": 637467840000000000,
    "epochTime": 1611187200,
    "hasValue": true,
    "time": "2021-01-21"
  },
  {
    "open": 1.086,
    "high": 1.103,
    "low": 1.08,
    "close": 1.0889,
    "priceDate": "2021-01-22T00:00:00-05:00",
    "ticks": 637468704000000000,
    "epochTime": 1611273600,
    "hasValue": true,
    "time": "2021-01-22"
  },
  {
    "open": 1.063,
    "high": 1.0703,
    "low": 1.0295,
    "close": 1.0312,
    "priceDate": "2021-01-25T00:00:00-05:00",
    "ticks": 637471296000000000,
    "epochTime": 1611532800,
    "hasValue": true,
    "time": "2021-01-25"
  },
  {
    "open": 1.045,
    "high": 1.05,
    "low": 1.033,
    "close": 1.0347,
    "priceDate": "2021-01-26T00:00:00-05:00",
    "ticks": 637472160000000000,
    "epochTime": 1611619200,
    "hasValue": true,
    "time": "2021-01-26"
  },
  {
    "open": 1.019,
    "high": 1.0262,
    "low": 1.0009,
    "close": 1.0195,
    "priceDate": "2021-01-27T00:00:00-05:00",
    "ticks": 637473024000000000,
    "epochTime": 1611705600,
    "hasValue": true,
    "time": "2021-01-27"
  },
  {
    "open": 1.009,
    "high": 1.0721,
    "low": 1.004,
    "close": 1.0483,
    "priceDate": "2021-01-28T00:00:00-05:00",
    "ticks": 637473888000000000,
    "epochTime": 1611792000,
    "hasValue": true,
    "time": "2021-01-28"
  },
  {
    "open": 1.067,
    "high": 1.105,
    "low": 1.065,
    "close": 1.067,
    "priceDate": "2021-01-29T00:00:00-05:00",
    "ticks": 637474752000000000,
    "epochTime": 1611878400,
    "hasValue": true,
    "time": "2021-01-29"
  },
  {
    "open": 1.074,
    "high": 1.088,
    "low": 1.06,
    "close": 1.0843,
    "priceDate": "2021-02-01T00:00:00-05:00",
    "ticks": 637477344000000000,
    "epochTime": 1612137600,
    "hasValue": true,
    "time": "2021-02-01"
  },
  {
    "open": 1.112,
    "high": 1.119,
    "low": 1.0946,
    "close": 1.098,
    "priceDate": "2021-02-02T00:00:00-05:00",
    "ticks": 637478208000000000,
    "epochTime": 1612224000,
    "hasValue": true,
    "time": "2021-02-02"
  },
  {
    "open": 1.119,
    "high": 1.141,
    "low": 1.113,
    "close": 1.1409,
    "priceDate": "2021-02-03T00:00:00-05:00",
    "ticks": 637479072000000000,
    "epochTime": 1612310400,
    "hasValue": true,
    "time": "2021-02-03"
  },
  {
    "open": 1.143,
    "high": 1.162,
    "low": 1.134,
    "close": 1.1426,
    "priceDate": "2021-02-04T00:00:00-05:00",
    "ticks": 637479936000000000,
    "epochTime": 1612396800,
    "hasValue": true,
    "time": "2021-02-04"
  },
  {
    "open": 1.17,
    "high": 1.188,
    "low": 1.136,
    "close": 1.1652,
    "priceDate": "2021-02-05T00:00:00-05:00",
    "ticks": 637480800000000000,
    "epochTime": 1612483200,
    "hasValue": true,
    "time": "2021-02-05"
  },
  {
    "open": 1.191,
    "high": 1.193,
    "low": 1.1498,
    "close": 1.1739,
    "priceDate": "2021-02-08T00:00:00-05:00",
    "ticks": 637483392000000000,
    "epochTime": 1612742400,
    "hasValue": true,
    "time": "2021-02-08"
  },
  {
    "open": 1.146,
    "high": 1.164,
    "low": 1.1396,
    "close": 1.16,
    "priceDate": "2021-02-09T00:00:00-05:00",
    "ticks": 637484256000000000,
    "epochTime": 1612828800,
    "hasValue": true,
    "time": "2021-02-09"
  },
  {
    "open": 1.172,
    "high": 1.176,
    "low": 1.122,
    "close": 1.1259,
    "priceDate": "2021-02-10T00:00:00-05:00",
    "ticks": 637485120000000000,
    "epochTime": 1612915200,
    "hasValue": true,
    "time": "2021-02-10"
  },
  {
    "open": 1.142,
    "high": 1.1665,
    "low": 1.138,
    "close": 1.1665,
    "priceDate": "2021-02-11T00:00:00-05:00",
    "ticks": 637485984000000000,
    "epochTime": 1613001600,
    "hasValue": true,
    "time": "2021-02-11"
  },
  {
    "open": 1.175,
    "high": 1.2132,
    "low": 1.173,
    "close": 1.2115,
    "priceDate": "2021-02-12T00:00:00-05:00",
    "ticks": 637486848000000000,
    "epochTime": 1613088000,
    "hasValue": true,
    "time": "2021-02-12"
  },
  {
    "open": 1.245,
    "high": 1.3192,
    "low": 1.238,
    "close": 1.3175,
    "priceDate": "2021-02-16T00:00:00-05:00",
    "ticks": 637490304000000000,
    "epochTime": 1613433600,
    "hasValue": true,
    "time": "2021-02-16"
  },
  {
    "open": 1.311,
    "high": 1.3311,
    "low": 1.2686,
    "close": 1.272,
    "priceDate": "2021-02-17T00:00:00-05:00",
    "ticks": 637491168000000000,
    "epochTime": 1613520000,
    "hasValue": true,
    "time": "2021-02-17"
  },
  {
    "open": 1.294,
    "high": 1.318,
    "low": 1.275,
    "close": 1.2973,
    "priceDate": "2021-02-18T00:00:00-05:00",
    "ticks": 637492032000000000,
    "epochTime": 1613606400,
    "hasValue": true,
    "time": "2021-02-18"
  },
  {
    "open": 1.316,
    "high": 1.364,
    "low": 1.3076,
    "close": 1.3431,
    "priceDate": "2021-02-19T00:00:00-05:00",
    "ticks": 637492896000000000,
    "epochTime": 1613692800,
    "hasValue": true,
    "time": "2021-02-19"
  },
  {
    "open": 1.37,
    "high": 1.379,
    "low": 1.326,
    "close": 1.367,
    "priceDate": "2021-02-22T00:00:00-05:00",
    "ticks": 637495488000000000,
    "epochTime": 1613952000,
    "hasValue": true,
    "time": "2021-02-22"
  },
  {
    "open": 1.359,
    "high": 1.3892,
    "low": 1.3416,
    "close": 1.345,
    "priceDate": "2021-02-23T00:00:00-05:00",
    "ticks": 637496352000000000,
    "epochTime": 1614038400,
    "hasValue": true,
    "time": "2021-02-23"
  },
  {
    "open": 1.381,
    "high": 1.4354,
    "low": 1.3688,
    "close": 1.379,
    "priceDate": "2021-02-24T00:00:00-05:00",
    "ticks": 637497216000000000,
    "epochTime": 1614124800,
    "hasValue": true,
    "time": "2021-02-24"
  },
  {
    "open": 1.453,
    "high": 1.6138,
    "low": 1.432,
    "close": 1.5199,
    "priceDate": "2021-02-25T00:00:00-05:00",
    "ticks": 637498080000000000,
    "epochTime": 1614211200,
    "hasValue": true,
    "time": "2021-02-25"
  },
  {
    "open": 1.482,
    "high": 1.5185,
    "low": 1.381,
    "close": 1.4083,
    "priceDate": "2021-02-26T00:00:00-05:00",
    "ticks": 637498944000000000,
    "epochTime": 1614297600,
    "hasValue": true,
    "time": "2021-02-26"
  },
  {
    "open": 1.45,
    "high": 1.46,
    "low": 1.4067,
    "close": 1.4204,
    "priceDate": "2021-03-01T00:00:00-05:00",
    "ticks": 637501536000000000,
    "epochTime": 1614556800,
    "hasValue": true,
    "time": "2021-03-01"
  },
  {
    "open": 1.445,
    "high": 1.4514,
    "low": 1.3897,
    "close": 1.3914,
    "priceDate": "2021-03-02T00:00:00-05:00",
    "ticks": 637502400000000000,
    "epochTime": 1614643200,
    "hasValue": true,
    "time": "2021-03-02"
  },
  {
    "open": 1.465,
    "high": 1.498,
    "low": 1.4549,
    "close": 1.4825,
    "priceDate": "2021-03-03T00:00:00-05:00",
    "ticks": 637503264000000000,
    "epochTime": 1614729600,
    "hasValue": true,
    "time": "2021-03-03"
  },
  {
    "open": 1.465,
    "high": 1.5693,
    "low": 1.458,
    "close": 1.569,
    "priceDate": "2021-03-04T00:00:00-05:00",
    "ticks": 637504128000000000,
    "epochTime": 1614816000,
    "hasValue": true,
    "time": "2021-03-04"
  },
  {
    "open": 1.578,
    "high": 1.626,
    "low": 1.54,
    "close": 1.5661,
    "priceDate": "2021-03-05T00:00:00-05:00",
    "ticks": 637504992000000000,
    "epochTime": 1614902400,
    "hasValue": true,
    "time": "2021-03-05"
  },
  {
    "open": 1.605,
    "high": 1.6082,
    "low": 1.575,
    "close": 1.5959,
    "priceDate": "2021-03-08T00:00:00-05:00",
    "ticks": 637507584000000000,
    "epochTime": 1615161600,
    "hasValue": true,
    "time": "2021-03-08"
  },
  {
    "open": 1.535,
    "high": 1.563,
    "low": 1.526,
    "close": 1.5281,
    "priceDate": "2021-03-09T00:00:00-05:00",
    "ticks": 637508448000000000,
    "epochTime": 1615248000,
    "hasValue": true,
    "time": "2021-03-09"
  },
  {
    "open": 1.563,
    "high": 1.565,
    "low": 1.5056,
    "close": 1.5195,
    "priceDate": "2021-03-10T00:00:00-05:00",
    "ticks": 637509312000000000,
    "epochTime": 1615334400,
    "hasValue": true,
    "time": "2021-03-10"
  },
  {
    "open": 1.488,
    "high": 1.5474,
    "low": 1.488,
    "close": 1.5405,
    "priceDate": "2021-03-11T00:00:00-05:00",
    "ticks": 637510176000000000,
    "epochTime": 1615420800,
    "hasValue": true,
    "time": "2021-03-11"
  },
  {
    "open": 1.593,
    "high": 1.6423,
    "low": 1.584,
    "close": 1.6264,
    "priceDate": "2021-03-12T00:00:00-05:00",
    "ticks": 637511040000000000,
    "epochTime": 1615507200,
    "hasValue": true,
    "time": "2021-03-12"
  },
  {
    "open": 1.628,
    "high": 1.632,
    "low": 1.595,
    "close": 1.609,
    "priceDate": "2021-03-15T00:00:00-04:00",
    "ticks": 637513632000000000,
    "epochTime": 1615766400,
    "hasValue": true,
    "time": "2021-03-15"
  },
  {
    "open": 1.593,
    "high": 1.6285,
    "low": 1.5846,
    "close": 1.6214,
    "priceDate": "2021-03-16T00:00:00-04:00",
    "ticks": 637514496000000000,
    "epochTime": 1615852800,
    "hasValue": true,
    "time": "2021-03-16"
  },
  {
    "open": 1.671,
    "high": 1.689,
    "low": 1.618,
    "close": 1.6462,
    "priceDate": "2021-03-17T00:00:00-04:00",
    "ticks": 637515360000000000,
    "epochTime": 1615939200,
    "hasValue": true,
    "time": "2021-03-17"
  },
  {
    "open": 1.728,
    "high": 1.7543,
    "low": 1.7046,
    "close": 1.7099,
    "priceDate": "2021-03-18T00:00:00-04:00",
    "ticks": 637516224000000000,
    "epochTime": 1616025600,
    "hasValue": true,
    "time": "2021-03-18"
  },
  {
    "open": 1.687,
    "high": 1.7495,
    "low": 1.682,
    "close": 1.7228,
    "priceDate": "2021-03-19T00:00:00-04:00",
    "ticks": 637517088000000000,
    "epochTime": 1616112000,
    "hasValue": true,
    "time": "2021-03-19"
  },
  {
    "open": 1.696,
    "high": 1.702,
    "low": 1.675,
    "close": 1.6981,
    "priceDate": "2021-03-22T00:00:00-04:00",
    "ticks": 637519680000000000,
    "epochTime": 1616371200,
    "hasValue": true,
    "time": "2021-03-22"
  },
  {
    "open": 1.647,
    "high": 1.665,
    "low": 1.615,
    "close": 1.6241,
    "priceDate": "2021-03-23T00:00:00-04:00",
    "ticks": 637520544000000000,
    "epochTime": 1616457600,
    "hasValue": true,
    "time": "2021-03-23"
  },
  {
    "open": 1.626,
    "high": 1.651,
    "low": 1.603,
    "close": 1.6102,
    "priceDate": "2021-03-24T00:00:00-04:00",
    "ticks": 637521408000000000,
    "epochTime": 1616544000,
    "hasValue": true,
    "time": "2021-03-24"
  },
  {
    "open": 1.603,
    "high": 1.642,
    "low": 1.591,
    "close": 1.6385,
    "priceDate": "2021-03-25T00:00:00-04:00",
    "ticks": 637522272000000000,
    "epochTime": 1616630400,
    "hasValue": true,
    "time": "2021-03-25"
  },
  {
    "open": 1.676,
    "high": 1.6813,
    "low": 1.6336,
    "close": 1.6778,
    "priceDate": "2021-03-26T00:00:00-04:00",
    "ticks": 637523136000000000,
    "epochTime": 1616716800,
    "hasValue": true,
    "time": "2021-03-26"
  },
  {
    "open": 1.65,
    "high": 1.728,
    "low": 1.6408,
    "close": 1.7116,
    "priceDate": "2021-03-29T00:00:00-04:00",
    "ticks": 637525728000000000,
    "epochTime": 1616976000,
    "hasValue": true,
    "time": "2021-03-29"
  },
  {
    "open": 1.751,
    "high": 1.7653,
    "low": 1.706,
    "close": 1.7064,
    "priceDate": "2021-03-30T00:00:00-04:00",
    "ticks": 637526592000000000,
    "epochTime": 1617062400,
    "hasValue": true,
    "time": "2021-03-30"
  },
  {
    "open": 1.73,
    "high": 1.753,
    "low": 1.708,
    "close": 1.7422,
    "priceDate": "2021-03-31T00:00:00-04:00",
    "ticks": 637527456000000000,
    "epochTime": 1617148800,
    "hasValue": true,
    "time": "2021-03-31"
  },
  {
    "open": 1.707,
    "high": 1.7072,
    "low": 1.6717,
    "close": 1.6717,
    "priceDate": "2021-04-01T00:00:00-04:00",
    "ticks": 637528320000000000,
    "epochTime": 1617235200,
    "hasValue": true,
    "time": "2021-04-01"
  },
  {
    "open": 1.674,
    "high": 1.729,
    "low": 1.6664,
    "close": 1.714,
    "priceDate": "2021-04-02T00:00:00-04:00",
    "ticks": 637529184000000000,
    "epochTime": 1617321600,
    "hasValue": true,
    "time": "2021-04-02"
  },
  {
    "open": 1.739,
    "high": 1.745,
    "low": 1.702,
    "close": 1.702,
    "priceDate": "2021-04-05T00:00:00-04:00",
    "ticks": 637531776000000000,
    "epochTime": 1617580800,
    "hasValue": true,
    "time": "2021-04-05"
  },
  {
    "open": 1.693,
    "high": 1.697,
    "low": 1.652,
    "close": 1.6613,
    "priceDate": "2021-04-06T00:00:00-04:00",
    "ticks": 637532640000000000,
    "epochTime": 1617667200,
    "hasValue": true,
    "time": "2021-04-06"
  },
  {
    "open": 1.66,
    "high": 1.6792,
    "low": 1.6349,
    "close": 1.6739,
    "priceDate": "2021-04-07T00:00:00-04:00",
    "ticks": 637533504000000000,
    "epochTime": 1617753600,
    "hasValue": true,
    "time": "2021-04-07"
  },
  {
    "open": 1.66,
    "high": 1.6652,
    "low": 1.617,
    "close": 1.6227,
    "priceDate": "2021-04-08T00:00:00-04:00",
    "ticks": 637534368000000000,
    "epochTime": 1617840000,
    "hasValue": true,
    "time": "2021-04-08"
  },
  {
    "open": 1.674,
    "high": 1.687,
    "low": 1.637,
    "close": 1.6638,
    "priceDate": "2021-04-09T00:00:00-04:00",
    "ticks": 637535232000000000,
    "epochTime": 1617926400,
    "hasValue": true,
    "time": "2021-04-09"
  },
  {
    "open": 1.671,
    "high": 1.6853,
    "low": 1.664,
    "close": 1.6675,
    "priceDate": "2021-04-12T00:00:00-04:00",
    "ticks": 637537824000000000,
    "epochTime": 1618185600,
    "hasValue": true,
    "time": "2021-04-12"
  },
  {
    "open": 1.682,
    "high": 1.698,
    "low": 1.616,
    "close": 1.618,
    "priceDate": "2021-04-13T00:00:00-04:00",
    "ticks": 637538688000000000,
    "epochTime": 1618272000,
    "hasValue": true,
    "time": "2021-04-13"
  },
  {
    "open": 1.627,
    "high": 1.65,
    "low": 1.627,
    "close": 1.6341,
    "priceDate": "2021-04-14T00:00:00-04:00",
    "ticks": 637539552000000000,
    "epochTime": 1618358400,
    "hasValue": true,
    "time": "2021-04-14"
  },
  {
    "open": 1.611,
    "high": 1.6183,
    "low": 1.5285,
    "close": 1.5812,
    "priceDate": "2021-04-15T00:00:00-04:00",
    "ticks": 637540416000000000,
    "epochTime": 1618444800,
    "hasValue": true,
    "time": "2021-04-15"
  },
  {
    "open": 1.555,
    "high": 1.5992,
    "low": 1.555,
    "close": 1.5816,
    "priceDate": "2021-04-16T00:00:00-04:00",
    "ticks": 637541280000000000,
    "epochTime": 1618531200,
    "hasValue": true,
    "time": "2021-04-16"
  },
  {
    "open": 1.585,
    "high": 1.6171,
    "low": 1.58,
    "close": 1.6064,
    "priceDate": "2021-04-19T00:00:00-04:00",
    "ticks": 637543872000000000,
    "epochTime": 1618790400,
    "hasValue": true,
    "time": "2021-04-19"
  },
  {
    "open": 1.594,
    "high": 1.612,
    "low": 1.557,
    "close": 1.5589,
    "priceDate": "2021-04-20T00:00:00-04:00",
    "ticks": 637544736000000000,
    "epochTime": 1618876800,
    "hasValue": true,
    "time": "2021-04-20"
  },
  {
    "open": 1.57,
    "high": 1.5855,
    "low": 1.5538,
    "close": 1.5608,
    "priceDate": "2021-04-21T00:00:00-04:00",
    "ticks": 637545600000000000,
    "epochTime": 1618963200,
    "hasValue": true,
    "time": "2021-04-21"
  },
  {
    "open": 1.577,
    "high": 1.5874,
    "low": 1.5398,
    "close": 1.5398,
    "priceDate": "2021-04-22T00:00:00-04:00",
    "ticks": 637546464000000000,
    "epochTime": 1619049600,
    "hasValue": true,
    "time": "2021-04-22"
  },
  {
    "open": 1.549,
    "high": 1.5824,
    "low": 1.531,
    "close": 1.5613,
    "priceDate": "2021-04-23T00:00:00-04:00",
    "ticks": 637547328000000000,
    "epochTime": 1619136000,
    "hasValue": true,
    "time": "2021-04-23"
  },
  {
    "open": 1.591,
    "high": 1.595,
    "low": 1.556,
    "close": 1.5684,
    "priceDate": "2021-04-26T00:00:00-04:00",
    "ticks": 637549920000000000,
    "epochTime": 1619395200,
    "hasValue": true,
    "time": "2021-04-26"
  },
  {
    "open": 1.584,
    "high": 1.631,
    "low": 1.57,
    "close": 1.6234,
    "priceDate": "2021-04-27T00:00:00-04:00",
    "ticks": 637550784000000000,
    "epochTime": 1619481600,
    "hasValue": true,
    "time": "2021-04-27"
  },
  {
    "open": 1.638,
    "high": 1.661,
    "low": 1.6076,
    "close": 1.6111,
    "priceDate": "2021-04-28T00:00:00-04:00",
    "ticks": 637551648000000000,
    "epochTime": 1619568000,
    "hasValue": true,
    "time": "2021-04-28"
  },
  {
    "open": 1.659,
    "high": 1.69,
    "low": 1.6326,
    "close": 1.6379,
    "priceDate": "2021-04-29T00:00:00-04:00",
    "ticks": 637552512000000000,
    "epochTime": 1619654400,
    "hasValue": true,
    "time": "2021-04-29"
  },
  {
    "open": 1.645,
    "high": 1.653,
    "low": 1.6205,
    "close": 1.6276,
    "priceDate": "2021-04-30T00:00:00-04:00",
    "ticks": 637553376000000000,
    "epochTime": 1619740800,
    "hasValue": true,
    "time": "2021-04-30"
  },
  {
    "open": 1.649,
    "high": 1.6545,
    "low": 1.578,
    "close": 1.6011,
    "priceDate": "2021-05-03T00:00:00-04:00",
    "ticks": 637555968000000000,
    "epochTime": 1620000000,
    "hasValue": true,
    "time": "2021-05-03"
  },
  {
    "open": 1.607,
    "high": 1.607,
    "low": 1.557,
    "close": 1.5942,
    "priceDate": "2021-05-04T00:00:00-04:00",
    "ticks": 637556832000000000,
    "epochTime": 1620086400,
    "hasValue": true,
    "time": "2021-05-04"
  },
  {
    "open": 1.612,
    "high": 1.6263,
    "low": 1.5677,
    "close": 1.5695,
    "priceDate": "2021-05-05T00:00:00-04:00",
    "ticks": 637557696000000000,
    "epochTime": 1620172800,
    "hasValue": true,
    "time": "2021-05-05"
  },
  {
    "open": 1.578,
    "high": 1.591,
    "low": 1.557,
    "close": 1.5732,
    "priceDate": "2021-05-06T00:00:00-04:00",
    "ticks": 637558560000000000,
    "epochTime": 1620259200,
    "hasValue": true,
    "time": "2021-05-06"
  },
  {
    "open": 1.57,
    "high": 1.5842,
    "low": 1.4695,
    "close": 1.5842,
    "priceDate": "2021-05-07T00:00:00-04:00",
    "ticks": 637559424000000000,
    "epochTime": 1620345600,
    "hasValue": true,
    "time": "2021-05-07"
  },
  {
    "open": 1.579,
    "high": 1.6091,
    "low": 1.559,
    "close": 1.6038,
    "priceDate": "2021-05-10T00:00:00-04:00",
    "ticks": 637562016000000000,
    "epochTime": 1620604800,
    "hasValue": true,
    "time": "2021-05-10"
  },
  {
    "open": 1.609,
    "high": 1.631,
    "low": 1.6,
    "close": 1.6235,
    "priceDate": "2021-05-11T00:00:00-04:00",
    "ticks": 637562880000000000,
    "epochTime": 1620691200,
    "hasValue": true,
    "time": "2021-05-11"
  },
  {
    "open": 1.617,
    "high": 1.701,
    "low": 1.6147,
    "close": 1.6952,
    "priceDate": "2021-05-12T00:00:00-04:00",
    "ticks": 637563744000000000,
    "epochTime": 1620777600,
    "hasValue": true,
    "time": "2021-05-12"
  },
  {
    "open": 1.686,
    "high": 1.702,
    "low": 1.6505,
    "close": 1.6608,
    "priceDate": "2021-05-13T00:00:00-04:00",
    "ticks": 637564608000000000,
    "epochTime": 1620864000,
    "hasValue": true,
    "time": "2021-05-13"
  },
  {
    "open": 1.639,
    "high": 1.6522,
    "low": 1.625,
    "close": 1.6318,
    "priceDate": "2021-05-14T00:00:00-04:00",
    "ticks": 637565472000000000,
    "epochTime": 1620950400,
    "hasValue": true,
    "time": "2021-05-14"
  },
  {
    "open": 1.635,
    "high": 1.6522,
    "low": 1.628,
    "close": 1.6522,
    "priceDate": "2021-05-17T00:00:00-04:00",
    "ticks": 637568064000000000,
    "epochTime": 1621209600,
    "hasValue": true,
    "time": "2021-05-17"
  },
  {
    "open": 1.64,
    "high": 1.6574,
    "low": 1.628,
    "close": 1.6403,
    "priceDate": "2021-05-18T00:00:00-04:00",
    "ticks": 637568928000000000,
    "epochTime": 1621296000,
    "hasValue": true,
    "time": "2021-05-18"
  },
  {
    "open": 1.656,
    "high": 1.692,
    "low": 1.6199,
    "close": 1.6745,
    "priceDate": "2021-05-19T00:00:00-04:00",
    "ticks": 637569792000000000,
    "epochTime": 1621382400,
    "hasValue": true,
    "time": "2021-05-19"
  },
  {
    "open": 1.662,
    "high": 1.666,
    "low": 1.625,
    "close": 1.6284,
    "priceDate": "2021-05-20T00:00:00-04:00",
    "ticks": 637570656000000000,
    "epochTime": 1621468800,
    "hasValue": true,
    "time": "2021-05-20"
  },
  {
    "open": 1.627,
    "high": 1.639,
    "low": 1.613,
    "close": 1.6199,
    "priceDate": "2021-05-21T00:00:00-04:00",
    "ticks": 637571520000000000,
    "epochTime": 1621555200,
    "hasValue": true,
    "time": "2021-05-21"
  },
  {
    "open": 1.615,
    "high": 1.622,
    "low": 1.596,
    "close": 1.6046,
    "priceDate": "2021-05-24T00:00:00-04:00",
    "ticks": 637574112000000000,
    "epochTime": 1621814400,
    "hasValue": true,
    "time": "2021-05-24"
  },
  {
    "open": 1.591,
    "high": 1.5995,
    "low": 1.5537,
    "close": 1.5587,
    "priceDate": "2021-05-25T00:00:00-04:00",
    "ticks": 637574976000000000,
    "epochTime": 1621900800,
    "hasValue": true,
    "time": "2021-05-25"
  },
  {
    "open": 1.564,
    "high": 1.5825,
    "low": 1.552,
    "close": 1.5825,
    "priceDate": "2021-05-26T00:00:00-04:00",
    "ticks": 637575840000000000,
    "epochTime": 1621987200,
    "hasValue": true,
    "time": "2021-05-26"
  },
  {
    "open": 1.608,
    "high": 1.625,
    "low": 1.601,
    "close": 1.6096,
    "priceDate": "2021-05-27T00:00:00-04:00",
    "ticks": 637576704000000000,
    "epochTime": 1622073600,
    "hasValue": true,
    "time": "2021-05-27"
  },
  {
    "open": 1.613,
    "high": 1.622,
    "low": 1.577,
    "close": 1.5807,
    "priceDate": "2021-05-28T00:00:00-04:00",
    "ticks": 637577568000000000,
    "epochTime": 1622160000,
    "hasValue": true,
    "time": "2021-05-28"
  },
  {
    "open": 1.6301,
    "high": 1.639,
    "low": 1.6045,
    "close": 1.6079,
    "priceDate": "2021-06-01T00:00:00-04:00",
    "ticks": 637581024000000000,
    "epochTime": 1622505600,
    "hasValue": true,
    "time": "2021-06-01"
  },
  {
    "open": 1.605,
    "high": 1.6062,
    "low": 1.587,
    "close": 1.5892,
    "priceDate": "2021-06-02T00:00:00-04:00",
    "ticks": 637581888000000000,
    "epochTime": 1622592000,
    "hasValue": true,
    "time": "2021-06-02"
  },
  {
    "open": 1.594,
    "high": 1.6301,
    "low": 1.5926,
    "close": 1.6284,
    "priceDate": "2021-06-03T00:00:00-04:00",
    "ticks": 637582752000000000,
    "epochTime": 1622678400,
    "hasValue": true,
    "time": "2021-06-03"
  },
  {
    "open": 1.625,
    "high": 1.6352,
    "low": 1.555,
    "close": 1.5568,
    "priceDate": "2021-06-04T00:00:00-04:00",
    "ticks": 637583616000000000,
    "epochTime": 1622764800,
    "hasValue": true,
    "time": "2021-06-04"
  },
  {
    "open": 1.581,
    "high": 1.5823,
    "low": 1.5636,
    "close": 1.5704,
    "priceDate": "2021-06-07T00:00:00-04:00",
    "ticks": 637586208000000000,
    "epochTime": 1623024000,
    "hasValue": true,
    "time": "2021-06-07"
  },
  {
    "open": 1.536,
    "high": 1.5381,
    "low": 1.5127,
    "close": 1.5364,
    "priceDate": "2021-06-08T00:00:00-04:00",
    "ticks": 637587072000000000,
    "epochTime": 1623110400,
    "hasValue": true,
    "time": "2021-06-08"
  },
  {
    "open": 1.503,
    "high": 1.508,
    "low": 1.472,
    "close": 1.4924,
    "priceDate": "2021-06-09T00:00:00-04:00",
    "ticks": 637587936000000000,
    "epochTime": 1623196800,
    "hasValue": true,
    "time": "2021-06-09"
  },
  {
    "open": 1.503,
    "high": 1.535,
    "low": 1.4335,
    "close": 1.4335,
    "priceDate": "2021-06-10T00:00:00-04:00",
    "ticks": 637588800000000000,
    "epochTime": 1623283200,
    "hasValue": true,
    "time": "2021-06-10"
  },
  {
    "open": 1.452,
    "high": 1.472,
    "low": 1.45,
    "close": 1.4535,
    "priceDate": "2021-06-11T00:00:00-04:00",
    "ticks": 637589664000000000,
    "epochTime": 1623369600,
    "hasValue": true,
    "time": "2021-06-11"
  },
  {
    "open": 1.464,
    "high": 1.5024,
    "low": 1.4585,
    "close": 1.4973,
    "priceDate": "2021-06-14T00:00:00-04:00",
    "ticks": 637592256000000000,
    "epochTime": 1623628800,
    "hasValue": true,
    "time": "2021-06-14"
  },
  {
    "open": 1.492,
    "high": 1.513,
    "low": 1.485,
    "close": 1.4922,
    "priceDate": "2021-06-15T00:00:00-04:00",
    "ticks": 637593120000000000,
    "epochTime": 1623715200,
    "hasValue": true,
    "time": "2021-06-15"
  },
  {
    "open": 1.491,
    "high": 1.5941,
    "low": 1.4837,
    "close": 1.5788,
    "priceDate": "2021-06-16T00:00:00-04:00",
    "ticks": 637593984000000000,
    "epochTime": 1623801600,
    "hasValue": true,
    "time": "2021-06-16"
  },
  {
    "open": 1.572,
    "high": 1.5754,
    "low": 1.4719,
    "close": 1.5057,
    "priceDate": "2021-06-17T00:00:00-04:00",
    "ticks": 637594848000000000,
    "epochTime": 1623888000,
    "hasValue": true,
    "time": "2021-06-17"
  },
  {
    "open": 1.485,
    "high": 1.523,
    "low": 1.438,
    "close": 1.4414,
    "priceDate": "2021-06-18T00:00:00-04:00",
    "ticks": 637595712000000000,
    "epochTime": 1623974400,
    "hasValue": true,
    "time": "2021-06-18"
  },
  {
    "open": 1.446,
    "high": 1.4971,
    "low": 1.441,
    "close": 1.492,
    "priceDate": "2021-06-21T00:00:00-04:00",
    "ticks": 637598304000000000,
    "epochTime": 1624233600,
    "hasValue": true,
    "time": "2021-06-21"
  },
  {
    "open": 1.489,
    "high": 1.509,
    "low": 1.4616,
    "close": 1.4666,
    "priceDate": "2021-06-22T00:00:00-04:00",
    "ticks": 637599168000000000,
    "epochTime": 1624320000,
    "hasValue": true,
    "time": "2021-06-22"
  },
  {
    "open": 1.465,
    "high": 1.499,
    "low": 1.463,
    "close": 1.4886,
    "priceDate": "2021-06-23T00:00:00-04:00",
    "ticks": 637600032000000000,
    "epochTime": 1624406400,
    "hasValue": true,
    "time": "2021-06-23"
  },
  {
    "open": 1.487,
    "high": 1.499,
    "low": 1.4767,
    "close": 1.4953,
    "priceDate": "2021-06-24T00:00:00-04:00",
    "ticks": 637600896000000000,
    "epochTime": 1624492800,
    "hasValue": true,
    "time": "2021-06-24"
  },
  {
    "open": 1.488,
    "high": 1.545,
    "low": 1.478,
    "close": 1.5275,
    "priceDate": "2021-06-25T00:00:00-04:00",
    "ticks": 637601760000000000,
    "epochTime": 1624579200,
    "hasValue": true,
    "time": "2021-06-25"
  },
  {
    "open": 1.509,
    "high": 1.5121,
    "low": 1.471,
    "close": 1.4799,
    "priceDate": "2021-06-28T00:00:00-04:00",
    "ticks": 637604352000000000,
    "epochTime": 1624838400,
    "hasValue": true,
    "time": "2021-06-28"
  },
  {
    "open": 1.493,
    "high": 1.5104,
    "low": 1.471,
    "close": 1.4731,
    "priceDate": "2021-06-29T00:00:00-04:00",
    "ticks": 637605216000000000,
    "epochTime": 1624924800,
    "hasValue": true,
    "time": "2021-06-29"
  },
  {
    "open": 1.458,
    "high": 1.4714,
    "low": 1.4376,
    "close": 1.4697,
    "priceDate": "2021-06-30T00:00:00-04:00",
    "ticks": 637606080000000000,
    "epochTime": 1625011200,
    "hasValue": true,
    "time": "2021-06-30"
  },
  {
    "open": 1.475,
    "high": 1.485,
    "low": 1.454,
    "close": 1.4578,
    "priceDate": "2021-07-01T00:00:00-04:00",
    "ticks": 637606944000000000,
    "epochTime": 1625097600,
    "hasValue": true,
    "time": "2021-07-01"
  },
  {
    "open": 1.446,
    "high": 1.468,
    "low": 1.4255,
    "close": 1.431,
    "priceDate": "2021-07-02T00:00:00-04:00",
    "ticks": 637607808000000000,
    "epochTime": 1625184000,
    "hasValue": true,
    "time": "2021-07-02"
  },
  {
    "open": 1.427,
    "high": 1.4271,
    "low": 1.348,
    "close": 1.3498,
    "priceDate": "2021-07-06T00:00:00-04:00",
    "ticks": 637611264000000000,
    "epochTime": 1625529600,
    "hasValue": true,
    "time": "2021-07-06"
  },
  {
    "open": 1.335,
    "high": 1.343,
    "low": 1.296,
    "close": 1.3179,
    "priceDate": "2021-07-07T00:00:00-04:00",
    "ticks": 637612128000000000,
    "epochTime": 1625616000,
    "hasValue": true,
    "time": "2021-07-07"
  },
  {
    "open": 1.286,
    "high": 1.3062,
    "low": 1.2679,
    "close": 1.2962,
    "priceDate": "2021-07-08T00:00:00-04:00",
    "ticks": 637612992000000000,
    "epochTime": 1625702400,
    "hasValue": true,
    "time": "2021-07-08"
  },
  {
    "open": 1.338,
    "high": 1.363,
    "low": 1.331,
    "close": 1.3629,
    "priceDate": "2021-07-09T00:00:00-04:00",
    "ticks": 637613856000000000,
    "epochTime": 1625788800,
    "hasValue": true,
    "time": "2021-07-09"
  },
  {
    "open": 1.346,
    "high": 1.3762,
    "low": 1.3376,
    "close": 1.3678,
    "priceDate": "2021-07-12T00:00:00-04:00",
    "ticks": 637616448000000000,
    "epochTime": 1626048000,
    "hasValue": true,
    "time": "2021-07-12"
  },
  {
    "open": 1.354,
    "high": 1.422,
    "low": 1.3426,
    "close": 1.42,
    "priceDate": "2021-07-13T00:00:00-04:00",
    "ticks": 637617312000000000,
    "epochTime": 1626134400,
    "hasValue": true,
    "time": "2021-07-13"
  },
  {
    "open": 1.385,
    "high": 1.388,
    "low": 1.3475,
    "close": 1.3475,
    "priceDate": "2021-07-14T00:00:00-04:00",
    "ticks": 637618176000000000,
    "epochTime": 1626220800,
    "hasValue": true,
    "time": "2021-07-14"
  },
  {
    "open": 1.326,
    "high": 1.3491,
    "low": 1.292,
    "close": 1.2989,
    "priceDate": "2021-07-15T00:00:00-04:00",
    "ticks": 637619040000000000,
    "epochTime": 1626307200,
    "hasValue": true,
    "time": "2021-07-15"
  },
  {
    "open": 1.317,
    "high": 1.336,
    "low": 1.292,
    "close": 1.2936,
    "priceDate": "2021-07-16T00:00:00-04:00",
    "ticks": 637619904000000000,
    "epochTime": 1626393600,
    "hasValue": true,
    "time": "2021-07-16"
  },
  {
    "open": 1.23,
    "high": 1.2302,
    "low": 1.1739,
    "close": 1.1905,
    "priceDate": "2021-07-19T00:00:00-04:00",
    "ticks": 637622496000000000,
    "epochTime": 1626652800,
    "hasValue": true,
    "time": "2021-07-19"
  },
  {
    "open": 1.182,
    "high": 1.2252,
    "low": 1.1277,
    "close": 1.2252,
    "priceDate": "2021-07-20T00:00:00-04:00",
    "ticks": 637623360000000000,
    "epochTime": 1626739200,
    "hasValue": true,
    "time": "2021-07-20"
  },
  {
    "open": 1.243,
    "high": 1.3034,
    "low": 1.233,
    "close": 1.2917,
    "priceDate": "2021-07-21T00:00:00-04:00",
    "ticks": 637624224000000000,
    "epochTime": 1626825600,
    "hasValue": true,
    "time": "2021-07-21"
  },
  {
    "open": 1.292,
    "high": 1.297,
    "low": 1.233,
    "close": 1.2833,
    "priceDate": "2021-07-22T00:00:00-04:00",
    "ticks": 637625088000000000,
    "epochTime": 1626912000,
    "hasValue": true,
    "time": "2021-07-22"
  },
  {
    "open": 1.301,
    "high": 1.3115,
    "low": 1.278,
    "close": 1.2797,
    "priceDate": "2021-07-23T00:00:00-04:00",
    "ticks": 637625952000000000,
    "epochTime": 1626998400,
    "hasValue": true,
    "time": "2021-07-23"
  },
  {
    "open": 1.251,
    "high": 1.2963,
    "low": 1.2478,
    "close": 1.293,
    "priceDate": "2021-07-26T00:00:00-04:00",
    "ticks": 637628544000000000,
    "epochTime": 1627257600,
    "hasValue": true,
    "time": "2021-07-26"
  },
  {
    "open": 1.256,
    "high": 1.2561,
    "low": 1.229,
    "close": 1.2444,
    "priceDate": "2021-07-27T00:00:00-04:00",
    "ticks": 637629408000000000,
    "epochTime": 1627344000,
    "hasValue": true,
    "time": "2021-07-27"
  },
  {
    "open": 1.261,
    "high": 1.278,
    "low": 1.226,
    "close": 1.236,
    "priceDate": "2021-07-28T00:00:00-04:00",
    "ticks": 637630272000000000,
    "epochTime": 1627430400,
    "hasValue": true,
    "time": "2021-07-28"
  },
  {
    "open": 1.263,
    "high": 1.2843,
    "low": 1.244,
    "close": 1.2726,
    "priceDate": "2021-07-29T00:00:00-04:00",
    "ticks": 637631136000000000,
    "epochTime": 1627516800,
    "hasValue": true,
    "time": "2021-07-29"
  },
  {
    "open": 1.242,
    "high": 1.2523,
    "low": 1.2239,
    "close": 1.2256,
    "priceDate": "2021-07-30T00:00:00-04:00",
    "ticks": 637632000000000000,
    "epochTime": 1627603200,
    "hasValue": true,
    "time": "2021-07-30"
  },
  {
    "open": 1.229,
    "high": 1.2322,
    "low": 1.1508,
    "close": 1.1789,
    "priceDate": "2021-08-02T00:00:00-04:00",
    "ticks": 637634592000000000,
    "epochTime": 1627862400,
    "hasValue": true,
    "time": "2021-08-02"
  },
  {
    "open": 1.184,
    "high": 1.1871,
    "low": 1.154,
    "close": 1.1738,
    "priceDate": "2021-08-03T00:00:00-04:00",
    "ticks": 637635456000000000,
    "epochTime": 1627948800,
    "hasValue": true,
    "time": "2021-08-03"
  },
  {
    "open": 1.134,
    "high": 1.2153,
    "low": 1.127,
    "close": 1.1854,
    "priceDate": "2021-08-04T00:00:00-04:00",
    "ticks": 637636320000000000,
    "epochTime": 1628035200,
    "hasValue": true,
    "time": "2021-08-04"
  },
  {
    "open": 1.177,
    "high": 1.229,
    "low": 1.175,
    "close": 1.2252,
    "priceDate": "2021-08-05T00:00:00-04:00",
    "ticks": 637637184000000000,
    "epochTime": 1628121600,
    "hasValue": true,
    "time": "2021-08-05"
  },
  {
    "open": 1.255,
    "high": 1.3053,
    "low": 1.2466,
    "close": 1.3019,
    "priceDate": "2021-08-06T00:00:00-04:00",
    "ticks": 637638048000000000,
    "epochTime": 1628208000,
    "hasValue": true,
    "time": "2021-08-06"
  },
  {
    "open": 1.28,
    "high": 1.3305,
    "low": 1.268,
    "close": 1.3254,
    "priceDate": "2021-08-09T00:00:00-04:00",
    "ticks": 637640640000000000,
    "epochTime": 1628467200,
    "hasValue": true,
    "time": "2021-08-09"
  },
  {
    "open": 1.3287,
    "high": 1.3574,
    "low": 1.31,
    "close": 1.3524,
    "priceDate": "2021-08-10T00:00:00-04:00",
    "ticks": 637641504000000000,
    "epochTime": 1628553600,
    "hasValue": true,
    "time": "2021-08-10"
  },
  {
    "open": 1.369,
    "high": 1.3743,
    "low": 1.3017,
    "close": 1.3354,
    "priceDate": "2021-08-11T00:00:00-04:00",
    "ticks": 637642368000000000,
    "epochTime": 1628640000,
    "hasValue": true,
    "time": "2021-08-11"
  },
  {
    "open": 1.357,
    "high": 1.3792,
    "low": 1.3506,
    "close": 1.3607,
    "priceDate": "2021-08-12T00:00:00-04:00",
    "ticks": 637643232000000000,
    "epochTime": 1628726400,
    "hasValue": true,
    "time": "2021-08-12"
  },
  {
    "open": 1.351,
    "high": 1.359,
    "low": 1.28,
    "close": 1.2801,
    "priceDate": "2021-08-13T00:00:00-04:00",
    "ticks": 637644096000000000,
    "epochTime": 1628812800,
    "hasValue": true,
    "time": "2021-08-13"
  },
  {
    "open": 1.2734,
    "high": 1.282,
    "low": 1.223,
    "close": 1.2684,
    "priceDate": "2021-08-16T00:00:00-04:00",
    "ticks": 637646688000000000,
    "epochTime": 1629072000,
    "hasValue": true,
    "time": "2021-08-16"
  },
  {
    "open": 1.228,
    "high": 1.2734,
    "low": 1.223,
    "close": 1.265,
    "priceDate": "2021-08-17T00:00:00-04:00",
    "ticks": 637647552000000000,
    "epochTime": 1629158400,
    "hasValue": true,
    "time": "2021-08-17"
  },
  {
    "open": 1.275,
    "high": 1.3002,
    "low": 1.2567,
    "close": 1.26,
    "priceDate": "2021-08-18T00:00:00-04:00",
    "ticks": 637648416000000000,
    "epochTime": 1629244800,
    "hasValue": true,
    "time": "2021-08-18"
  },
  {
    "open": 1.23,
    "high": 1.257,
    "low": 1.23,
    "close": 1.245,
    "priceDate": "2021-08-19T00:00:00-04:00",
    "ticks": 637649280000000000,
    "epochTime": 1629331200,
    "hasValue": true,
    "time": "2021-08-19"
  },
  {
    "open": 1.23,
    "high": 1.267,
    "low": 1.2266,
    "close": 1.257,
    "priceDate": "2021-08-20T00:00:00-04:00",
    "ticks": 637650144000000000,
    "epochTime": 1629417600,
    "hasValue": true,
    "time": "2021-08-20"
  },
  {
    "open": 1.27,
    "high": 1.2734,
    "low": 1.2517,
    "close": 1.255,
    "priceDate": "2021-08-23T00:00:00-04:00",
    "ticks": 637652736000000000,
    "epochTime": 1629676800,
    "hasValue": true,
    "time": "2021-08-23"
  },
  {
    "open": 1.267,
    "high": 1.299,
    "low": 1.26,
    "close": 1.2969,
    "priceDate": "2021-08-24T00:00:00-04:00",
    "ticks": 637653600000000000,
    "epochTime": 1629763200,
    "hasValue": true,
    "time": "2021-08-24"
  },
  {
    "open": 1.304,
    "high": 1.3525,
    "low": 1.2885,
    "close": 1.342,
    "priceDate": "2021-08-25T00:00:00-04:00",
    "ticks": 637654464000000000,
    "epochTime": 1629849600,
    "hasValue": true,
    "time": "2021-08-25"
  },
  {
    "open": 1.3576,
    "high": 1.375,
    "low": 1.339,
    "close": 1.3508,
    "priceDate": "2021-08-26T00:00:00-04:00",
    "ticks": 637655328000000000,
    "epochTime": 1629936000,
    "hasValue": true,
    "time": "2021-08-26"
  },
  {
    "open": 1.346,
    "high": 1.3594,
    "low": 1.3,
    "close": 1.3104,
    "priceDate": "2021-08-27T00:00:00-04:00",
    "ticks": 637656192000000000,
    "epochTime": 1630022400,
    "hasValue": true,
    "time": "2021-08-27"
  },
  {
    "open": 1.314,
    "high": 1.3155,
    "low": 1.278,
    "close": 1.2802,
    "priceDate": "2021-08-30T00:00:00-04:00",
    "ticks": 637658784000000000,
    "epochTime": 1630281600,
    "hasValue": true,
    "time": "2021-08-30"
  },
  {
    "open": 1.294,
    "high": 1.3155,
    "low": 1.27,
    "close": 1.3104,
    "priceDate": "2021-08-31T00:00:00-04:00",
    "ticks": 637659648000000000,
    "epochTime": 1630368000,
    "hasValue": true,
    "time": "2021-08-31"
  },
  {
    "open": 1.321,
    "high": 1.3223,
    "low": 1.2835,
    "close": 1.297,
    "priceDate": "2021-09-01T00:00:00-04:00",
    "ticks": 637660512000000000,
    "epochTime": 1630454400,
    "hasValue": true,
    "time": "2021-09-01"
  },
  {
    "open": 1.287,
    "high": 1.304,
    "low": 1.2835,
    "close": 1.2852,
    "priceDate": "2021-09-02T00:00:00-04:00",
    "ticks": 637661376000000000,
    "epochTime": 1630540800,
    "hasValue": true,
    "time": "2021-09-02"
  },
  {
    "open": 1.299,
    "high": 1.336,
    "low": 1.2668,
    "close": 1.3257,
    "priceDate": "2021-09-03T00:00:00-04:00",
    "ticks": 637662240000000000,
    "epochTime": 1630627200,
    "hasValue": true,
    "time": "2021-09-03"
  },
  {
    "open": 1.366,
    "high": 1.3851,
    "low": 1.3579,
    "close": 1.3749,
    "priceDate": "2021-09-07T00:00:00-04:00",
    "ticks": 637665696000000000,
    "epochTime": 1630972800,
    "hasValue": true,
    "time": "2021-09-07"
  },
  {
    "open": 1.346,
    "high": 1.363,
    "low": 1.327,
    "close": 1.3393,
    "priceDate": "2021-09-08T00:00:00-04:00",
    "ticks": 637666560000000000,
    "epochTime": 1631059200,
    "hasValue": true,
    "time": "2021-09-08"
  },
  {
    "open": 1.341,
    "high": 1.3461,
    "low": 1.287,
    "close": 1.3004,
    "priceDate": "2021-09-09T00:00:00-04:00",
    "ticks": 637667424000000000,
    "epochTime": 1631145600,
    "hasValue": true,
    "time": "2021-09-09"
  },
  {
    "open": 1.322,
    "high": 1.355,
    "low": 1.3157,
    "close": 1.3462,
    "priceDate": "2021-09-10T00:00:00-04:00",
    "ticks": 637668288000000000,
    "epochTime": 1631232000,
    "hasValue": true,
    "time": "2021-09-10"
  },
  {
    "open": 1.329,
    "high": 1.338,
    "low": 1.3157,
    "close": 1.3275,
    "priceDate": "2021-09-13T00:00:00-04:00",
    "ticks": 637670880000000000,
    "epochTime": 1631491200,
    "hasValue": true,
    "time": "2021-09-13"
  },
  {
    "open": 1.343,
    "high": 1.35,
    "low": 1.263,
    "close": 1.2853,
    "priceDate": "2021-09-14T00:00:00-04:00",
    "ticks": 637671744000000000,
    "epochTime": 1631577600,
    "hasValue": true,
    "time": "2021-09-14"
  },
  {
    "open": 1.279,
    "high": 1.321,
    "low": 1.26,
    "close": 1.3039,
    "priceDate": "2021-09-15T00:00:00-04:00",
    "ticks": 637672608000000000,
    "epochTime": 1631664000,
    "hasValue": true,
    "time": "2021-09-15"
  },
  {
    "open": 1.3073,
    "high": 1.3514,
    "low": 1.307,
    "close": 1.3412,
    "priceDate": "2021-09-16T00:00:00-04:00",
    "ticks": 637673472000000000,
    "epochTime": 1631750400,
    "hasValue": true,
    "time": "2021-09-16"
  },
  {
    "open": 1.345,
    "high": 1.3855,
    "low": 1.334,
    "close": 1.365,
    "priceDate": "2021-09-17T00:00:00-04:00",
    "ticks": 637674336000000000,
    "epochTime": 1631836800,
    "hasValue": true,
    "time": "2021-09-17"
  },
  {
    "open": 1.309,
    "high": 1.338,
    "low": 1.297,
    "close": 1.3141,
    "priceDate": "2021-09-20T00:00:00-04:00",
    "ticks": 637676928000000000,
    "epochTime": 1632096000,
    "hasValue": true,
    "time": "2021-09-20"
  },
  {
    "open": 1.326,
    "high": 1.328,
    "low": 1.304,
    "close": 1.3243,
    "priceDate": "2021-09-21T00:00:00-04:00",
    "ticks": 637677792000000000,
    "epochTime": 1632182400,
    "hasValue": true,
    "time": "2021-09-21"
  },
  {
    "open": 1.335,
    "high": 1.34,
    "low": 1.2955,
    "close": 1.304,
    "priceDate": "2021-09-22T00:00:00-04:00",
    "ticks": 637678656000000000,
    "epochTime": 1632268800,
    "hasValue": true,
    "time": "2021-09-22"
  },
  {
    "open": 1.34,
    "high": 1.437,
    "low": 1.3328,
    "close": 1.4336,
    "priceDate": "2021-09-23T00:00:00-04:00",
    "ticks": 637679520000000000,
    "epochTime": 1632355200,
    "hasValue": true,
    "time": "2021-09-23"
  },
  {
    "open": 1.42,
    "high": 1.4664,
    "low": 1.418,
    "close": 1.456,
    "priceDate": "2021-09-24T00:00:00-04:00",
    "ticks": 637680384000000000,
    "epochTime": 1632441600,
    "hasValue": true,
    "time": "2021-09-24"
  },
  {
    "open": 1.485,
    "high": 1.517,
    "low": 1.4699,
    "close": 1.4871,
    "priceDate": "2021-09-27T00:00:00-04:00",
    "ticks": 637682976000000000,
    "epochTime": 1632700800,
    "hasValue": true,
    "time": "2021-09-27"
  },
  {
    "open": 1.534,
    "high": 1.567,
    "low": 1.513,
    "close": 1.539,
    "priceDate": "2021-09-28T00:00:00-04:00",
    "ticks": 637683840000000000,
    "epochTime": 1632787200,
    "hasValue": true,
    "time": "2021-09-28"
  },
  {
    "open": 1.51,
    "high": 1.5531,
    "low": 1.4976,
    "close": 1.5184,
    "priceDate": "2021-09-29T00:00:00-04:00",
    "ticks": 637684704000000000,
    "epochTime": 1632873600,
    "hasValue": true,
    "time": "2021-09-29"
  },
  {
    "open": 1.531,
    "high": 1.557,
    "low": 1.4839,
    "close": 1.4873,
    "priceDate": "2021-09-30T00:00:00-04:00",
    "ticks": 637685568000000000,
    "epochTime": 1632960000,
    "hasValue": true,
    "time": "2021-09-30"
  },
  {
    "open": 1.493,
    "high": 1.505,
    "low": 1.4616,
    "close": 1.465,
    "priceDate": "2021-10-01T00:00:00-04:00",
    "ticks": 637686432000000000,
    "epochTime": 1633046400,
    "hasValue": true,
    "time": "2021-10-01"
  },
  {
    "open": 1.4893,
    "high": 1.5083,
    "low": 1.463,
    "close": 1.4806,
    "priceDate": "2021-10-04T00:00:00-04:00",
    "ticks": 637689024000000000,
    "epochTime": 1633305600,
    "hasValue": true,
    "time": "2021-10-04"
  },
  {
    "open": 1.491,
    "high": 1.54,
    "low": 1.4859,
    "close": 1.531,
    "priceDate": "2021-10-05T00:00:00-04:00",
    "ticks": 637689888000000000,
    "epochTime": 1633392000,
    "hasValue": true,
    "time": "2021-10-05"
  },
  {
    "open": 1.538,
    "high": 1.5554,
    "low": 1.508,
    "close": 1.5206,
    "priceDate": "2021-10-06T00:00:00-04:00",
    "ticks": 637690752000000000,
    "epochTime": 1633478400,
    "hasValue": true,
    "time": "2021-10-06"
  },
  {
    "open": 1.529,
    "high": 1.58,
    "low": 1.5276,
    "close": 1.5729,
    "priceDate": "2021-10-07T00:00:00-04:00",
    "ticks": 637691616000000000,
    "epochTime": 1633564800,
    "hasValue": true,
    "time": "2021-10-07"
  },
  {
    "open": 1.5803,
    "high": 1.619,
    "low": 1.5576,
    "close": 1.6171,
    "priceDate": "2021-10-08T00:00:00-04:00",
    "ticks": 637692480000000000,
    "epochTime": 1633651200,
    "hasValue": true,
    "time": "2021-10-08"
  },
  {
    "open": 1.605,
    "high": 1.6154,
    "low": 1.5646,
    "close": 1.5786,
    "priceDate": "2021-10-12T00:00:00-04:00",
    "ticks": 637695936000000000,
    "epochTime": 1633996800,
    "hasValue": true,
    "time": "2021-10-12"
  },
  {
    "open": 1.563,
    "high": 1.6015,
    "low": 1.526,
    "close": 1.5385,
    "priceDate": "2021-10-13T00:00:00-04:00",
    "ticks": 637696800000000000,
    "epochTime": 1634083200,
    "hasValue": true,
    "time": "2021-10-13"
  },
  {
    "open": 1.528,
    "high": 1.546,
    "low": 1.507,
    "close": 1.516,
    "priceDate": "2021-10-14T00:00:00-04:00",
    "ticks": 637697664000000000,
    "epochTime": 1634169600,
    "hasValue": true,
    "time": "2021-10-14"
  },
  {
    "open": 1.544,
    "high": 1.579,
    "low": 1.5388,
    "close": 1.5738,
    "priceDate": "2021-10-15T00:00:00-04:00",
    "ticks": 637698528000000000,
    "epochTime": 1634256000,
    "hasValue": true,
    "time": "2021-10-15"
  },
  {
    "open": 1.591,
    "high": 1.6274,
    "low": 1.576,
    "close": 1.6054,
    "priceDate": "2021-10-18T00:00:00-04:00",
    "ticks": 637701120000000000,
    "epochTime": 1634515200,
    "hasValue": true,
    "time": "2021-10-18"
  },
  {
    "open": 1.595,
    "high": 1.646,
    "low": 1.5888,
    "close": 1.6372,
    "priceDate": "2021-10-19T00:00:00-04:00",
    "ticks": 637701984000000000,
    "epochTime": 1634601600,
    "hasValue": true,
    "time": "2021-10-19"
  },
  {
    "open": 1.63,
    "high": 1.6611,
    "low": 1.6197,
    "close": 1.6585,
    "priceDate": "2021-10-20T00:00:00-04:00",
    "ticks": 637702848000000000,
    "epochTime": 1634688000,
    "hasValue": true,
    "time": "2021-10-20"
  },
  {
    "open": 1.677,
    "high": 1.7064,
    "low": 1.644,
    "close": 1.7046,
    "priceDate": "2021-10-21T00:00:00-04:00",
    "ticks": 637703712000000000,
    "epochTime": 1634774400,
    "hasValue": true,
    "time": "2021-10-21"
  },
  {
    "open": 1.691,
    "high": 1.6935,
    "low": 1.634,
    "close": 1.6359,
    "priceDate": "2021-10-22T00:00:00-04:00",
    "ticks": 637704576000000000,
    "epochTime": 1634860800,
    "hasValue": true,
    "time": "2021-10-22"
  },
  {
    "open": 1.655,
    "high": 1.6732,
    "low": 1.62,
    "close": 1.6325,
    "priceDate": "2021-10-25T00:00:00-04:00",
    "ticks": 637707168000000000,
    "epochTime": 1635120000,
    "hasValue": true,
    "time": "2021-10-25"
  },
  {
    "open": 1.62,
    "high": 1.654,
    "low": 1.6088,
    "close": 1.6097,
    "priceDate": "2021-10-26T00:00:00-04:00",
    "ticks": 637708032000000000,
    "epochTime": 1635206400,
    "hasValue": true,
    "time": "2021-10-26"
  },
  {
    "open": 1.585,
    "high": 1.6001,
    "low": 1.519,
    "close": 1.5431,
    "priceDate": "2021-10-27T00:00:00-04:00",
    "ticks": 637708896000000000,
    "epochTime": 1635292800,
    "hasValue": true,
    "time": "2021-10-27"
  },
  {
    "open": 1.5466,
    "high": 1.5844,
    "low": 1.53,
    "close": 1.5808,
    "priceDate": "2021-10-28T00:00:00-04:00",
    "ticks": 637709760000000000,
    "epochTime": 1635379200,
    "hasValue": true,
    "time": "2021-10-28"
  },
  {
    "open": 1.6031,
    "high": 1.619,
    "low": 1.536,
    "close": 1.5556,
    "priceDate": "2021-10-29T00:00:00-04:00",
    "ticks": 637710624000000000,
    "epochTime": 1635465600,
    "hasValue": true,
    "time": "2021-10-29"
  },
  {
    "open": 1.589,
    "high": 1.605,
    "low": 1.557,
    "close": 1.5592,
    "priceDate": "2021-11-01T00:00:00-04:00",
    "ticks": 637713216000000000,
    "epochTime": 1635724800,
    "hasValue": true,
    "time": "2021-11-01"
  },
  {
    "open": 1.556,
    "high": 1.57,
    "low": 1.5278,
    "close": 1.554,
    "priceDate": "2021-11-02T00:00:00-04:00",
    "ticks": 637714080000000000,
    "epochTime": 1635811200,
    "hasValue": true,
    "time": "2021-11-02"
  },
  {
    "open": 1.53,
    "high": 1.609,
    "low": 1.526,
    "close": 1.6087,
    "priceDate": "2021-11-03T00:00:00-04:00",
    "ticks": 637714944000000000,
    "epochTime": 1635897600,
    "hasValue": true,
    "time": "2021-11-03"
  },
  {
    "open": 1.572,
    "high": 1.581,
    "low": 1.5087,
    "close": 1.5297,
    "priceDate": "2021-11-04T00:00:00-04:00",
    "ticks": 637715808000000000,
    "epochTime": 1635984000,
    "hasValue": true,
    "time": "2021-11-04"
  },
  {
    "open": 1.525,
    "high": 1.5492,
    "low": 1.4357,
    "close": 1.4548,
    "priceDate": "2021-11-05T00:00:00-04:00",
    "ticks": 637716672000000000,
    "epochTime": 1636070400,
    "hasValue": true,
    "time": "2021-11-05"
  },
  {
    "open": 1.484,
    "high": 1.504,
    "low": 1.46,
    "close": 1.4932,
    "priceDate": "2021-11-08T00:00:00-05:00",
    "ticks": 637719264000000000,
    "epochTime": 1636329600,
    "hasValue": true,
    "time": "2021-11-08"
  },
  {
    "open": 1.464,
    "high": 1.469,
    "low": 1.415,
    "close": 1.4375,
    "priceDate": "2021-11-09T00:00:00-05:00",
    "ticks": 637720128000000000,
    "epochTime": 1636416000,
    "hasValue": true,
    "time": "2021-11-09"
  },
  {
    "open": 1.473,
    "high": 1.5921,
    "low": 1.4626,
    "close": 1.5528,
    "priceDate": "2021-11-10T00:00:00-05:00",
    "ticks": 637720992000000000,
    "epochTime": 1636502400,
    "hasValue": true,
    "time": "2021-11-10"
  },
  {
    "open": 1.563,
    "high": 1.589,
    "low": 1.5408,
    "close": 1.563,
    "priceDate": "2021-11-12T00:00:00-05:00",
    "ticks": 637722720000000000,
    "epochTime": 1636675200,
    "hasValue": true,
    "time": "2021-11-12"
  },
  {
    "open": 1.558,
    "high": 1.632,
    "low": 1.549,
    "close": 1.618,
    "priceDate": "2021-11-15T00:00:00-05:00",
    "ticks": 637725312000000000,
    "epochTime": 1636934400,
    "hasValue": true,
    "time": "2021-11-15"
  },
  {
    "open": 1.608,
    "high": 1.646,
    "low": 1.599,
    "close": 1.637,
    "priceDate": "2021-11-16T00:00:00-05:00",
    "ticks": 637726176000000000,
    "epochTime": 1637020800,
    "hasValue": true,
    "time": "2021-11-16"
  },
  {
    "open": 1.646,
    "high": 1.6491,
    "low": 1.5837,
    "close": 1.5889,
    "priceDate": "2021-11-17T00:00:00-05:00",
    "ticks": 637727040000000000,
    "epochTime": 1637107200,
    "hasValue": true,
    "time": "2021-11-17"
  },
  {
    "open": 1.594,
    "high": 1.613,
    "low": 1.575,
    "close": 1.5872,
    "priceDate": "2021-11-18T00:00:00-05:00",
    "ticks": 637727904000000000,
    "epochTime": 1637193600,
    "hasValue": true,
    "time": "2021-11-18"
  },
  {
    "open": 1.533,
    "high": 1.5565,
    "low": 1.5206,
    "close": 1.5514,
    "priceDate": "2021-11-19T00:00:00-05:00",
    "ticks": 637728768000000000,
    "epochTime": 1637280000,
    "hasValue": true,
    "time": "2021-11-19"
  },
  {
    "open": 1.572,
    "high": 1.634,
    "low": 1.57,
    "close": 1.627,
    "priceDate": "2021-11-22T00:00:00-05:00",
    "ticks": 637731360000000000,
    "epochTime": 1637539200,
    "hasValue": true,
    "time": "2021-11-22"
  },
  {
    "open": 1.6634,
    "high": 1.6842,
    "low": 1.639,
    "close": 1.6686,
    "priceDate": "2021-11-23T00:00:00-05:00",
    "ticks": 637732224000000000,
    "epochTime": 1637625600,
    "hasValue": true,
    "time": "2021-11-23"
  },
  {
    "open": 1.665,
    "high": 1.693,
    "low": 1.6358,
    "close": 1.6376,
    "priceDate": "2021-11-24T00:00:00-05:00",
    "ticks": 637733088000000000,
    "epochTime": 1637712000,
    "hasValue": true,
    "time": "2021-11-24"
  },
  {
    "open": 1.55,
    "high": 1.5551,
    "low": 1.473,
    "close": 1.4816,
    "priceDate": "2021-11-26T00:00:00-05:00",
    "ticks": 637734816000000000,
    "epochTime": 1637884800,
    "hasValue": true,
    "time": "2021-11-26"
  },
  {
    "open": 1.548,
    "high": 1.5654,
    "low": 1.497,
    "close": 1.5021,
    "priceDate": "2021-11-29T00:00:00-05:00",
    "ticks": 637737408000000000,
    "epochTime": 1638144000,
    "hasValue": true,
    "time": "2021-11-29"
  },
  {
    "open": 1.443,
    "high": 1.5004,
    "low": 1.412,
    "close": 1.4494,
    "priceDate": "2021-11-30T00:00:00-05:00",
    "ticks": 637738272000000000,
    "epochTime": 1638230400,
    "hasValue": true,
    "time": "2021-11-30"
  },
  {
    "open": 1.4817,
    "high": 1.4971,
    "low": 1.402,
    "close": 1.4037,
    "priceDate": "2021-12-01T00:00:00-05:00",
    "ticks": 637739136000000000,
    "epochTime": 1638316800,
    "hasValue": true,
    "time": "2021-12-01"
  },
  {
    "open": 1.417,
    "high": 1.4664,
    "low": 1.4087,
    "close": 1.446,
    "priceDate": "2021-12-02T00:00:00-05:00",
    "ticks": 637740000000000000,
    "epochTime": 1638403200,
    "hasValue": true,
    "time": "2021-12-02"
  },
  {
    "open": 1.431,
    "high": 1.472,
    "low": 1.3346,
    "close": 1.3447,
    "priceDate": "2021-12-03T00:00:00-05:00",
    "ticks": 637740864000000000,
    "epochTime": 1638489600,
    "hasValue": true,
    "time": "2021-12-03"
  },
  {
    "open": 1.392,
    "high": 1.443,
    "low": 1.3699,
    "close": 1.4393,
    "priceDate": "2021-12-06T00:00:00-05:00",
    "ticks": 637743456000000000,
    "epochTime": 1638748800,
    "hasValue": true,
    "time": "2021-12-06"
  },
  {
    "open": 1.448,
    "high": 1.487,
    "low": 1.4376,
    "close": 1.4751,
    "priceDate": "2021-12-07T00:00:00-05:00",
    "ticks": 637744320000000000,
    "epochTime": 1638835200,
    "hasValue": true,
    "time": "2021-12-07"
  },
  {
    "open": 1.487,
    "high": 1.537,
    "low": 1.4819,
    "close": 1.5247,
    "priceDate": "2021-12-08T00:00:00-05:00",
    "ticks": 637745184000000000,
    "epochTime": 1638921600,
    "hasValue": true,
    "time": "2021-12-08"
  },
  {
    "open": 1.487,
    "high": 1.5093,
    "low": 1.4717,
    "close": 1.5024,
    "priceDate": "2021-12-09T00:00:00-05:00",
    "ticks": 637746048000000000,
    "epochTime": 1639008000,
    "hasValue": true,
    "time": "2021-12-09"
  },
  {
    "open": 1.513,
    "high": 1.52,
    "low": 1.451,
    "close": 1.4906,
    "priceDate": "2021-12-10T00:00:00-05:00",
    "ticks": 637746912000000000,
    "epochTime": 1639094400,
    "hasValue": true,
    "time": "2021-12-10"
  },
  {
    "open": 1.4667,
    "high": 1.472,
    "low": 1.412,
    "close": 1.419,
    "priceDate": "2021-12-13T00:00:00-05:00",
    "ticks": 637749504000000000,
    "epochTime": 1639353600,
    "hasValue": true,
    "time": "2021-12-13"
  },
  {
    "open": 1.439,
    "high": 1.472,
    "low": 1.4207,
    "close": 1.4445,
    "priceDate": "2021-12-14T00:00:00-05:00",
    "ticks": 637750368000000000,
    "epochTime": 1639440000,
    "hasValue": true,
    "time": "2021-12-14"
  },
  {
    "open": 1.45,
    "high": 1.4838,
    "low": 1.436,
    "close": 1.4616,
    "priceDate": "2021-12-15T00:00:00-05:00",
    "ticks": 637751232000000000,
    "epochTime": 1639526400,
    "hasValue": true,
    "time": "2021-12-15"
  },
  {
    "open": 1.4719,
    "high": 1.479,
    "low": 1.412,
    "close": 1.4122,
    "priceDate": "2021-12-16T00:00:00-05:00",
    "ticks": 637752096000000000,
    "epochTime": 1639612800,
    "hasValue": true,
    "time": "2021-12-16"
  },
  {
    "open": 1.39,
    "high": 1.416,
    "low": 1.3716,
    "close": 1.4038,
    "priceDate": "2021-12-17T00:00:00-05:00",
    "ticks": 637752960000000000,
    "epochTime": 1639699200,
    "hasValue": true,
    "time": "2021-12-17"
  },
  {
    "open": 1.382,
    "high": 1.4293,
    "low": 1.375,
    "close": 1.4259,
    "priceDate": "2021-12-20T00:00:00-05:00",
    "ticks": 637755552000000000,
    "epochTime": 1639958400,
    "hasValue": true,
    "time": "2021-12-20"
  },
  {
    "open": 1.453,
    "high": 1.498,
    "low": 1.448,
    "close": 1.4651,
    "priceDate": "2021-12-21T00:00:00-05:00",
    "ticks": 637756416000000000,
    "epochTime": 1640044800,
    "hasValue": true,
    "time": "2021-12-21"
  },
  {
    "open": 1.477,
    "high": 1.481,
    "low": 1.448,
    "close": 1.4549,
    "priceDate": "2021-12-22T00:00:00-05:00",
    "ticks": 637757280000000000,
    "epochTime": 1640131200,
    "hasValue": true,
    "time": "2021-12-22"
  },
  {
    "open": 1.477,
    "high": 1.5012,
    "low": 1.458,
    "close": 1.4926,
    "priceDate": "2021-12-23T00:00:00-05:00",
    "ticks": 637758144000000000,
    "epochTime": 1640217600,
    "hasValue": true,
    "time": "2021-12-23"
  },
  {
    "open": 1.491,
    "high": 1.4944,
    "low": 1.4756,
    "close": 1.479,
    "priceDate": "2021-12-27T00:00:00-05:00",
    "ticks": 637761600000000000,
    "epochTime": 1640563200,
    "hasValue": true,
    "time": "2021-12-27"
  },
  {
    "open": 1.484,
    "high": 1.4893,
    "low": 1.455,
    "close": 1.4842,
    "priceDate": "2021-12-28T00:00:00-05:00",
    "ticks": 637762464000000000,
    "epochTime": 1640649600,
    "hasValue": true,
    "time": "2021-12-28"
  },
  {
    "open": 1.5,
    "high": 1.56,
    "low": 1.4979,
    "close": 1.5531,
    "priceDate": "2021-12-29T00:00:00-05:00",
    "ticks": 637763328000000000,
    "epochTime": 1640736000,
    "hasValue": true,
    "time": "2021-12-29"
  },
  {
    "open": 1.525,
    "high": 1.55,
    "low": 1.501,
    "close": 1.5117,
    "priceDate": "2021-12-30T00:00:00-05:00",
    "ticks": 637764192000000000,
    "epochTime": 1640822400,
    "hasValue": true,
    "time": "2021-12-30"
  },
  {
    "open": 1.507,
    "high": 1.524,
    "low": 1.491,
    "close": 1.5118,
    "priceDate": "2021-12-31T00:00:00-05:00",
    "ticks": 637765056000000000,
    "epochTime": 1640908800,
    "hasValue": true,
    "time": "2021-12-31"
  },
  {
    "open": 1.536,
    "high": 1.642,
    "low": 1.5308,
    "close": 1.6315,
    "priceDate": "2022-01-03T00:00:00-05:00",
    "ticks": 637767648000000000,
    "epochTime": 1641168000,
    "hasValue": true,
    "time": "2022-01-03"
  },
  {
    "open": 1.666,
    "high": 1.686,
    "low": 1.6438,
    "close": 1.6507,
    "priceDate": "2022-01-04T00:00:00-05:00",
    "ticks": 637768512000000000,
    "epochTime": 1641254400,
    "hasValue": true,
    "time": "2022-01-04"
  },
  {
    "open": 1.651,
    "high": 1.7122,
    "low": 1.647,
    "close": 1.7087,
    "priceDate": "2022-01-05T00:00:00-05:00",
    "ticks": 637769376000000000,
    "epochTime": 1641340800,
    "hasValue": true,
    "time": "2022-01-05"
  },
  {
    "open": 1.735,
    "high": 1.744,
    "low": 1.721,
    "close": 1.7264,
    "priceDate": "2022-01-06T00:00:00-05:00",
    "ticks": 637770240000000000,
    "epochTime": 1641427200,
    "hasValue": true,
    "time": "2022-01-06"
  },
  {
    "open": 1.735,
    "high": 1.801,
    "low": 1.7266,
    "close": 1.766,
    "priceDate": "2022-01-07T00:00:00-05:00",
    "ticks": 637771104000000000,
    "epochTime": 1641513600,
    "hasValue": true,
    "time": "2022-01-07"
  },
  {
    "open": 1.771,
    "high": 1.8082,
    "low": 1.7497,
    "close": 1.7621,
    "priceDate": "2022-01-10T00:00:00-05:00",
    "ticks": 637773696000000000,
    "epochTime": 1641772800,
    "hasValue": true,
    "time": "2022-01-10"
  },
  {
    "open": 1.76,
    "high": 1.7852,
    "low": 1.7339,
    "close": 1.734,
    "priceDate": "2022-01-11T00:00:00-05:00",
    "ticks": 637774560000000000,
    "epochTime": 1641859200,
    "hasValue": true,
    "time": "2022-01-11"
  },
  {
    "open": 1.741,
    "high": 1.7534,
    "low": 1.711,
    "close": 1.7463,
    "priceDate": "2022-01-12T00:00:00-05:00",
    "ticks": 637775424000000000,
    "epochTime": 1641945600,
    "hasValue": true,
    "time": "2022-01-12"
  },
  {
    "open": 1.739,
    "high": 1.7464,
    "low": 1.6935,
    "close": 1.7059,
    "priceDate": "2022-01-13T00:00:00-05:00",
    "ticks": 637776288000000000,
    "epochTime": 1642032000,
    "hasValue": true,
    "time": "2022-01-13"
  },
  {
    "open": 1.731,
    "high": 1.795,
    "low": 1.706,
    "close": 1.7876,
    "priceDate": "2022-01-14T00:00:00-05:00",
    "ticks": 637777152000000000,
    "epochTime": 1642118400,
    "hasValue": true,
    "time": "2022-01-14"
  },
  {
    "open": 1.816,
    "high": 1.881,
    "low": 1.8127,
    "close": 1.8771,
    "priceDate": "2022-01-18T00:00:00-05:00",
    "ticks": 637780608000000000,
    "epochTime": 1642464000,
    "hasValue": true,
    "time": "2022-01-18"
  },
  {
    "open": 1.868,
    "high": 1.874,
    "low": 1.8217,
    "close": 1.8646,
    "priceDate": "2022-01-19T00:00:00-05:00",
    "ticks": 637781472000000000,
    "epochTime": 1642550400,
    "hasValue": true,
    "time": "2022-01-19"
  },
  {
    "open": 1.829,
    "high": 1.8451,
    "low": 1.804,
    "close": 1.806,
    "priceDate": "2022-01-20T00:00:00-05:00",
    "ticks": 637782336000000000,
    "epochTime": 1642636800,
    "hasValue": true,
    "time": "2022-01-20"
  },
  {
    "open": 1.776,
    "high": 1.785,
    "low": 1.733,
    "close": 1.7616,
    "priceDate": "2022-01-21T00:00:00-05:00",
    "ticks": 637783200000000000,
    "epochTime": 1642723200,
    "hasValue": true,
    "time": "2022-01-21"
  },
  {
    "open": 1.74,
    "high": 1.778,
    "low": 1.7068,
    "close": 1.7742,
    "priceDate": "2022-01-24T00:00:00-05:00",
    "ticks": 637785792000000000,
    "epochTime": 1642982400,
    "hasValue": true,
    "time": "2022-01-24"
  },
  {
    "open": 1.767,
    "high": 1.787,
    "low": 1.728,
    "close": 1.7725,
    "priceDate": "2022-01-25T00:00:00-05:00",
    "ticks": 637786656000000000,
    "epochTime": 1643068800,
    "hasValue": true,
    "time": "2022-01-25"
  },
  {
    "open": 1.789,
    "high": 1.88,
    "low": 1.769,
    "close": 1.8691,
    "priceDate": "2022-01-26T00:00:00-05:00",
    "ticks": 637787520000000000,
    "epochTime": 1643155200,
    "hasValue": true,
    "time": "2022-01-26"
  },
  {
    "open": 1.844,
    "high": 1.8441,
    "low": 1.7816,
    "close": 1.8048,
    "priceDate": "2022-01-27T00:00:00-05:00",
    "ticks": 637788384000000000,
    "epochTime": 1643241600,
    "hasValue": true,
    "time": "2022-01-27"
  },
  {
    "open": 1.841,
    "high": 1.8481,
    "low": 1.771,
    "close": 1.7712,
    "priceDate": "2022-01-28T00:00:00-05:00",
    "ticks": 637789248000000000,
    "epochTime": 1643328000,
    "hasValue": true,
    "time": "2022-01-28"
  },
  {
    "open": 1.805,
    "high": 1.816,
    "low": 1.773,
    "close": 1.7802,
    "priceDate": "2022-01-31T00:00:00-05:00",
    "ticks": 637791840000000000,
    "epochTime": 1643587200,
    "hasValue": true,
    "time": "2022-01-31"
  },
  {
    "open": 1.7483,
    "high": 1.82,
    "low": 1.748,
    "close": 1.7928,
    "priceDate": "2022-02-01T00:00:00-05:00",
    "ticks": 637792704000000000,
    "epochTime": 1643673600,
    "hasValue": true,
    "time": "2022-02-01"
  },
  {
    "open": 1.779,
    "high": 1.811,
    "low": 1.743,
    "close": 1.7805,
    "priceDate": "2022-02-02T00:00:00-05:00",
    "ticks": 637793568000000000,
    "epochTime": 1643760000,
    "hasValue": true,
    "time": "2022-02-02"
  },
  {
    "open": 1.798,
    "high": 1.847,
    "low": 1.789,
    "close": 1.8324,
    "priceDate": "2022-02-03T00:00:00-05:00",
    "ticks": 637794432000000000,
    "epochTime": 1643846400,
    "hasValue": true,
    "time": "2022-02-03"
  },
  {
    "open": 1.818,
    "high": 1.936,
    "low": 1.809,
    "close": 1.9121,
    "priceDate": "2022-02-04T00:00:00-05:00",
    "ticks": 637795296000000000,
    "epochTime": 1643932800,
    "hasValue": true,
    "time": "2022-02-04"
  },
  {
    "open": 1.918,
    "high": 1.9394,
    "low": 1.91,
    "close": 1.9159,
    "priceDate": "2022-02-07T00:00:00-05:00",
    "ticks": 637797888000000000,
    "epochTime": 1644192000,
    "hasValue": true,
    "time": "2022-02-07"
  },
  {
    "open": 1.947,
    "high": 1.9705,
    "low": 1.941,
    "close": 1.965,
    "priceDate": "2022-02-08T00:00:00-05:00",
    "ticks": 637798752000000000,
    "epochTime": 1644278400,
    "hasValue": true,
    "time": "2022-02-08"
  },
  {
    "open": 1.931,
    "high": 1.9524,
    "low": 1.9089,
    "close": 1.9452,
    "priceDate": "2022-02-09T00:00:00-05:00",
    "ticks": 637799616000000000,
    "epochTime": 1644364800,
    "hasValue": true,
    "time": "2022-02-09"
  },
  {
    "open": 1.925,
    "high": 2.056,
    "low": 1.923,
    "close": 2.0346,
    "priceDate": "2022-02-10T00:00:00-05:00",
    "ticks": 637800480000000000,
    "epochTime": 1644451200,
    "hasValue": true,
    "time": "2022-02-10"
  },
  {
    "open": 2.012,
    "high": 2.063,
    "low": 1.9129,
    "close": 1.9423,
    "priceDate": "2022-02-11T00:00:00-05:00",
    "ticks": 637801344000000000,
    "epochTime": 1644537600,
    "hasValue": true,
    "time": "2022-02-11"
  },
  {
    "open": 1.9597,
    "high": 2.026,
    "low": 1.9527,
    "close": 1.991,
    "priceDate": "2022-02-14T00:00:00-05:00",
    "ticks": 637803936000000000,
    "epochTime": 1644796800,
    "hasValue": true,
    "time": "2022-02-14"
  },
  {
    "open": 2.029,
    "high": 2.056,
    "low": 2.024,
    "close": 2.0469,
    "priceDate": "2022-02-15T00:00:00-05:00",
    "ticks": 637804800000000000,
    "epochTime": 1644883200,
    "hasValue": true,
    "time": "2022-02-15"
  },
  {
    "open": 2.035,
    "high": 2.0645,
    "low": 2.0067,
    "close": 2.0399,
    "priceDate": "2022-02-16T00:00:00-05:00",
    "ticks": 637805664000000000,
    "epochTime": 1644969600,
    "hasValue": true,
    "time": "2022-02-16"
  },
  {
    "open": 2.003,
    "high": 2.014,
    "low": 1.9528,
    "close": 1.965,
    "priceDate": "2022-02-17T00:00:00-05:00",
    "ticks": 637806528000000000,
    "epochTime": 1645056000,
    "hasValue": true,
    "time": "2022-02-17"
  },
  {
    "open": 1.963,
    "high": 1.9633,
    "low": 1.916,
    "close": 1.9303,
    "priceDate": "2022-02-18T00:00:00-05:00",
    "ticks": 637807392000000000,
    "epochTime": 1645142400,
    "hasValue": true,
    "time": "2022-02-18"
  },
  {
    "open": 1.951,
    "high": 1.96,
    "low": 1.918,
    "close": 1.9425,
    "priceDate": "2022-02-22T00:00:00-05:00",
    "ticks": 637810848000000000,
    "epochTime": 1645488000,
    "hasValue": true,
    "time": "2022-02-22"
  },
  {
    "open": 1.976,
    "high": 2,
    "low": 1.9546,
    "close": 1.993,
    "priceDate": "2022-02-23T00:00:00-05:00",
    "ticks": 637811712000000000,
    "epochTime": 1645574400,
    "hasValue": true,
    "time": "2022-02-23"
  },
  {
    "open": 1.873,
    "high": 1.981,
    "low": 1.856,
    "close": 1.9686,
    "priceDate": "2022-02-24T00:00:00-05:00",
    "ticks": 637812576000000000,
    "epochTime": 1645660800,
    "hasValue": true,
    "time": "2022-02-24"
  },
  {
    "open": 2.005,
    "high": 2.0123,
    "low": 1.9617,
    "close": 1.9686,
    "priceDate": "2022-02-25T00:00:00-05:00",
    "ticks": 637813440000000000,
    "epochTime": 1645747200,
    "hasValue": true,
    "time": "2022-02-25"
  },
  {
    "open": 1.915,
    "high": 1.92,
    "low": 1.816,
    "close": 1.8267,
    "priceDate": "2022-02-28T00:00:00-05:00",
    "ticks": 637816032000000000,
    "epochTime": 1646006400,
    "hasValue": true,
    "time": "2022-02-28"
  },
  {
    "open": 1.748,
    "high": 1.7941,
    "low": 1.6817,
    "close": 1.7343,
    "priceDate": "2022-03-01T00:00:00-05:00",
    "ticks": 637816896000000000,
    "epochTime": 1646092800,
    "hasValue": true,
    "time": "2022-03-01"
  },
  {
    "open": 1.765,
    "high": 1.91,
    "low": 1.758,
    "close": 1.8784,
    "priceDate": "2022-03-02T00:00:00-05:00",
    "ticks": 637817760000000000,
    "epochTime": 1646179200,
    "hasValue": true,
    "time": "2022-03-02"
  },
  {
    "open": 1.858,
    "high": 1.8974,
    "low": 1.83,
    "close": 1.8422,
    "priceDate": "2022-03-03T00:00:00-05:00",
    "ticks": 637818624000000000,
    "epochTime": 1646265600,
    "hasValue": true,
    "time": "2022-03-03"
  },
  {
    "open": 1.789,
    "high": 1.8163,
    "low": 1.698,
    "close": 1.7307,
    "priceDate": "2022-03-04T00:00:00-05:00",
    "ticks": 637819488000000000,
    "epochTime": 1646352000,
    "hasValue": true,
    "time": "2022-03-04"
  },
  {
    "open": 1.77,
    "high": 1.806,
    "low": 1.7188,
    "close": 1.7803,
    "priceDate": "2022-03-07T00:00:00-05:00",
    "ticks": 637822080000000000,
    "epochTime": 1646611200,
    "hasValue": true,
    "time": "2022-03-07"
  },
  {
    "open": 1.8525,
    "high": 1.8784,
    "low": 1.8352,
    "close": 1.849,
    "priceDate": "2022-03-08T00:00:00-05:00",
    "ticks": 637822944000000000,
    "epochTime": 1646697600,
    "hasValue": true,
    "time": "2022-03-08"
  },
  {
    "open": 1.9131,
    "high": 1.9566,
    "low": 1.8923,
    "close": 1.9566,
    "priceDate": "2022-03-09T00:00:00-05:00",
    "ticks": 637823808000000000,
    "epochTime": 1646784000,
    "hasValue": true,
    "time": "2022-03-09"
  },
  {
    "open": 1.9724,
    "high": 2.0214,
    "low": 1.9462,
    "close": 1.9916,
    "priceDate": "2022-03-10T00:00:00-05:00",
    "ticks": 637824672000000000,
    "epochTime": 1646870400,
    "hasValue": true,
    "time": "2022-03-10"
  },
  {
    "open": 2.0057,
    "high": 2.0198,
    "low": 1.9759,
    "close": 1.997,
    "priceDate": "2022-03-11T00:00:00-05:00",
    "ticks": 637825536000000000,
    "epochTime": 1646956800,
    "hasValue": true,
    "time": "2022-03-11"
  },
  {
    "open": 2.0709,
    "high": 2.1472,
    "low": 2.0692,
    "close": 2.1383,
    "priceDate": "2022-03-14T00:00:00-04:00",
    "ticks": 637828128000000000,
    "epochTime": 1647216000,
    "hasValue": true,
    "time": "2022-03-14"
  },
  {
    "open": 2.1188,
    "high": 2.1633,
    "low": 2.0781,
    "close": 2.1491,
    "priceDate": "2022-03-15T00:00:00-04:00",
    "ticks": 637828992000000000,
    "epochTime": 1647302400,
    "hasValue": true,
    "time": "2022-03-15"
  },
  {
    "open": 2.1634,
    "high": 2.2458,
    "low": 2.1491,
    "close": 2.1902,
    "priceDate": "2022-03-16T00:00:00-04:00",
    "ticks": 637829856000000000,
    "epochTime": 1647388800,
    "hasValue": true,
    "time": "2022-03-16"
  },
  {
    "open": 2.1367,
    "high": 2.2136,
    "low": 2.1332,
    "close": 2.1742,
    "priceDate": "2022-03-17T00:00:00-04:00",
    "ticks": 637830720000000000,
    "epochTime": 1647475200,
    "hasValue": true,
    "time": "2022-03-17"
  },
  {
    "open": 2.1441,
    "high": 2.1798,
    "low": 2.1369,
    "close": 2.153,
    "priceDate": "2022-03-18T00:00:00-04:00",
    "ticks": 637831584000000000,
    "epochTime": 1647561600,
    "hasValue": true,
    "time": "2022-03-18"
  },
  {
    "open": 2.2014,
    "high": 2.3205,
    "low": 2.1996,
    "close": 2.2915,
    "priceDate": "2022-03-21T00:00:00-04:00",
    "ticks": 637834176000000000,
    "epochTime": 1647820800,
    "hasValue": true,
    "time": "2022-03-21"
  },
  {
    "open": 2.3497,
    "high": 2.3916,
    "low": 2.3333,
    "close": 2.3861,
    "priceDate": "2022-03-22T00:00:00-04:00",
    "ticks": 637835040000000000,
    "epochTime": 1647907200,
    "hasValue": true,
    "time": "2022-03-22"
  },
  {
    "open": 2.3771,
    "high": 2.3954,
    "low": 2.2862,
    "close": 2.2953,
    "priceDate": "2022-03-23T00:00:00-04:00",
    "ticks": 637835904000000000,
    "epochTime": 1647993600,
    "hasValue": true,
    "time": "2022-03-23"
  },
  {
    "open": 2.3736,
    "high": 2.3864,
    "low": 2.3262,
    "close": 2.3736,
    "priceDate": "2022-03-24T00:00:00-04:00",
    "ticks": 637836768000000000,
    "epochTime": 1648080000,
    "hasValue": true,
    "time": "2022-03-24"
  },
  {
    "open": 2.3648,
    "high": 2.5027,
    "low": 2.3539,
    "close": 2.4824,
    "priceDate": "2022-03-25T00:00:00-04:00",
    "ticks": 637837632000000000,
    "epochTime": 1648166400,
    "hasValue": true,
    "time": "2022-03-25"
  },
  {
    "open": 2.4622,
    "high": 2.4807,
    "low": 2.4144,
    "close": 2.4622,
    "priceDate": "2022-03-28T00:00:00-04:00",
    "ticks": 637840224000000000,
    "epochTime": 1648425600,
    "hasValue": true,
    "time": "2022-03-28"
  },
  {
    "open": 2.503,
    "high": 2.5067,
    "low": 2.3797,
    "close": 2.398,
    "priceDate": "2022-03-29T00:00:00-04:00",
    "ticks": 637841088000000000,
    "epochTime": 1648512000,
    "hasValue": true,
    "time": "2022-03-29"
  },
  {
    "open": 2.4055,
    "high": 2.4349,
    "low": 2.3397,
    "close": 2.3524,
    "priceDate": "2022-03-30T00:00:00-04:00",
    "ticks": 637841952000000000,
    "epochTime": 1648598400,
    "hasValue": true,
    "time": "2022-03-30"
  },
  {
    "open": 2.3161,
    "high": 2.3507,
    "low": 2.3106,
    "close": 2.3434,
    "priceDate": "2022-03-31T00:00:00-04:00",
    "ticks": 637842816000000000,
    "epochTime": 1648684800,
    "hasValue": true,
    "time": "2022-03-31"
  },
  {
    "open": 2.4005,
    "high": 2.4557,
    "low": 2.3566,
    "close": 2.384,
    "priceDate": "2022-04-01T00:00:00-04:00",
    "ticks": 637843680000000000,
    "epochTime": 1648771200,
    "hasValue": true,
    "time": "2022-04-01"
  },
  {
    "open": 2.3915,
    "high": 2.4337,
    "low": 2.3695,
    "close": 2.4006,
    "priceDate": "2022-04-04T00:00:00-04:00",
    "ticks": 637846272000000000,
    "epochTime": 1649030400,
    "hasValue": true,
    "time": "2022-04-04"
  },
  {
    "open": 2.4726,
    "high": 2.5674,
    "low": 2.4468,
    "close": 2.5525,
    "priceDate": "2022-04-05T00:00:00-04:00",
    "ticks": 637847136000000000,
    "epochTime": 1649116800,
    "hasValue": true,
    "time": "2022-04-05"
  },
  {
    "open": 2.6369,
    "high": 2.6426,
    "low": 2.5657,
    "close": 2.6012,
    "priceDate": "2022-04-06T00:00:00-04:00",
    "ticks": 637848000000000000,
    "epochTime": 1649203200,
    "hasValue": true,
    "time": "2022-04-06"
  },
  {
    "open": 2.6258,
    "high": 2.6729,
    "low": 2.6089,
    "close": 2.6616,
    "priceDate": "2022-04-07T00:00:00-04:00",
    "ticks": 637848864000000000,
    "epochTime": 1649289600,
    "hasValue": true,
    "time": "2022-04-07"
  },
  {
    "open": 2.6754,
    "high": 2.7303,
    "low": 2.6678,
    "close": 2.7,
    "priceDate": "2022-04-08T00:00:00-04:00",
    "ticks": 637849728000000000,
    "epochTime": 1649376000,
    "hasValue": true,
    "time": "2022-04-08"
  },
  {
    "open": 2.7496,
    "high": 2.7935,
    "low": 2.7325,
    "close": 2.7839,
    "priceDate": "2022-04-11T00:00:00-04:00",
    "ticks": 637852320000000000,
    "epochTime": 1649635200,
    "hasValue": true,
    "time": "2022-04-11"
  },
  {
    "open": 2.7555,
    "high": 2.7727,
    "low": 2.6739,
    "close": 2.7251,
    "priceDate": "2022-04-12T00:00:00-04:00",
    "ticks": 637853184000000000,
    "epochTime": 1649721600,
    "hasValue": true,
    "time": "2022-04-12"
  },
  {
    "open": 2.7424,
    "high": 2.7614,
    "low": 2.6458,
    "close": 2.7063,
    "priceDate": "2022-04-13T00:00:00-04:00",
    "ticks": 637854048000000000,
    "epochTime": 1649808000,
    "hasValue": true,
    "time": "2022-04-13"
  },
  {
    "open": 2.6693,
    "high": 2.8351,
    "low": 2.6617,
    "close": 2.8275,
    "priceDate": "2022-04-14T00:00:00-04:00",
    "ticks": 637854912000000000,
    "epochTime": 1649894400,
    "hasValue": true,
    "time": "2022-04-14"
  },
  {
    "open": 2.8623,
    "high": 2.8701,
    "low": 2.8104,
    "close": 2.8566,
    "priceDate": "2022-04-18T00:00:00-04:00",
    "ticks": 637858368000000000,
    "epochTime": 1650240000,
    "hasValue": true,
    "time": "2022-04-18"
  },
  {
    "open": 2.88,
    "high": 2.9478,
    "low": 2.878,
    "close": 2.94,
    "priceDate": "2022-04-19T00:00:00-04:00",
    "ticks": 637859232000000000,
    "epochTime": 1650326400,
    "hasValue": true,
    "time": "2022-04-19"
  },
  {
    "open": 2.8648,
    "high": 2.9034,
    "low": 2.8186,
    "close": 2.834,
    "priceDate": "2022-04-20T00:00:00-04:00",
    "ticks": 637860096000000000,
    "epochTime": 1650412800,
    "hasValue": true,
    "time": "2022-04-20"
  },
  {
    "open": 2.8573,
    "high": 2.9542,
    "low": 2.8438,
    "close": 2.9134,
    "priceDate": "2022-04-21T00:00:00-04:00",
    "ticks": 637860960000000000,
    "epochTime": 1650499200,
    "hasValue": true,
    "time": "2022-04-21"
  },
  {
    "open": 2.922,
    "high": 2.9375,
    "low": 2.8638,
    "close": 2.9064,
    "priceDate": "2022-04-22T00:00:00-04:00",
    "ticks": 637861824000000000,
    "epochTime": 1650585600,
    "hasValue": true,
    "time": "2022-04-22"
  },
  {
    "open": 2.8179,
    "high": 2.8429,
    "low": 2.7603,
    "close": 2.8217,
    "priceDate": "2022-04-25T00:00:00-04:00",
    "ticks": 637864416000000000,
    "epochTime": 1650844800,
    "hasValue": true,
    "time": "2022-04-25"
  },
  {
    "open": 2.774,
    "high": 2.7874,
    "low": 2.7243,
    "close": 2.7243,
    "priceDate": "2022-04-26T00:00:00-04:00",
    "ticks": 637865280000000000,
    "epochTime": 1650931200,
    "hasValue": true,
    "time": "2022-04-26"
  },
  {
    "open": 2.7551,
    "high": 2.8395,
    "low": 2.7302,
    "close": 2.8337,
    "priceDate": "2022-04-27T00:00:00-04:00",
    "ticks": 637866144000000000,
    "epochTime": 1651017600,
    "hasValue": true,
    "time": "2022-04-27"
  },
  {
    "open": 2.8494,
    "high": 2.8881,
    "low": 2.8224,
    "close": 2.8224,
    "priceDate": "2022-04-28T00:00:00-04:00",
    "ticks": 637867008000000000,
    "epochTime": 1651104000,
    "hasValue": true,
    "time": "2022-04-28"
  },
  {
    "open": 2.856,
    "high": 2.9433,
    "low": 2.8463,
    "close": 2.9375,
    "priceDate": "2022-04-29T00:00:00-04:00",
    "ticks": 637867872000000000,
    "epochTime": 1651190400,
    "hasValue": true,
    "time": "2022-04-29"
  },
  {
    "open": 2.9144,
    "high": 3.0101,
    "low": 2.9066,
    "close": 2.9885,
    "priceDate": "2022-05-02T00:00:00-04:00",
    "ticks": 637870464000000000,
    "epochTime": 1651449600,
    "hasValue": true,
    "time": "2022-05-02"
  },
  {
    "open": 2.9536,
    "high": 2.9888,
    "low": 2.9127,
    "close": 2.9751,
    "priceDate": "2022-05-03T00:00:00-04:00",
    "ticks": 637871328000000000,
    "epochTime": 1651536000,
    "hasValue": true,
    "time": "2022-05-03"
  },
  {
    "open": 2.9617,
    "high": 3.0107,
    "low": 2.9013,
    "close": 2.9383,
    "priceDate": "2022-05-04T00:00:00-04:00",
    "ticks": 637872192000000000,
    "epochTime": 1651622400,
    "hasValue": true,
    "time": "2022-05-04"
  },
  {
    "open": 2.9444,
    "high": 3.1077,
    "low": 2.9249,
    "close": 3.0464,
    "priceDate": "2022-05-05T00:00:00-04:00",
    "ticks": 637873056000000000,
    "epochTime": 1651708800,
    "hasValue": true,
    "time": "2022-05-05"
  },
  {
    "open": 3.0848,
    "high": 3.1464,
    "low": 3.0433,
    "close": 3.1404,
    "priceDate": "2022-05-06T00:00:00-04:00",
    "ticks": 637873920000000000,
    "epochTime": 1651795200,
    "hasValue": true,
    "time": "2022-05-06"
  },
  {
    "open": 3.1627,
    "high": 3.1687,
    "low": 3.0279,
    "close": 3.0377,
    "priceDate": "2022-05-09T00:00:00-04:00",
    "ticks": 637876512000000000,
    "epochTime": 1652054400,
    "hasValue": true,
    "time": "2022-05-09"
  },
  {
    "open": 3.0026,
    "high": 3.0065,
    "low": 2.9419,
    "close": 2.9967,
    "priceDate": "2022-05-10T00:00:00-04:00",
    "ticks": 637877376000000000,
    "epochTime": 1652140800,
    "hasValue": true,
    "time": "2022-05-10"
  },
  {
    "open": 2.9402,
    "high": 3.0759,
    "low": 2.907,
    "close": 2.9246,
    "priceDate": "2022-05-11T00:00:00-04:00",
    "ticks": 637878240000000000,
    "epochTime": 1652227200,
    "hasValue": true,
    "time": "2022-05-11"
  },
  {
    "open": 2.8245,
    "high": 2.8804,
    "low": 2.8155,
    "close": 2.8515,
    "priceDate": "2022-05-12T00:00:00-04:00",
    "ticks": 637879104000000000,
    "epochTime": 1652313600,
    "hasValue": true,
    "time": "2022-05-12"
  },
  {
    "open": 2.9131,
    "high": 2.944,
    "low": 2.8877,
    "close": 2.9258,
    "priceDate": "2022-05-13T00:00:00-04:00",
    "ticks": 637879968000000000,
    "epochTime": 1652400000,
    "hasValue": true,
    "time": "2022-05-13"
  },
  {
    "open": 2.9203,
    "high": 2.9331,
    "low": 2.8533,
    "close": 2.8858,
    "priceDate": "2022-05-16T00:00:00-04:00",
    "ticks": 637882560000000000,
    "epochTime": 1652659200,
    "hasValue": true,
    "time": "2022-05-16"
  },
  {
    "open": 2.9094,
    "high": 2.997,
    "low": 2.9058,
    "close": 2.9897,
    "priceDate": "2022-05-17T00:00:00-04:00",
    "ticks": 637883424000000000,
    "epochTime": 1652745600,
    "hasValue": true,
    "time": "2022-05-17"
  },
  {
    "open": 2.9952,
    "high": 3.0154,
    "low": 2.8732,
    "close": 2.8877,
    "priceDate": "2022-05-18T00:00:00-04:00",
    "ticks": 637884288000000000,
    "epochTime": 1652832000,
    "hasValue": true,
    "time": "2022-05-18"
  },
  {
    "open": 2.8442,
    "high": 2.8587,
    "low": 2.7723,
    "close": 2.8406,
    "priceDate": "2022-05-19T00:00:00-04:00",
    "ticks": 637885152000000000,
    "epochTime": 1652918400,
    "hasValue": true,
    "time": "2022-05-19"
  },
  {
    "open": 2.8677,
    "high": 2.8677,
    "low": 2.774,
    "close": 2.7847,
    "priceDate": "2022-05-20T00:00:00-04:00",
    "ticks": 637886016000000000,
    "epochTime": 1653004800,
    "hasValue": true,
    "time": "2022-05-20"
  },
  {
    "open": 2.8243,
    "high": 2.8731,
    "low": 2.8009,
    "close": 2.855,
    "priceDate": "2022-05-23T00:00:00-04:00",
    "ticks": 637888608000000000,
    "epochTime": 1653264000,
    "hasValue": true,
    "time": "2022-05-23"
  },
  {
    "open": 2.8081,
    "high": 2.8279,
    "low": 2.7184,
    "close": 2.7524,
    "priceDate": "2022-05-24T00:00:00-04:00",
    "ticks": 637889472000000000,
    "epochTime": 1653350400,
    "hasValue": true,
    "time": "2022-05-24"
  },
  {
    "open": 2.7255,
    "high": 2.7703,
    "low": 2.7077,
    "close": 2.7506,
    "priceDate": "2022-05-25T00:00:00-04:00",
    "ticks": 637890336000000000,
    "epochTime": 1653436800,
    "hasValue": true,
    "time": "2022-05-25"
  },
  {
    "open": 2.7469,
    "high": 2.7972,
    "low": 2.729,
    "close": 2.7541,
    "priceDate": "2022-05-26T00:00:00-04:00",
    "ticks": 637891200000000000,
    "epochTime": 1653523200,
    "hasValue": true,
    "time": "2022-05-26"
  },
  {
    "open": 2.7307,
    "high": 2.7522,
    "low": 2.7092,
    "close": 2.7432,
    "priceDate": "2022-05-27T00:00:00-04:00",
    "ticks": 637892064000000000,
    "epochTime": 1653609600,
    "hasValue": true,
    "time": "2022-05-27"
  },
  {
    "open": 2.8278,
    "high": 2.884,
    "low": 2.8151,
    "close": 2.8459,
    "priceDate": "2022-05-31T00:00:00-04:00",
    "ticks": 637895520000000000,
    "epochTime": 1653955200,
    "hasValue": true,
    "time": "2022-05-31"
  },
  {
    "open": 2.8749,
    "high": 2.9515,
    "low": 2.8332,
    "close": 2.9113,
    "priceDate": "2022-06-01T00:00:00-04:00",
    "ticks": 637896384000000000,
    "epochTime": 1654041600,
    "hasValue": true,
    "time": "2022-06-01"
  },
  {
    "open": 2.9113,
    "high": 2.9442,
    "low": 2.8894,
    "close": 2.9113,
    "priceDate": "2022-06-02T00:00:00-04:00",
    "ticks": 637897248000000000,
    "epochTime": 1654128000,
    "hasValue": true,
    "time": "2022-06-02"
  },
  {
    "open": 2.9204,
    "high": 2.9864,
    "low": 2.9149,
    "close": 2.9369,
    "priceDate": "2022-06-03T00:00:00-04:00",
    "ticks": 637898112000000000,
    "epochTime": 1654214400,
    "hasValue": true,
    "time": "2022-06-03"
  },
  {
    "open": 2.9534,
    "high": 3.0491,
    "low": 2.9515,
    "close": 3.0454,
    "priceDate": "2022-06-06T00:00:00-04:00",
    "ticks": 637900704000000000,
    "epochTime": 1654473600,
    "hasValue": true,
    "time": "2022-06-06"
  },
  {
    "open": 3.0307,
    "high": 3.0307,
    "low": 2.9571,
    "close": 2.9736,
    "priceDate": "2022-06-07T00:00:00-04:00",
    "ticks": 637901568000000000,
    "epochTime": 1654560000,
    "hasValue": true,
    "time": "2022-06-07"
  },
  {
    "open": 3.0067,
    "high": 3.0418,
    "low": 2.9883,
    "close": 3.027,
    "priceDate": "2022-06-08T00:00:00-04:00",
    "ticks": 637902432000000000,
    "epochTime": 1654646400,
    "hasValue": true,
    "time": "2022-06-08"
  },
  {
    "open": 3.0344,
    "high": 3.0733,
    "low": 3.0178,
    "close": 3.0474,
    "priceDate": "2022-06-09T00:00:00-04:00",
    "ticks": 637903296000000000,
    "epochTime": 1654732800,
    "hasValue": true,
    "time": "2022-06-09"
  },
  {
    "open": 3.0438,
    "high": 3.178,
    "low": 2.9902,
    "close": 3.1649,
    "priceDate": "2022-06-10T00:00:00-04:00",
    "ticks": 637904160000000000,
    "epochTime": 1654819200,
    "hasValue": true,
    "time": "2022-06-10"
  },
  {
    "open": 3.2704,
    "high": 3.4404,
    "low": 3.2458,
    "close": 3.3713,
    "priceDate": "2022-06-13T00:00:00-04:00",
    "ticks": 637906752000000000,
    "epochTime": 1655078400,
    "hasValue": true,
    "time": "2022-06-13"
  },
  {
    "open": 3.3504,
    "high": 3.4984,
    "low": 3.3028,
    "close": 3.4752,
    "priceDate": "2022-06-14T00:00:00-04:00",
    "ticks": 637907616000000000,
    "epochTime": 1655164800,
    "hasValue": true,
    "time": "2022-06-14"
  },
  {
    "open": 3.3677,
    "high": 3.4483,
    "low": 3.2801,
    "close": 3.2877,
    "priceDate": "2022-06-15T00:00:00-04:00",
    "ticks": 637908480000000000,
    "epochTime": 1655251200,
    "hasValue": true,
    "time": "2022-06-15"
  },
  {
    "open": 3.4543,
    "high": 3.4562,
    "low": 3.1783,
    "close": 3.1971,
    "priceDate": "2022-06-16T00:00:00-04:00",
    "ticks": 637909344000000000,
    "epochTime": 1655337600,
    "hasValue": true,
    "time": "2022-06-16"
  },
  {
    "open": 3.2237,
    "high": 3.3129,
    "low": 3.1973,
    "close": 3.2294,
    "priceDate": "2022-06-17T00:00:00-04:00",
    "ticks": 637910208000000000,
    "epochTime": 1655424000,
    "hasValue": true,
    "time": "2022-06-17"
  },
  {
    "open": 3.2939,
    "high": 3.3168,
    "low": 3.2579,
    "close": 3.2806,
    "priceDate": "2022-06-21T00:00:00-04:00",
    "ticks": 637913664000000000,
    "epochTime": 1655769600,
    "hasValue": true,
    "time": "2022-06-21"
  },
  {
    "open": 3.2088,
    "high": 3.2126,
    "low": 3.1243,
    "close": 3.1618,
    "priceDate": "2022-06-22T00:00:00-04:00",
    "ticks": 637914528000000000,
    "epochTime": 1655856000,
    "hasValue": true,
    "time": "2022-06-22"
  },
  {
    "open": 3.1243,
    "high": 3.1243,
    "low": 3.0053,
    "close": 3.0963,
    "priceDate": "2022-06-23T00:00:00-04:00",
    "ticks": 637915392000000000,
    "epochTime": 1655942400,
    "hasValue": true,
    "time": "2022-06-23"
  },
  {
    "open": 3.1189,
    "high": 3.1414,
    "low": 3.0573,
    "close": 3.1357,
    "priceDate": "2022-06-24T00:00:00-04:00",
    "ticks": 637916256000000000,
    "epochTime": 1656028800,
    "hasValue": true,
    "time": "2022-06-24"
  },
  {
    "open": 3.1903,
    "high": 3.2186,
    "low": 3.1527,
    "close": 3.2054,
    "priceDate": "2022-06-27T00:00:00-04:00",
    "ticks": 637918848000000000,
    "epochTime": 1656288000,
    "hasValue": true,
    "time": "2022-06-27"
  },
  {
    "open": 3.2319,
    "high": 3.2528,
    "low": 3.1715,
    "close": 3.1772,
    "priceDate": "2022-06-28T00:00:00-04:00",
    "ticks": 637919712000000000,
    "epochTime": 1656374400,
    "hasValue": true,
    "time": "2022-06-28"
  },
  {
    "open": 3.1584,
    "high": 3.1867,
    "low": 3.0873,
    "close": 3.0928,
    "priceDate": "2022-06-29T00:00:00-04:00",
    "ticks": 637920576000000000,
    "epochTime": 1656460800,
    "hasValue": true,
    "time": "2022-06-29"
  },
  {
    "open": 3.037,
    "high": 3.0407,
    "low": 2.9703,
    "close": 3.0166,
    "priceDate": "2022-06-30T00:00:00-04:00",
    "ticks": 637921440000000000,
    "epochTime": 1656547200,
    "hasValue": true,
    "time": "2022-06-30"
  },
  {
    "open": 2.9427,
    "high": 2.9464,
    "low": 2.7909,
    "close": 2.8894,
    "priceDate": "2022-07-01T00:00:00-04:00",
    "ticks": 637922304000000000,
    "epochTime": 1656633600,
    "hasValue": true,
    "time": "2022-07-01"
  },
  {
    "open": 2.8766,
    "high": 2.8821,
    "low": 2.78,
    "close": 2.809,
    "priceDate": "2022-07-05T00:00:00-04:00",
    "ticks": 637925760000000000,
    "epochTime": 1656979200,
    "hasValue": true,
    "time": "2022-07-05"
  },
  {
    "open": 2.7945,
    "high": 2.9354,
    "low": 2.7455,
    "close": 2.9335,
    "priceDate": "2022-07-06T00:00:00-04:00",
    "ticks": 637926624000000000,
    "epochTime": 1657065600,
    "hasValue": true,
    "time": "2022-07-06"
  },
  {
    "open": 2.9262,
    "high": 3.0168,
    "low": 2.9207,
    "close": 2.9982,
    "priceDate": "2022-07-07T00:00:00-04:00",
    "ticks": 637927488000000000,
    "epochTime": 1657152000,
    "hasValue": true,
    "time": "2022-07-07"
  },
  {
    "open": 2.9779,
    "high": 3.1009,
    "low": 2.9761,
    "close": 3.0822,
    "priceDate": "2022-07-08T00:00:00-04:00",
    "ticks": 637928352000000000,
    "epochTime": 1657238400,
    "hasValue": true,
    "time": "2022-07-08"
  },
  {
    "open": 3.0504,
    "high": 3.0504,
    "low": 2.9668,
    "close": 2.9965,
    "priceDate": "2022-07-11T00:00:00-04:00",
    "ticks": 637930944000000000,
    "epochTime": 1657497600,
    "hasValue": true,
    "time": "2022-07-11"
  },
  {
    "open": 2.9299,
    "high": 2.9835,
    "low": 2.8986,
    "close": 2.9743,
    "priceDate": "2022-07-12T00:00:00-04:00",
    "ticks": 637931808000000000,
    "epochTime": 1657584000,
    "hasValue": true,
    "time": "2022-07-12"
  },
  {
    "open": 2.9558,
    "high": 3.0711,
    "low": 2.8986,
    "close": 2.9355,
    "priceDate": "2022-07-13T00:00:00-04:00",
    "ticks": 637932672000000000,
    "epochTime": 1657670400,
    "hasValue": true,
    "time": "2022-07-13"
  },
  {
    "open": 2.9355,
    "high": 3.0282,
    "low": 2.9355,
    "close": 2.9669,
    "priceDate": "2022-07-14T00:00:00-04:00",
    "ticks": 637933536000000000,
    "epochTime": 1657756800,
    "hasValue": true,
    "time": "2022-07-14"
  },
  {
    "open": 2.9373,
    "high": 2.9725,
    "low": 2.8986,
    "close": 2.9189,
    "priceDate": "2022-07-15T00:00:00-04:00",
    "ticks": 637934400000000000,
    "epochTime": 1657843200,
    "hasValue": true,
    "time": "2022-07-15"
  },
  {
    "open": 2.9559,
    "high": 3.019,
    "low": 2.9485,
    "close": 2.9892,
    "priceDate": "2022-07-18T00:00:00-04:00",
    "ticks": 637936992000000000,
    "epochTime": 1658102400,
    "hasValue": true,
    "time": "2022-07-18"
  },
  {
    "open": 2.9818,
    "high": 3.0377,
    "low": 2.9689,
    "close": 3.0246,
    "priceDate": "2022-07-19T00:00:00-04:00",
    "ticks": 637937856000000000,
    "epochTime": 1658188800,
    "hasValue": true,
    "time": "2022-07-19"
  },
  {
    "open": 2.9763,
    "high": 3.0415,
    "low": 2.9429,
    "close": 3.0284,
    "priceDate": "2022-07-20T00:00:00-04:00",
    "ticks": 637938720000000000,
    "epochTime": 1658275200,
    "hasValue": true,
    "time": "2022-07-20"
  },
  {
    "open": 3.0527,
    "high": 3.0827,
    "low": 2.871,
    "close": 2.8784,
    "priceDate": "2022-07-21T00:00:00-04:00",
    "ticks": 637939584000000000,
    "epochTime": 1658361600,
    "hasValue": true,
    "time": "2022-07-21"
  },
  {
    "open": 2.8069,
    "high": 2.8233,
    "low": 2.7322,
    "close": 2.7522,
    "priceDate": "2022-07-22T00:00:00-04:00",
    "ticks": 637940448000000000,
    "epochTime": 1658448000,
    "hasValue": true,
    "time": "2022-07-22"
  },
  {
    "open": 2.8233,
    "high": 2.8453,
    "low": 2.7959,
    "close": 2.8014,
    "priceDate": "2022-07-25T00:00:00-04:00",
    "ticks": 637943040000000000,
    "epochTime": 1658707200,
    "hasValue": true,
    "time": "2022-07-25"
  },
  {
    "open": 2.7521,
    "high": 2.8123,
    "low": 2.7068,
    "close": 2.8087,
    "priceDate": "2022-07-26T00:00:00-04:00",
    "ticks": 637943904000000000,
    "epochTime": 1658793600,
    "hasValue": true,
    "time": "2022-07-26"
  },
  {
    "open": 2.8087,
    "high": 2.8105,
    "low": 2.723,
    "close": 2.7885,
    "priceDate": "2022-07-27T00:00:00-04:00",
    "ticks": 637944768000000000,
    "epochTime": 1658880000,
    "hasValue": true,
    "time": "2022-07-27"
  },
  {
    "open": 2.7648,
    "high": 2.7904,
    "low": 2.6489,
    "close": 2.6777,
    "priceDate": "2022-07-28T00:00:00-04:00",
    "ticks": 637945632000000000,
    "epochTime": 1658966400,
    "hasValue": true,
    "time": "2022-07-28"
  },
  {
    "open": 2.7102,
    "high": 2.7283,
    "low": 2.6181,
    "close": 2.6541,
    "priceDate": "2022-07-29T00:00:00-04:00",
    "ticks": 637946496000000000,
    "epochTime": 1659052800,
    "hasValue": true,
    "time": "2022-07-29"
  },
  {
    "open": 2.6577,
    "high": 2.6956,
    "low": 2.575,
    "close": 2.5768,
    "priceDate": "2022-08-01T00:00:00-04:00",
    "ticks": 637949088000000000,
    "epochTime": 1659312000,
    "hasValue": true,
    "time": "2022-08-01"
  },
  {
    "open": 2.557,
    "high": 2.7738,
    "low": 2.5249,
    "close": 2.7556,
    "priceDate": "2022-08-02T00:00:00-04:00",
    "ticks": 637949952000000000,
    "epochTime": 1659398400,
    "hasValue": true,
    "time": "2022-08-02"
  },
  {
    "open": 2.7884,
    "high": 2.8508,
    "low": 2.6992,
    "close": 2.7046,
    "priceDate": "2022-08-03T00:00:00-04:00",
    "ticks": 637950816000000000,
    "epochTime": 1659484800,
    "hasValue": true,
    "time": "2022-08-03"
  },
  {
    "open": 2.6937,
    "high": 2.7209,
    "low": 2.6557,
    "close": 2.6883,
    "priceDate": "2022-08-04T00:00:00-04:00",
    "ticks": 637951680000000000,
    "epochTime": 1659571200,
    "hasValue": true,
    "time": "2022-08-04"
  },
  {
    "open": 2.7045,
    "high": 2.8692,
    "low": 2.6881,
    "close": 2.8287,
    "priceDate": "2022-08-05T00:00:00-04:00",
    "ticks": 637952544000000000,
    "epochTime": 1659657600,
    "hasValue": true,
    "time": "2022-08-05"
  },
  {
    "open": 2.7938,
    "high": 2.8066,
    "low": 2.739,
    "close": 2.7609,
    "priceDate": "2022-08-08T00:00:00-04:00",
    "ticks": 637955136000000000,
    "epochTime": 1659916800,
    "hasValue": true,
    "time": "2022-08-08"
  },
  {
    "open": 2.8139,
    "high": 2.8158,
    "low": 2.7736,
    "close": 2.7846,
    "priceDate": "2022-08-09T00:00:00-04:00",
    "ticks": 637956000000000000,
    "epochTime": 1660003200,
    "hasValue": true,
    "time": "2022-08-09"
  },
  {
    "open": 2.7974,
    "high": 2.8176,
    "low": 2.6735,
    "close": 2.7864,
    "priceDate": "2022-08-10T00:00:00-04:00",
    "ticks": 637956864000000000,
    "epochTime": 1660089600,
    "hasValue": true,
    "time": "2022-08-10"
  },
  {
    "open": 2.7392,
    "high": 2.9022,
    "low": 2.7302,
    "close": 2.893,
    "priceDate": "2022-08-11T00:00:00-04:00",
    "ticks": 637957728000000000,
    "epochTime": 1660176000,
    "hasValue": true,
    "time": "2022-08-11"
  },
  {
    "open": 2.8621,
    "high": 2.8785,
    "low": 2.8349,
    "close": 2.8367,
    "priceDate": "2022-08-12T00:00:00-04:00",
    "ticks": 637958592000000000,
    "epochTime": 1660262400,
    "hasValue": true,
    "time": "2022-08-12"
  },
  {
    "open": 2.8149,
    "high": 2.8149,
    "low": 2.759,
    "close": 2.7896,
    "priceDate": "2022-08-15T00:00:00-04:00",
    "ticks": 637961184000000000,
    "epochTime": 1660521600,
    "hasValue": true,
    "time": "2022-08-15"
  },
  {
    "open": 2.8077,
    "high": 2.873,
    "low": 2.8041,
    "close": 2.8059,
    "priceDate": "2022-08-16T00:00:00-04:00",
    "ticks": 637962048000000000,
    "epochTime": 1660608000,
    "hasValue": true,
    "time": "2022-08-16"
  },
  {
    "open": 2.8895,
    "high": 2.9187,
    "low": 2.8603,
    "close": 2.9022,
    "priceDate": "2022-08-17T00:00:00-04:00",
    "ticks": 637962912000000000,
    "epochTime": 1660694400,
    "hasValue": true,
    "time": "2022-08-17"
  },
  {
    "open": 2.8513,
    "high": 2.8913,
    "low": 2.8349,
    "close": 2.884,
    "priceDate": "2022-08-18T00:00:00-04:00",
    "ticks": 637963776000000000,
    "epochTime": 1660780800,
    "hasValue": true,
    "time": "2022-08-18"
  },
  {
    "open": 2.9592,
    "high": 2.9979,
    "low": 2.9519,
    "close": 2.9758,
    "priceDate": "2022-08-19T00:00:00-04:00",
    "ticks": 637964640000000000,
    "epochTime": 1660867200,
    "hasValue": true,
    "time": "2022-08-19"
  },
  {
    "open": 2.9869,
    "high": 3.0405,
    "low": 2.9648,
    "close": 3.0201,
    "priceDate": "2022-08-22T00:00:00-04:00",
    "ticks": 637967232000000000,
    "epochTime": 1661126400,
    "hasValue": true,
    "time": "2022-08-22"
  },
  {
    "open": 3.0183,
    "high": 3.0777,
    "low": 2.9832,
    "close": 3.0461,
    "priceDate": "2022-08-23T00:00:00-04:00",
    "ticks": 637968096000000000,
    "epochTime": 1661212800,
    "hasValue": true,
    "time": "2022-08-23"
  },
  {
    "open": 3.0443,
    "high": 3.1263,
    "low": 3.0387,
    "close": 3.1095,
    "priceDate": "2022-08-24T00:00:00-04:00",
    "ticks": 637968960000000000,
    "epochTime": 1661299200,
    "hasValue": true,
    "time": "2022-08-24"
  },
  {
    "open": 3.1077,
    "high": 3.1282,
    "low": 3.0203,
    "close": 3.0277,
    "priceDate": "2022-08-25T00:00:00-04:00",
    "ticks": 637969824000000000,
    "epochTime": 1661385600,
    "hasValue": true,
    "time": "2022-08-25"
  },
  {
    "open": 3.0725,
    "high": 3.0874,
    "low": 3.0075,
    "close": 3.0409,
    "priceDate": "2022-08-26T00:00:00-04:00",
    "ticks": 637970688000000000,
    "epochTime": 1661472000,
    "hasValue": true,
    "time": "2022-08-26"
  },
  {
    "open": 3.1024,
    "high": 3.1248,
    "low": 3.0856,
    "close": 3.108,
    "priceDate": "2022-08-29T00:00:00-04:00",
    "ticks": 637973280000000000,
    "epochTime": 1661731200,
    "hasValue": true,
    "time": "2022-08-29"
  },
  {
    "open": 3.0707,
    "high": 3.153,
    "low": 3.0633,
    "close": 3.1043,
    "priceDate": "2022-08-30T00:00:00-04:00",
    "ticks": 637974144000000000,
    "epochTime": 1661817600,
    "hasValue": true,
    "time": "2022-08-30"
  },
  {
    "open": 3.1343,
    "high": 3.1983,
    "low": 3.1025,
    "close": 3.1983,
    "priceDate": "2022-08-31T00:00:00-04:00",
    "ticks": 637975008000000000,
    "epochTime": 1661904000,
    "hasValue": true,
    "time": "2022-08-31"
  },
  {
    "open": 3.1927,
    "high": 3.297,
    "low": 3.1927,
    "close": 3.2552,
    "priceDate": "2022-09-01T00:00:00-04:00",
    "ticks": 637975872000000000,
    "epochTime": 1661990400,
    "hasValue": true,
    "time": "2022-09-01"
  },
  {
    "open": 3.2632,
    "high": 3.2899,
    "low": 3.1743,
    "close": 3.1912,
    "priceDate": "2022-09-02T00:00:00-04:00",
    "ticks": 637976736000000000,
    "epochTime": 1662076800,
    "hasValue": true,
    "time": "2022-09-02"
  },
  {
    "open": 3.2462,
    "high": 3.3569,
    "low": 3.2424,
    "close": 3.3569,
    "priceDate": "2022-09-06T00:00:00-04:00",
    "ticks": 637980192000000000,
    "epochTime": 1662422400,
    "hasValue": true,
    "time": "2022-09-06"
  },
  {
    "open": 3.3302,
    "high": 3.3321,
    "low": 3.2501,
    "close": 3.2711,
    "priceDate": "2022-09-07T00:00:00-04:00",
    "ticks": 637981056000000000,
    "epochTime": 1662508800,
    "hasValue": true,
    "time": "2022-09-07"
  },
  {
    "open": 3.2218,
    "high": 3.3284,
    "low": 3.201,
    "close": 3.3227,
    "priceDate": "2022-09-08T00:00:00-04:00",
    "ticks": 637981920000000000,
    "epochTime": 1662595200,
    "hasValue": true,
    "time": "2022-09-08"
  },
  {
    "open": 3.2753,
    "high": 3.3327,
    "low": 3.2487,
    "close": 3.3154,
    "priceDate": "2022-09-09T00:00:00-04:00",
    "ticks": 637982784000000000,
    "epochTime": 1662681600,
    "hasValue": true,
    "time": "2022-09-09"
  },
  {
    "open": 3.2717,
    "high": 3.377,
    "low": 3.2621,
    "close": 3.3654,
    "priceDate": "2022-09-12T00:00:00-04:00",
    "ticks": 637985376000000000,
    "epochTime": 1662940800,
    "hasValue": true,
    "time": "2022-09-12"
  },
  {
    "open": 3.3023,
    "high": 3.4603,
    "low": 3.2928,
    "close": 3.408,
    "priceDate": "2022-09-13T00:00:00-04:00",
    "ticks": 637986240000000000,
    "epochTime": 1663027200,
    "hasValue": true,
    "time": "2022-09-13"
  },
  {
    "open": 3.4585,
    "high": 3.476,
    "low": 3.3831,
    "close": 3.4062,
    "priceDate": "2022-09-14T00:00:00-04:00",
    "ticks": 637987104000000000,
    "epochTime": 1663113600,
    "hasValue": true,
    "time": "2022-09-14"
  },
  {
    "open": 3.4606,
    "high": 3.4684,
    "low": 3.4102,
    "close": 3.4528,
    "priceDate": "2022-09-15T00:00:00-04:00",
    "ticks": 637987968000000000,
    "epochTime": 1663200000,
    "hasValue": true,
    "time": "2022-09-15"
  },
  {
    "open": 3.4533,
    "high": 3.4922,
    "low": 3.4146,
    "close": 3.4514,
    "priceDate": "2022-09-16T00:00:00-04:00",
    "ticks": 637988832000000000,
    "epochTime": 1663286400,
    "hasValue": true,
    "time": "2022-09-16"
  },
  {
    "open": 3.51,
    "high": 3.5139,
    "low": 3.4613,
    "close": 3.4944,
    "priceDate": "2022-09-19T00:00:00-04:00",
    "ticks": 637991424000000000,
    "epochTime": 1663545600,
    "hasValue": true,
    "time": "2022-09-19"
  },
  {
    "open": 3.5493,
    "high": 3.6044,
    "low": 3.5336,
    "close": 3.5689,
    "priceDate": "2022-09-20T00:00:00-04:00",
    "ticks": 637992288000000000,
    "epochTime": 1663632000,
    "hasValue": true,
    "time": "2022-09-20"
  },
  {
    "open": 3.5318,
    "high": 3.6401,
    "low": 3.4986,
    "close": 3.5318,
    "priceDate": "2022-09-21T00:00:00-04:00",
    "ticks": 637993152000000000,
    "epochTime": 1663718400,
    "hasValue": true,
    "time": "2022-09-21"
  },
  {
    "open": 3.5418,
    "high": 3.7198,
    "low": 3.534,
    "close": 3.7158,
    "priceDate": "2022-09-22T00:00:00-04:00",
    "ticks": 637994016000000000,
    "epochTime": 1663804800,
    "hasValue": true,
    "time": "2022-09-22"
  },
  {
    "open": 3.7685,
    "high": 3.7846,
    "low": 3.6588,
    "close": 3.6866,
    "priceDate": "2022-09-23T00:00:00-04:00",
    "ticks": 637994880000000000,
    "epochTime": 1663891200,
    "hasValue": true,
    "time": "2022-09-23"
  },
  {
    "open": 3.7768,
    "high": 3.9326,
    "low": 3.7347,
    "close": 3.9305,
    "priceDate": "2022-09-26T00:00:00-04:00",
    "ticks": 637997472000000000,
    "epochTime": 1664150400,
    "hasValue": true,
    "time": "2022-09-26"
  },
  {
    "open": 3.8294,
    "high": 3.9921,
    "low": 3.8032,
    "close": 3.9451,
    "priceDate": "2022-09-27T00:00:00-04:00",
    "ticks": 637998336000000000,
    "epochTime": 1664236800,
    "hasValue": true,
    "time": "2022-09-27"
  },
  {
    "open": 3.9189,
    "high": 3.9209,
    "low": 3.6952,
    "close": 3.7372,
    "priceDate": "2022-09-28T00:00:00-04:00",
    "ticks": 637999200000000000,
    "epochTime": 1664323200,
    "hasValue": true,
    "time": "2022-09-28"
  },
  {
    "open": 3.8218,
    "high": 3.8319,
    "low": 3.7214,
    "close": 3.7855,
    "priceDate": "2022-09-29T00:00:00-04:00",
    "ticks": 638000064000000000,
    "epochTime": 1664409600,
    "hasValue": true,
    "time": "2022-09-29"
  },
  {
    "open": 3.7061,
    "high": 3.8428,
    "low": 3.6842,
    "close": 3.8347,
    "priceDate": "2022-09-30T00:00:00-04:00",
    "ticks": 638000928000000000,
    "epochTime": 1664496000,
    "hasValue": true,
    "time": "2022-09-30"
  },
  {
    "open": 3.7043,
    "high": 3.7183,
    "low": 3.5675,
    "close": 3.6426,
    "priceDate": "2022-10-03T00:00:00-04:00",
    "ticks": 638003520000000000,
    "epochTime": 1664755200,
    "hasValue": true,
    "time": "2022-10-03"
  },
  {
    "open": 3.5953,
    "high": 3.6587,
    "low": 3.5637,
    "close": 3.6369,
    "priceDate": "2022-10-04T00:00:00-04:00",
    "ticks": 638004384000000000,
    "epochTime": 1664841600,
    "hasValue": true,
    "time": "2022-10-04"
  },
  {
    "open": 3.7028,
    "high": 3.789,
    "low": 3.6828,
    "close": 3.7589,
    "priceDate": "2022-10-05T00:00:00-04:00",
    "ticks": 638005248000000000,
    "epochTime": 1664928000,
    "hasValue": true,
    "time": "2022-10-05"
  },
  {
    "open": 3.7591,
    "high": 3.8458,
    "low": 3.739,
    "close": 3.8256,
    "priceDate": "2022-10-06T00:00:00-04:00",
    "ticks": 638006112000000000,
    "epochTime": 1665014400,
    "hasValue": true,
    "time": "2022-10-06"
  },
  {
    "open": 3.8307,
    "high": 3.9099,
    "low": 3.8266,
    "close": 3.8855,
    "priceDate": "2022-10-07T00:00:00-04:00",
    "ticks": 638006976000000000,
    "epochTime": 1665100800,
    "hasValue": true,
    "time": "2022-10-07"
  },
  {
    "open": 3.9143,
    "high": 3.9716,
    "low": 3.8674,
    "close": 3.9511,
    "priceDate": "2022-10-11T00:00:00-04:00",
    "ticks": 638010432000000000,
    "epochTime": 1665446400,
    "hasValue": true,
    "time": "2022-10-11"
  },
  {
    "open": 3.9678,
    "high": 3.9781,
    "low": 3.884,
    "close": 3.8982,
    "priceDate": "2022-10-12T00:00:00-04:00",
    "ticks": 638011296000000000,
    "epochTime": 1665532800,
    "hasValue": true,
    "time": "2022-10-12"
  },
  {
    "open": 3.87,
    "high": 4.0795,
    "low": 3.8416,
    "close": 3.9496,
    "priceDate": "2022-10-13T00:00:00-04:00",
    "ticks": 638012160000000000,
    "epochTime": 1665619200,
    "hasValue": true,
    "time": "2022-10-13"
  },
  {
    "open": 3.883,
    "high": 4.0308,
    "low": 3.8505,
    "close": 4.0225,
    "priceDate": "2022-10-14T00:00:00-04:00",
    "ticks": 638013024000000000,
    "epochTime": 1665705600,
    "hasValue": true,
    "time": "2022-10-14"
  },
  {
    "open": 3.9446,
    "high": 4.0269,
    "low": 3.9098,
    "close": 4.0166,
    "priceDate": "2022-10-17T00:00:00-04:00",
    "ticks": 638015616000000000,
    "epochTime": 1665964800,
    "hasValue": true,
    "time": "2022-10-17"
  },
  {
    "open": 4.0025,
    "high": 4.0666,
    "low": 3.9634,
    "close": 4.0128,
    "priceDate": "2022-10-18T00:00:00-04:00",
    "ticks": 638016480000000000,
    "epochTime": 1666051200,
    "hasValue": true,
    "time": "2022-10-18"
  },
  {
    "open": 4.1001,
    "high": 4.1398,
    "low": 4.0669,
    "close": 4.1398,
    "priceDate": "2022-10-19T00:00:00-04:00",
    "ticks": 638017344000000000,
    "epochTime": 1666137600,
    "hasValue": true,
    "time": "2022-10-19"
  },
  {
    "open": 4.1317,
    "high": 4.243,
    "low": 4.0984,
    "close": 4.2283,
    "priceDate": "2022-10-20T00:00:00-04:00",
    "ticks": 638018208000000000,
    "epochTime": 1666224000,
    "hasValue": true,
    "time": "2022-10-20"
  },
  {
    "open": 4.3034,
    "high": 4.3375,
    "low": 4.1998,
    "close": 4.2209,
    "priceDate": "2022-10-21T00:00:00-04:00",
    "ticks": 638019072000000000,
    "epochTime": 1666310400,
    "hasValue": true,
    "time": "2022-10-21"
  },
  {
    "open": 4.1708,
    "high": 4.2911,
    "low": 4.1624,
    "close": 4.2487,
    "priceDate": "2022-10-24T00:00:00-04:00",
    "ticks": 638021664000000000,
    "epochTime": 1666569600,
    "hasValue": true,
    "time": "2022-10-24"
  },
  {
    "open": 4.1795,
    "high": 4.1816,
    "low": 4.0522,
    "close": 4.1042,
    "priceDate": "2022-10-25T00:00:00-04:00",
    "ticks": 638022528000000000,
    "epochTime": 1666656000,
    "hasValue": true,
    "time": "2022-10-25"
  },
  {
    "open": 4.0587,
    "high": 4.0816,
    "low": 3.9945,
    "close": 4.0069,
    "priceDate": "2022-10-26T00:00:00-04:00",
    "ticks": 638023392000000000,
    "epochTime": 1666742400,
    "hasValue": true,
    "time": "2022-10-26"
  },
  {
    "open": 4.0673,
    "high": 4.0798,
    "low": 3.8983,
    "close": 3.9249,
    "priceDate": "2022-10-27T00:00:00-04:00",
    "ticks": 638024256000000000,
    "epochTime": 1666828800,
    "hasValue": true,
    "time": "2022-10-27"
  },
  {
    "open": 4.0102,
    "high": 4.0496,
    "low": 3.9483,
    "close": 4.0205,
    "priceDate": "2022-10-28T00:00:00-04:00",
    "ticks": 638025120000000000,
    "epochTime": 1666915200,
    "hasValue": true,
    "time": "2022-10-28"
  },
  {
    "open": 4.0457,
    "high": 4.1124,
    "low": 4.0312,
    "close": 4.0561,
    "priceDate": "2022-10-31T00:00:00-04:00",
    "ticks": 638027712000000000,
    "epochTime": 1667174400,
    "hasValue": true,
    "time": "2022-10-31"
  },
  {
    "open": 3.951,
    "high": 4.0793,
    "low": 3.9201,
    "close": 4.0481,
    "priceDate": "2022-11-01T00:00:00-04:00",
    "ticks": 638028576000000000,
    "epochTime": 1667260800,
    "hasValue": true,
    "time": "2022-11-01"
  },
  {
    "open": 4.0297,
    "high": 4.1151,
    "low": 3.9739,
    "close": 4.1109,
    "priceDate": "2022-11-02T00:00:00-04:00",
    "ticks": 638029440000000000,
    "epochTime": 1667347200,
    "hasValue": true,
    "time": "2022-11-02"
  },
  {
    "open": 4.1805,
    "high": 4.2227,
    "low": 4.111,
    "close": 4.1553,
    "priceDate": "2022-11-03T00:00:00-04:00",
    "ticks": 638030304000000000,
    "epochTime": 1667433600,
    "hasValue": true,
    "time": "2022-11-03"
  },
  {
    "open": 4.163,
    "high": 4.209,
    "low": 4.1018,
    "close": 4.1605,
    "priceDate": "2022-11-04T00:00:00-04:00",
    "ticks": 638031168000000000,
    "epochTime": 1667520000,
    "hasValue": true,
    "time": "2022-11-04"
  },
  {
    "open": 4.1398,
    "high": 4.2262,
    "low": 4.1335,
    "close": 4.2177,
    "priceDate": "2022-11-07T00:00:00-05:00",
    "ticks": 638033760000000000,
    "epochTime": 1667779200,
    "hasValue": true,
    "time": "2022-11-07"
  },
  {
    "open": 4.2075,
    "high": 4.212,
    "low": 4.121,
    "close": 4.128,
    "priceDate": "2022-11-08T00:00:00-05:00",
    "ticks": 638034624000000000,
    "epochTime": 1667865600,
    "hasValue": true,
    "time": "2022-11-08"
  },
  {
    "open": 4.1426,
    "high": 4.1762,
    "low": 4.0569,
    "close": 4.097,
    "priceDate": "2022-11-09T00:00:00-05:00",
    "ticks": 638035488000000000,
    "epochTime": 1667952000,
    "hasValue": true,
    "time": "2022-11-09"
  },
  {
    "open": 4.0885,
    "high": 4.102,
    "low": 3.8069,
    "close": 3.8162,
    "priceDate": "2022-11-10T00:00:00-05:00",
    "ticks": 638036352000000000,
    "epochTime": 1668038400,
    "hasValue": true,
    "time": "2022-11-10"
  },
  {
    "open": 3.893,
    "high": 3.901,
    "low": 3.848,
    "close": 3.859,
    "priceDate": "2022-11-14T00:00:00-05:00",
    "ticks": 638039808000000000,
    "epochTime": 1668384000,
    "hasValue": true,
    "time": "2022-11-14"
  },
  {
    "open": 3.8012,
    "high": 3.8442,
    "low": 3.7566,
    "close": 3.7733,
    "priceDate": "2022-11-15T00:00:00-05:00",
    "ticks": 638040672000000000,
    "epochTime": 1668470400,
    "hasValue": true,
    "time": "2022-11-15"
  },
  {
    "open": 3.7658,
    "high": 3.7974,
    "low": 3.671,
    "close": 3.6917,
    "priceDate": "2022-11-16T00:00:00-05:00",
    "ticks": 638041536000000000,
    "epochTime": 1668556800,
    "hasValue": true,
    "time": "2022-11-16"
  },
  {
    "open": 3.773,
    "high": 3.805,
    "low": 3.743,
    "close": 3.769,
    "priceDate": "2022-11-17T00:00:00-05:00",
    "ticks": 638042400000000000,
    "epochTime": 1668643200,
    "hasValue": true,
    "time": "2022-11-17"
  },
  {
    "open": 3.7915,
    "high": 3.8363,
    "low": 3.7617,
    "close": 3.833,
    "priceDate": "2022-11-18T00:00:00-05:00",
    "ticks": 638043264000000000,
    "epochTime": 1668729600,
    "hasValue": true,
    "time": "2022-11-18"
  },
  {
    "open": 3.8213,
    "high": 3.842,
    "low": 3.7616,
    "close": 3.8325,
    "priceDate": "2022-11-21T00:00:00-05:00",
    "ticks": 638045856000000000,
    "epochTime": 1668988800,
    "hasValue": true,
    "time": "2022-11-21"
  },
  {
    "open": 3.81,
    "high": 3.8174,
    "low": 3.7466,
    "close": 3.7597,
    "priceDate": "2022-11-22T00:00:00-05:00",
    "ticks": 638046720000000000,
    "epochTime": 1669075200,
    "hasValue": true,
    "time": "2022-11-22"
  },
  {
    "open": 3.7762,
    "high": 3.799,
    "low": 3.689,
    "close": 3.6964,
    "priceDate": "2022-11-23T00:00:00-05:00",
    "ticks": 638047584000000000,
    "epochTime": 1669161600,
    "hasValue": true,
    "time": "2022-11-23"
  },
  {
    "open": 3.7257,
    "high": 3.7555,
    "low": 3.6813,
    "close": 3.6905,
    "priceDate": "2022-11-25T00:00:00-05:00",
    "ticks": 638049312000000000,
    "epochTime": 1669334400,
    "hasValue": true,
    "time": "2022-11-25"
  },
  {
    "open": 3.6719,
    "high": 3.7201,
    "low": 3.6646,
    "close": 3.6849,
    "priceDate": "2022-11-28T00:00:00-05:00",
    "ticks": 638051904000000000,
    "epochTime": 1669593600,
    "hasValue": true,
    "time": "2022-11-28"
  },
  {
    "open": 3.6792,
    "high": 3.7627,
    "low": 3.679,
    "close": 3.748,
    "priceDate": "2022-11-29T00:00:00-05:00",
    "ticks": 638052768000000000,
    "epochTime": 1669680000,
    "hasValue": true,
    "time": "2022-11-29"
  },
  {
    "open": 3.7329,
    "high": 3.7981,
    "low": 3.5999,
    "close": 3.6017,
    "priceDate": "2022-11-30T00:00:00-05:00",
    "ticks": 638053632000000000,
    "epochTime": 1669766400,
    "hasValue": true,
    "time": "2022-11-30"
  },
  {
    "open": 3.5943,
    "high": 3.631,
    "low": 3.5048,
    "close": 3.5084,
    "priceDate": "2022-12-01T00:00:00-05:00",
    "ticks": 638054496000000000,
    "epochTime": 1669852800,
    "hasValue": true,
    "time": "2022-12-01"
  },
  {
    "open": 3.512,
    "high": 3.638,
    "low": 3.473,
    "close": 3.492,
    "priceDate": "2022-12-02T00:00:00-05:00",
    "ticks": 638055360000000000,
    "epochTime": 1669939200,
    "hasValue": true,
    "time": "2022-12-02"
  },
  {
    "open": 3.5279,
    "high": 3.6121,
    "low": 3.513,
    "close": 3.5791,
    "priceDate": "2022-12-05T00:00:00-05:00",
    "ticks": 638057952000000000,
    "epochTime": 1670198400,
    "hasValue": true,
    "time": "2022-12-05"
  },
  {
    "open": 3.5661,
    "high": 3.5845,
    "low": 3.5077,
    "close": 3.5296,
    "priceDate": "2022-12-06T00:00:00-05:00",
    "ticks": 638058816000000000,
    "epochTime": 1670284800,
    "hasValue": true,
    "time": "2022-12-06"
  },
  {
    "open": 3.5568,
    "high": 3.5587,
    "low": 3.4024,
    "close": 3.4223,
    "priceDate": "2022-12-07T00:00:00-05:00",
    "ticks": 638059680000000000,
    "epochTime": 1670371200,
    "hasValue": true,
    "time": "2022-12-07"
  },
  {
    "open": 3.462,
    "high": 3.506,
    "low": 3.447,
    "close": 3.4837,
    "priceDate": "2022-12-08T00:00:00-05:00",
    "ticks": 638060544000000000,
    "epochTime": 1670457600,
    "hasValue": true,
    "time": "2022-12-08"
  },
  {
    "open": 3.4724,
    "high": 3.595,
    "low": 3.463,
    "close": 3.5893,
    "priceDate": "2022-12-09T00:00:00-05:00",
    "ticks": 638061408000000000,
    "epochTime": 1670544000,
    "hasValue": true,
    "time": "2022-12-09"
  },
  {
    "open": 3.54,
    "high": 3.6316,
    "low": 3.5214,
    "close": 3.6131,
    "priceDate": "2022-12-12T00:00:00-05:00",
    "ticks": 638064000000000000,
    "epochTime": 1670803200,
    "hasValue": true,
    "time": "2022-12-12"
  },
  {
    "open": 3.5854,
    "high": 3.63,
    "low": 3.421,
    "close": 3.5085,
    "priceDate": "2022-12-13T00:00:00-05:00",
    "ticks": 638064864000000000,
    "epochTime": 1670889600,
    "hasValue": true,
    "time": "2022-12-13"
  },
  {
    "open": 3.5047,
    "high": 3.5614,
    "low": 3.461,
    "close": 3.481,
    "priceDate": "2022-12-14T00:00:00-05:00",
    "ticks": 638065728000000000,
    "epochTime": 1670976000,
    "hasValue": true,
    "time": "2022-12-14"
  },
  {
    "open": 3.4827,
    "high": 3.523,
    "low": 3.428,
    "close": 3.4518,
    "priceDate": "2022-12-15T00:00:00-05:00",
    "ticks": 638066592000000000,
    "epochTime": 1671062400,
    "hasValue": true,
    "time": "2022-12-15"
  },
  {
    "open": 3.4968,
    "high": 3.5572,
    "low": 3.462,
    "close": 3.4913,
    "priceDate": "2022-12-16T00:00:00-05:00",
    "ticks": 638067456000000000,
    "epochTime": 1671148800,
    "hasValue": true,
    "time": "2022-12-16"
  },
  {
    "open": 3.5534,
    "high": 3.6012,
    "low": 3.5497,
    "close": 3.592,
    "priceDate": "2022-12-19T00:00:00-05:00",
    "ticks": 638070048000000000,
    "epochTime": 1671408000,
    "hasValue": true,
    "time": "2022-12-19"
  },
  {
    "open": 3.6584,
    "high": 3.703,
    "low": 3.6528,
    "close": 3.6881,
    "priceDate": "2022-12-20T00:00:00-05:00",
    "ticks": 638070912000000000,
    "epochTime": 1671494400,
    "hasValue": true,
    "time": "2022-12-20"
  },
  {
    "open": 3.6545,
    "high": 3.6973,
    "low": 3.621,
    "close": 3.6638,
    "priceDate": "2022-12-21T00:00:00-05:00",
    "ticks": 638071776000000000,
    "epochTime": 1671580800,
    "hasValue": true,
    "time": "2022-12-21"
  },
  {
    "open": 3.6581,
    "high": 3.688,
    "low": 3.6452,
    "close": 3.6804,
    "priceDate": "2022-12-22T00:00:00-05:00",
    "ticks": 638072640000000000,
    "epochTime": 1671667200,
    "hasValue": true,
    "time": "2022-12-22"
  },
  {
    "open": 3.7023,
    "high": 3.753,
    "low": 3.6949,
    "close": 3.7509,
    "priceDate": "2022-12-23T00:00:00-05:00",
    "ticks": 638073504000000000,
    "epochTime": 1671753600,
    "hasValue": true,
    "time": "2022-12-23"
  },
  {
    "open": 3.7883,
    "high": 3.862,
    "low": 3.7865,
    "close": 3.8468,
    "priceDate": "2022-12-27T00:00:00-05:00",
    "ticks": 638076960000000000,
    "epochTime": 1672099200,
    "hasValue": true,
    "time": "2022-12-27"
  },
  {
    "open": 3.8071,
    "high": 3.8922,
    "low": 3.807,
    "close": 3.8846,
    "priceDate": "2022-12-28T00:00:00-05:00",
    "ticks": 638077824000000000,
    "epochTime": 1672185600,
    "hasValue": true,
    "time": "2022-12-28"
  },
  {
    "open": 3.875,
    "high": 3.8864,
    "low": 3.816,
    "close": 3.8183,
    "priceDate": "2022-12-29T00:00:00-05:00",
    "ticks": 638078688000000000,
    "epochTime": 1672272000,
    "hasValue": true,
    "time": "2022-12-29"
  },
  {
    "open": 3.8615,
    "high": 3.9052,
    "low": 3.829,
    "close": 3.8786,
    "priceDate": "2022-12-30T00:00:00-05:00",
    "ticks": 638079552000000000,
    "epochTime": 1672358400,
    "hasValue": true,
    "time": "2022-12-30"
  },
  {
    "open": 3.7558,
    "high": 3.8123,
    "low": 3.7239,
    "close": 3.7427,
    "priceDate": "2023-01-03T00:00:00-05:00",
    "ticks": 638083008000000000,
    "epochTime": 1672704000,
    "hasValue": true,
    "time": "2023-01-03"
  },
  {
    "open": 3.6827,
    "high": 3.728,
    "low": 3.6641,
    "close": 3.6921,
    "priceDate": "2023-01-04T00:00:00-05:00",
    "ticks": 638083872000000000,
    "epochTime": 1672790400,
    "hasValue": true,
    "time": "2023-01-04"
  },
  {
    "open": 3.7088,
    "high": 3.7838,
    "low": 3.6976,
    "close": 3.7219,
    "priceDate": "2023-01-05T00:00:00-05:00",
    "ticks": 638084736000000000,
    "epochTime": 1672876800,
    "hasValue": true,
    "time": "2023-01-05"
  },
  {
    "open": 3.7422,
    "high": 3.7554,
    "low": 3.5506,
    "close": 3.5636,
    "priceDate": "2023-01-06T00:00:00-05:00",
    "ticks": 638085600000000000,
    "epochTime": 1672963200,
    "hasValue": true,
    "time": "2023-01-06"
  },
  {
    "open": 3.6004,
    "high": 3.6004,
    "low": 3.508,
    "close": 3.528,
    "priceDate": "2023-01-09T00:00:00-05:00",
    "ticks": 638088192000000000,
    "epochTime": 1673222400,
    "hasValue": true,
    "time": "2023-01-09"
  },
  {
    "open": 3.5688,
    "high": 3.6392,
    "low": 3.567,
    "close": 3.6225,
    "priceDate": "2023-01-10T00:00:00-05:00",
    "ticks": 638089056000000000,
    "epochTime": 1673308800,
    "hasValue": true,
    "time": "2023-01-10"
  },
  {
    "open": 3.5779,
    "high": 3.5946,
    "low": 3.528,
    "close": 3.541,
    "priceDate": "2023-01-11T00:00:00-05:00",
    "ticks": 638089920000000000,
    "epochTime": 1673395200,
    "hasValue": true,
    "time": "2023-01-11"
  },
  {
    "open": 3.5114,
    "high": 3.5908,
    "low": 3.4236,
    "close": 3.467,
    "priceDate": "2023-01-12T00:00:00-05:00",
    "ticks": 638090784000000000,
    "epochTime": 1673481600,
    "hasValue": true,
    "time": "2023-01-12"
  },
  {
    "open": 3.4906,
    "high": 3.515,
    "low": 3.4302,
    "close": 3.5035,
    "priceDate": "2023-01-13T00:00:00-05:00",
    "ticks": 638091648000000000,
    "epochTime": 1673568000,
    "hasValue": true,
    "time": "2023-01-13"
  },
  {
    "open": 3.5735,
    "high": 3.585,
    "low": 3.496,
    "close": 3.555,
    "priceDate": "2023-01-17T00:00:00-05:00",
    "ticks": 638095104000000000,
    "epochTime": 1673913600,
    "hasValue": true,
    "time": "2023-01-17"
  },
  {
    "open": 3.4702,
    "high": 3.4702,
    "low": 3.368,
    "close": 3.3753,
    "priceDate": "2023-01-18T00:00:00-05:00",
    "ticks": 638095968000000000,
    "epochTime": 1674000000,
    "hasValue": true,
    "time": "2023-01-18"
  },
  {
    "open": 3.4024,
    "high": 3.428,
    "low": 3.3696,
    "close": 3.3933,
    "priceDate": "2023-01-19T00:00:00-05:00",
    "ticks": 638096832000000000,
    "epochTime": 1674086400,
    "hasValue": true,
    "time": "2023-01-19"
  },
  {
    "open": 3.4329,
    "high": 3.5008,
    "low": 3.4311,
    "close": 3.4806,
    "priceDate": "2023-01-20T00:00:00-05:00",
    "ticks": 638097696000000000,
    "epochTime": 1674172800,
    "hasValue": true,
    "time": "2023-01-20"
  },
  {
    "open": 3.5062,
    "high": 3.5486,
    "low": 3.4914,
    "close": 3.5172,
    "priceDate": "2023-01-23T00:00:00-05:00",
    "ticks": 638100288000000000,
    "epochTime": 1674432000,
    "hasValue": true,
    "time": "2023-01-23"
  },
  {
    "open": 3.5115,
    "high": 3.5559,
    "low": 3.4527,
    "close": 3.4527,
    "priceDate": "2023-01-24T00:00:00-05:00",
    "ticks": 638101152000000000,
    "epochTime": 1674518400,
    "hasValue": true,
    "time": "2023-01-24"
  },
  {
    "open": 3.4269,
    "high": 3.4893,
    "low": 3.4196,
    "close": 3.4452,
    "priceDate": "2023-01-25T00:00:00-05:00",
    "ticks": 638102016000000000,
    "epochTime": 1674604800,
    "hasValue": true,
    "time": "2023-01-25"
  },
  {
    "open": 3.4892,
    "high": 3.5205,
    "low": 3.4524,
    "close": 3.502,
    "priceDate": "2023-01-26T00:00:00-05:00",
    "ticks": 638102880000000000,
    "epochTime": 1674691200,
    "hasValue": true,
    "time": "2023-01-26"
  },
  {
    "open": 3.548,
    "high": 3.5515,
    "low": 3.505,
    "close": 3.509,
    "priceDate": "2023-01-27T00:00:00-05:00",
    "ticks": 638103744000000000,
    "epochTime": 1674777600,
    "hasValue": true,
    "time": "2023-01-27"
  },
  {
    "open": 3.5514,
    "high": 3.574,
    "low": 3.5218,
    "close": 3.5403,
    "priceDate": "2023-01-30T00:00:00-05:00",
    "ticks": 638106336000000000,
    "epochTime": 1675036800,
    "hasValue": true,
    "time": "2023-01-30"
  },
  {
    "open": 3.5216,
    "high": 3.5531,
    "low": 3.4866,
    "close": 3.5105,
    "priceDate": "2023-01-31T00:00:00-05:00",
    "ticks": 638107200000000000,
    "epochTime": 1675123200,
    "hasValue": true,
    "time": "2023-01-31"
  },
  {
    "open": 3.4864,
    "high": 3.5104,
    "low": 3.387,
    "close": 3.4221,
    "priceDate": "2023-02-01T00:00:00-05:00",
    "ticks": 638108064000000000,
    "epochTime": 1675209600,
    "hasValue": true,
    "time": "2023-02-01"
  },
  {
    "open": 3.3909,
    "high": 3.4092,
    "low": 3.3326,
    "close": 3.4,
    "priceDate": "2023-02-02T00:00:00-05:00",
    "ticks": 638108928000000000,
    "epochTime": 1675296000,
    "hasValue": true,
    "time": "2023-02-02"
  },
  {
    "open": 3.3885,
    "high": 3.5561,
    "low": 3.379,
    "close": 3.5283,
    "priceDate": "2023-02-03T00:00:00-05:00",
    "ticks": 638109792000000000,
    "epochTime": 1675382400,
    "hasValue": true,
    "time": "2023-02-03"
  },
  {
    "open": 3.6025,
    "high": 3.655,
    "low": 3.5988,
    "close": 3.6436,
    "priceDate": "2023-02-06T00:00:00-05:00",
    "ticks": 638112384000000000,
    "epochTime": 1675641600,
    "hasValue": true,
    "time": "2023-02-06"
  },
  {
    "open": 3.6398,
    "high": 3.6904,
    "low": 3.5968,
    "close": 3.6773,
    "priceDate": "2023-02-07T00:00:00-05:00",
    "ticks": 638113248000000000,
    "epochTime": 1675728000,
    "hasValue": true,
    "time": "2023-02-07"
  },
  {
    "open": 3.6528,
    "high": 3.6922,
    "low": 3.6116,
    "close": 3.6116,
    "priceDate": "2023-02-08T00:00:00-05:00",
    "ticks": 638114112000000000,
    "epochTime": 1675814400,
    "hasValue": true,
    "time": "2023-02-08"
  },
  {
    "open": 3.5881,
    "high": 3.6901,
    "low": 3.5749,
    "close": 3.6617,
    "priceDate": "2023-02-09T00:00:00-05:00",
    "ticks": 638114976000000000,
    "epochTime": 1675900800,
    "hasValue": true,
    "time": "2023-02-09"
  },
  {
    "open": 3.7016,
    "high": 3.7511,
    "low": 3.673,
    "close": 3.7416,
    "priceDate": "2023-02-10T00:00:00-05:00",
    "ticks": 638115840000000000,
    "epochTime": 1675987200,
    "hasValue": true,
    "time": "2023-02-10"
  },
  {
    "open": 3.7378,
    "high": 3.755,
    "low": 3.7016,
    "close": 3.7035,
    "priceDate": "2023-02-13T00:00:00-05:00",
    "ticks": 638118432000000000,
    "epochTime": 1676246400,
    "hasValue": true,
    "time": "2023-02-13"
  },
  {
    "open": 3.684,
    "high": 3.799,
    "low": 3.622,
    "close": 3.7492,
    "priceDate": "2023-02-14T00:00:00-05:00",
    "ticks": 638119296000000000,
    "epochTime": 1676332800,
    "hasValue": true,
    "time": "2023-02-14"
  },
  {
    "open": 3.7531,
    "high": 3.8222,
    "low": 3.749,
    "close": 3.8068,
    "priceDate": "2023-02-15T00:00:00-05:00",
    "ticks": 638120160000000000,
    "epochTime": 1676419200,
    "hasValue": true,
    "time": "2023-02-15"
  },
  {
    "open": 3.8011,
    "high": 3.8724,
    "low": 3.793,
    "close": 3.867,
    "priceDate": "2023-02-16T00:00:00-05:00",
    "ticks": 638121024000000000,
    "epochTime": 1676505600,
    "hasValue": true,
    "time": "2023-02-16"
  },
  {
    "open": 3.8882,
    "high": 3.9,
    "low": 3.8129,
    "close": 3.8225,
    "priceDate": "2023-02-17T00:00:00-05:00",
    "ticks": 638121888000000000,
    "epochTime": 1676592000,
    "hasValue": true,
    "time": "2023-02-17"
  },
  {
    "open": 3.8922,
    "high": 3.9623,
    "low": 3.8806,
    "close": 3.9584,
    "priceDate": "2023-02-21T00:00:00-05:00",
    "ticks": 638125344000000000,
    "epochTime": 1676937600,
    "hasValue": true,
    "time": "2023-02-21"
  },
  {
    "open": 3.939,
    "high": 3.951,
    "low": 3.8903,
    "close": 3.9195,
    "priceDate": "2023-02-22T00:00:00-05:00",
    "ticks": 638126208000000000,
    "epochTime": 1677024000,
    "hasValue": true,
    "time": "2023-02-22"
  },
  {
    "open": 3.9469,
    "high": 3.9781,
    "low": 3.8633,
    "close": 3.8807,
    "priceDate": "2023-02-23T00:00:00-05:00",
    "ticks": 638127072000000000,
    "epochTime": 1677110400,
    "hasValue": true,
    "time": "2023-02-23"
  },
  {
    "open": 3.914,
    "high": 3.9784,
    "low": 3.908,
    "close": 3.9471,
    "priceDate": "2023-02-24T00:00:00-05:00",
    "ticks": 638127936000000000,
    "epochTime": 1677196800,
    "hasValue": true,
    "time": "2023-02-24"
  },
  {
    "open": 3.9688,
    "high": 3.9766,
    "low": 3.8966,
    "close": 3.916,
    "priceDate": "2023-02-27T00:00:00-05:00",
    "ticks": 638130528000000000,
    "epochTime": 1677456000,
    "hasValue": true,
    "time": "2023-02-27"
  },
  {
    "open": 3.9317,
    "high": 3.983,
    "low": 3.8986,
    "close": 3.9239,
    "priceDate": "2023-02-28T00:00:00-05:00",
    "ticks": 638131392000000000,
    "epochTime": 1677542400,
    "hasValue": true,
    "time": "2023-02-28"
  },
  {
    "open": 3.932,
    "high": 4.0102,
    "low": 3.9299,
    "close": 3.9964,
    "priceDate": "2023-03-01T00:00:00-05:00",
    "ticks": 638132256000000000,
    "epochTime": 1677628800,
    "hasValue": true,
    "time": "2023-03-01"
  },
  {
    "open": 4.0379,
    "high": 4.0913,
    "low": 4.0379,
    "close": 4.0576,
    "priceDate": "2023-03-02T00:00:00-05:00",
    "ticks": 638133120000000000,
    "epochTime": 1677715200,
    "hasValue": true,
    "time": "2023-03-02"
  },
  {
    "open": 4.0224,
    "high": 4.0264,
    "low": 3.9537,
    "close": 3.9556,
    "priceDate": "2023-03-03T00:00:00-05:00",
    "ticks": 638133984000000000,
    "epochTime": 1677801600,
    "hasValue": true,
    "time": "2023-03-03"
  },
  {
    "open": 3.9108,
    "high": 3.9891,
    "low": 3.897,
    "close": 3.964,
    "priceDate": "2023-03-06T00:00:00-05:00",
    "ticks": 638136576000000000,
    "epochTime": 1678060800,
    "hasValue": true,
    "time": "2023-03-06"
  },
  {
    "open": 3.9402,
    "high": 4.0069,
    "low": 3.9187,
    "close": 3.9676,
    "priceDate": "2023-03-07T00:00:00-05:00",
    "ticks": 638137440000000000,
    "epochTime": 1678147200,
    "hasValue": true,
    "time": "2023-03-07"
  },
  {
    "open": 3.952,
    "high": 3.9991,
    "low": 3.899,
    "close": 3.9972,
    "priceDate": "2023-03-08T00:00:00-05:00",
    "ticks": 638138304000000000,
    "epochTime": 1678233600,
    "hasValue": true,
    "time": "2023-03-08"
  },
  {
    "open": 4.005,
    "high": 4.019,
    "low": 3.8935,
    "close": 3.9071,
    "priceDate": "2023-03-09T00:00:00-05:00",
    "ticks": 638139168000000000,
    "epochTime": 1678320000,
    "hasValue": true,
    "time": "2023-03-09"
  },
  {
    "open": 3.8238,
    "high": 3.8335,
    "low": 3.6739,
    "close": 3.697,
    "priceDate": "2023-03-10T00:00:00-05:00",
    "ticks": 638140032000000000,
    "epochTime": 1678406400,
    "hasValue": true,
    "time": "2023-03-10"
  },
  {
    "open": 3.5073,
    "high": 3.594,
    "low": 3.4175,
    "close": 3.571,
    "priceDate": "2023-03-13T00:00:00-04:00",
    "ticks": 638142624000000000,
    "epochTime": 1678665600,
    "hasValue": true,
    "time": "2023-03-13"
  },
  {
    "open": 3.5941,
    "high": 3.6988,
    "low": 3.5543,
    "close": 3.6988,
    "priceDate": "2023-03-14T00:00:00-04:00",
    "ticks": 638143488000000000,
    "epochTime": 1678752000,
    "hasValue": true,
    "time": "2023-03-14"
  },
  {
    "open": 3.5185,
    "high": 3.5355,
    "low": 3.3877,
    "close": 3.46,
    "priceDate": "2023-03-15T00:00:00-04:00",
    "ticks": 638144352000000000,
    "epochTime": 1678838400,
    "hasValue": true,
    "time": "2023-03-15"
  },
  {
    "open": 3.4398,
    "high": 3.587,
    "low": 3.369,
    "close": 3.5846,
    "priceDate": "2023-03-16T00:00:00-04:00",
    "ticks": 638145216000000000,
    "epochTime": 1678924800,
    "hasValue": true,
    "time": "2023-03-16"
  },
  {
    "open": 3.5035,
    "high": 3.5035,
    "low": 3.382,
    "close": 3.4398,
    "priceDate": "2023-03-17T00:00:00-04:00",
    "ticks": 638146080000000000,
    "epochTime": 1679011200,
    "hasValue": true,
    "time": "2023-03-17"
  },
  {
    "open": 3.4006,
    "high": 3.5072,
    "low": 3.393,
    "close": 3.4903,
    "priceDate": "2023-03-20T00:00:00-04:00",
    "ticks": 638148672000000000,
    "epochTime": 1679270400,
    "hasValue": true,
    "time": "2023-03-20"
  },
  {
    "open": 3.5638,
    "high": 3.621,
    "low": 3.537,
    "close": 3.621,
    "priceDate": "2023-03-21T00:00:00-04:00",
    "ticks": 638149536000000000,
    "epochTime": 1679356800,
    "hasValue": true,
    "time": "2023-03-21"
  },
  {
    "open": 3.6322,
    "high": 3.644,
    "low": 3.4304,
    "close": 3.4434,
    "priceDate": "2023-03-22T00:00:00-04:00",
    "ticks": 638150400000000000,
    "epochTime": 1679443200,
    "hasValue": true,
    "time": "2023-03-22"
  },
  {
    "open": 3.4809,
    "high": 3.5204,
    "low": 3.3744,
    "close": 3.425,
    "priceDate": "2023-03-23T00:00:00-04:00",
    "ticks": 638151264000000000,
    "epochTime": 1679529600,
    "hasValue": true,
    "time": "2023-03-23"
  },
  {
    "open": 3.291,
    "high": 3.3967,
    "low": 3.2891,
    "close": 3.3799,
    "priceDate": "2023-03-24T00:00:00-04:00",
    "ticks": 638152128000000000,
    "epochTime": 1679616000,
    "hasValue": true,
    "time": "2023-03-24"
  },
  {
    "open": 3.468,
    "high": 3.545,
    "low": 3.464,
    "close": 3.5336,
    "priceDate": "2023-03-27T00:00:00-04:00",
    "ticks": 638154720000000000,
    "epochTime": 1679875200,
    "hasValue": true,
    "time": "2023-03-27"
  },
  {
    "open": 3.5544,
    "high": 3.583,
    "low": 3.5223,
    "close": 3.5734,
    "priceDate": "2023-03-28T00:00:00-04:00",
    "ticks": 638155584000000000,
    "epochTime": 1679961600,
    "hasValue": true,
    "time": "2023-03-28"
  },
  {
    "open": 3.5601,
    "high": 3.6114,
    "low": 3.545,
    "close": 3.5696,
    "priceDate": "2023-03-29T00:00:00-04:00",
    "ticks": 638156448000000000,
    "epochTime": 1680048000,
    "hasValue": true,
    "time": "2023-03-29"
  },
  {
    "open": 3.56,
    "high": 3.5962,
    "low": 3.539,
    "close": 3.5526,
    "priceDate": "2023-03-30T00:00:00-04:00",
    "ticks": 638157312000000000,
    "epochTime": 1680134400,
    "hasValue": true,
    "time": "2023-03-30"
  },
  {
    "open": 3.556,
    "high": 3.5621,
    "low": 3.4695,
    "close": 3.4695,
    "priceDate": "2023-03-31T00:00:00-04:00",
    "ticks": 638158176000000000,
    "epochTime": 1680220800,
    "hasValue": true,
    "time": "2023-03-31"
  },
  {
    "open": 3.5147,
    "high": 3.5242,
    "low": 3.4002,
    "close": 3.413,
    "priceDate": "2023-04-03T00:00:00-04:00",
    "ticks": 638160768000000000,
    "epochTime": 1680480000,
    "hasValue": true,
    "time": "2023-04-03"
  },
  {
    "open": 3.4639,
    "high": 3.485,
    "low": 3.3349,
    "close": 3.3424,
    "priceDate": "2023-04-04T00:00:00-04:00",
    "ticks": 638161632000000000,
    "epochTime": 1680566400,
    "hasValue": true,
    "time": "2023-04-04"
  },
  {
    "open": 3.3405,
    "high": 3.3405,
    "low": 3.2664,
    "close": 3.3108,
    "priceDate": "2023-04-05T00:00:00-04:00",
    "ticks": 638162496000000000,
    "epochTime": 1680652800,
    "hasValue": true,
    "time": "2023-04-05"
  },
  {
    "open": 3.2773,
    "high": 3.3087,
    "low": 3.253,
    "close": 3.3087,
    "priceDate": "2023-04-06T00:00:00-04:00",
    "ticks": 638163360000000000,
    "epochTime": 1680739200,
    "hasValue": true,
    "time": "2023-04-06"
  },
  {
    "open": 3.3087,
    "high": 3.415,
    "low": 3.3087,
    "close": 3.413,
    "priceDate": "2023-04-07T00:00:00-04:00",
    "ticks": 638164224000000000,
    "epochTime": 1680825600,
    "hasValue": true,
    "time": "2023-04-07"
  },
  {
    "open": 3.3719,
    "high": 3.436,
    "low": 3.3496,
    "close": 3.4224,
    "priceDate": "2023-04-10T00:00:00-04:00",
    "ticks": 638166816000000000,
    "epochTime": 1681084800,
    "hasValue": true,
    "time": "2023-04-10"
  },
  {
    "open": 3.4168,
    "high": 3.4562,
    "low": 3.3906,
    "close": 3.4299,
    "priceDate": "2023-04-11T00:00:00-04:00",
    "ticks": 638167680000000000,
    "epochTime": 1681171200,
    "hasValue": true,
    "time": "2023-04-11"
  },
  {
    "open": 3.4525,
    "high": 3.462,
    "low": 3.34,
    "close": 3.3943,
    "priceDate": "2023-04-12T00:00:00-04:00",
    "ticks": 638168544000000000,
    "epochTime": 1681257600,
    "hasValue": true,
    "time": "2023-04-12"
  },
  {
    "open": 3.432,
    "high": 3.46,
    "low": 3.3718,
    "close": 3.4524,
    "priceDate": "2023-04-13T00:00:00-04:00",
    "ticks": 638169408000000000,
    "epochTime": 1681344000,
    "hasValue": true,
    "time": "2023-04-13"
  },
  {
    "open": 3.4599,
    "high": 3.5375,
    "low": 3.443,
    "close": 3.52,
    "priceDate": "2023-04-14T00:00:00-04:00",
    "ticks": 638170272000000000,
    "epochTime": 1681430400,
    "hasValue": true,
    "time": "2023-04-14"
  },
  {
    "open": 3.5451,
    "high": 3.608,
    "low": 3.5375,
    "close": 3.6042,
    "priceDate": "2023-04-17T00:00:00-04:00",
    "ticks": 638172864000000000,
    "epochTime": 1681689600,
    "hasValue": true,
    "time": "2023-04-17"
  },
  {
    "open": 3.5698,
    "high": 3.6023,
    "low": 3.5489,
    "close": 3.5794,
    "priceDate": "2023-04-18T00:00:00-04:00",
    "ticks": 638173728000000000,
    "epochTime": 1681776000,
    "hasValue": true,
    "time": "2023-04-18"
  },
  {
    "open": 3.6215,
    "high": 3.6387,
    "low": 3.587,
    "close": 3.5947,
    "priceDate": "2023-04-19T00:00:00-04:00",
    "ticks": 638174592000000000,
    "epochTime": 1681862400,
    "hasValue": true,
    "time": "2023-04-19"
  },
  {
    "open": 3.5699,
    "high": 3.5794,
    "low": 3.526,
    "close": 3.5394,
    "priceDate": "2023-04-20T00:00:00-04:00",
    "ticks": 638175456000000000,
    "epochTime": 1681948800,
    "hasValue": true,
    "time": "2023-04-20"
  },
  {
    "open": 3.5318,
    "high": 3.5795,
    "low": 3.501,
    "close": 3.5775,
    "priceDate": "2023-04-21T00:00:00-04:00",
    "ticks": 638176320000000000,
    "epochTime": 1682035200,
    "hasValue": true,
    "time": "2023-04-21"
  },
  {
    "open": 3.5413,
    "high": 3.5471,
    "low": 3.492,
    "close": 3.4958,
    "priceDate": "2023-04-24T00:00:00-04:00",
    "ticks": 638178912000000000,
    "epochTime": 1682294400,
    "hasValue": true,
    "time": "2023-04-24"
  },
  {
    "open": 3.45,
    "high": 3.4504,
    "low": 3.3789,
    "close": 3.4052,
    "priceDate": "2023-04-25T00:00:00-04:00",
    "ticks": 638179776000000000,
    "epochTime": 1682380800,
    "hasValue": true,
    "time": "2023-04-25"
  },
  {
    "open": 3.4146,
    "high": 3.4579,
    "low": 3.375,
    "close": 3.4504,
    "priceDate": "2023-04-26T00:00:00-04:00",
    "ticks": 638180640000000000,
    "epochTime": 1682467200,
    "hasValue": true,
    "time": "2023-04-26"
  },
  {
    "open": 3.454,
    "high": 3.538,
    "low": 3.4466,
    "close": 3.5204,
    "priceDate": "2023-04-27T00:00:00-04:00",
    "ticks": 638181504000000000,
    "epochTime": 1682553600,
    "hasValue": true,
    "time": "2023-04-27"
  },
  {
    "open": 3.4806,
    "high": 3.496,
    "low": 3.422,
    "close": 3.4277,
    "priceDate": "2023-04-28T00:00:00-04:00",
    "ticks": 638182368000000000,
    "epochTime": 1682640000,
    "hasValue": true,
    "time": "2023-04-28"
  },
  {
    "open": 3.4806,
    "high": 3.6083,
    "low": 3.4616,
    "close": 3.57,
    "priceDate": "2023-05-01T00:00:00-04:00",
    "ticks": 638184960000000000,
    "epochTime": 1682899200,
    "hasValue": true,
    "time": "2023-05-01"
  },
  {
    "open": 3.5376,
    "high": 3.559,
    "low": 3.4239,
    "close": 3.43,
    "priceDate": "2023-05-02T00:00:00-04:00",
    "ticks": 638185824000000000,
    "epochTime": 1682985600,
    "hasValue": true,
    "time": "2023-05-02"
  },
  {
    "open": 3.4031,
    "high": 3.424,
    "low": 3.3393,
    "close": 3.3393,
    "priceDate": "2023-05-03T00:00:00-04:00",
    "ticks": 638186688000000000,
    "epochTime": 1683072000,
    "hasValue": true,
    "time": "2023-05-03"
  },
  {
    "open": 3.358,
    "high": 3.411,
    "low": 3.2964,
    "close": 3.3862,
    "priceDate": "2023-05-04T00:00:00-04:00",
    "ticks": 638187552000000000,
    "epochTime": 1683158400,
    "hasValue": true,
    "time": "2023-05-04"
  },
  {
    "open": 3.4049,
    "high": 3.4654,
    "low": 3.395,
    "close": 3.4427,
    "priceDate": "2023-05-05T00:00:00-04:00",
    "ticks": 638188416000000000,
    "epochTime": 1683244800,
    "hasValue": true,
    "time": "2023-05-05"
  },
  {
    "open": 3.4881,
    "high": 3.5205,
    "low": 3.488,
    "close": 3.5091,
    "priceDate": "2023-05-08T00:00:00-04:00",
    "ticks": 638191008000000000,
    "epochTime": 1683504000,
    "hasValue": true,
    "time": "2023-05-08"
  },
  {
    "open": 3.4881,
    "high": 3.532,
    "low": 3.484,
    "close": 3.5243,
    "priceDate": "2023-05-09T00:00:00-04:00",
    "ticks": 638191872000000000,
    "epochTime": 1683590400,
    "hasValue": true,
    "time": "2023-05-09"
  },
  {
    "open": 3.5091,
    "high": 3.5224,
    "low": 3.435,
    "close": 3.446,
    "priceDate": "2023-05-10T00:00:00-04:00",
    "ticks": 638192736000000000,
    "epochTime": 1683676800,
    "hasValue": true,
    "time": "2023-05-10"
  },
  {
    "open": 3.39,
    "high": 3.416,
    "low": 3.349,
    "close": 3.388,
    "priceDate": "2023-05-11T00:00:00-04:00",
    "ticks": 638193600000000000,
    "epochTime": 1683763200,
    "hasValue": true,
    "time": "2023-05-11"
  },
  {
    "open": 3.42,
    "high": 3.47,
    "low": 3.384,
    "close": 3.468,
    "priceDate": "2023-05-12T00:00:00-04:00",
    "ticks": 638194464000000000,
    "epochTime": 1683849600,
    "hasValue": true,
    "time": "2023-05-12"
  },
  {
    "open": 3.502,
    "high": 3.511,
    "low": 3.468,
    "close": 3.506,
    "priceDate": "2023-05-15T00:00:00-04:00",
    "ticks": 638197056000000000,
    "epochTime": 1684108800,
    "hasValue": true,
    "time": "2023-05-15"
  },
  {
    "open": 3.489,
    "high": 3.574,
    "low": 3.485,
    "close": 3.54,
    "priceDate": "2023-05-16T00:00:00-04:00",
    "ticks": 638197920000000000,
    "epochTime": 1684195200,
    "hasValue": true,
    "time": "2023-05-16"
  },
  {
    "open": 3.521,
    "high": 3.589,
    "low": 3.517,
    "close": 3.57,
    "priceDate": "2023-05-17T00:00:00-04:00",
    "ticks": 638198784000000000,
    "epochTime": 1684281600,
    "hasValue": true,
    "time": "2023-05-17"
  },
  {
    "open": 3.6,
    "high": 3.657,
    "low": 3.596,
    "close": 3.651,
    "priceDate": "2023-05-18T00:00:00-04:00",
    "ticks": 638199648000000000,
    "epochTime": 1684368000,
    "hasValue": true,
    "time": "2023-05-18"
  },
  {
    "open": 3.663,
    "high": 3.719,
    "low": 3.64,
    "close": 3.675,
    "priceDate": "2023-05-19T00:00:00-04:00",
    "ticks": 638200512000000000,
    "epochTime": 1684454400,
    "hasValue": true,
    "time": "2023-05-19"
  },
  {
    "open": 3.688,
    "high": 3.728,
    "low": 3.669,
    "close": 3.721,
    "priceDate": "2023-05-22T00:00:00-04:00",
    "ticks": 638203104000000000,
    "epochTime": 1684713600,
    "hasValue": true,
    "time": "2023-05-22"
  },
  {
    "open": 3.744,
    "high": 3.761,
    "low": 3.685,
    "close": 3.696,
    "priceDate": "2023-05-23T00:00:00-04:00",
    "ticks": 638203968000000000,
    "epochTime": 1684800000,
    "hasValue": true,
    "time": "2023-05-23"
  },
  {
    "open": 3.673,
    "high": 3.748,
    "low": 3.669,
    "close": 3.746,
    "priceDate": "2023-05-24T00:00:00-04:00",
    "ticks": 638204832000000000,
    "epochTime": 1684886400,
    "hasValue": true,
    "time": "2023-05-24"
  },
  {
    "open": 3.746,
    "high": 3.827,
    "low": 3.73,
    "close": 3.825,
    "priceDate": "2023-05-25T00:00:00-04:00",
    "ticks": 638205696000000000,
    "epochTime": 1684972800,
    "hasValue": true,
    "time": "2023-05-25"
  },
  {
    "open": 3.789,
    "high": 3.859,
    "low": 3.777,
    "close": 3.81,
    "priceDate": "2023-05-26T00:00:00-04:00",
    "ticks": 638206560000000000,
    "epochTime": 1685059200,
    "hasValue": true,
    "time": "2023-05-26"
  },
  {
    "open": 3.713,
    "high": 3.754,
    "low": 3.681,
    "close": 3.688,
    "priceDate": "2023-05-30T00:00:00-04:00",
    "ticks": 638210016000000000,
    "epochTime": 1685404800,
    "hasValue": true,
    "time": "2023-05-30"
  },
  {
    "open": 3.646,
    "high": 3.689,
    "low": 3.614,
    "close": 3.646,
    "priceDate": "2023-05-31T00:00:00-04:00",
    "ticks": 638210880000000000,
    "epochTime": 1685491200,
    "hasValue": true,
    "time": "2023-05-31"
  },
  {
    "open": 3.643,
    "high": 3.662,
    "low": 3.57,
    "close": 3.599,
    "priceDate": "2023-06-01T00:00:00-04:00",
    "ticks": 638211744000000000,
    "epochTime": 1685577600,
    "hasValue": true,
    "time": "2023-06-01"
  },
  {
    "open": 3.605,
    "high": 3.7,
    "low": 3.605,
    "close": 3.7,
    "priceDate": "2023-06-02T00:00:00-04:00",
    "ticks": 638212608000000000,
    "epochTime": 1685664000,
    "hasValue": true,
    "time": "2023-06-02"
  },
  {
    "open": 3.751,
    "high": 3.758,
    "low": 3.66,
    "close": 3.685,
    "priceDate": "2023-06-05T00:00:00-04:00",
    "ticks": 638215200000000000,
    "epochTime": 1685923200,
    "hasValue": true,
    "time": "2023-06-05"
  },
  {
    "open": 3.677,
    "high": 3.731,
    "low": 3.658,
    "close": 3.662,
    "priceDate": "2023-06-06T00:00:00-04:00",
    "ticks": 638216064000000000,
    "epochTime": 1686009600,
    "hasValue": true,
    "time": "2023-06-06"
  },
  {
    "open": 3.701,
    "high": 3.801,
    "low": 3.695,
    "close": 3.797,
    "priceDate": "2023-06-07T00:00:00-04:00",
    "ticks": 638216928000000000,
    "epochTime": 1686096000,
    "hasValue": true,
    "time": "2023-06-07"
  },
  {
    "open": 3.817,
    "high": 3.821,
    "low": 3.708,
    "close": 3.722,
    "priceDate": "2023-06-08T00:00:00-04:00",
    "ticks": 638217792000000000,
    "epochTime": 1686182400,
    "hasValue": true,
    "time": "2023-06-08"
  },
  {
    "open": 3.755,
    "high": 3.778,
    "low": 3.718,
    "close": 3.741,
    "priceDate": "2023-06-09T00:00:00-04:00",
    "ticks": 638218656000000000,
    "epochTime": 1686268800,
    "hasValue": true,
    "time": "2023-06-09"
  },
  {
    "open": 3.741,
    "high": 3.794,
    "low": 3.711,
    "close": 3.739,
    "priceDate": "2023-06-12T00:00:00-04:00",
    "ticks": 638221248000000000,
    "epochTime": 1686528000,
    "hasValue": true,
    "time": "2023-06-12"
  },
  {
    "open": 3.728,
    "high": 3.845,
    "low": 3.687,
    "close": 3.817,
    "priceDate": "2023-06-13T00:00:00-04:00",
    "ticks": 638222112000000000,
    "epochTime": 1686614400,
    "hasValue": true,
    "time": "2023-06-13"
  },
  {
    "open": 3.809,
    "high": 3.849,
    "low": 3.771,
    "close": 3.79,
    "priceDate": "2023-06-14T00:00:00-04:00",
    "ticks": 638222976000000000,
    "epochTime": 1686700800,
    "hasValue": true,
    "time": "2023-06-14"
  },
  {
    "open": 3.829,
    "high": 3.839,
    "low": 3.707,
    "close": 3.72,
    "priceDate": "2023-06-15T00:00:00-04:00",
    "ticks": 638223840000000000,
    "epochTime": 1686787200,
    "hasValue": true,
    "time": "2023-06-15"
  },
  {
    "open": 3.736,
    "high": 3.806,
    "low": 3.725,
    "close": 3.769,
    "priceDate": "2023-06-16T00:00:00-04:00",
    "ticks": 638224704000000000,
    "epochTime": 1686873600,
    "hasValue": true,
    "time": "2023-06-16"
  },
  {
    "open": 3.74,
    "high": 3.775,
    "low": 3.701,
    "close": 3.723,
    "priceDate": "2023-06-20T00:00:00-04:00",
    "ticks": 638228160000000000,
    "epochTime": 1687219200,
    "hasValue": true,
    "time": "2023-06-20"
  },
  {
    "open": 3.75,
    "high": 3.791,
    "low": 3.713,
    "close": 3.725,
    "priceDate": "2023-06-21T00:00:00-04:00",
    "ticks": 638229024000000000,
    "epochTime": 1687305600,
    "hasValue": true,
    "time": "2023-06-21"
  },
  {
    "open": 3.74,
    "high": 3.808,
    "low": 3.717,
    "close": 3.799,
    "priceDate": "2023-06-22T00:00:00-04:00",
    "ticks": 638229888000000000,
    "epochTime": 1687392000,
    "hasValue": true,
    "time": "2023-06-22"
  },
  {
    "open": 3.731,
    "high": 3.76,
    "low": 3.692,
    "close": 3.735,
    "priceDate": "2023-06-23T00:00:00-04:00",
    "ticks": 638230752000000000,
    "epochTime": 1687478400,
    "hasValue": true,
    "time": "2023-06-23"
  },
  {
    "open": 3.71,
    "high": 3.737,
    "low": 3.679,
    "close": 3.725,
    "priceDate": "2023-06-26T00:00:00-04:00",
    "ticks": 638233344000000000,
    "epochTime": 1687737600,
    "hasValue": true,
    "time": "2023-06-26"
  },
  {
    "open": 3.717,
    "high": 3.776,
    "low": 3.694,
    "close": 3.77,
    "priceDate": "2023-06-27T00:00:00-04:00",
    "ticks": 638234208000000000,
    "epochTime": 1687824000,
    "hasValue": true,
    "time": "2023-06-27"
  },
  {
    "open": 3.739,
    "high": 3.764,
    "low": 3.706,
    "close": 3.71,
    "priceDate": "2023-06-28T00:00:00-04:00",
    "ticks": 638235072000000000,
    "epochTime": 1687910400,
    "hasValue": true,
    "time": "2023-06-28"
  },
  {
    "open": 3.749,
    "high": 3.868,
    "low": 3.745,
    "close": 3.842,
    "priceDate": "2023-06-29T00:00:00-04:00",
    "ticks": 638235936000000000,
    "epochTime": 1687996800,
    "hasValue": true,
    "time": "2023-06-29"
  },
  {
    "open": 3.866,
    "high": 3.87,
    "low": 3.805,
    "close": 3.843,
    "priceDate": "2023-06-30T00:00:00-04:00",
    "ticks": 638236800000000000,
    "epochTime": 1688083200,
    "hasValue": true,
    "time": "2023-06-30"
  },
  {
    "open": 3.855,
    "high": 3.868,
    "low": 3.78,
    "close": 3.858,
    "priceDate": "2023-07-03T00:00:00-04:00",
    "ticks": 638239392000000000,
    "epochTime": 1688342400,
    "hasValue": true,
    "time": "2023-07-03"
  },
  {
    "open": 3.87,
    "high": 3.945,
    "low": 3.862,
    "close": 3.934,
    "priceDate": "2023-07-05T00:00:00-04:00",
    "ticks": 638241120000000000,
    "epochTime": 1688515200,
    "hasValue": true,
    "time": "2023-07-05"
  },
  {
    "open": 3.965,
    "high": 4.081,
    "low": 3.961,
    "close": 4.035,
    "priceDate": "2023-07-06T00:00:00-04:00",
    "ticks": 638241984000000000,
    "epochTime": 1688601600,
    "hasValue": true,
    "time": "2023-07-06"
  },
  {
    "open": 4.062,
    "high": 4.09,
    "low": 4.006,
    "close": 4.07,
    "priceDate": "2023-07-07T00:00:00-04:00",
    "ticks": 638242848000000000,
    "epochTime": 1688688000,
    "hasValue": true,
    "time": "2023-07-07"
  },
  {
    "open": 4.046,
    "high": 4.09,
    "low": 3.986,
    "close": 4,
    "priceDate": "2023-07-10T00:00:00-04:00",
    "ticks": 638245440000000000,
    "epochTime": 1688947200,
    "hasValue": true,
    "time": "2023-07-10"
  },
  {
    "open": 3.97,
    "high": 4.002,
    "low": 3.962,
    "close": 3.974,
    "priceDate": "2023-07-11T00:00:00-04:00",
    "ticks": 638246304000000000,
    "epochTime": 1689033600,
    "hasValue": true,
    "time": "2023-07-11"
  },
  {
    "open": 3.948,
    "high": 3.954,
    "low": 3.844,
    "close": 3.859,
    "priceDate": "2023-07-12T00:00:00-04:00",
    "ticks": 638247168000000000,
    "epochTime": 1689120000,
    "hasValue": true,
    "time": "2023-07-12"
  },
  {
    "open": 3.824,
    "high": 3.846,
    "low": 3.758,
    "close": 3.767,
    "priceDate": "2023-07-13T00:00:00-04:00",
    "ticks": 638248032000000000,
    "epochTime": 1689206400,
    "hasValue": true,
    "time": "2023-07-13"
  },
  {
    "open": 3.771,
    "high": 3.842,
    "low": 3.762,
    "close": 3.842,
    "priceDate": "2023-07-14T00:00:00-04:00",
    "ticks": 638248896000000000,
    "epochTime": 1689292800,
    "hasValue": true,
    "time": "2023-07-14"
  },
  {
    "open": 3.775,
    "high": 3.836,
    "low": 3.775,
    "close": 3.813,
    "priceDate": "2023-07-17T00:00:00-04:00",
    "ticks": 638251488000000000,
    "epochTime": 1689552000,
    "hasValue": true,
    "time": "2023-07-17"
  },
  {
    "open": 3.746,
    "high": 3.801,
    "low": 3.738,
    "close": 3.789,
    "priceDate": "2023-07-18T00:00:00-04:00",
    "ticks": 638252352000000000,
    "epochTime": 1689638400,
    "hasValue": true,
    "time": "2023-07-18"
  },
  {
    "open": 3.746,
    "high": 3.797,
    "low": 3.735,
    "close": 3.752,
    "priceDate": "2023-07-19T00:00:00-04:00",
    "ticks": 638253216000000000,
    "epochTime": 1689724800,
    "hasValue": true,
    "time": "2023-07-19"
  },
  {
    "open": 3.791,
    "high": 3.872,
    "low": 3.791,
    "close": 3.854,
    "priceDate": "2023-07-20T00:00:00-04:00",
    "ticks": 638254080000000000,
    "epochTime": 1689811200,
    "hasValue": true,
    "time": "2023-07-20"
  },
  {
    "open": 3.845,
    "high": 3.845,
    "low": 3.809,
    "close": 3.841,
    "priceDate": "2023-07-21T00:00:00-04:00",
    "ticks": 638254944000000000,
    "epochTime": 1689897600,
    "hasValue": true,
    "time": "2023-07-21"
  },
  {
    "open": 3.802,
    "high": 3.878,
    "low": 3.798,
    "close": 3.876,
    "priceDate": "2023-07-24T00:00:00-04:00",
    "ticks": 638257536000000000,
    "epochTime": 1690156800,
    "hasValue": true,
    "time": "2023-07-24"
  },
  {
    "open": 3.896,
    "high": 3.92,
    "low": 3.877,
    "close": 3.888,
    "priceDate": "2023-07-25T00:00:00-04:00",
    "ticks": 638258400000000000,
    "epochTime": 1690243200,
    "hasValue": true,
    "time": "2023-07-25"
  },
  {
    "open": 3.885,
    "high": 3.904,
    "low": 3.851,
    "close": 3.871,
    "priceDate": "2023-07-26T00:00:00-04:00",
    "ticks": 638259264000000000,
    "epochTime": 1690329600,
    "hasValue": true,
    "time": "2023-07-26"
  },
  {
    "open": 3.865,
    "high": 4.022,
    "low": 3.853,
    "close": 4.004,
    "priceDate": "2023-07-27T00:00:00-04:00",
    "ticks": 638260128000000000,
    "epochTime": 1690416000,
    "hasValue": true,
    "time": "2023-07-27"
  },
  {
    "open": 3.951,
    "high": 3.993,
    "low": 3.945,
    "close": 3.953,
    "priceDate": "2023-07-28T00:00:00-04:00",
    "ticks": 638260992000000000,
    "epochTime": 1690502400,
    "hasValue": true,
    "time": "2023-07-28"
  },
  {
    "open": 3.967,
    "high": 3.981,
    "low": 3.929,
    "close": 3.961,
    "priceDate": "2023-07-31T00:00:00-04:00",
    "ticks": 638263584000000000,
    "epochTime": 1690761600,
    "hasValue": true,
    "time": "2023-07-31"
  },
  {
    "open": 3.993,
    "high": 4.057,
    "low": 3.993,
    "close": 4.027,
    "priceDate": "2023-08-01T00:00:00-04:00",
    "ticks": 638264448000000000,
    "epochTime": 1690848000,
    "hasValue": true,
    "time": "2023-08-01"
  },
  {
    "open": 4.021,
    "high": 4.126,
    "low": 4.019,
    "close": 4.082,
    "priceDate": "2023-08-02T00:00:00-04:00",
    "ticks": 638265312000000000,
    "epochTime": 1690934400,
    "hasValue": true,
    "time": "2023-08-02"
  },
  {
    "open": 4.143,
    "high": 4.198,
    "low": 4.13,
    "close": 4.181,
    "priceDate": "2023-08-03T00:00:00-04:00",
    "ticks": 638266176000000000,
    "epochTime": 1691020800,
    "hasValue": true,
    "time": "2023-08-03"
  },
  {
    "open": 4.19,
    "high": 4.204,
    "low": 4.038,
    "close": 4.038,
    "priceDate": "2023-08-04T00:00:00-04:00",
    "ticks": 638267040000000000,
    "epochTime": 1691107200,
    "hasValue": true,
    "time": "2023-08-04"
  },
  {
    "open": 4.103,
    "high": 4.113,
    "low": 4.064,
    "close": 4.097,
    "priceDate": "2023-08-07T00:00:00-04:00",
    "ticks": 638269632000000000,
    "epochTime": 1691366400,
    "hasValue": true,
    "time": "2023-08-07"
  },
  {
    "open": 3.994,
    "high": 4.034,
    "low": 3.984,
    "close": 4.026,
    "priceDate": "2023-08-08T00:00:00-04:00",
    "ticks": 638270496000000000,
    "epochTime": 1691452800,
    "hasValue": true,
    "time": "2023-08-08"
  },
  {
    "open": 4.03,
    "high": 4.038,
    "low": 3.99,
    "close": 4.012,
    "priceDate": "2023-08-09T00:00:00-04:00",
    "ticks": 638271360000000000,
    "epochTime": 1691539200,
    "hasValue": true,
    "time": "2023-08-09"
  },
  {
    "open": 3.984,
    "high": 4.113,
    "low": 3.959,
    "close": 4.111,
    "priceDate": "2023-08-10T00:00:00-04:00",
    "ticks": 638272224000000000,
    "epochTime": 1691625600,
    "hasValue": true,
    "time": "2023-08-10"
  },
  {
    "open": 4.098,
    "high": 4.178,
    "low": 4.09,
    "close": 4.156,
    "priceDate": "2023-08-11T00:00:00-04:00",
    "ticks": 638273088000000000,
    "epochTime": 1691712000,
    "hasValue": true,
    "time": "2023-08-11"
  },
  {
    "open": 4.17,
    "high": 4.215,
    "low": 4.148,
    "close": 4.199,
    "priceDate": "2023-08-14T00:00:00-04:00",
    "ticks": 638275680000000000,
    "epochTime": 1691971200,
    "hasValue": true,
    "time": "2023-08-14"
  },
  {
    "open": 4.235,
    "high": 4.27,
    "low": 4.168,
    "close": 4.217,
    "priceDate": "2023-08-15T00:00:00-04:00",
    "ticks": 638276544000000000,
    "epochTime": 1692057600,
    "hasValue": true,
    "time": "2023-08-15"
  },
  {
    "open": 4.199,
    "high": 4.278,
    "low": 4.191,
    "close": 4.252,
    "priceDate": "2023-08-16T00:00:00-04:00",
    "ticks": 638277408000000000,
    "epochTime": 1692144000,
    "hasValue": true,
    "time": "2023-08-16"
  },
  {
    "open": 4.282,
    "high": 4.328,
    "low": 4.274,
    "close": 4.278,
    "priceDate": "2023-08-17T00:00:00-04:00",
    "ticks": 638278272000000000,
    "epochTime": 1692230400,
    "hasValue": true,
    "time": "2023-08-17"
  },
  {
    "open": 4.233,
    "high": 4.28,
    "low": 4.223,
    "close": 4.257,
    "priceDate": "2023-08-18T00:00:00-04:00",
    "ticks": 638279136000000000,
    "epochTime": 1692316800,
    "hasValue": true,
    "time": "2023-08-18"
  },
  {
    "open": 4.302,
    "high": 4.354,
    "low": 4.288,
    "close": 4.342,
    "priceDate": "2023-08-21T00:00:00-04:00",
    "ticks": 638281728000000000,
    "epochTime": 1692576000,
    "hasValue": true,
    "time": "2023-08-21"
  },
  {
    "open": 4.314,
    "high": 4.362,
    "low": 4.31,
    "close": 4.326,
    "priceDate": "2023-08-22T00:00:00-04:00",
    "ticks": 638282592000000000,
    "epochTime": 1692662400,
    "hasValue": true,
    "time": "2023-08-22"
  },
  {
    "open": 4.275,
    "high": 4.292,
    "low": 4.184,
    "close": 4.194,
    "priceDate": "2023-08-23T00:00:00-04:00",
    "ticks": 638283456000000000,
    "epochTime": 1692748800,
    "hasValue": true,
    "time": "2023-08-23"
  },
  {
    "open": 4.223,
    "high": 4.243,
    "low": 4.19,
    "close": 4.239,
    "priceDate": "2023-08-24T00:00:00-04:00",
    "ticks": 638284320000000000,
    "epochTime": 1692835200,
    "hasValue": true,
    "time": "2023-08-24"
  },
  {
    "open": 4.239,
    "high": 4.283,
    "low": 4.204,
    "close": 4.239,
    "priceDate": "2023-08-25T00:00:00-04:00",
    "ticks": 638285184000000000,
    "epochTime": 1692921600,
    "hasValue": true,
    "time": "2023-08-25"
  },
  {
    "open": 4.22,
    "high": 4.233,
    "low": 4.196,
    "close": 4.204,
    "priceDate": "2023-08-28T00:00:00-04:00",
    "ticks": 638287776000000000,
    "epochTime": 1693180800,
    "hasValue": true,
    "time": "2023-08-28"
  },
  {
    "open": 4.218,
    "high": 4.241,
    "low": 4.106,
    "close": 4.122,
    "priceDate": "2023-08-29T00:00:00-04:00",
    "ticks": 638288640000000000,
    "epochTime": 1693267200,
    "hasValue": true,
    "time": "2023-08-29"
  },
  {
    "open": 4.143,
    "high": 4.155,
    "low": 4.087,
    "close": 4.118,
    "priceDate": "2023-08-30T00:00:00-04:00",
    "ticks": 638289504000000000,
    "epochTime": 1693353600,
    "hasValue": true,
    "time": "2023-08-30"
  },
  {
    "open": 4.1,
    "high": 4.118,
    "low": 4.077,
    "close": 4.11,
    "priceDate": "2023-08-31T00:00:00-04:00",
    "ticks": 638290368000000000,
    "epochTime": 1693440000,
    "hasValue": true,
    "time": "2023-08-31"
  },
  {
    "open": 4.095,
    "high": 4.2,
    "low": 4.06,
    "close": 4.183,
    "priceDate": "2023-09-01T00:00:00-04:00",
    "ticks": 638291232000000000,
    "epochTime": 1693526400,
    "hasValue": true,
    "time": "2023-09-01"
  },
  {
    "open": 4.226,
    "high": 4.275,
    "low": 4.211,
    "close": 4.265,
    "priceDate": "2023-09-05T00:00:00-04:00",
    "ticks": 638294688000000000,
    "epochTime": 1693872000,
    "hasValue": true,
    "time": "2023-09-05"
  },
  {
    "open": 4.242,
    "high": 4.305,
    "low": 4.238,
    "close": 4.288,
    "priceDate": "2023-09-06T00:00:00-04:00",
    "ticks": 638295552000000000,
    "epochTime": 1693958400,
    "hasValue": true,
    "time": "2023-09-06"
  },
  {
    "open": 4.272,
    "high": 4.308,
    "low": 4.248,
    "close": 4.248,
    "priceDate": "2023-09-07T00:00:00-04:00",
    "ticks": 638296416000000000,
    "epochTime": 1694044800,
    "hasValue": true,
    "time": "2023-09-07"
  },
  {
    "open": 4.26,
    "high": 4.268,
    "low": 4.213,
    "close": 4.268,
    "priceDate": "2023-09-08T00:00:00-04:00",
    "ticks": 638297280000000000,
    "epochTime": 1694131200,
    "hasValue": true,
    "time": "2023-09-08"
  },
  {
    "open": 4.29,
    "high": 4.3,
    "low": 4.272,
    "close": 4.292,
    "priceDate": "2023-09-11T00:00:00-04:00",
    "ticks": 638299872000000000,
    "epochTime": 1694390400,
    "hasValue": true,
    "time": "2023-09-11"
  },
  {
    "open": 4.288,
    "high": 4.298,
    "low": 4.264,
    "close": 4.282,
    "priceDate": "2023-09-12T00:00:00-04:00",
    "ticks": 638300736000000000,
    "epochTime": 1694476800,
    "hasValue": true,
    "time": "2023-09-12"
  },
  {
    "open": 4.304,
    "high": 4.344,
    "low": 4.237,
    "close": 4.252,
    "priceDate": "2023-09-13T00:00:00-04:00",
    "ticks": 638301600000000000,
    "epochTime": 1694563200,
    "hasValue": true,
    "time": "2023-09-13"
  },
  {
    "open": 4.262,
    "high": 4.298,
    "low": 4.221,
    "close": 4.292,
    "priceDate": "2023-09-14T00:00:00-04:00",
    "ticks": 638302464000000000,
    "epochTime": 1694649600,
    "hasValue": true,
    "time": "2023-09-14"
  },
  {
    "open": 4.318,
    "high": 4.336,
    "low": 4.304,
    "close": 4.336,
    "priceDate": "2023-09-15T00:00:00-04:00",
    "ticks": 638303328000000000,
    "epochTime": 1694736000,
    "hasValue": true,
    "time": "2023-09-15"
  },
  {
    "open": 4.341,
    "high": 4.357,
    "low": 4.303,
    "close": 4.303,
    "priceDate": "2023-09-18T00:00:00-04:00",
    "ticks": 638305920000000000,
    "epochTime": 1694995200,
    "hasValue": true,
    "time": "2023-09-18"
  },
  {
    "open": 4.329,
    "high": 4.371,
    "low": 4.325,
    "close": 4.359,
    "priceDate": "2023-09-19T00:00:00-04:00",
    "ticks": 638306784000000000,
    "epochTime": 1695081600,
    "hasValue": true,
    "time": "2023-09-19"
  },
  {
    "open": 4.349,
    "high": 4.411,
    "low": 4.313,
    "close": 4.411,
    "priceDate": "2023-09-20T00:00:00-04:00",
    "ticks": 638307648000000000,
    "epochTime": 1695168000,
    "hasValue": true,
    "time": "2023-09-20"
  },
  {
    "open": 4.458,
    "high": 4.498,
    "low": 4.454,
    "close": 4.496,
    "priceDate": "2023-09-21T00:00:00-04:00",
    "ticks": 638308512000000000,
    "epochTime": 1695254400,
    "hasValue": true,
    "time": "2023-09-21"
  },
  {
    "open": 4.48,
    "high": 4.486,
    "low": 4.424,
    "close": 4.438,
    "priceDate": "2023-09-22T00:00:00-04:00",
    "ticks": 638309376000000000,
    "epochTime": 1695340800,
    "hasValue": true,
    "time": "2023-09-22"
  },
  {
    "open": 4.497,
    "high": 4.548,
    "low": 4.495,
    "close": 4.537,
    "priceDate": "2023-09-25T00:00:00-04:00",
    "ticks": 638311968000000000,
    "epochTime": 1695600000,
    "hasValue": true,
    "time": "2023-09-25"
  },
  {
    "open": 4.495,
    "high": 4.564,
    "low": 4.483,
    "close": 4.536,
    "priceDate": "2023-09-26T00:00:00-04:00",
    "ticks": 638312832000000000,
    "epochTime": 1695686400,
    "hasValue": true,
    "time": "2023-09-26"
  },
  {
    "open": 4.507,
    "high": 4.643,
    "low": 4.491,
    "close": 4.612,
    "priceDate": "2023-09-27T00:00:00-04:00",
    "ticks": 638313696000000000,
    "epochTime": 1695772800,
    "hasValue": true,
    "time": "2023-09-27"
  },
  {
    "open": 4.622,
    "high": 4.688,
    "low": 4.573,
    "close": 4.577,
    "priceDate": "2023-09-28T00:00:00-04:00",
    "ticks": 638314560000000000,
    "epochTime": 1695859200,
    "hasValue": true,
    "time": "2023-09-28"
  },
  {
    "open": 4.549,
    "high": 4.598,
    "low": 4.508,
    "close": 4.575,
    "priceDate": "2023-09-29T00:00:00-04:00",
    "ticks": 638315424000000000,
    "epochTime": 1695945600,
    "hasValue": true,
    "time": "2023-09-29"
  },
  {
    "open": 4.633,
    "high": 4.701,
    "low": 4.627,
    "close": 4.681,
    "priceDate": "2023-10-02T00:00:00-04:00",
    "ticks": 638318016000000000,
    "epochTime": 1696204800,
    "hasValue": true,
    "time": "2023-10-02"
  },
  {
    "open": 4.752,
    "high": 4.81,
    "low": 4.695,
    "close": 4.798,
    "priceDate": "2023-10-03T00:00:00-04:00",
    "ticks": 638318880000000000,
    "epochTime": 1696291200,
    "hasValue": true,
    "time": "2023-10-03"
  },
  {
    "open": 4.771,
    "high": 4.791,
    "low": 4.72,
    "close": 4.735,
    "priceDate": "2023-10-04T00:00:00-04:00",
    "ticks": 638319744000000000,
    "epochTime": 1696377600,
    "hasValue": true,
    "time": "2023-10-04"
  },
  {
    "open": 4.714,
    "high": 4.775,
    "low": 4.702,
    "close": 4.719,
    "priceDate": "2023-10-05T00:00:00-04:00",
    "ticks": 638320608000000000,
    "epochTime": 1696464000,
    "hasValue": true,
    "time": "2023-10-05"
  },
  {
    "open": 4.734,
    "high": 4.887,
    "low": 4.734,
    "close": 4.805,
    "priceDate": "2023-10-06T00:00:00-04:00",
    "ticks": 638321472000000000,
    "epochTime": 1696550400,
    "hasValue": true,
    "time": "2023-10-06"
  },
  {
    "open": 4.699,
    "high": 4.711,
    "low": 4.62,
    "close": 4.653,
    "priceDate": "2023-10-10T00:00:00-04:00",
    "ticks": 638324928000000000,
    "epochTime": 1696896000,
    "hasValue": true,
    "time": "2023-10-10"
  },
  {
    "open": 4.566,
    "high": 4.624,
    "low": 4.556,
    "close": 4.558,
    "priceDate": "2023-10-11T00:00:00-04:00",
    "ticks": 638325792000000000,
    "epochTime": 1696982400,
    "hasValue": true,
    "time": "2023-10-11"
  },
  {
    "open": 4.55,
    "high": 4.728,
    "low": 4.54,
    "close": 4.701,
    "priceDate": "2023-10-12T00:00:00-04:00",
    "ticks": 638326656000000000,
    "epochTime": 1697068800,
    "hasValue": true,
    "time": "2023-10-12"
  },
  {
    "open": 4.614,
    "high": 4.65,
    "low": 4.588,
    "close": 4.617,
    "priceDate": "2023-10-13T00:00:00-04:00",
    "ticks": 638327520000000000,
    "epochTime": 1697155200,
    "hasValue": true,
    "time": "2023-10-13"
  },
  {
    "open": 4.696,
    "high": 4.725,
    "low": 4.666,
    "close": 4.708,
    "priceDate": "2023-10-16T00:00:00-04:00",
    "ticks": 638330112000000000,
    "epochTime": 1697414400,
    "hasValue": true,
    "time": "2023-10-16"
  },
  {
    "open": 4.771,
    "high": 4.859,
    "low": 4.761,
    "close": 4.838,
    "priceDate": "2023-10-17T00:00:00-04:00",
    "ticks": 638330976000000000,
    "epochTime": 1697500800,
    "hasValue": true,
    "time": "2023-10-17"
  },
  {
    "open": 4.834,
    "high": 4.928,
    "low": 4.834,
    "close": 4.917,
    "priceDate": "2023-10-18T00:00:00-04:00",
    "ticks": 638331840000000000,
    "epochTime": 1697587200,
    "hasValue": true,
    "time": "2023-10-18"
  },
  {
    "open": 4.975,
    "high": 4.996,
    "low": 4.894,
    "close": 4.994,
    "priceDate": "2023-10-19T00:00:00-04:00",
    "ticks": 638332704000000000,
    "epochTime": 1697673600,
    "hasValue": true,
    "time": "2023-10-19"
  },
  {
    "open": 4.967,
    "high": 4.991,
    "low": 4.892,
    "close": 4.914,
    "priceDate": "2023-10-20T00:00:00-04:00",
    "ticks": 638333568000000000,
    "epochTime": 1697760000,
    "hasValue": true,
    "time": "2023-10-20"
  },
  {
    "open": 5.002,
    "high": 5.006,
    "low": 4.831,
    "close": 4.852,
    "priceDate": "2023-10-23T00:00:00-04:00",
    "ticks": 638336160000000000,
    "epochTime": 1698019200,
    "hasValue": true,
    "time": "2023-10-23"
  },
  {
    "open": 4.872,
    "high": 4.886,
    "low": 4.81,
    "close": 4.825,
    "priceDate": "2023-10-24T00:00:00-04:00",
    "ticks": 638337024000000000,
    "epochTime": 1698105600,
    "hasValue": true,
    "time": "2023-10-24"
  },
  {
    "open": 4.855,
    "high": 4.966,
    "low": 4.853,
    "close": 4.957,
    "priceDate": "2023-10-25T00:00:00-04:00",
    "ticks": 638337888000000000,
    "epochTime": 1698192000,
    "hasValue": true,
    "time": "2023-10-25"
  },
  {
    "open": 4.968,
    "high": 4.981,
    "low": 4.838,
    "close": 4.847,
    "priceDate": "2023-10-26T00:00:00-04:00",
    "ticks": 638338752000000000,
    "epochTime": 1698278400,
    "hasValue": true,
    "time": "2023-10-26"
  },
  {
    "open": 4.868,
    "high": 4.892,
    "low": 4.83,
    "close": 4.835,
    "priceDate": "2023-10-27T00:00:00-04:00",
    "ticks": 638339616000000000,
    "epochTime": 1698364800,
    "hasValue": true,
    "time": "2023-10-27"
  },
  {
    "open": 4.898,
    "high": 4.92,
    "low": 4.852,
    "close": 4.898,
    "priceDate": "2023-10-30T00:00:00-04:00",
    "ticks": 638342208000000000,
    "epochTime": 1698624000,
    "hasValue": true,
    "time": "2023-10-30"
  },
  {
    "open": 4.814,
    "high": 4.933,
    "low": 4.805,
    "close": 4.933,
    "priceDate": "2023-10-31T00:00:00-04:00",
    "ticks": 638343072000000000,
    "epochTime": 1698710400,
    "hasValue": true,
    "time": "2023-10-31"
  },
  {
    "open": 4.901,
    "high": 4.905,
    "low": 4.734,
    "close": 4.734,
    "priceDate": "2023-11-01T00:00:00-04:00",
    "ticks": 638343936000000000,
    "epochTime": 1698796800,
    "hasValue": true,
    "time": "2023-11-01"
  },
  {
    "open": 4.707,
    "high": 4.707,
    "low": 4.628,
    "close": 4.663,
    "priceDate": "2023-11-02T00:00:00-04:00",
    "ticks": 638344800000000000,
    "epochTime": 1698883200,
    "hasValue": true,
    "time": "2023-11-02"
  },
  {
    "open": 4.641,
    "high": 4.643,
    "low": 4.484,
    "close": 4.574,
    "priceDate": "2023-11-03T00:00:00-04:00",
    "ticks": 638345664000000000,
    "epochTime": 1698969600,
    "hasValue": true,
    "time": "2023-11-03"
  },
  {
    "open": 4.608,
    "high": 4.666,
    "low": 4.608,
    "close": 4.647,
    "priceDate": "2023-11-06T00:00:00-05:00",
    "ticks": 638348256000000000,
    "epochTime": 1699228800,
    "hasValue": true,
    "time": "2023-11-06"
  },
  {
    "open": 4.616,
    "high": 4.625,
    "low": 4.546,
    "close": 4.569,
    "priceDate": "2023-11-07T00:00:00-05:00",
    "ticks": 638349120000000000,
    "epochTime": 1699315200,
    "hasValue": true,
    "time": "2023-11-07"
  },
  {
    "open": 4.567,
    "high": 4.575,
    "low": 4.488,
    "close": 4.495,
    "priceDate": "2023-11-08T00:00:00-05:00",
    "ticks": 638349984000000000,
    "epochTime": 1699401600,
    "hasValue": true,
    "time": "2023-11-08"
  },
  {
    "open": 4.561,
    "high": 4.65,
    "low": 4.527,
    "close": 4.632,
    "priceDate": "2023-11-09T00:00:00-05:00",
    "ticks": 638350848000000000,
    "epochTime": 1699488000,
    "hasValue": true,
    "time": "2023-11-09"
  },
  {
    "open": 4.596,
    "high": 4.656,
    "low": 4.571,
    "close": 4.656,
    "priceDate": "2023-11-10T00:00:00-05:00",
    "ticks": 638351712000000000,
    "epochTime": 1699574400,
    "hasValue": true,
    "time": "2023-11-10"
  },
  {
    "open": 4.644,
    "high": 4.694,
    "low": 4.626,
    "close": 4.642,
    "priceDate": "2023-11-13T00:00:00-05:00",
    "ticks": 638354304000000000,
    "epochTime": 1699833600,
    "hasValue": true,
    "time": "2023-11-13"
  },
  {
    "open": 4.624,
    "high": 4.624,
    "low": 4.434,
    "close": 4.451,
    "priceDate": "2023-11-14T00:00:00-05:00",
    "ticks": 638355168000000000,
    "epochTime": 1699920000,
    "hasValue": true,
    "time": "2023-11-14"
  },
  {
    "open": 4.465,
    "high": 4.559,
    "low": 4.445,
    "close": 4.533,
    "priceDate": "2023-11-15T00:00:00-05:00",
    "ticks": 638356032000000000,
    "epochTime": 1700006400,
    "hasValue": true,
    "time": "2023-11-15"
  },
  {
    "open": 4.486,
    "high": 4.49,
    "low": 4.432,
    "close": 4.439,
    "priceDate": "2023-11-16T00:00:00-05:00",
    "ticks": 638356896000000000,
    "epochTime": 1700092800,
    "hasValue": true,
    "time": "2023-11-16"
  },
  {
    "open": 4.41,
    "high": 4.469,
    "low": 4.4,
    "close": 4.435,
    "priceDate": "2023-11-17T00:00:00-05:00",
    "ticks": 638357760000000000,
    "epochTime": 1700179200,
    "hasValue": true,
    "time": "2023-11-17"
  },
  {
    "open": 4.476,
    "high": 4.48,
    "low": 4.41,
    "close": 4.424,
    "priceDate": "2023-11-20T00:00:00-05:00",
    "ticks": 638360352000000000,
    "epochTime": 1700438400,
    "hasValue": true,
    "time": "2023-11-20"
  },
  {
    "open": 4.406,
    "high": 4.443,
    "low": 4.391,
    "close": 4.391,
    "priceDate": "2023-11-21T00:00:00-05:00",
    "ticks": 638361216000000000,
    "epochTime": 1700524800,
    "hasValue": true,
    "time": "2023-11-21"
  },
  {
    "open": 4.369,
    "high": 4.447,
    "low": 4.363,
    "close": 4.408,
    "priceDate": "2023-11-22T00:00:00-05:00",
    "ticks": 638362080000000000,
    "epochTime": 1700611200,
    "hasValue": true,
    "time": "2023-11-22"
  },
  {
    "open": 4.472,
    "high": 4.492,
    "low": 4.461,
    "close": 4.472,
    "priceDate": "2023-11-24T00:00:00-05:00",
    "ticks": 638363808000000000,
    "epochTime": 1700784000,
    "hasValue": true,
    "time": "2023-11-24"
  },
  {
    "open": 4.453,
    "high": 4.461,
    "low": 4.381,
    "close": 4.388,
    "priceDate": "2023-11-27T00:00:00-05:00",
    "ticks": 638366400000000000,
    "epochTime": 1701043200,
    "hasValue": true,
    "time": "2023-11-27"
  },
  {
    "open": 4.418,
    "high": 4.422,
    "low": 4.321,
    "close": 4.323,
    "priceDate": "2023-11-28T00:00:00-05:00",
    "ticks": 638367264000000000,
    "epochTime": 1701129600,
    "hasValue": true,
    "time": "2023-11-28"
  },
  {
    "open": 4.29,
    "high": 4.321,
    "low": 4.253,
    "close": 4.259,
    "priceDate": "2023-11-29T00:00:00-05:00",
    "ticks": 638368128000000000,
    "epochTime": 1701216000,
    "hasValue": true,
    "time": "2023-11-29"
  },
  {
    "open": 4.286,
    "high": 4.367,
    "low": 4.269,
    "close": 4.328,
    "priceDate": "2023-11-30T00:00:00-05:00",
    "ticks": 638368992000000000,
    "epochTime": 1701302400,
    "hasValue": true,
    "time": "2023-11-30"
  },
  {
    "open": 4.328,
    "high": 4.348,
    "low": 4.197,
    "close": 4.197,
    "priceDate": "2023-12-01T00:00:00-05:00",
    "ticks": 638369856000000000,
    "epochTime": 1701388800,
    "hasValue": true,
    "time": "2023-12-01"
  },
  {
    "open": 4.255,
    "high": 4.297,
    "low": 4.239,
    "close": 4.253,
    "priceDate": "2023-12-04T00:00:00-05:00",
    "ticks": 638372448000000000,
    "epochTime": 1701648000,
    "hasValue": true,
    "time": "2023-12-04"
  },
  {
    "open": 4.228,
    "high": 4.228,
    "low": 4.165,
    "close": 4.167,
    "priceDate": "2023-12-05T00:00:00-05:00",
    "ticks": 638373312000000000,
    "epochTime": 1701734400,
    "hasValue": true,
    "time": "2023-12-05"
  },
  {
    "open": 4.188,
    "high": 4.19,
    "low": 4.106,
    "close": 4.108,
    "priceDate": "2023-12-06T00:00:00-05:00",
    "ticks": 638374176000000000,
    "epochTime": 1701820800,
    "hasValue": true,
    "time": "2023-12-06"
  },
  {
    "open": 4.159,
    "high": 4.178,
    "low": 4.104,
    "close": 4.151,
    "priceDate": "2023-12-07T00:00:00-05:00",
    "ticks": 638375040000000000,
    "epochTime": 1701907200,
    "hasValue": true,
    "time": "2023-12-07"
  },
  {
    "open": 4.182,
    "high": 4.278,
    "low": 4.178,
    "close": 4.229,
    "priceDate": "2023-12-08T00:00:00-05:00",
    "ticks": 638375904000000000,
    "epochTime": 1701993600,
    "hasValue": true,
    "time": "2023-12-08"
  },
  {
    "open": 4.278,
    "high": 4.291,
    "low": 4.231,
    "close": 4.235,
    "priceDate": "2023-12-11T00:00:00-05:00",
    "ticks": 638378496000000000,
    "epochTime": 1702252800,
    "hasValue": true,
    "time": "2023-12-11"
  },
  {
    "open": 4.185,
    "high": 4.25,
    "low": 4.153,
    "close": 4.201,
    "priceDate": "2023-12-12T00:00:00-05:00",
    "ticks": 638379360000000000,
    "epochTime": 1702339200,
    "hasValue": true,
    "time": "2023-12-12"
  },
  {
    "open": 4.181,
    "high": 4.189,
    "low": 4.011,
    "close": 4.018,
    "priceDate": "2023-12-13T00:00:00-05:00",
    "ticks": 638380224000000000,
    "epochTime": 1702425600,
    "hasValue": true,
    "time": "2023-12-13"
  },
  {
    "open": 3.949,
    "high": 3.986,
    "low": 3.887,
    "close": 3.919,
    "priceDate": "2023-12-14T00:00:00-05:00",
    "ticks": 638381088000000000,
    "epochTime": 1702512000,
    "hasValue": true,
    "time": "2023-12-14"
  },
  {
    "open": 3.915,
    "high": 3.971,
    "low": 3.894,
    "close": 3.913,
    "priceDate": "2023-12-15T00:00:00-05:00",
    "ticks": 638381952000000000,
    "epochTime": 1702598400,
    "hasValue": true,
    "time": "2023-12-15"
  },
  {
    "open": 3.916,
    "high": 3.969,
    "low": 3.909,
    "close": 3.931,
    "priceDate": "2023-12-18T00:00:00-05:00",
    "ticks": 638384544000000000,
    "epochTime": 1702857600,
    "hasValue": true,
    "time": "2023-12-18"
  },
  {
    "open": 3.901,
    "high": 3.933,
    "low": 3.898,
    "close": 3.933,
    "priceDate": "2023-12-19T00:00:00-05:00",
    "ticks": 638385408000000000,
    "epochTime": 1702944000,
    "hasValue": true,
    "time": "2023-12-19"
  },
  {
    "open": 3.883,
    "high": 3.92,
    "low": 3.849,
    "close": 3.851,
    "priceDate": "2023-12-20T00:00:00-05:00",
    "ticks": 638386272000000000,
    "epochTime": 1703030400,
    "hasValue": true,
    "time": "2023-12-20"
  },
  {
    "open": 3.86,
    "high": 3.905,
    "low": 3.831,
    "close": 3.892,
    "priceDate": "2023-12-21T00:00:00-05:00",
    "ticks": 638387136000000000,
    "epochTime": 1703116800,
    "hasValue": true,
    "time": "2023-12-21"
  },
  {
    "open": 3.858,
    "high": 3.919,
    "low": 3.848,
    "close": 3.901,
    "priceDate": "2023-12-22T00:00:00-05:00",
    "ticks": 638388000000000000,
    "epochTime": 1703203200,
    "hasValue": true,
    "time": "2023-12-22"
  },
  {
    "open": 3.906,
    "high": 3.91,
    "low": 3.882,
    "close": 3.899,
    "priceDate": "2023-12-26T00:00:00-05:00",
    "ticks": 638391456000000000,
    "epochTime": 1703548800,
    "hasValue": true,
    "time": "2023-12-26"
  },
  {
    "open": 3.863,
    "high": 3.863,
    "low": 3.783,
    "close": 3.798,
    "priceDate": "2023-12-27T00:00:00-05:00",
    "ticks": 638392320000000000,
    "epochTime": 1703635200,
    "hasValue": true,
    "time": "2023-12-27"
  },
  {
    "open": 3.818,
    "high": 3.859,
    "low": 3.8,
    "close": 3.848,
    "priceDate": "2023-12-28T00:00:00-05:00",
    "ticks": 638393184000000000,
    "epochTime": 1703721600,
    "hasValue": true,
    "time": "2023-12-28"
  },
  {
    "open": 3.881,
    "high": 3.896,
    "low": 3.847,
    "close": 3.866,
    "priceDate": "2023-12-29T00:00:00-05:00",
    "ticks": 638394048000000000,
    "epochTime": 1703808000,
    "hasValue": true,
    "time": "2023-12-29"
  },
  {
    "open": 3.967,
    "high": 3.974,
    "low": 3.92,
    "close": 3.933,
    "priceDate": "2024-01-02T00:00:00-05:00",
    "ticks": 638397504000000000,
    "epochTime": 1704153600,
    "hasValue": true,
    "time": "2024-01-02"
  },
  {
    "open": 3.978,
    "high": 4.01,
    "low": 3.896,
    "close": 3.92,
    "priceDate": "2024-01-03T00:00:00-05:00",
    "ticks": 638398368000000000,
    "epochTime": 1704240000,
    "hasValue": true,
    "time": "2024-01-03"
  },
  {
    "open": 3.963,
    "high": 4.006,
    "low": 3.963,
    "close": 4.004,
    "priceDate": "2024-01-04T00:00:00-05:00",
    "ticks": 638399232000000000,
    "epochTime": 1704326400,
    "hasValue": true,
    "time": "2024-01-04"
  },
  {
    "open": 4.05,
    "high": 4.097,
    "low": 3.955,
    "close": 4.05,
    "priceDate": "2024-01-05T00:00:00-05:00",
    "ticks": 638400096000000000,
    "epochTime": 1704412800,
    "hasValue": true,
    "time": "2024-01-05"
  },
  {
    "open": 4.061,
    "high": 4.063,
    "low": 3.966,
    "close": 4.03,
    "priceDate": "2024-01-08T00:00:00-05:00",
    "ticks": 638402688000000000,
    "epochTime": 1704672000,
    "hasValue": true,
    "time": "2024-01-08"
  },
  {
    "open": 4.042,
    "high": 4.053,
    "low": 3.996,
    "close": 4.015,
    "priceDate": "2024-01-09T00:00:00-05:00",
    "ticks": 638403552000000000,
    "epochTime": 1704758400,
    "hasValue": true,
    "time": "2024-01-09"
  },
  {
    "open": 3.992,
    "high": 4.044,
    "low": 3.985,
    "close": 4.032,
    "priceDate": "2024-01-10T00:00:00-05:00",
    "ticks": 638404416000000000,
    "epochTime": 1704844800,
    "hasValue": true,
    "time": "2024-01-10"
  },
  {
    "open": 3.988,
    "high": 4.068,
    "low": 3.968,
    "close": 3.968,
    "priceDate": "2024-01-11T00:00:00-05:00",
    "ticks": 638405280000000000,
    "epochTime": 1704931200,
    "hasValue": true,
    "time": "2024-01-11"
  },
  {
    "open": 4.001,
    "high": 4.005,
    "low": 3.916,
    "close": 3.943,
    "priceDate": "2024-01-12T00:00:00-05:00",
    "ticks": 638406144000000000,
    "epochTime": 1705017600,
    "hasValue": true,
    "time": "2024-01-12"
  },
  {
    "open": 4.007,
    "high": 4.083,
    "low": 3.994,
    "close": 4.062,
    "priceDate": "2024-01-16T00:00:00-05:00",
    "ticks": 638409600000000000,
    "epochTime": 1705363200,
    "hasValue": true,
    "time": "2024-01-16"
  },
  {
    "open": 4.075,
    "high": 4.129,
    "low": 4.075,
    "close": 4.104,
    "priceDate": "2024-01-17T00:00:00-05:00",
    "ticks": 638410464000000000,
    "epochTime": 1705449600,
    "hasValue": true,
    "time": "2024-01-17"
  },
  {
    "open": 4.092,
    "high": 4.154,
    "low": 4.086,
    "close": 4.146,
    "priceDate": "2024-01-18T00:00:00-05:00",
    "ticks": 638411328000000000,
    "epochTime": 1705536000,
    "hasValue": true,
    "time": "2024-01-18"
  },
  {
    "open": 4.13,
    "high": 4.196,
    "low": 4.123,
    "close": 4.124,
    "priceDate": "2024-01-19T00:00:00-05:00",
    "ticks": 638412192000000000,
    "epochTime": 1705622400,
    "hasValue": true,
    "time": "2024-01-19"
  },
  {
    "open": 4.086,
    "high": 4.111,
    "low": 4.075,
    "close": 4.109,
    "priceDate": "2024-01-22T00:00:00-05:00",
    "ticks": 638414784000000000,
    "epochTime": 1705881600,
    "hasValue": true,
    "time": "2024-01-22"
  },
  {
    "open": 4.132,
    "high": 4.155,
    "low": 4.122,
    "close": 4.128,
    "priceDate": "2024-01-23T00:00:00-05:00",
    "ticks": 638415648000000000,
    "epochTime": 1705968000,
    "hasValue": true,
    "time": "2024-01-23"
  },
  {
    "open": 4.105,
    "high": 4.186,
    "low": 4.086,
    "close": 4.18,
    "priceDate": "2024-01-24T00:00:00-05:00",
    "ticks": 638416512000000000,
    "epochTime": 1706054400,
    "hasValue": true,
    "time": "2024-01-24"
  },
  {
    "open": 4.163,
    "high": 4.182,
    "low": 4.12,
    "close": 4.12,
    "priceDate": "2024-01-25T00:00:00-05:00",
    "ticks": 638417376000000000,
    "epochTime": 1706140800,
    "hasValue": true,
    "time": "2024-01-25"
  },
  {
    "open": 4.124,
    "high": 4.166,
    "low": 4.109,
    "close": 4.139,
    "priceDate": "2024-01-26T00:00:00-05:00",
    "ticks": 638418240000000000,
    "epochTime": 1706227200,
    "hasValue": true,
    "time": "2024-01-26"
  },
  {
    "open": 4.105,
    "high": 4.12,
    "low": 4.059,
    "close": 4.078,
    "priceDate": "2024-01-29T00:00:00-05:00",
    "ticks": 638420832000000000,
    "epochTime": 1706486400,
    "hasValue": true,
    "time": "2024-01-29"
  },
  {
    "open": 4.074,
    "high": 4.103,
    "low": 4.034,
    "close": 4.034,
    "priceDate": "2024-01-30T00:00:00-05:00",
    "ticks": 638421696000000000,
    "epochTime": 1706572800,
    "hasValue": true,
    "time": "2024-01-30"
  },
  {
    "open": 4.032,
    "high": 4.036,
    "low": 3.912,
    "close": 3.916,
    "priceDate": "2024-01-31T00:00:00-05:00",
    "ticks": 638422560000000000,
    "epochTime": 1706659200,
    "hasValue": true,
    "time": "2024-01-31"
  },
  {
    "open": 3.929,
    "high": 3.929,
    "low": 3.817,
    "close": 3.882,
    "priceDate": "2024-02-01T00:00:00-05:00",
    "ticks": 638423424000000000,
    "epochTime": 1706745600,
    "hasValue": true,
    "time": "2024-02-01"
  },
  {
    "open": 3.885,
    "high": 4.054,
    "low": 3.885,
    "close": 4.026,
    "priceDate": "2024-02-02T00:00:00-05:00",
    "ticks": 638424288000000000,
    "epochTime": 1706832000,
    "hasValue": true,
    "time": "2024-02-02"
  },
  {
    "open": 4.117,
    "high": 4.177,
    "low": 4.11,
    "close": 4.16,
    "priceDate": "2024-02-05T00:00:00-05:00",
    "ticks": 638426880000000000,
    "epochTime": 1707091200,
    "hasValue": true,
    "time": "2024-02-05"
  },
  {
    "open": 4.148,
    "high": 4.162,
    "low": 4.079,
    "close": 4.102,
    "priceDate": "2024-02-06T00:00:00-05:00",
    "ticks": 638427744000000000,
    "epochTime": 1707177600,
    "hasValue": true,
    "time": "2024-02-06"
  },
  {
    "open": 4.123,
    "high": 4.127,
    "low": 4.067,
    "close": 4.123,
    "priceDate": "2024-02-07T00:00:00-05:00",
    "ticks": 638428608000000000,
    "epochTime": 1707264000,
    "hasValue": true,
    "time": "2024-02-07"
  },
  {
    "open": 4.139,
    "high": 4.172,
    "low": 4.131,
    "close": 4.158,
    "priceDate": "2024-02-08T00:00:00-05:00",
    "ticks": 638429472000000000,
    "epochTime": 1707350400,
    "hasValue": true,
    "time": "2024-02-08"
  },
  {
    "open": 4.17,
    "high": 4.193,
    "low": 4.127,
    "close": 4.177,
    "priceDate": "2024-02-09T00:00:00-05:00",
    "ticks": 638430336000000000,
    "epochTime": 1707436800,
    "hasValue": true,
    "time": "2024-02-09"
  },
  {
    "open": 4.148,
    "high": 4.197,
    "low": 4.148,
    "close": 4.181,
    "priceDate": "2024-02-12T00:00:00-05:00",
    "ticks": 638432928000000000,
    "epochTime": 1707696000,
    "hasValue": true,
    "time": "2024-02-12"
  },
  {
    "open": 4.158,
    "high": 4.328,
    "low": 4.15,
    "close": 4.318,
    "priceDate": "2024-02-13T00:00:00-05:00",
    "ticks": 638433792000000000,
    "epochTime": 1707782400,
    "hasValue": true,
    "time": "2024-02-13"
  },
  {
    "open": 4.295,
    "high": 4.322,
    "low": 4.246,
    "close": 4.257,
    "priceDate": "2024-02-14T00:00:00-05:00",
    "ticks": 638434656000000000,
    "epochTime": 1707868800,
    "hasValue": true,
    "time": "2024-02-14"
  },
  {
    "open": 4.228,
    "high": 4.255,
    "low": 4.191,
    "close": 4.236,
    "priceDate": "2024-02-15T00:00:00-05:00",
    "ticks": 638435520000000000,
    "epochTime": 1707955200,
    "hasValue": true,
    "time": "2024-02-15"
  },
  {
    "open": 4.271,
    "high": 4.328,
    "low": 4.271,
    "close": 4.283,
    "priceDate": "2024-02-16T00:00:00-05:00",
    "ticks": 638436384000000000,
    "epochTime": 1708041600,
    "hasValue": true,
    "time": "2024-02-16"
  },
  {
    "open": 4.273,
    "high": 4.289,
    "low": 4.244,
    "close": 4.279,
    "priceDate": "2024-02-20T00:00:00-05:00",
    "ticks": 638439840000000000,
    "epochTime": 1708387200,
    "hasValue": true,
    "time": "2024-02-20"
  },
  {
    "open": 4.264,
    "high": 4.331,
    "low": 4.256,
    "close": 4.319,
    "priceDate": "2024-02-21T00:00:00-05:00",
    "ticks": 638440704000000000,
    "epochTime": 1708473600,
    "hasValue": true,
    "time": "2024-02-21"
  },
  {
    "open": 4.338,
    "high": 4.35,
    "low": 4.299,
    "close": 4.327,
    "priceDate": "2024-02-22T00:00:00-05:00",
    "ticks": 638441568000000000,
    "epochTime": 1708560000,
    "hasValue": true,
    "time": "2024-02-22"
  },
  {
    "open": 4.311,
    "high": 4.327,
    "low": 4.246,
    "close": 4.25,
    "priceDate": "2024-02-23T00:00:00-05:00",
    "ticks": 638442432000000000,
    "epochTime": 1708646400,
    "hasValue": true,
    "time": "2024-02-23"
  },
  {
    "open": 4.24,
    "high": 4.307,
    "low": 4.24,
    "close": 4.283,
    "priceDate": "2024-02-26T00:00:00-05:00",
    "ticks": 638445024000000000,
    "epochTime": 1708905600,
    "hasValue": true,
    "time": "2024-02-26"
  },
  {
    "open": 4.268,
    "high": 4.321,
    "low": 4.264,
    "close": 4.303,
    "priceDate": "2024-02-27T00:00:00-05:00",
    "ticks": 638445888000000000,
    "epochTime": 1708992000,
    "hasValue": true,
    "time": "2024-02-27"
  },
  {
    "open": 4.284,
    "high": 4.307,
    "low": 4.264,
    "close": 4.268,
    "priceDate": "2024-02-28T00:00:00-05:00",
    "ticks": 638446752000000000,
    "epochTime": 1709078400,
    "hasValue": true,
    "time": "2024-02-28"
  },
  {
    "open": 4.319,
    "high": 4.319,
    "low": 4.225,
    "close": 4.252,
    "priceDate": "2024-02-29T00:00:00-05:00",
    "ticks": 638447616000000000,
    "epochTime": 1709164800,
    "hasValue": true,
    "time": "2024-02-29"
  },
  {
    "open": 4.262,
    "high": 4.296,
    "low": 4.178,
    "close": 4.184,
    "priceDate": "2024-03-01T00:00:00-05:00",
    "ticks": 638448480000000000,
    "epochTime": 1709251200,
    "hasValue": true,
    "time": "2024-03-01"
  },
  {
    "open": 4.217,
    "high": 4.235,
    "low": 4.205,
    "close": 4.213,
    "priceDate": "2024-03-04T00:00:00-05:00",
    "ticks": 638451072000000000,
    "epochTime": 1709510400,
    "hasValue": true,
    "time": "2024-03-04"
  },
  {
    "open": 4.172,
    "high": 4.174,
    "low": 4.116,
    "close": 4.154,
    "priceDate": "2024-03-05T00:00:00-05:00",
    "ticks": 638451936000000000,
    "epochTime": 1709596800,
    "hasValue": true,
    "time": "2024-03-05"
  },
  {
    "open": 4.139,
    "high": 4.147,
    "low": 4.081,
    "close": 4.106,
    "priceDate": "2024-03-06T00:00:00-05:00",
    "ticks": 638452800000000000,
    "epochTime": 1709683200,
    "hasValue": true,
    "time": "2024-03-06"
  },
  {
    "open": 4.092,
    "high": 4.123,
    "low": 4.054,
    "close": 4.087,
    "priceDate": "2024-03-07T00:00:00-05:00",
    "ticks": 638453664000000000,
    "epochTime": 1709769600,
    "hasValue": true,
    "time": "2024-03-07"
  },
  {
    "open": 4.069,
    "high": 4.131,
    "low": 4.042,
    "close": 4.079,
    "priceDate": "2024-03-08T00:00:00-05:00",
    "ticks": 638454528000000000,
    "epochTime": 1709856000,
    "hasValue": true,
    "time": "2024-03-08"
  },
  {
    "open": 4.073,
    "high": 4.116,
    "low": 4.071,
    "close": 4.1,
    "priceDate": "2024-03-11T00:00:00-04:00",
    "ticks": 638457120000000000,
    "epochTime": 1710115200,
    "hasValue": true,
    "time": "2024-03-11"
  },
  {
    "open": 4.089,
    "high": 4.17,
    "low": 4.081,
    "close": 4.157,
    "priceDate": "2024-03-12T00:00:00-04:00",
    "ticks": 638457984000000000,
    "epochTime": 1710201600,
    "hasValue": true,
    "time": "2024-03-12"
  },
  {
    "open": 4.178,
    "high": 4.198,
    "low": 4.17,
    "close": 4.19,
    "priceDate": "2024-03-13T00:00:00-04:00",
    "ticks": 638458848000000000,
    "epochTime": 1710288000,
    "hasValue": true,
    "time": "2024-03-13"
  },
  {
    "open": 4.2,
    "high": 4.3,
    "low": 4.19,
    "close": 4.292,
    "priceDate": "2024-03-14T00:00:00-04:00",
    "ticks": 638459712000000000,
    "epochTime": 1710374400,
    "hasValue": true,
    "time": "2024-03-14"
  },
  {
    "open": 4.285,
    "high": 4.32,
    "low": 4.281,
    "close": 4.31,
    "priceDate": "2024-03-15T00:00:00-04:00",
    "ticks": 638460576000000000,
    "epochTime": 1710460800,
    "hasValue": true,
    "time": "2024-03-15"
  },
  {
    "open": 4.304,
    "high": 4.348,
    "low": 4.304,
    "close": 4.324,
    "priceDate": "2024-03-18T00:00:00-04:00",
    "ticks": 638463168000000000,
    "epochTime": 1710720000,
    "hasValue": true,
    "time": "2024-03-18"
  },
  {
    "open": 4.322,
    "high": 4.336,
    "low": 4.289,
    "close": 4.295,
    "priceDate": "2024-03-19T00:00:00-04:00",
    "ticks": 638464032000000000,
    "epochTime": 1710806400,
    "hasValue": true,
    "time": "2024-03-19"
  },
  {
    "open": 4.281,
    "high": 4.32,
    "low": 4.243,
    "close": 4.277,
    "priceDate": "2024-03-20T00:00:00-04:00",
    "ticks": 638464896000000000,
    "epochTime": 1710892800,
    "hasValue": true,
    "time": "2024-03-20"
  },
  {
    "open": 4.226,
    "high": 4.293,
    "low": 4.226,
    "close": 4.273,
    "priceDate": "2024-03-21T00:00:00-04:00",
    "ticks": 638465760000000000,
    "epochTime": 1710979200,
    "hasValue": true,
    "time": "2024-03-21"
  },
  {
    "open": 4.228,
    "high": 4.228,
    "low": 4.198,
    "close": 4.198,
    "priceDate": "2024-03-22T00:00:00-04:00",
    "ticks": 638466624000000000,
    "epochTime": 1711065600,
    "hasValue": true,
    "time": "2024-03-22"
  },
  {
    "open": 4.238,
    "high": 4.261,
    "low": 4.222,
    "close": 4.249,
    "priceDate": "2024-03-25T00:00:00-04:00",
    "ticks": 638469216000000000,
    "epochTime": 1711324800,
    "hasValue": true,
    "time": "2024-03-25"
  },
  {
    "open": 4.236,
    "high": 4.273,
    "low": 4.228,
    "close": 4.234,
    "priceDate": "2024-03-26T00:00:00-04:00",
    "ticks": 638470080000000000,
    "epochTime": 1711411200,
    "hasValue": true,
    "time": "2024-03-26"
  },
  {
    "open": 4.222,
    "high": 4.226,
    "low": 4.184,
    "close": 4.192,
    "priceDate": "2024-03-27T00:00:00-04:00",
    "ticks": 638470944000000000,
    "epochTime": 1711497600,
    "hasValue": true,
    "time": "2024-03-27"
  },
  {
    "open": 4.22,
    "high": 4.2388,
    "low": 4.1816,
    "close": 4.2008,
    "priceDate": "2024-03-28T00:00:00-04:00",
    "ticks": 638471808000000000,
    "epochTime": 1711584000,
    "hasValue": true,
    "time": "2024-03-28"
  },
  {
    "open": 4.228,
    "high": 4.3351,
    "low": 4.228,
    "close": 4.3196,
    "priceDate": "2024-04-01T00:00:00-04:00",
    "ticks": 638475264000000000,
    "epochTime": 1711929600,
    "hasValue": true,
    "time": "2024-04-01"
  },
  {
    "open": 4.3676,
    "high": 4.4032,
    "low": 4.3496,
    "close": 4.3501,
    "priceDate": "2024-04-02T00:00:00-04:00",
    "ticks": 638476128000000000,
    "epochTime": 1712016000,
    "hasValue": true,
    "time": "2024-04-02"
  },
  {
    "open": 4.3667,
    "high": 4.4274,
    "low": 4.3457,
    "close": 4.3472,
    "priceDate": "2024-04-03T00:00:00-04:00",
    "ticks": 638476992000000000,
    "epochTime": 1712102400,
    "hasValue": true,
    "time": "2024-04-03"
  },
  {
    "open": 4.3683,
    "high": 4.3803,
    "low": 4.2984,
    "close": 4.3119,
    "priceDate": "2024-04-04T00:00:00-04:00",
    "ticks": 638477856000000000,
    "epochTime": 1712188800,
    "hasValue": true,
    "time": "2024-04-04"
  },
  {
    "open": 4.33,
    "high": 4.4056,
    "low": 4.3131,
    "close": 4.4021,
    "priceDate": "2024-04-05T00:00:00-04:00",
    "ticks": 638478720000000000,
    "epochTime": 1712275200,
    "hasValue": true,
    "time": "2024-04-05"
  },
  {
    "open": 4.4611,
    "high": 4.4632,
    "low": 4.4047,
    "close": 4.4208,
    "priceDate": "2024-04-08T00:00:00-04:00",
    "ticks": 638481312000000000,
    "epochTime": 1712534400,
    "hasValue": true,
    "time": "2024-04-08"
  },
  {
    "open": 4.3827,
    "high": 4.3947,
    "low": 4.3536,
    "close": 4.3596,
    "priceDate": "2024-04-09T00:00:00-04:00",
    "ticks": 638482176000000000,
    "epochTime": 1712620800,
    "hasValue": true,
    "time": "2024-04-09"
  },
  {
    "open": 4.3442,
    "high": 4.5675,
    "low": 4.3312,
    "close": 4.5435,
    "priceDate": "2024-04-10T00:00:00-04:00",
    "ticks": 638483040000000000,
    "epochTime": 1712707200,
    "hasValue": true,
    "time": "2024-04-10"
  },
  {
    "open": 4.5625,
    "high": 4.6034,
    "low": 4.5131,
    "close": 4.5917,
    "priceDate": "2024-04-11T00:00:00-04:00",
    "ticks": 638483904000000000,
    "epochTime": 1712793600,
    "hasValue": true,
    "time": "2024-04-11"
  },
  {
    "open": 4.5196,
    "high": 4.5318,
    "low": 4.4815,
    "close": 4.5236,
    "priceDate": "2024-04-12T00:00:00-04:00",
    "ticks": 638484768000000000,
    "epochTime": 1712880000,
    "hasValue": true,
    "time": "2024-04-12"
  },
  {
    "open": 4.5819,
    "high": 4.6631,
    "low": 4.5753,
    "close": 4.5958,
    "priceDate": "2024-04-15T00:00:00-04:00",
    "ticks": 638487360000000000,
    "epochTime": 1713139200,
    "hasValue": true,
    "time": "2024-04-15"
  },
  {
    "open": 4.6447,
    "high": 4.6943,
    "low": 4.6262,
    "close": 4.6689,
    "priceDate": "2024-04-16T00:00:00-04:00",
    "ticks": 638488224000000000,
    "epochTime": 1713225600,
    "hasValue": true,
    "time": "2024-04-16"
  },
  {
    "open": 4.6526,
    "high": 4.6603,
    "low": 4.5735,
    "close": 4.5894,
    "priceDate": "2024-04-17T00:00:00-04:00",
    "ticks": 638489088000000000,
    "epochTime": 1713312000,
    "hasValue": true,
    "time": "2024-04-17"
  },
  {
    "open": 4.5859,
    "high": 4.6522,
    "low": 4.5859,
    "close": 4.6342,
    "priceDate": "2024-04-18T00:00:00-04:00",
    "ticks": 638489952000000000,
    "epochTime": 1713398400,
    "hasValue": true,
    "time": "2024-04-18"
  },
  {
    "open": 4.5883,
    "high": 4.63,
    "low": 4.5786,
    "close": 4.6228,
    "priceDate": "2024-04-19T00:00:00-04:00",
    "ticks": 638490816000000000,
    "epochTime": 1713484800,
    "hasValue": true,
    "time": "2024-04-19"
  },
  {
    "open": 4.6559,
    "high": 4.6579,
    "low": 4.6075,
    "close": 4.61,
    "priceDate": "2024-04-22T00:00:00-04:00",
    "ticks": 638493408000000000,
    "epochTime": 1713744000,
    "hasValue": true,
    "time": "2024-04-22"
  },
  {
    "open": 4.6509,
    "high": 4.6519,
    "low": 4.5666,
    "close": 4.602,
    "priceDate": "2024-04-23T00:00:00-04:00",
    "ticks": 638494272000000000,
    "epochTime": 1713830400,
    "hasValue": true,
    "time": "2024-04-23"
  },
  {
    "open": 4.6381,
    "high": 4.6696,
    "low": 4.6263,
    "close": 4.6422,
    "priceDate": "2024-04-24T00:00:00-04:00",
    "ticks": 638495136000000000,
    "epochTime": 1713916800,
    "hasValue": true,
    "time": "2024-04-24"
  },
  {
    "open": 4.6527,
    "high": 4.7372,
    "low": 4.6151,
    "close": 4.6988,
    "priceDate": "2024-04-25T00:00:00-04:00",
    "ticks": 638496000000000000,
    "epochTime": 1714003200,
    "hasValue": true,
    "time": "2024-04-25"
  },
  {
    "open": 4.6832,
    "high": 4.6857,
    "low": 4.6433,
    "close": 4.6656,
    "priceDate": "2024-04-26T00:00:00-04:00",
    "ticks": 638496864000000000,
    "epochTime": 1714089600,
    "hasValue": true,
    "time": "2024-04-26"
  },
  {
    "open": 4.6223,
    "high": 4.6476,
    "low": 4.6064,
    "close": 4.6208,
    "priceDate": "2024-04-29T00:00:00-04:00",
    "ticks": 638499456000000000,
    "epochTime": 1714348800,
    "hasValue": true,
    "time": "2024-04-29"
  },
  {
    "open": 4.624,
    "high": 4.6918,
    "low": 4.605,
    "close": 4.6829,
    "priceDate": "2024-04-30T00:00:00-04:00",
    "ticks": 638500320000000000,
    "epochTime": 1714435200,
    "hasValue": true,
    "time": "2024-04-30"
  },
  {
    "open": 4.6722,
    "high": 4.6847,
    "low": 4.5799,
    "close": 4.6283,
    "priceDate": "2024-05-01T00:00:00-04:00",
    "ticks": 638501184000000000,
    "epochTime": 1714521600,
    "hasValue": true,
    "time": "2024-05-01"
  },
  {
    "open": 4.6135,
    "high": 4.6501,
    "low": 4.5667,
    "close": 4.5775,
    "priceDate": "2024-05-02T00:00:00-04:00",
    "ticks": 638502048000000000,
    "epochTime": 1714608000,
    "hasValue": true,
    "time": "2024-05-02"
  },
  {
    "open": 4.5537,
    "high": 4.5563,
    "low": 4.4451,
    "close": 4.5123,
    "priceDate": "2024-05-03T00:00:00-04:00",
    "ticks": 638502912000000000,
    "epochTime": 1714694400,
    "hasValue": true,
    "time": "2024-05-03"
  },
  {
    "open": 4.4884,
    "high": 4.5129,
    "low": 4.4686,
    "close": 4.4961,
    "priceDate": "2024-05-06T00:00:00-04:00",
    "ticks": 638505504000000000,
    "epochTime": 1714953600,
    "hasValue": true,
    "time": "2024-05-06"
  },
  {
    "open": 4.4722,
    "high": 4.4743,
    "low": 4.4204,
    "close": 4.4565,
    "priceDate": "2024-05-07T00:00:00-04:00",
    "ticks": 638506368000000000,
    "epochTime": 1715040000,
    "hasValue": true,
    "time": "2024-05-07"
  },
  {
    "open": 4.4886,
    "high": 4.5004,
    "low": 4.4749,
    "close": 4.4973,
    "priceDate": "2024-05-08T00:00:00-04:00",
    "ticks": 638507232000000000,
    "epochTime": 1715126400,
    "hasValue": true,
    "time": "2024-05-08"
  },
  {
    "open": 4.5151,
    "high": 4.5185,
    "low": 4.4463,
    "close": 4.4531,
    "priceDate": "2024-05-09T00:00:00-04:00",
    "ticks": 638508096000000000,
    "epochTime": 1715212800,
    "hasValue": true,
    "time": "2024-05-09"
  },
  {
    "open": 4.4698,
    "high": 4.5082,
    "low": 4.4698,
    "close": 4.5047,
    "priceDate": "2024-05-10T00:00:00-04:00",
    "ticks": 638508960000000000,
    "epochTime": 1715299200,
    "hasValue": true,
    "time": "2024-05-10"
  },
  {
    "open": 4.4845,
    "high": 4.4895,
    "low": 4.457,
    "close": 4.4885,
    "priceDate": "2024-05-13T00:00:00-04:00",
    "ticks": 638511552000000000,
    "epochTime": 1715558400,
    "hasValue": true,
    "time": "2024-05-13"
  },
  {
    "open": 4.4777,
    "high": 4.5146,
    "low": 4.4389,
    "close": 4.4389,
    "priceDate": "2024-05-14T00:00:00-04:00",
    "ticks": 638512416000000000,
    "epochTime": 1715644800,
    "hasValue": true,
    "time": "2024-05-14"
  },
  {
    "open": 4.414,
    "high": 4.4169,
    "low": 4.339,
    "close": 4.3473,
    "priceDate": "2024-05-15T00:00:00-04:00",
    "ticks": 638513280000000000,
    "epochTime": 1715731200,
    "hasValue": true,
    "time": "2024-05-15"
  },
  {
    "open": 4.3293,
    "high": 4.3828,
    "low": 4.3158,
    "close": 4.3691,
    "priceDate": "2024-05-16T00:00:00-04:00",
    "ticks": 638514144000000000,
    "epochTime": 1715817600,
    "hasValue": true,
    "time": "2024-05-16"
  },
  {
    "open": 4.3944,
    "high": 4.4242,
    "low": 4.3895,
    "close": 4.4213,
    "priceDate": "2024-05-17T00:00:00-04:00",
    "ticks": 638515008000000000,
    "epochTime": 1715904000,
    "hasValue": true,
    "time": "2024-05-17"
  },
  {
    "open": 4.4159,
    "high": 4.4546,
    "low": 4.413,
    "close": 4.4448,
    "priceDate": "2024-05-20T00:00:00-04:00",
    "ticks": 638517600000000000,
    "epochTime": 1716163200,
    "hasValue": true,
    "time": "2024-05-20"
  },
  {
    "open": 4.4311,
    "high": 4.4355,
    "low": 4.3973,
    "close": 4.4091,
    "priceDate": "2024-05-21T00:00:00-04:00",
    "ticks": 638518464000000000,
    "epochTime": 1716249600,
    "hasValue": true,
    "time": "2024-05-21"
  },
  {
    "open": 4.4497,
    "high": 4.46,
    "low": 4.4115,
    "close": 4.4183,
    "priceDate": "2024-05-22T00:00:00-04:00",
    "ticks": 638519328000000000,
    "epochTime": 1716336000,
    "hasValue": true,
    "time": "2024-05-22"
  },
  {
    "open": 4.4178,
    "high": 4.4974,
    "low": 4.3983,
    "close": 4.4797,
    "priceDate": "2024-05-23T00:00:00-04:00",
    "ticks": 638520192000000000,
    "epochTime": 1716422400,
    "hasValue": true,
    "time": "2024-05-23"
  },
  {
    "open": 4.4856,
    "high": 4.5014,
    "low": 4.462,
    "close": 4.4659,
    "priceDate": "2024-05-24T00:00:00-04:00",
    "ticks": 638521056000000000,
    "epochTime": 1716508800,
    "hasValue": true,
    "time": "2024-05-24"
  },
  {
    "open": 4.4576,
    "high": 4.5564,
    "low": 4.4473,
    "close": 4.5564,
    "priceDate": "2024-05-28T00:00:00-04:00",
    "ticks": 638524512000000000,
    "epochTime": 1716854400,
    "hasValue": true,
    "time": "2024-05-28"
  },
  {
    "open": 4.5659,
    "high": 4.6372,
    "low": 4.5579,
    "close": 4.6097,
    "priceDate": "2024-05-29T00:00:00-04:00",
    "ticks": 638525376000000000,
    "epochTime": 1716940800,
    "hasValue": true,
    "time": "2024-05-29"
  },
  {
    "open": 4.5873,
    "high": 4.5993,
    "low": 4.5416,
    "close": 4.547,
    "priceDate": "2024-05-30T00:00:00-04:00",
    "ticks": 638526240000000000,
    "epochTime": 1717027200,
    "hasValue": true,
    "time": "2024-05-30"
  },
  {
    "open": 4.5545,
    "high": 4.556,
    "low": 4.4847,
    "close": 4.4995,
    "priceDate": "2024-05-31T00:00:00-04:00",
    "ticks": 638527104000000000,
    "epochTime": 1717113600,
    "hasValue": true,
    "time": "2024-05-31"
  },
  {
    "open": 4.4684,
    "high": 4.4729,
    "low": 4.3825,
    "close": 4.3825,
    "priceDate": "2024-06-03T00:00:00-04:00",
    "ticks": 638529696000000000,
    "epochTime": 1717372800,
    "hasValue": true,
    "time": "2024-06-03"
  },
  {
    "open": 4.3732,
    "high": 4.3737,
    "low": 4.3133,
    "close": 4.3284,
    "priceDate": "2024-06-04T00:00:00-04:00",
    "ticks": 638530560000000000,
    "epochTime": 1717459200,
    "hasValue": true,
    "time": "2024-06-04"
  },
  {
    "open": 4.3186,
    "high": 4.3513,
    "low": 4.2735,
    "close": 4.274,
    "priceDate": "2024-06-05T00:00:00-04:00",
    "ticks": 638531424000000000,
    "epochTime": 1717545600,
    "hasValue": true,
    "time": "2024-06-05"
  },
  {
    "open": 4.3089,
    "high": 4.321,
    "low": 4.2745,
    "close": 4.287,
    "priceDate": "2024-06-06T00:00:00-04:00",
    "ticks": 638532288000000000,
    "epochTime": 1717632000,
    "hasValue": true,
    "time": "2024-06-06"
  },
  {
    "open": 4.2981,
    "high": 4.4463,
    "low": 4.2889,
    "close": 4.4345,
    "priceDate": "2024-06-07T00:00:00-04:00",
    "ticks": 638533152000000000,
    "epochTime": 1717718400,
    "hasValue": true,
    "time": "2024-06-07"
  },
  {
    "open": 4.4547,
    "high": 4.4789,
    "low": 4.4453,
    "close": 4.468,
    "priceDate": "2024-06-10T00:00:00-04:00",
    "ticks": 638535744000000000,
    "epochTime": 1717977600,
    "hasValue": true,
    "time": "2024-06-10"
  },
  {
    "open": 4.4261,
    "high": 4.4616,
    "low": 4.3947,
    "close": 4.4035,
    "priceDate": "2024-06-11T00:00:00-04:00",
    "ticks": 638536608000000000,
    "epochTime": 1718064000,
    "hasValue": true,
    "time": "2024-06-11"
  },
  {
    "open": 4.3937,
    "high": 4.3947,
    "low": 4.2481,
    "close": 4.3121,
    "priceDate": "2024-06-12T00:00:00-04:00",
    "ticks": 638537472000000000,
    "epochTime": 1718150400,
    "hasValue": true,
    "time": "2024-06-12"
  },
  {
    "open": 4.317,
    "high": 4.317,
    "low": 4.222,
    "close": 4.2432,
    "priceDate": "2024-06-13T00:00:00-04:00",
    "ticks": 638538336000000000,
    "epochTime": 1718236800,
    "hasValue": true,
    "time": "2024-06-13"
  },
  {
    "open": 4.1977,
    "high": 4.2344,
    "low": 4.1871,
    "close": 4.2252,
    "priceDate": "2024-06-14T00:00:00-04:00",
    "ticks": 638539200000000000,
    "epochTime": 1718323200,
    "hasValue": true,
    "time": "2024-06-14"
  },
  {
    "open": 4.2518,
    "high": 4.2945,
    "low": 4.2508,
    "close": 4.2814,
    "priceDate": "2024-06-17T00:00:00-04:00",
    "ticks": 638541792000000000,
    "epochTime": 1718582400,
    "hasValue": true,
    "time": "2024-06-17"
  },
  {
    "open": 4.2905,
    "high": 4.292,
    "low": 4.2067,
    "close": 4.2236,
    "priceDate": "2024-06-18T00:00:00-04:00",
    "ticks": 638542656000000000,
    "epochTime": 1718668800,
    "hasValue": true,
    "time": "2024-06-18"
  },
  {
    "open": 4.2463,
    "high": 4.2934,
    "low": 4.2352,
    "close": 4.2604,
    "priceDate": "2024-06-20T00:00:00-04:00",
    "ticks": 638544384000000000,
    "epochTime": 1718841600,
    "hasValue": true,
    "time": "2024-06-20"
  },
  {
    "open": 4.2254,
    "high": 4.2773,
    "low": 4.207,
    "close": 4.2569,
    "priceDate": "2024-06-21T00:00:00-04:00",
    "ticks": 638545248000000000,
    "epochTime": 1718928000,
    "hasValue": true,
    "time": "2024-06-21"
  },
  {
    "open": 4.2714,
    "high": 4.2758,
    "low": 4.2259,
    "close": 4.2336,
    "priceDate": "2024-06-24T00:00:00-04:00",
    "ticks": 638547840000000000,
    "epochTime": 1719187200,
    "hasValue": true,
    "time": "2024-06-24"
  },
  {
    "open": 4.2142,
    "high": 4.2578,
    "low": 4.2079,
    "close": 4.2486,
    "priceDate": "2024-06-25T00:00:00-04:00",
    "ticks": 638548704000000000,
    "epochTime": 1719273600,
    "hasValue": true,
    "time": "2024-06-25"
  },
  {
    "open": 4.2879,
    "high": 4.3309,
    "low": 4.2782,
    "close": 4.3304,
    "priceDate": "2024-06-26T00:00:00-04:00",
    "ticks": 638549568000000000,
    "epochTime": 1719360000,
    "hasValue": true,
    "time": "2024-06-26"
  },
  {
    "open": 4.3245,
    "high": 4.3362,
    "low": 4.2733,
    "close": 4.2879,
    "priceDate": "2024-06-27T00:00:00-04:00",
    "ticks": 638550432000000000,
    "epochTime": 1719446400,
    "hasValue": true,
    "time": "2024-06-27"
  },
  {
    "open": 4.3049,
    "high": 4.4045,
    "low": 4.2591,
    "close": 4.3976,
    "priceDate": "2024-06-28T00:00:00-04:00",
    "ticks": 638551296000000000,
    "epochTime": 1719532800,
    "hasValue": true,
    "time": "2024-06-28"
  },
  {
    "open": 4.4163,
    "high": 4.4916,
    "low": 4.4153,
    "close": 4.4623,
    "priceDate": "2024-07-01T00:00:00-04:00",
    "ticks": 638553888000000000,
    "epochTime": 1719792000,
    "hasValue": true,
    "time": "2024-07-01"
  },
  {
    "open": 4.438,
    "high": 4.4544,
    "low": 4.4123,
    "close": 4.4321,
    "priceDate": "2024-07-02T00:00:00-04:00",
    "ticks": 638554752000000000,
    "epochTime": 1719878400,
    "hasValue": true,
    "time": "2024-07-02"
  },
  {
    "open": 4.4326,
    "high": 4.4371,
    "low": 4.3371,
    "close": 4.3602,
    "priceDate": "2024-07-03T00:00:00-04:00",
    "ticks": 638555616000000000,
    "epochTime": 1719964800,
    "hasValue": true,
    "time": "2024-07-03"
  },
  {
    "open": 4.3312,
    "high": 4.3346,
    "low": 4.2686,
    "close": 4.2803,
    "priceDate": "2024-07-05T00:00:00-04:00",
    "ticks": 638557344000000000,
    "epochTime": 1720137600,
    "hasValue": true,
    "time": "2024-07-05"
  },
  {
    "open": 4.3086,
    "high": 4.3125,
    "low": 4.2632,
    "close": 4.2808,
    "priceDate": "2024-07-08T00:00:00-04:00",
    "ticks": 638559936000000000,
    "epochTime": 1720396800,
    "hasValue": true,
    "time": "2024-07-08"
  },
  {
    "open": 4.2949,
    "high": 4.3282,
    "low": 4.2783,
    "close": 4.2925,
    "priceDate": "2024-07-09T00:00:00-04:00",
    "ticks": 638560800000000000,
    "epochTime": 1720483200,
    "hasValue": true,
    "time": "2024-07-09"
  },
  {
    "open": 4.2695,
    "high": 4.3037,
    "low": 4.2695,
    "close": 4.2851,
    "priceDate": "2024-07-10T00:00:00-04:00",
    "ticks": 638561664000000000,
    "epochTime": 1720569600,
    "hasValue": true,
    "time": "2024-07-10"
  },
  {
    "open": 4.2924,
    "high": 4.2934,
    "low": 4.1656,
    "close": 4.2111,
    "priceDate": "2024-07-11T00:00:00-04:00",
    "ticks": 638562528000000000,
    "epochTime": 1720656000,
    "hasValue": true,
    "time": "2024-07-11"
  },
  {
    "open": 4.2139,
    "high": 4.2362,
    "low": 4.1766,
    "close": 4.1853,
    "priceDate": "2024-07-12T00:00:00-04:00",
    "ticks": 638563392000000000,
    "epochTime": 1720742400,
    "hasValue": true,
    "time": "2024-07-12"
  },
  {
    "open": 4.2357,
    "high": 4.2425,
    "low": 4.1983,
    "close": 4.2323,
    "priceDate": "2024-07-15T00:00:00-04:00",
    "ticks": 638565984000000000,
    "epochTime": 1721001600,
    "hasValue": true,
    "time": "2024-07-15"
  },
  {
    "open": 4.1765,
    "high": 4.217,
    "low": 4.1547,
    "close": 4.1576,
    "priceDate": "2024-07-16T00:00:00-04:00",
    "ticks": 638566848000000000,
    "epochTime": 1721088000,
    "hasValue": true,
    "time": "2024-07-16"
  },
  {
    "open": 4.1813,
    "high": 4.1953,
    "low": 4.1431,
    "close": 4.158,
    "priceDate": "2024-07-17T00:00:00-04:00",
    "ticks": 638567712000000000,
    "epochTime": 1721174400,
    "hasValue": true,
    "time": "2024-07-17"
  },
  {
    "open": 4.1812,
    "high": 4.2103,
    "low": 4.1546,
    "close": 4.2025,
    "priceDate": "2024-07-18T00:00:00-04:00",
    "ticks": 638568576000000000,
    "epochTime": 1721260800,
    "hasValue": true,
    "time": "2024-07-18"
  },
  {
    "open": 4.232,
    "high": 4.2487,
    "low": 4.2233,
    "close": 4.2389,
    "priceDate": "2024-07-19T00:00:00-04:00",
    "ticks": 638569440000000000,
    "epochTime": 1721347200,
    "hasValue": true,
    "time": "2024-07-19"
  },
  {
    "open": 4.2209,
    "high": 4.2765,
    "low": 4.2102,
    "close": 4.253,
    "priceDate": "2024-07-22T00:00:00-04:00",
    "ticks": 638572032000000000,
    "epochTime": 1721606400,
    "hasValue": true,
    "time": "2024-07-22"
  },
  {
    "open": 4.2349,
    "high": 4.255,
    "low": 4.2213,
    "close": 4.2501,
    "priceDate": "2024-07-23T00:00:00-04:00",
    "ticks": 638572896000000000,
    "epochTime": 1721692800,
    "hasValue": true,
    "time": "2024-07-23"
  },
  {
    "open": 4.2305,
    "high": 4.2946,
    "low": 4.2057,
    "close": 4.2872,
    "priceDate": "2024-07-24T00:00:00-04:00",
    "ticks": 638573760000000000,
    "epochTime": 1721779200,
    "hasValue": true,
    "time": "2024-07-24"
  },
  {
    "open": 4.2115,
    "high": 4.2656,
    "low": 4.194,
    "close": 4.2427,
    "priceDate": "2024-07-25T00:00:00-04:00",
    "ticks": 638574624000000000,
    "epochTime": 1721865600,
    "hasValue": true,
    "time": "2024-07-25"
  },
  {
    "open": 4.2406,
    "high": 4.2577,
    "low": 4.1837,
    "close": 4.1934,
    "priceDate": "2024-07-26T00:00:00-04:00",
    "ticks": 638575488000000000,
    "epochTime": 1721952000,
    "hasValue": true,
    "time": "2024-07-26"
  },
  {
    "open": 4.1526,
    "high": 4.1851,
    "low": 4.1492,
    "close": 4.1846,
    "priceDate": "2024-07-29T00:00:00-04:00",
    "ticks": 638578080000000000,
    "epochTime": 1722211200,
    "hasValue": true,
    "time": "2024-07-29"
  },
  {
    "open": 4.1709,
    "high": 4.1836,
    "low": 4.1288,
    "close": 4.1361,
    "priceDate": "2024-07-30T00:00:00-04:00",
    "ticks": 638578944000000000,
    "epochTime": 1722297600,
    "hasValue": true,
    "time": "2024-07-30"
  },
  {
    "open": 4.1341,
    "high": 4.1413,
    "low": 4.0301,
    "close": 4.0306,
    "priceDate": "2024-07-31T00:00:00-04:00",
    "ticks": 638579808000000000,
    "epochTime": 1722384000,
    "hasValue": true,
    "time": "2024-07-31"
  },
  {
    "open": 4.0598,
    "high": 4.0626,
    "low": 3.9631,
    "close": 3.9774,
    "priceDate": "2024-08-01T00:00:00-04:00",
    "ticks": 638580672000000000,
    "epochTime": 1722470400,
    "hasValue": true,
    "time": "2024-08-01"
  },
  {
    "open": 3.9376,
    "high": 3.94,
    "low": 3.7852,
    "close": 3.7899,
    "priceDate": "2024-08-02T00:00:00-04:00",
    "ticks": 638581536000000000,
    "epochTime": 1722556800,
    "hasValue": true,
    "time": "2024-08-02"
  },
  {
    "open": 3.7062,
    "high": 3.8306,
    "low": 3.6658,
    "close": 3.7902,
    "priceDate": "2024-08-05T00:00:00-04:00",
    "ticks": 638584128000000000,
    "epochTime": 1722816000,
    "hasValue": true,
    "time": "2024-08-05"
  },
  {
    "open": 3.8413,
    "high": 3.908,
    "low": 3.8042,
    "close": 3.8957,
    "priceDate": "2024-08-06T00:00:00-04:00",
    "ticks": 638584992000000000,
    "epochTime": 1722902400,
    "hasValue": true,
    "time": "2024-08-06"
  },
  {
    "open": 3.9316,
    "high": 3.9769,
    "low": 3.9264,
    "close": 3.9421,
    "priceDate": "2024-08-07T00:00:00-04:00",
    "ticks": 638585856000000000,
    "epochTime": 1722988800,
    "hasValue": true,
    "time": "2024-08-07"
  },
  {
    "open": 3.9298,
    "high": 4.0209,
    "low": 3.9236,
    "close": 3.9935,
    "priceDate": "2024-08-08T00:00:00-04:00",
    "ticks": 638586720000000000,
    "epochTime": 1723075200,
    "hasValue": true,
    "time": "2024-08-08"
  },
  {
    "open": 3.9431,
    "high": 3.9494,
    "low": 3.9207,
    "close": 3.9388,
    "priceDate": "2024-08-09T00:00:00-04:00",
    "ticks": 638587584000000000,
    "epochTime": 1723161600,
    "hasValue": true,
    "time": "2024-08-09"
  },
  {
    "open": 3.9417,
    "high": 3.9656,
    "low": 3.8954,
    "close": 3.905,
    "priceDate": "2024-08-12T00:00:00-04:00",
    "ticks": 638590176000000000,
    "epochTime": 1723420800,
    "hasValue": true,
    "time": "2024-08-12"
  }
]

export const LONG_Term_INV_numbers = {
  '15': {
    "amortisationGainArray": [
      1896.59,
      3875.38,
      5939.93,
      8093.950000000001,
      10341.32,
      12686.1,
      15132.470000000001,
      17684.88,
      20347.89,
      23126.3,
      26025.16,
      29049.64,
      32205.2,
      35497.48,
      38932.47
    ],
    "taxBerettaArray": [
      -6657.07,
      -6680.91,
      -6705.77,
      -6731.72,
      -6758.79,
      -6787.04,
      -6816.51,
      -6847.25,
      -6879.33,
      -6912.8,
      -6947.72,
      -6984.15,
      -7022.16,
      -7061.82,
      -7103.2
    ],
    "appreciationGainArray": [
      8655,
      17809.390000000014,
      27492,
      37733.28,
      48565.48999999999,
      60022.72,
      72141.03,
      84958.57,
      98515.68,
      112855.03999999998,
      128021.77000000002,
      144063.63,
      161031.09999999998,
      178977.59000000003,
      197959.59999999998
    ],
    "totals": {
      "amortisationGainTotal": 38932.47,
      "taxBerettaTotal": 8523,
      "appreciationGainTotal": 197959.59999999998
    }
  },
  '30': {
    "amortisationGainArray": [
      1896.59,
      3875.38,
      5939.93,
      8093.950000000001,
      10341.32,
      12686.1,
      15132.470000000001,
      17684.88,
      20347.89,
      23126.3,
      26025.16,
      29049.64,
      32205.2,
      35497.48,
      38932.47,
      42516.31,
      46255.46,
      50156.67,
      54226.939999999995,
      58473.60999999999,
      62904.34,
      67527.06999999999,
      72350.13999999998,
      77382.20999999999,
      82632.4,
      88110.09,
      93825.17,
      99787.94,
      106009.13,
      112499.92
    ],
    "taxBerettaArray": [
      -6657.07,
      -6680.91,
      -6705.77,
      -6731.72,
      -6758.79,
      -6787.04,
      -6816.51,
      -6847.25,
      -6879.33,
      -6912.8,
      -6947.72,
      -6984.15,
      -7022.16,
      -7061.82,
      -7103.2,
      -7146.37,
      -7191.41,
      -7238.41,
      -7287.44,
      -7338.59,
      -7391.96,
      -7447.65,
      -7505.75,
      -7566.36,
      -7629.6,
      -7695.59,
      -7764.43,
      -7836.26,
      -7911.2,
      -7989.38
    ],
    "appreciationGainArray": [
      8655,
      17809.390000000014,
      27492,
      37733.28,
      48565.48999999999,
      60022.72,
      72141.03,
      84958.57,
      98515.68,
      112855.03999999998,
      128021.77000000002,
      144063.63,
      161031.09999999998,
      178977.59000000003,
      197959.59999999998,
      218036.87,
      239272.59999999998,
      261733.63,
      285490.66,
      310618.47,
      337196.15,
      365307.37,
      395040.61,
      426489.44999999995,
      459752.89,
      494935.63,
      532148.42,
      571508.38,
      613139.42,
      657172.56
    ],
    "totals": {
      "amortisationGainTotal": 112499.92,
      "taxBerettaTotal": -215836.63999999998,
      "appreciationGainTotal": 657172.56
    }
  }
}

export const BI_WEEKLY_SAVING = {
  "biWeeklyPayment": "10195",
  "totalInterestSaved": "472977.94",
  "paidOffEarlyYears": 2,
  "paidOffEarlyMonths": 2,
  "savingsPerYear": [
    "15765.93",
    "31531.86",
    "47297.79",
    "63063.72",
    "78829.65",
    "94595.58",
    "110361.51",
    "126127.44",
    "141893.37",
    "157659.30",
    "173425.23",
    "189191.16",
    "204957.09",
    "220723.02",
    "236488.95",
    "252254.88",
    "268020.81",
    "283786.74",
    "299552.67",
    "315318.60",
    "331084.53",
    "346850.46",
    "362616.39",
    "378382.32",
    "394148.25",
    "409914.18",
    "425680.11",
    "441446.04",
    "457211.97",
    "472977.90"
  ]
}

export const BREAK_EVEN_POINT = {
  "years": 4,
  "months": 3,
  "monthlySavings": "132.91",
  "currentInterestRate": "4.3",
  "interestRateWithoutPoints": "4.5",
  "costOfPoints": "5625"
}

export const BY_DOWN_CALCULATOR: IBuyDownOption[] = [
  {
    "key": "oneYearBuyDown",
    "title": "1 Year buydown",
    "rows": [
      {
        "key": "oneYearBuyDown-0",
        "interestRate": "3.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "5039.90",
        "monthlySubsidy": "651.95",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "7823.40"
      }
    ],
    "total": "7823.40"
  },
  {
    "key": "twoYearsBuyDown",
    "title": "2 Year buydown",
    "rows": [
      {
        "key": "twoYearsBuyDown-0",
        "interestRate": "2.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "4430.64",
        "monthlySubsidy": "1261.21",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "15134.52"
      },
      {
        "key": "twoYearsBuyDown-1",
        "interestRate": "3.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "5039.90",
        "monthlySubsidy": "651.95",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "7823.40"
      }
    ],
    "total": "22957.92"
  },
  {
    "key": "threeYearsBuyDown",
    "title": "3 Year buydown",
    "rows": [
      {
        "key": "threeYearsBuyDown-0",
        "interestRate": "1.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "3866.36",
        "monthlySubsidy": "1825.49",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "21905.88"
      },
      {
        "key": "threeYearsBuyDown-1",
        "interestRate": "2.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "4430.64",
        "monthlySubsidy": "1261.21",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "15134.52"
      },
      {
        "key": "threeYearsBuyDown-2",
        "interestRate": "3.375%",
        "payment": "5691.85",
        "paymentWithSubstitudy": "5039.90",
        "monthlySubsidy": "651.95",
        "numPaymentsPerYear": 12,
        "annualSubsidyPayments": "7823.40"
      }
    ],
    "total": "44863.80"
  }
]

export const RENTCAST_DATA: any = {
  "bedrooms2": [
    {
      "month": "2021-11",
      "bedrooms": 2,
      "averageRent": 2122.22,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 27
    },
    {
      "month": "2021-12",
      "bedrooms": 2,
      "averageRent": 2110.88,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 34
    },
    {
      "month": "2021-10",
      "bedrooms": 2,
      "averageRent": 2138.1,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 42
    },
    {
      "month": "2021-09",
      "bedrooms": 2,
      "averageRent": 2145.35,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 43
    },
    {
      "month": "2021-08",
      "bedrooms": 2,
      "averageRent": 2130.72,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 47
    },
    {
      "month": "2021-07",
      "bedrooms": 2,
      "averageRent": 2134.78,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 50
    },
    {
      "month": "2022-01",
      "bedrooms": 2,
      "averageRent": 2161.82,
      "minRent": 1700,
      "maxRent": 3600,
      "totalListings": 28
    },
    {
      "month": "2022-02",
      "bedrooms": 2,
      "averageRent": 2196.65,
      "minRent": 1695,
      "maxRent": 3600,
      "totalListings": 26
    },
    {
      "month": "2022-03",
      "bedrooms": 2,
      "averageRent": 2156.25,
      "minRent": 1200,
      "maxRent": 3600,
      "totalListings": 24
    },
    {
      "month": "2022-04",
      "bedrooms": 2,
      "averageRent": 2289.62,
      "minRent": 1200,
      "maxRent": 3600,
      "totalListings": 26
    },
    {
      "month": "2022-05",
      "bedrooms": 2,
      "averageRent": 2367.15,
      "minRent": 1200,
      "maxRent": 3600,
      "totalListings": 39
    },
    {
      "month": "2022-06",
      "bedrooms": 2,
      "averageRent": 2409.72,
      "minRent": 1200,
      "maxRent": 3600,
      "totalListings": 43
    },
    {
      "month": "2022-07",
      "bedrooms": 2,
      "averageRent": 2444.8,
      "minRent": 1495,
      "maxRent": 3600,
      "totalListings": 45
    },
    {
      "month": "2022-08",
      "bedrooms": 2,
      "averageRent": 2496.86,
      "minRent": 1600,
      "maxRent": 3600,
      "totalListings": 44
    },
    {
      "month": "2022-09",
      "bedrooms": 2,
      "averageRent": 2506.8,
      "minRent": 1700,
      "maxRent": 3442,
      "totalListings": 45
    },
    {
      "month": "2022-10",
      "bedrooms": 2,
      "averageRent": 2481.84,
      "minRent": 1495,
      "maxRent": 3442,
      "totalListings": 50
    },
    {
      "month": "2022-11",
      "bedrooms": 2,
      "averageRent": 2445.07,
      "minRent": 1495,
      "maxRent": 3442,
      "totalListings": 45
    },
    {
      "month": "2022-12",
      "bedrooms": 2,
      "averageRent": 2390.72,
      "minRent": 1495,
      "maxRent": 2895,
      "totalListings": 46
    },
    {
      "month": "2023-01",
      "bedrooms": 2,
      "averageRent": 2401,
      "minRent": 1495,
      "maxRent": 2999,
      "totalListings": 50
    },
    {
      "month": "2023-02",
      "bedrooms": 2,
      "averageRent": 2406,
      "minRent": 1454,
      "maxRent": 3050,
      "totalListings": 53
    },
    {
      "month": "2023-03",
      "bedrooms": 2,
      "averageRent": 2473,
      "minRent": 1700,
      "maxRent": 3200,
      "totalListings": 56
    },
    {
      "month": "2023-04",
      "bedrooms": 2,
      "averageRent": 2466,
      "minRent": 1700,
      "maxRent": 3200,
      "totalListings": 58
    },
    {
      "month": "2023-05",
      "bedrooms": 2,
      "averageRent": 2447,
      "minRent": 1495,
      "maxRent": 3200,
      "totalListings": 60
    },
    {
      "month": "2023-06",
      "bedrooms": 2,
      "averageRent": 2428,
      "minRent": 1495,
      "maxRent": 3200,
      "totalListings": 62
    },
    {
      "month": "2023-07",
      "bedrooms": 2,
      "averageRent": 2420,
      "minRent": 1495,
      "maxRent": 2899,
      "totalListings": 56
    },
    {
      "month": "2023-08",
      "bedrooms": 2,
      "averageRent": 2429,
      "minRent": 1495,
      "maxRent": 3400,
      "totalListings": 61
    },
    {
      "month": "2023-09",
      "bedrooms": 2,
      "averageRent": 2504,
      "minRent": 1495,
      "maxRent": 3400,
      "totalListings": 59
    },
    {
      "month": "2023-10",
      "bedrooms": 2,
      "averageRent": 2526,
      "minRent": 1495,
      "maxRent": 3400,
      "totalListings": 57
    },
    {
      "month": "2023-11",
      "bedrooms": 2,
      "averageRent": 2536,
      "minRent": 1495,
      "maxRent": 3400,
      "totalListings": 64
    },
    {
      "month": "2023-12",
      "bedrooms": 2,
      "averageRent": 2540,
      "minRent": 1495,
      "maxRent": 3300,
      "totalListings": 58
    },
    {
      "month": "2024-01",
      "bedrooms": 2,
      "averageRent": 2517,
      "minRent": 1495,
      "maxRent": 3300,
      "totalListings": 43
    },
    {
      "month": "2024-02",
      "bedrooms": 2,
      "averageRent": 2499,
      "minRent": 1495,
      "maxRent": 3300,
      "totalListings": 44
    },
    {
      "month": "2024-03",
      "bedrooms": 2,
      "averageRent": 2509,
      "minRent": 1495,
      "maxRent": 3300,
      "totalListings": 43
    },
    {
      "month": "2024-04",
      "bedrooms": 2,
      "averageRent": 2461,
      "minRent": 1495,
      "maxRent": 3500,
      "totalListings": 44
    },
    {
      "month": "2024-05",
      "bedrooms": 2,
      "averageRent": 2479,
      "minRent": 1495,
      "maxRent": 3500,
      "totalListings": 57
    },
    {
      "month": "2024-06",
      "bedrooms": 2,
      "averageRent": 2474,
      "minRent": 1495,
      "maxRent": 3500,
      "totalListings": 63
    }
  ],
  "bedrooms2Average": 2474,
  "bedrooms4": [
    {
      "month": "2021-11",
      "bedrooms": 4,
      "averageRent": 3350,
      "minRent": 3000,
      "maxRent": 3850,
      "totalListings": 3
    },
    {
      "month": "2021-12",
      "bedrooms": 4,
      "averageRent": 3712.5,
      "minRent": 3000,
      "maxRent": 4800,
      "totalListings": 4
    },
    {
      "month": "2021-10",
      "bedrooms": 4,
      "averageRent": 3889,
      "minRent": 3000,
      "maxRent": 4800,
      "totalListings": 5
    },
    {
      "month": "2021-09",
      "bedrooms": 4,
      "averageRent": 3889,
      "minRent": 3000,
      "maxRent": 4800,
      "totalListings": 5
    },
    {
      "month": "2021-08",
      "bedrooms": 4,
      "averageRent": 3889,
      "minRent": 3000,
      "maxRent": 4800,
      "totalListings": 5
    },
    {
      "month": "2021-07",
      "bedrooms": 4,
      "averageRent": 3740,
      "minRent": 2995,
      "maxRent": 4800,
      "totalListings": 6
    },
    {
      "month": "2022-01",
      "bedrooms": 4,
      "averageRent": 4437.5,
      "minRent": 3850,
      "maxRent": 5200,
      "totalListings": 4
    },
    {
      "month": "2022-02",
      "bedrooms": 4,
      "averageRent": 4437.5,
      "minRent": 3850,
      "maxRent": 5200,
      "totalListings": 4
    },
    {
      "month": "2022-03",
      "bedrooms": 4,
      "averageRent": 4474.75,
      "minRent": 3900,
      "maxRent": 5200,
      "totalListings": 4
    },
    {
      "month": "2022-04",
      "bedrooms": 4,
      "averageRent": 4149.75,
      "minRent": 3500,
      "maxRent": 5200,
      "totalListings": 4
    },
    {
      "month": "2022-05",
      "bedrooms": 4,
      "averageRent": 4631.33,
      "minRent": 3900,
      "maxRent": 5995,
      "totalListings": 3
    },
    {
      "month": "2022-06",
      "bedrooms": 4,
      "averageRent": 4153.8,
      "minRent": 3200,
      "maxRent": 5995,
      "totalListings": 5
    },
    {
      "month": "2022-07",
      "bedrooms": 4,
      "averageRent": 4259.14,
      "minRent": 3200,
      "maxRent": 5995,
      "totalListings": 7
    },
    {
      "month": "2022-08",
      "bedrooms": 4,
      "averageRent": 4173.57,
      "minRent": 3200,
      "maxRent": 5995,
      "totalListings": 7
    },
    {
      "month": "2022-09",
      "bedrooms": 4,
      "averageRent": 3870,
      "minRent": 3200,
      "maxRent": 4250,
      "totalListings": 6
    },
    {
      "month": "2022-10",
      "bedrooms": 4,
      "averageRent": 4291.43,
      "minRent": 3395,
      "maxRent": 5200,
      "totalListings": 7
    },
    {
      "month": "2022-11",
      "bedrooms": 4,
      "averageRent": 4165,
      "minRent": 3395,
      "maxRent": 5200,
      "totalListings": 6
    },
    {
      "month": "2022-12",
      "bedrooms": 4,
      "averageRent": 4165,
      "minRent": 3395,
      "maxRent": 5200,
      "totalListings": 6
    },
    {
      "month": "2023-01",
      "bedrooms": 4,
      "averageRent": 4518,
      "minRent": 3395,
      "maxRent": 5500,
      "totalListings": 5
    },
    {
      "month": "2023-02",
      "bedrooms": 4,
      "averageRent": 4097,
      "minRent": 3395,
      "maxRent": 5500,
      "totalListings": 3
    },
    {
      "month": "2023-03",
      "bedrooms": 4,
      "averageRent": 4748,
      "minRent": 3995,
      "maxRent": 5500,
      "totalListings": 2
    },
    {
      "month": "2023-04",
      "bedrooms": 4,
      "averageRent": 4748,
      "minRent": 3995,
      "maxRent": 5500,
      "totalListings": 2
    },
    {
      "month": "2023-05",
      "bedrooms": 4,
      "averageRent": 5746,
      "minRent": 3995,
      "maxRent": 6500,
      "totalListings": 4
    },
    {
      "month": "2023-06",
      "bedrooms": 4,
      "averageRent": 5621,
      "minRent": 3995,
      "maxRent": 6495,
      "totalListings": 4
    },
    {
      "month": "2023-07",
      "bedrooms": 4,
      "averageRent": 5382,
      "minRent": 3990,
      "maxRent": 6495,
      "totalListings": 4
    },
    {
      "month": "2023-08",
      "bedrooms": 4,
      "averageRent": 5363,
      "minRent": 3990,
      "maxRent": 6495,
      "totalListings": 6
    },
    {
      "month": "2023-09",
      "bedrooms": 4,
      "averageRent": 5057,
      "minRent": 3990,
      "maxRent": 6000,
      "totalListings": 5
    },
    {
      "month": "2023-10",
      "bedrooms": 4,
      "averageRent": 4774,
      "minRent": 3950,
      "maxRent": 6000,
      "totalListings": 7
    },
    {
      "month": "2023-11",
      "bedrooms": 4,
      "averageRent": 4569,
      "minRent": 3950,
      "maxRent": 6000,
      "totalListings": 6
    },
    {
      "month": "2023-12",
      "bedrooms": 4,
      "averageRent": 4523,
      "minRent": 3950,
      "maxRent": 6000,
      "totalListings": 5
    },
    {
      "month": "2024-01",
      "bedrooms": 4,
      "averageRent": 4143,
      "minRent": 3950,
      "maxRent": 4480,
      "totalListings": 3
    },
    {
      "month": "2024-02",
      "bedrooms": 4,
      "averageRent": 4000,
      "minRent": 4000,
      "maxRent": 4000,
      "totalListings": 1
    },
    {
      "month": "2024-03",
      "bedrooms": 4,
      "averageRent": 4717,
      "minRent": 4000,
      "maxRent": 5650,
      "totalListings": 3
    },
    {
      "month": "2024-04",
      "bedrooms": 4,
      "averageRent": 5075,
      "minRent": 4500,
      "maxRent": 5650,
      "totalListings": 2
    },
    {
      "month": "2024-05",
      "bedrooms": 4,
      "averageRent": 5548,
      "minRent": 4500,
      "maxRent": 6495,
      "totalListings": 3
    },
    {
      "month": "2024-06",
      "bedrooms": 4,
      "averageRent": 5548,
      "minRent": 4500,
      "maxRent": 6495,
      "totalListings": 3
    }
  ],
  "bedrooms4Average": 5548,
  "avg": [
    {
      "month": "2021-11",
      "averageRent": 2646.4,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 65
    },
    {
      "month": "2021-12",
      "averageRent": 2680.95,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 80
    },
    {
      "month": "2021-10",
      "averageRent": 2701.82,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 93
    },
    {
      "month": "2021-09",
      "averageRent": 2701.11,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 95
    },
    {
      "month": "2021-08",
      "averageRent": 2698.67,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 99
    },
    {
      "month": "2021-07",
      "averageRent": 2671.35,
      "minRent": 950,
      "maxRent": 5000,
      "totalListings": 105
    },
    {
      "month": "2022-01",
      "averageRent": 2757.61,
      "minRent": 950,
      "maxRent": 5200,
      "totalListings": 72
    },
    {
      "month": "2022-02",
      "averageRent": 2619.8,
      "minRent": 950,
      "maxRent": 5200,
      "totalListings": 70
    },
    {
      "month": "2022-03",
      "averageRent": 2618.21,
      "minRent": 1195,
      "maxRent": 5200,
      "totalListings": 67
    },
    {
      "month": "2022-04",
      "averageRent": 2624.24,
      "minRent": 775,
      "maxRent": 5200,
      "totalListings": 65
    },
    {
      "month": "2022-05",
      "averageRent": 2751.16,
      "minRent": 775,
      "maxRent": 5995,
      "totalListings": 79
    },
    {
      "month": "2022-06",
      "averageRent": 2704.69,
      "minRent": 775,
      "maxRent": 5995,
      "totalListings": 93
    },
    {
      "month": "2022-07",
      "averageRent": 2706.08,
      "minRent": 775,
      "maxRent": 5995,
      "totalListings": 96
    },
    {
      "month": "2022-08",
      "averageRent": 3250.56,
      "minRent": 775,
      "maxRent": 5995,
      "totalListings": 97
    },
    {
      "month": "2022-09",
      "averageRent": 3195.61,
      "minRent": 775,
      "maxRent": 5960,
      "totalListings": 96
    },
    {
      "month": "2022-10",
      "averageRent": 3129.75,
      "minRent": 775,
      "maxRent": 5960,
      "totalListings": 103
    },
    {
      "month": "2022-11",
      "averageRent": 3135.82,
      "minRent": 950,
      "maxRent": 5960,
      "totalListings": 106
    },
    {
      "month": "2022-12",
      "averageRent": 3137,
      "minRent": 950,
      "maxRent": 5960,
      "totalListings": 100
    },
    {
      "month": "2023-01",
      "averageRent": 2734,
      "minRent": 1325,
      "maxRent": 5500,
      "totalListings": 105
    },
    {
      "month": "2023-02",
      "averageRent": 2857,
      "minRent": 1395,
      "maxRent": 5500,
      "totalListings": 115
    },
    {
      "month": "2023-03",
      "averageRent": 2617,
      "minRent": 1390,
      "maxRent": 5500,
      "totalListings": 108
    },
    {
      "month": "2023-04",
      "averageRent": 2631,
      "minRent": 1450,
      "maxRent": 5500,
      "totalListings": 105
    },
    {
      "month": "2023-05",
      "averageRent": 2723,
      "minRent": 1450,
      "maxRent": 6500,
      "totalListings": 111
    },
    {
      "month": "2023-06",
      "averageRent": 2651,
      "minRent": 899,
      "maxRent": 6495,
      "totalListings": 108
    },
    {
      "month": "2023-07",
      "averageRent": 2628,
      "minRent": 899,
      "maxRent": 6495,
      "totalListings": 105
    },
    {
      "month": "2023-08",
      "averageRent": 2647,
      "minRent": 899,
      "maxRent": 6495,
      "totalListings": 111
    },
    {
      "month": "2023-09",
      "averageRent": 2707,
      "minRent": 899,
      "maxRent": 6000,
      "totalListings": 107
    },
    {
      "month": "2023-10",
      "averageRent": 2712,
      "minRent": 950,
      "maxRent": 6000,
      "totalListings": 112
    },
    {
      "month": "2023-11",
      "averageRent": 2649,
      "minRent": 950,
      "maxRent": 6000,
      "totalListings": 116
    },
    {
      "month": "2023-12",
      "averageRent": 2691,
      "minRent": 1000,
      "maxRent": 6000,
      "totalListings": 106
    },
    {
      "month": "2024-01",
      "averageRent": 2711,
      "minRent": 950,
      "maxRent": 4800,
      "totalListings": 79
    },
    {
      "month": "2024-02",
      "averageRent": 2631,
      "minRent": 950,
      "maxRent": 4800,
      "totalListings": 86
    },
    {
      "month": "2024-03",
      "averageRent": 2671,
      "minRent": 950,
      "maxRent": 5650,
      "totalListings": 84
    },
    {
      "month": "2024-04",
      "averageRent": 2565,
      "minRent": 950,
      "maxRent": 5650,
      "totalListings": 91
    },
    {
      "month": "2024-05",
      "averageRent": 2587,
      "minRent": 950,
      "maxRent": 6495,
      "totalListings": 111
    },
    {
      "month": "2024-06",
      "averageRent": 2601,
      "minRent": 950,
      "maxRent": 6495,
      "totalListings": 115
    }
  ],
  "averageRent": 2601
}

export const RENTCAST_LABELS = "[\"Average\",\"2BD\",\"4BD\"]"

export const RECENTLY_VIEWED: IRecentlyViewed[] = [
  {
    "id": 1,
    "name": "Emily Johnson",
    "email": "emily.johnson@example.com",
    "createdAt": "2024-10-10T10:00:00.000Z",
    "updatedAt": "2024-10-10T10:00:00.000Z",
    "viewIp": "192.168.1.1",
    "Report": {
      "id": "f50e5f99-2600-4c57-9fca-dad9473c2525",
      "name": "Emily Johnson - Home Purchase"
    }
  },
  {
    "id": 2,
    "name": "Michael Smith",
    "email": "michael.smith@example.com",
    "createdAt": "2024-10-10T11:00:00.000Z",
    "updatedAt": "2024-10-10T11:00:00.000Z",
    "viewIp": "192.168.1.2",
    "Report": {
      "id": "c43e5f99-2600-4c57-9fca-dad9473c2526",
      "name": "Michael Smith - Home Purchase"
    }
  },
  {
    "id": 3,
    "name": "Jessica Lee",
    "email": null,
    "createdAt": "2024-10-10T12:00:00.000Z",
    "updatedAt": "2024-10-10T12:00:00.000Z",
    "viewIp": "192.168.1.3",
    "Report": {
      "id": "b72e5f99-2600-4c57-9fca-dad9473c2527",
      "name": "Jessica Lee - Home Purchase"
    }
  },
  {
    "id": 4,
    "name": "David Brown",
    "email": "david.brown@example.com",
    "createdAt": "2024-10-10T13:00:00.000Z",
    "updatedAt": "2024-10-10T13:00:00.000Z",
    "viewIp": "192.168.1.4",
    "Report": {
      "id": "a61e5f99-2600-4c57-9fca-dad9473c2528",
      "name": "David Brown - Home Purchase"
    }
  },
  {
    "id": 5,
    "name": "Laura Williams",
    "email": "laura.williams@example.com",
    "createdAt": "2024-10-10T14:00:00.000Z",
    "updatedAt": "2024-10-10T14:00:00.000Z",
    "viewIp": "192.168.1.5",
    "Report": {
      "id": "f87e5f99-2600-4c57-9fca-dad9473c2529",
      "name": "Laura Williams - Home Purchase"
    }
  },
  {
    "id": 6,
    "name": "James Miller",
    "email": "james.miller@example.com",
    "createdAt": "2024-10-10T15:00:00.000Z",
    "updatedAt": "2024-10-10T15:00:00.000Z",
    "viewIp": "192.168.1.6",
    "Report": {
      "id": "d92e5f99-2600-4c57-9fca-dad9473c252a",
      "name": "James Miller - Home Purchase"
    }
  },
  {
    "id": 7,
    "name": "Olivia Wilson",
    "email": "olivia.wilson@example.com",
    "createdAt": "2024-10-10T16:00:00.000Z",
    "updatedAt": "2024-10-10T16:00:00.000Z",
    "viewIp": "192.168.1.7",
    "Report": {
      "id": "e12e5f99-2600-4c57-9fca-dad9473c252b",
      "name": "Olivia Wilson - Home Purchase"
    }
  },
  {
    "id": 8,
    "name": "William Anderson",
    "email": "william.anderson@example.com",
    "createdAt": "2024-10-10T17:00:00.000Z",
    "updatedAt": "2024-10-10T17:00:00.000Z",
    "viewIp": "192.168.1.8",
    "Report": {
      "id": "f34e5f99-2600-4c57-9fca-dad9473c252c",
      "name": "William Anderson - Home Purchase"
    }
  },
  {
    "id": 9,
    "name": "Sophia Thomas",
    "email": "sophia.thomas@example.com",
    "createdAt": "2024-10-10T18:00:00.000Z",
    "updatedAt": "2024-10-10T18:00:00.000Z",
    "viewIp": "192.168.1.9",
    "Report": {
      "id": "g78e5f99-2600-4c57-9fca-dad9473c252d",
      "name": "Sophia Thomas - Home Purchase"
    }
  },
  {
    "id": 10,
    "name": "Aiden Garcia",
    "email": "aiden.garcia@example.com",
    "createdAt": "2024-10-10T19:00:00.000Z",
    "updatedAt": "2024-10-10T19:00:00.000Z",
    "viewIp": "192.168.1.10",
    "Report": {
      "id": "h23e5f99-2600-4c57-9fca-dad9473c252e",
      "name": "Aiden Garcia - Home Purchase"
    }
  },
  {
    "id": 11,
    "name": "Mia Martinez",
    "email": "mia.martinez@example.com",
    "createdAt": "2024-10-10T20:00:00.000Z",
    "updatedAt": "2024-10-10T20:00:00.000Z",
    "viewIp": "192.168.1.11",
    "Report": {
      "id": "j45e5f99-2600-4c57-9fca-dad9473c252f",
      "name": "Mia Martinez - Home Purchase"
    }
  },
  {
    "id": 12,
    "name": "Lucas Hernandez",
    "email": "lucas.hernandez@example.com",
    "createdAt": "2024-10-10T21:00:00.000Z",
    "updatedAt": "2024-10-10T21:00:00.000Z",
    "viewIp": "192.168.1.12",
    "Report": {
      "id": "k76e5f99-2600-4c57-9fca-dad9473c252g",
      "name": "Lucas Hernandez - Home Purchase"
    }
  },
  {
    "id": 13,
    "name": "Isabella Clark",
    "email": "isabella.clark@example.com",
    "createdAt": "2024-10-10T22:00:00.000Z",
    "updatedAt": "2024-10-10T22:00:00.000Z",
    "viewIp": "192.168.1.13",
    "Report": {
      "id": "l87e5f99-2600-4c57-9fca-dad9473c252h",
      "name": "Isabella Clark - Home Purchase"
    }
  },
  {
    "id": 14,
    "name": "Ethan Lewis",
    "email": "ethan.lewis@example.com",
    "createdAt": "2024-10-10T23:00:00.000Z",
    "updatedAt": "2024-10-10T23:00:00.000Z",
    "viewIp": "192.168.1.14",
    "Report": {
      "id": "m98e5f99-2600-4c57-9fca-dad9473c252i",
      "name": "Ethan Lewis - Home Purchase"
    }
  }
]

export const ALL_VIEWED_REPORTS: IAllViewed[] = [
  {
    "id": "9bfcc7df-363f-4532-8ebc-734105361522",
    "name": "Ethos Lending Demo",
    "status": "draft",
    "createdAt": "2024-06-07T16:04:04.000Z",
    "updatedAt": "2024-06-10T19:45:29.000Z",
    "UserViews": [
      {
        "id": 1,
        "name": "Shawn B.",
        "email": null,
        "createdAt": "2024-06-07T16:15:53.000Z",
        "updatedAt": "2024-06-07T16:15:53.000Z",
        "viewIp": "68.101.150.245"
      }
    ]
  },
  {
    "id": "509c62ce-1783-4dc7-91d8-607fa69cfa58",
    "name": "Jordan and Alyssa Zurowski",
    "status": "completed",
    "createdAt": "2024-05-03T01:39:08.000Z",
    "updatedAt": "2024-06-07T16:42:56.000Z",
    "UserViews": [
      {
        "id": 2,
        "name": "Shawn",
        "email": null,
        "createdAt": "2024-06-07T16:39:20.000Z",
        "updatedAt": "2024-06-07T16:39:20.000Z",
        "viewIp": "68.101.150.245"
      },
      {
        "id": 3,
        "name": "Mario O.",
        "email": null,
        "createdAt": "2024-06-07T16:42:16.000Z",
        "updatedAt": "2024-06-07T16:42:16.000Z",
        "viewIp": "23.127.137.49"
      }
    ]
  },
  {
    "id": "f74303b7-9cb4-4df6-8d25-ef2a7f19b463",
    "name": "Korine Craze",
    "status": "draft",
    "createdAt": "2024-06-02T03:00:43.000Z",
    "updatedAt": "2024-09-02T13:22:06.000Z",
    "UserViews": [
      {
        "id": 4,
        "name": "Shawn B",
        "email": null,
        "createdAt": "2024-06-08T22:47:00.000Z",
        "updatedAt": "2024-06-08T22:47:00.000Z",
        "viewIp": "68.101.150.245"
      },
      {
        "id": 5,
        "name": "Korine Craze",
        "email": null,
        "createdAt": "2024-06-08T23:02:17.000Z",
        "updatedAt": "2024-06-08T23:02:17.000Z",
        "viewIp": "172.56.191.174"
      },
      {
        "id": 6,
        "name": "Korine Craze",
        "email": null,
        "createdAt": "2024-06-09T23:24:44.000Z",
        "updatedAt": "2024-06-09T23:24:44.000Z",
        "viewIp": "68.5.197.114"
      },
      {
        "id": 27,
        "name": "Shawn Brown",
        "email": null,
        "createdAt": "2024-07-13T21:08:20.000Z",
        "updatedAt": "2024-07-13T21:08:20.000Z",
        "viewIp": "174.202.6.181"
      },
      {
        "id": 31,
        "name": "Sb",
        "email": null,
        "createdAt": "2024-07-22T18:13:51.000Z",
        "updatedAt": "2024-07-22T18:13:51.000Z",
        "viewIp": "68.8.56.244"
      }
    ]
  },
  {
    "id": "ac2f960f-1609-4ca4-8ec3-e1b8375e6589",
    "name": "asdasdas",
    "status": "draft",
    "createdAt": "2024-06-04T16:21:38.000Z",
    "updatedAt": "2024-06-18T11:25:19.000Z",
    "UserViews": [
      {
        "id": 12,
        "name": "Sahak",
        "email": null,
        "createdAt": "2024-06-18T11:24:38.000Z",
        "updatedAt": "2024-06-18T11:24:38.000Z",
        "viewIp": "81.16.8.234"
      }
    ]
  },
  {
    "id": "72ac2d4b-71e1-471a-9819-9c734c3d41f0",
    "name": "8104 Denali Drive, San Diego, CA 92126",
    "status": "completed",
    "createdAt": "2024-06-20T17:32:00.000Z",
    "updatedAt": "2024-07-07T20:55:29.000Z",
    "UserViews": [
      {
        "id": 13,
        "name": "Julie",
        "email": "julie@clendinggroup.com",
        "createdAt": "2024-06-20T18:03:21.000Z",
        "updatedAt": "2024-06-20T18:03:21.000Z",
        "viewIp": "68.6.224.97"
      },
      {
        "id": 14,
        "name": "Dove",
        "email": null,
        "createdAt": "2024-06-20T20:37:12.000Z",
        "updatedAt": "2024-06-20T20:37:12.000Z",
        "viewIp": "107.115.41.63"
      }
    ]
  },
  {
    "id": "acfc9f30-9d86-455c-ac65-353b95c053d8",
    "name": "",
    "status": "completed",
    "createdAt": "2024-06-08T22:26:14.000Z",
    "updatedAt": "2024-06-27T14:40:28.000Z",
    "UserViews": [
      {
        "id": 20,
        "name": "sahak",
        "email": null,
        "createdAt": "2024-06-27T14:06:42.000Z",
        "updatedAt": "2024-06-27T14:06:42.000Z",
        "viewIp": "81.16.8.234"
      }
    ]
  },
  {
    "id": "389712d6-ec53-4108-a2b7-3da4ac5a8e25",
    "name": "New Test Report",
    "status": "completed",
    "createdAt": "2024-06-29T14:21:08.000Z",
    "updatedAt": "2024-06-29T14:43:00.000Z",
    "UserViews": [
      {
        "id": 21,
        "name": "Shawn B.",
        "email": "Test@Gmail.com",
        "createdAt": "2024-06-29T14:41:02.000Z",
        "updatedAt": "2024-06-29T14:41:02.000Z",
        "viewIp": "68.6.224.97"
      }
    ]
  },
  {
    "id": "f143ad95-b4fc-40d7-acff-1ffb7b106063",
    "name": "New Report TKesting",
    "status": "completed",
    "createdAt": "2024-06-29T14:43:03.000Z",
    "updatedAt": "2024-07-02T17:56:03.000Z",
    "UserViews": [
      {
        "id": 22,
        "name": "Testing ",
        "email": null,
        "createdAt": "2024-06-29T14:46:04.000Z",
        "updatedAt": "2024-06-29T14:46:04.000Z",
        "viewIp": "68.6.224.97"
      },
      {
        "id": 23,
        "name": "Testing ",
        "email": null,
        "createdAt": "2024-06-29T14:46:04.000Z",
        "updatedAt": "2024-06-29T14:46:04.000Z",
        "viewIp": "68.6.224.97"
      }
    ]
  },
  {
    "id": "4baa22fe-c79d-428d-89a9-fe2deebb6892",
    "name": "",
    "status": "draft",
    "createdAt": "2024-06-29T14:46:52.000Z",
    "updatedAt": "2024-06-29T14:50:19.000Z",
    "UserViews": [
      {
        "id": 24,
        "name": "ss",
        "email": null,
        "createdAt": "2024-06-29T14:49:06.000Z",
        "updatedAt": "2024-06-29T14:49:06.000Z",
        "viewIp": "68.6.224.97"
      }
    ]
  },
  {
    "id": "6eeada03-5318-4868-ae8a-579b1311cf0f",
    "name": "Toggle Testing",
    "status": "completed",
    "createdAt": "2024-06-29T14:50:19.000Z",
    "updatedAt": "2024-06-29T15:00:05.000Z",
    "UserViews": [
      {
        "id": 25,
        "name": "s",
        "email": null,
        "createdAt": "2024-06-29T14:53:38.000Z",
        "updatedAt": "2024-06-29T14:53:38.000Z",
        "viewIp": "68.6.224.97"
      }
    ]
  },
  {
    "id": "fc185ecc-7eb9-4d37-b5d2-3ab8e938950c",
    "name": "Testing 7/2 ",
    "status": "draft",
    "createdAt": "2024-07-02T17:49:12.000Z",
    "updatedAt": "2024-07-03T12:15:33.000Z",
    "UserViews": [
      {
        "id": 26,
        "name": "Shawn B",
        "email": null,
        "createdAt": "2024-07-02T18:04:49.000Z",
        "updatedAt": "2024-07-02T18:04:49.000Z",
        "viewIp": "68.6.224.97"
      }
    ]
  },
  {
    "id": "c19baef5-1b44-42de-8d7f-5e5566d570be",
    "name": "Bill and Leslie Myers",
    "status": "draft",
    "createdAt": "2024-07-27T20:31:04.000Z",
    "updatedAt": "2024-08-24T01:49:05.000Z",
    "UserViews": [
      {
        "id": 33,
        "name": "Shawn B",
        "email": null,
        "createdAt": "2024-07-27T21:46:43.000Z",
        "updatedAt": "2024-07-27T21:46:43.000Z",
        "viewIp": "68.8.56.244"
      },
      {
        "id": 34,
        "name": "Leslie  Myers",
        "email": null,
        "createdAt": "2024-07-27T22:08:54.000Z",
        "updatedAt": "2024-07-27T22:08:54.000Z",
        "viewIp": "104.28.48.166"
      },
      {
        "id": 35,
        "name": "Leslie Myers",
        "email": "leslie@lesliesaintmaux.com",
        "createdAt": "2024-07-27T22:15:14.000Z",
        "updatedAt": "2024-07-27T22:15:14.000Z",
        "viewIp": "98.97.140.33"
      }
    ]
  },
  {
    "id": "cfe06cf1-11f3-40a9-9954-63e7c31f0c6b",
    "name": "",
    "status": "draft",
    "createdAt": "2024-07-31T17:26:17.000Z",
    "updatedAt": "2024-08-05T16:40:32.000Z",
    "UserViews": [
      {
        "id": 36,
        "name": "Testing again",
        "email": null,
        "createdAt": "2024-07-31T17:36:09.000Z",
        "updatedAt": "2024-07-31T17:36:09.000Z",
        "viewIp": "68.8.56.244"
      }
    ]
  },
  {
    "id": "446bf015-53b4-4e70-ac98-30a3bf2f0479",
    "name": "Paul and Martin's - Home Purchase",
    "status": "draft",
    "createdAt": "2024-08-27T22:27:43.000Z",
    "updatedAt": "2024-09-11T18:43:59.000Z",
    "UserViews": [
      {
        "id": 48,
        "name": "test",
        "email": null,
        "createdAt": "2024-08-27T23:11:47.000Z",
        "updatedAt": "2024-08-27T23:11:47.000Z",
        "viewIp": "68.8.56.244"
      },
      {
        "id": 49,
        "name": "Martin",
        "email": null,
        "createdAt": "2024-08-27T23:25:13.000Z",
        "updatedAt": "2024-08-27T23:25:13.000Z",
        "viewIp": "108.75.133.80"
      },
      {
        "id": 55,
        "name": "Paul Smits",
        "email": "smits.paul89@gmail.com",
        "createdAt": "2024-09-02T07:52:34.000Z",
        "updatedAt": "2024-09-02T07:52:34.000Z",
        "viewIp": "89.101.25.65"
      }
    ]
  },
  {
    "id": "bfce5d6d-e78c-4873-901e-c49808ed59c2",
    "name": "Otto and Joile Garcia's Home Purchase",
    "status": "completed",
    "createdAt": "2024-08-29T19:20:13.000Z",
    "updatedAt": "2024-09-06T23:46:01.000Z",
    "UserViews": [
      {
        "id": 50,
        "name": "Tracy Moore",
        "email": "tracy@mooregroupadvantage.com",
        "createdAt": "2024-08-29T23:12:27.000Z",
        "updatedAt": "2024-08-29T23:12:27.000Z",
        "viewIp": "76.88.86.89"
      },
      {
        "id": 51,
        "name": "Jolie Garcia ",
        "email": "jolieegarcia@icloud.com",
        "createdAt": "2024-08-30T18:04:55.000Z",
        "updatedAt": "2024-08-30T18:04:55.000Z",
        "viewIp": "104.28.111.140"
      },
      {
        "id": 52,
        "name": "Jolie Garcia ",
        "email": "jolieegarcia@icloud.com",
        "createdAt": "2024-08-30T18:44:43.000Z",
        "updatedAt": "2024-08-30T18:44:43.000Z",
        "viewIp": "104.28.85.117"
      },
      {
        "id": 53,
        "name": "Shawn",
        "email": null,
        "createdAt": "2024-08-30T22:48:56.000Z",
        "updatedAt": "2024-08-30T22:48:56.000Z",
        "viewIp": "68.8.56.244"
      },
      {
        "id": 54,
        "name": "Jolie Garcia",
        "email": "Jolieegarcia@icloud.com",
        "createdAt": "2024-08-31T07:42:26.000Z",
        "updatedAt": "2024-08-31T07:42:26.000Z",
        "viewIp": "76.93.148.121"
      },
      {
        "id": 56,
        "name": "Jolie Garcia ",
        "email": "jolieegarcia@icloud.com",
        "createdAt": "2024-09-03T00:34:49.000Z",
        "updatedAt": "2024-09-03T00:34:49.000Z",
        "viewIp": "104.28.48.166"
      }
    ]
  },
  {
    "id": "6d515c99-2600-4c57-9fca-dad9473c2525",
    "name": "Sarah Faye - Home Purchase ",
    "status": "draft",
    "createdAt": "2024-09-10T00:24:08.000Z",
    "updatedAt": "2024-09-16T17:04:45.000Z",
    "UserViews": [
      {
        "id": 58,
        "name": "Lisa Waltman",
        "email": null,
        "createdAt": "2024-09-10T13:24:03.000Z",
        "updatedAt": "2024-09-10T13:24:03.000Z",
        "viewIp": "68.7.224.74"
      },
      {
        "id": 59,
        "name": "Shawn Green",
        "email": "1shawnbrown@gmail.com",
        "createdAt": "2024-09-10T16:10:01.000Z",
        "updatedAt": "2024-09-10T16:10:01.000Z",
        "viewIp": "68.8.56.244"
      },
      {
        "id": 60,
        "name": "Sarah Kaye ",
        "email": "Sarahfanoe@gmail.com",
        "createdAt": "2024-09-10T16:37:07.000Z",
        "updatedAt": "2024-09-10T16:37:07.000Z",
        "viewIp": "99.39.66.76"
      }
    ]
  }
]

export const MOST_VIEWED_REPORTS: IMostViewed[] = [
  {
    "id": "1b25c3b4-bf24-40e9-83c3-8c0917326b66",
    "name": "Jessica and Mark Thompson",
    "viewCount": 12
  },
  {
    "id": "7ac94f78-b6a2-44c2-bbfc-16c004c12b8c",
    "name": "Brian and Amy White",
    "viewCount": 9
  },
  {
    "id": "79a6e5e3-2f98-4077-802c-7fa12ecb25f9",
    "name": "Tom and Sara Smith",
    "viewCount": 8
  },
  {
    "id": "de9b9198-bf85-4a3f-9ae7-501b70d2f5b3",
    "name": "Michael Johnson",
    "viewCount": 7
  },
  {
    "id": "6f1b92e8-5d4b-42a2-8f54-3d182b44bc43",
    "name": "Anne and John Doe",
    "viewCount": 6
  },
  {
    "id": "bd82fbe2-6126-4995-95e5-1837c445e03d",
    "name": "Laura and Ben Harrison",
    "viewCount": 5
  },
  {
    "id": "d1ff7f9e-fcb4-41c9-88ee-1586c751cd6b",
    "name": "Emily and Brian Murphy",
    "viewCount": 4
  },
  {
    "id": "3a71f1be-9d65-48c7-85a1-67da69c67c66",
    "name": "Jennifer and Mike Taylor",
    "viewCount": 3
  },
  {
    "id": "00f09d08-bbd0-49cf-9d47-d5f12a83b87a",
    "name": "Mark and Sandy Stevens",
    "viewCount": 3
  },
  {
    "id": "31b896b1-0f38-42a4-b8c1-df5b3b3e5200",
    "name": "Ethan and Madison Wilson",
    "viewCount": 2
  },
  {
    "id": "4313d2b8-1c5b-4e58-b4fc-8c70a6d0b1db",
    "name": "Sophia and Jack Garcia",
    "viewCount": 2
  },
  {
    "id": "920e03dc-6e7d-4d7c-8a57-b3d531f0c19c",
    "name": "Robert and Sarah Johnson",
    "viewCount": 1
  },
  {
    "id": "f7b59b92-574f-4ec9-a07b-054cbb2de647",
    "name": "Diana and Frank Lopez",
    "viewCount": 1
  },
  {
    "id": "cf896e77-9e77-40e7-a05d-bbb74b1c086f",
    "name": "Lucas and Kate Martin",
    "viewCount": 0
  },
  {
    "id": "c6e76c3b-b28a-4382-a43f-b621afc6f6cc",
    "name": "Nora and Tom Baker",
    "viewCount": 0
  },
  {
    "id": "ea4d35bb-fb5c-4117-b5ba-b342a6e1b3f9",
    "name": "Alice and Bob Anderson",
    "viewCount": 0
  },
  {
    "id": "16877a4c-0dc6-4bc7-b0cb-fb86a57476b5",
    "name": "Kim and Joe Harris",
    "viewCount": 0
  },
  {
    "id": "d2c24695-b17b-4eb4-b2d0-538a8b0dc208",
    "name": "Tina and Roger Scott",
    "viewCount": 0
  },
  {
    "id": "76b3e49f-07c7-4344-87d7-89b2a90cb3a8",
    "name": "Grace and Alan Clark",
    "viewCount": 0
  },
  {
    "id": "b171e43f-0b37-4660-9a5e-ea249dd9646d",
    "name": "James and Emma Reed",
    "viewCount": 0
  },
  {
    "id": "415b1a0c-b4d1-4d2b-8d9e-c2341b57731b",
    "name": "Derek and Lisa Green",
    "viewCount": 0
  },
  {
    "id": "90f9493c-2464-45e4-9538-0d1f55482e6d",
    "name": "Ryan and Lucy King",
    "viewCount": 0
  },
  {
    "id": "46d0030d-b75f-47ed-b5aa-e66da6e8a9b2",
    "name": "Zoe and Brian Young",
    "viewCount": 0
  },
  {
    "id": "9f4e3d3b-b4b5-4b35-b7af-21ff32ae29e7",
    "name": "Gary and Mia Allen",
    "viewCount": 0
  },
  {
    "id": "8a0e90c3-cdc3-4b71-bc48-4fa583fcb71f",
    "name": "Jasmine and Lucas Carter",
    "viewCount": 0
  },
  {
    "id": "d6b0b774-c4e7-41a3-91a0-e37c227cf50f",
    "name": "Jason and Mia Phillips",
    "viewCount": 0
  },
  {
    "id": "5b62d515-91d1-4e62-b5cc-017066dd69c9",
    "name": "Claire and Daniel Campbell",
    "viewCount": 0
  },
  {
    "id": "f5fa26c7-d6a3-4817-8e4b-fb55b65741d5",
    "name": "Ann and Mike Stewart",
    "viewCount": 0
  },
  {
    "id": "83c1395d-4d7c-4cc5-b68a-e4b84c3e4cb6",
    "name": "Paula and John Lee",
    "viewCount": 0
  },
  {
    "id": "7eb1f08f-6e95-4c51-a7fa-3912efde8a59",
    "name": "Natalie and Steven Hill",
    "viewCount": 0
  },
  {
    "id": "cf8d5dc7-0d36-4af3-9228-99be10ef80c3",
    "name": "Ashley and Max Walker",
    "viewCount": 0
  },
  {
    "id": "1ffb22af-e472-4618-b10d-e95ff2d65b08",
    "name": "Jacob and Emily Scott",
    "viewCount": 0
  },
  {
    "id": "54234c30-1e59-4b42-bc0d-3240d254f65f",
    "name": "Anna and Jason Wright",
    "viewCount": 0
  },
  {
    "id": "ed54fbc5-38f3-4d05-a0eb-f373606992a2",
    "name": "Katherine and Paul Hall",
    "viewCount": 0
  },
  {
    "id": "0384017c-120c-4e78-a6f5-f31f1a2b4906",
    "name": "Olivia and Lucas Nelson",
    "viewCount": 0
  },
  {
    "id": "0b8ad775-8b51-4ac0-bd6f-7ec5f7dc5a1e",
    "name": "Mia and Andrew Reed",
    "viewCount": 0
  },
  {
    "id": "ab9137e2-2e6a-4074-8fd9-3cb3a98ec77e",
    "name": "Elijah and Hannah Campbell",
    "viewCount": 0
  },
  {
    "id": "7e849ef6-f75c-4e80-b1c1-e27f26d74e63",
    "name": "David and Karen Brooks",
    "viewCount": 0
  },
  {
    "id": "e1be73ec-cdc1-4658-b9af-b88652cb5c67",
    "name": "Sophia and James Foster",
    "viewCount": 0
  },
  {
    "id": "0be50e7f-3b07-4f57-9a64-dc282d01b091",
    "name": "Zachary and Megan Long",
    "viewCount": 0
  },
  {
    "id": "f0626e0a-fb68-472f-b50d-14eea6a0364f",
    "name": "William and Jessica Moore",
    "viewCount": 0
  },
  {
    "id": "63a5bc15-1a59-4a08-9621-4779c1c1d8a7",
    "name": "Steven and Karen Harris",
    "viewCount": 0
  },
  {
    "id": "b1da48ff-d6be-4b69-ae4d-57e4a67c3f26",
    "name": "Michelle and Ryan Bell",
    "viewCount": 0
  },
  {
    "id": "3700629b-bc6f-4978-b77f-160e06da9d72",
    "name": "Laura and Jacob Martin",
    "viewCount": 0
  },
  {
    "id": "c7c7e3c6-bc1c-4c88-bc14-4f39bb2d292b",
    "name": "Jessica and Matthew Wilson",
    "viewCount": 0
  },
  {
    "id": "43cfc8da-81ab-4858-8d43-82675137c74e",
    "name": "Brittany and Adam Young",
    "viewCount": 0
  },
  {
    "id": "5b703b79-75d6-45f5-b3c2-21c6c6242e37",
    "name": "Chloe and Liam Jones",
    "viewCount": 0
  },
  {
    "id": "70d50f87-1fba-4e2b-94c3-01f6fdfecf3d",
    "name": "Emily and Daniel Kim",
    "viewCount": 0
  },
  {
    "id": "1b5435f4-e2a8-4f4b-9c1c-9b2a3b1500c1",
    "name": "Ryan and Katie Wilson",
    "viewCount": 0
  },
  {
    "id": "83b30b2e-66e5-4d98-8d45-fab54aa45d94",
    "name": "Hannah and George Parker",
    "viewCount": 0
  },
  {
    "id": "e8cd26e8-5046-4dbf-b2ed-d31302b37d84",
    "name": "Ella and Nathan Reed",
    "viewCount": 0
  },
  {
    "id": "b7a29e70-0633-4295-a5dc-7d2f54ac8cb6",
    "name": "Olivia and Andrew Taylor",
    "viewCount": 0
  },
  {
    "id": "15d83e13-bec2-4b78-91e9-b6c7e85dfad5",
    "name": "Sophia and David Martinez",
    "viewCount": 0
  },
  {
    "id": "e39a3eaf-7b6b-4e38-8439-6cc8d546ffec",
    "name": "Grace and Charles Miller",
    "viewCount": 0
  },
  {
    "id": "6b535aaa-20a0-489b-b1e6-4bb5d7d0199c",
    "name": "Mia and Robert Lewis",
    "viewCount": 0
  },
  {
    "id": "c30418d9-fd77-44d9-a200-155d913daaa1",
    "name": "Natalie and John Martinez",
    "viewCount": 0
  },
  {
    "id": "18203c11-958c-4583-b604-d5be28cdd3fc",
    "name": "Liam and Ella Robinson",
    "viewCount": 0
  },
  {
    "id": "d1bb64f0-0138-4c89-b1a7-9b3b7b53a622",
    "name": "Avery and Noah Thompson",
    "viewCount": 0
  },
  {
    "id": "f7893421-7b76-40a6-9f06-93c12a2e7a72",
    "name": "Jessica and Matthew Young",
    "viewCount": 0
  },
  {
    "id": "e95b0e9f-fca3-473e-bc54-9e9be22e9bc0",
    "name": "Mason and Ava Brown",
    "viewCount": 0
  },
  {
    "id": "08c36d9b-3b61-4fc5-8209-bf8bcb20e64c",
    "name": "Abigail and Elijah Harris",
    "viewCount": 0
  },
  {
    "id": "4a4f5c4f-e0f2-42a1-9d87-ec69e292d159",
    "name": "Megan and Zachary Scott",
    "viewCount": 0
  },
  {
    "id": "fb19f0d5-c6b0-4690-a224-4eab9d2f6342",
    "name": "James and Sofia Garcia",
    "viewCount": 0
  },
  {
    "id": "72ec4dc4-bb4d-4a06-bd57-664ba89de5f2",
    "name": "Michael and Riley Smith",
    "viewCount": 0
  },
  {
    "id": "c739d86e-7701-47f6-948e-0cc215f993d3",
    "name": "Lucas and Chloe Walker",
    "viewCount": 0
  },
  {
    "id": "f96c2953-e857-4749-9e30-3ab571c01ae6",
    "name": "Anthony and Charlotte Wilson",
    "viewCount": 0
  },
  {
    "id": "c425ad7e-bd61-45c1-b6f0-2956d9ec24f1",
    "name": "Jaxon and Amelia Lee",
    "viewCount": 0
  },
  {
    "id": "b33d6db8-e9e5-4649-9e86-bb45505de6d8",
    "name": "Ella and Daniel Miller",
    "viewCount": 0
  },
  {
    "id": "8c814e7b-46cb-43a1-bc48-7d9bbcd12154",
    "name": "Henry and Grace Parker",
    "viewCount": 0
  },
  {
    "id": "fcae58f2-2e3e-4a4a-b96e-330b52d56f6a",
    "name": "Avery and Liam Gonzalez",
    "viewCount": 0
  },
  {
    "id": "58d951a2-b3a8-43b2-89af-4eb0720488a1",
    "name": "Evelyn and Samuel Johnson",
    "viewCount": 0
  },
  {
    "id": "16b2b760-4d54-4cb2-b015-51d0562da07b",
    "name": "Lucas and Charlotte Scott",
    "viewCount": 0
  },
  {
    "id": "9e42a2ff-414c-48f3-82e2-d437c4248e4b",
    "name": "Mason and Scarlett Thompson",
    "viewCount": 0
  },
  {
    "id": "03e6d021-87a4-48cc-9b3d-f03594c90e2a",
    "name": "Liam and Mia Ramirez",
    "viewCount": 0
  },
  {
    "id": "8a5b8b36-26a3-4a7a-a5a7-cf4b0ab1c2a5",
    "name": "Dylan and Harper Baker",
    "viewCount": 0
  },
  {
    "id": "2f2c6c94-8d52-409e-966f-47f285b3ad3d",
    "name": "John and Anna Martinez",
    "viewCount": 0
  },
  {
    "id": "1b5c8e08-5f41-44d1-bbc4-bb07b0b8283b",
    "name": "Elijah and Lila Anderson",
    "viewCount": 0
  },
  {
    "id": "5c8658ee-3a0e-4d9a-8d86-184a231b066e",
    "name": "Natalie and Ryan Green",
    "viewCount": 0
  },
  {
    "id": "0cda2bb2-5f44-4d2b-a8f2-e743d72dc8c5",
    "name": "Oliver and Isla Reed",
    "viewCount": 0
  },
  {
    "id": "71e69cbb-b31e-4856-9e15-1de8fdd807e4",
    "name": "Hannah and Ethan Hall",
    "viewCount": 0
  },
  {
    "id": "5e1b3a45-5506-4d77-b8a8-34b3ea6e8360",
    "name": "Abigail and David Wright",
    "viewCount": 0
  },
  {
    "id": "2f477c4e-0be8-4011-bf18-bd3f772c1bb0",
    "name": "Emily and William Perez",
    "viewCount": 0
  },
  {
    "id": "cd0c04e2-3b69-41ec-8348-0b693b92723c",
    "name": "Scarlett and Jacob Flores",
    "viewCount": 0
  },
  {
    "id": "cdd38b60-c6a0-4c98-90d4-1d2ed8eb0d6a",
    "name": "Madison and Elijah Hughes",
    "viewCount": 0
  },
  {
    "id": "3f1c50a2-b732-451b-a1a4-c74f095d0de5",
    "name": "Chloe and William Rivera",
    "viewCount": 0
  },
  {
    "id": "6ac57b54-cd5f-48ae-8ae5-fd21674e67e7",
    "name": "Ava and Matthew Stewart",
    "viewCount": 0
  },
  {
    "id": "d6ec12ab-d495-43f2-b3d4-43f4a216a632",
    "name": "Sofia and Caleb Morales",
    "viewCount": 0
  },
  {
    "id": "5710a146-30b9-49f1-8e05-4024c6b58e79",
    "name": "Harper and Owen Carter",
    "viewCount": 0
  },
  {
    "id": "cf3d273b-6439-43f7-b272-36bc7437f8e8",
    "name": "Liam and Ella Collins",
    "viewCount": 0
  },
  {
    "id": "04d8d5ed-56b5-4c00-8c06-3180a5736bc6",
    "name": "Maya and Daniel Campbell",
    "viewCount": 0
  },
  {
    "id": "222d5f76-00bc-4da1-8e24-9a0be6f7a6c4",
    "name": "Aiden and Sophia Davis",
    "viewCount": 0
  },
  {
    "id": "430f1d4b-3c09-49f7-b892-6b4b94f78369",
    "name": "Jasper and Mia Ramirez",
    "viewCount": 0
  },
  {
    "id": "5178c162-5e52-4aa0-a19e-401fb6377743",
    "name": "Carter and Ruby Gonzalez",
    "viewCount": 0
  },
  {
    "id": "c0888c82-46a8-40af-b64f-7a9fa72c5379",
    "name": "Zoe and John Flores",
    "viewCount": 0
  },
  {
    "id": "fa96f304-f5a5-40e7-bda9-8bb1d82e646c",
    "name": "Avery and Caleb Young",
    "viewCount": 0
  },
  {
    "id": "16bb29e7-5d04-4dc3-8b44-fc56c0c62e4b",
    "name": "Grace and Oliver Johnson",
    "viewCount": 0
  },
  {
    "id": "96f3af35-2c8b-4e26-9c82-50b2e8ca8963",
    "name": "Luke and Sophie Martin",
    "viewCount": 0
  },
  {
    "id": "b2a64212-79b9-489e-a054-f7499d04e12d",
    "name": "Scarlett and Jack Anderson",
    "viewCount": 0
  },
  {
    "id": "24d8b7c1-efb7-4b39-8c5e-ec9994ed07c1",
    "name": "Owen and Lila Perez",
    "viewCount": 0
  },
  {
    "id": "8de8c1f6-2ff4-4051-9b38-4dc02660a012",
    "name": "Jacob and Emma Lewis",
    "viewCount": 0
  },
  {
    "id": "4d02e4a1-061b-4e63-b1de-d8018451a10c",
    "name": "Sophie and Lucas Hall",
    "viewCount": 0
  },
  {
    "id": "c817d43c-d56c-4113-8bba-b30fc8490c44",
    "name": "James and Mia Wright",
    "viewCount": 0
  },
  {
    "id": "b0213f56-bf3e-49eb-826b-b9646b8c5119",
    "name": "Mila and Ethan Harris",
    "viewCount": 0
  },
  {
    "id": "80358e74-6640-4f0b-9e08-0eecf4e9d944",
    "name": "Natalie and Noah Carter",
    "viewCount": 0
  },
  {
    "id": "d5c37489-e2f7-45ae-8009-cb0cbd37302b",
    "name": "Charlotte and Ryan Rodriguez",
    "viewCount": 0
  },
  {
    "id": "e1f02a05-4146-4be5-a65f-4fa3bce6c5fa",
    "name": "Leah and Daniel Hill",
    "viewCount": 0
  },
  {
    "id": "a2ae9d0e-71a4-4fb9-93ed-e4ed4eb8a0a2",
    "name": "Ella and Jayden Adams",
    "viewCount": 0
  },
  {
    "id": "2b98f4b0-f38e-46e2-aaf8-1964af8eb4e4",
    "name": "Amelia and Chase Scott",
    "viewCount": 0
  },
  {
    "id": "576c720f-487e-459e-b06c-8e8b47b50e69",
    "name": "Oliver and Ava Nelson",
    "viewCount": 0
  },
  {
    "id": "587ff6dc-3a8f-49f3-a6a7-5b8a6e587589",
    "name": "Emma and Jason Harris",
    "viewCount": 0
  },
  {
    "id": "fd6a72d4-9b8a-4781-b39c-e48d63364cd9",
    "name": "Aiden and Mia Johnson",
    "viewCount": 0
  },
  {
    "id": "7a474c55-efc5-4fa5-8472-bc55efc1ef92",
    "name": "Zoe and Jacob Walker",
    "viewCount": 0
  },
  {
    "id": "68c3fc3c-4a6b-4875-b9cb-b2f9ecf78887",
    "name": "Isaac and Ava Smith",
    "viewCount": 0
  },
  {
    "id": "8b0b601e-df36-4e84-a682-b1c8275c09f2",
    "name": "Julian and Lily King",
    "viewCount": 0
  },
  {
    "id": "ea8f619f-46f8-4e88-b8e3-2380e1dbd3e0",
    "name": "Lucas and Sofia Johnson",
    "viewCount": 0
  },
  {
    "id": "7756f408-3257-4bd1-b16d-8b0844c48525",
    "name": "Oliver and Chloe Garcia",
    "viewCount": 0
  },
  {
    "id": "d146da53-d83a-44f0-b89f-c4cb2c63d6b9",
    "name": "Layla and Jacob Brown",
    "viewCount": 0
  },
  {
    "id": "c17bb81e-5359-4eb9-8b1a-62d6b0081840",
    "name": "Ava and Mason Rodriguez",
    "viewCount": 0
  },
  {
    "id": "eb798b3a-d051-4f47-85e2-fab4869929ed",
    "name": "Nora and Jack Campbell",
    "viewCount": 0
  },
  {
    "id": "ecb500d8-46de-4481-bc4b-c2e94e1777fc",
    "name": "Wesley and Maya Adams",
    "viewCount": 0
  },
  {
    "id": "1a9cb49b-e04e-4965-b0c5-2e7d02d58ebd",
    "name": "Ella and Daniel Thompson",
    "viewCount": 0
  },
  {
    "id": "7ae3ca01-bad2-4114-b0f0-2ca4a6419f38",
    "name": "Liam and Hannah Scott",
    "viewCount": 0
  },
  {
    "id": "3f9cdca4-54a7-4312-a1cc-5f515e67214d",
    "name": "Oliver and Emma Collins",
    "viewCount": 0
  },
  {
    "id": "b4408687-0d98-48db-a869-34a80de444ab",
    "name": "Sofia and William Rogers",
    "viewCount": 0
  },
  {
    "id": "26ca7e93-707e-43f1-8fa3-8e90543d19e7",
    "name": "Dylan and Natalie Ramirez",
    "viewCount": 0
  },
  {
    "id": "e3f17612-317c-4f87-bc70-18b1410aa705",
    "name": "Mia and Matthew Foster",
    "viewCount": 0
  },
  {
    "id": "d2e5ee8c-11c3-4978-89c2-e3b116c7a69e",
    "name": "Liam and Emily Nelson",
    "viewCount": 0
  },
  {
    "id": "c7d99f75-f3c3-47f0-b22a-23691ac5e4d7",
    "name": "James and Harper Sanchez",
    "viewCount": 0
  },
  {
    "id": "9e4f7bfa-4645-4578-a05f-f1b2e2dcb917",
    "name": "William and Lila Brooks",
    "viewCount": 0
  },
  {
    "id": "ca028b71-e7f1-44f6-8c87-b11eaeaf5ff2",
    "name": "Sofia and Nathan Kim",
    "viewCount": 0
  },
  {
    "id": "f98949e7-b84c-4046-a465-19416bb3f215",
    "name": "Oliver and Chloe Morgan",
    "viewCount": 0
  },
  {
    "id": "7c48ef66-c4f7-4b73-9498-7854c0d84e78",
    "name": "Liam and Emma Ramirez",
    "viewCount": 0
  },
  {
    "id": "8a52b9b0-1f3a-44d4-94dc-e2c2cc7089f5",
    "name": "Madison and Henry Thompson",
    "viewCount": 0
  },
  {
    "id": "b600a57f-4f3b-4606-b0ca-b22e376cdbb3",
    "name": "Abigail and Ethan Anderson",
    "viewCount": 0
  },
  {
    "id": "752d1b44-5ec8-4f8e-ae3d-b62382b64f84",
    "name": "Jessica and Noah Robinson",
    "viewCount": 0
  },
  {
    "id": "a5a52b93-0e5d-4421-bb09-e96cc5e38e5f",
    "name": "Liam and Maya White",
    "viewCount": 0
  },
  {
    "id": "8e0f3d65-e823-4b0c-bb5d-2e1fd4c97574",
    "name": "Matthew and Ava Clark",
    "viewCount": 0
  },
  {
    "id": "ee5fd1ea-9de9-403e-82c2-26d5d4ae943f",
    "name": "Zoe and Ethan Williams",
    "viewCount": 0
  },
  {
    "id": "56bc62c7-7332-4d69-b036-11d22a6cc788",
    "name": "Emery and James Scott",
    "viewCount": 0
  },
  {
    "id": "4f489d26-f5f1-486b-b637-1815b74bc033",
    "name": "Scarlett and Joshua Harris",
    "viewCount": 0
  },
  {
    "id": "26b63c5b-b314-487e-93b9-c29920e96f25",
    "name": "Benjamin and Grace Collins",
    "viewCount": 0
  },
  {
    "id": "30028cf4-2d8d-4bb8-8047-3f9e3b080a09",
    "name": "Andrew and Sophie Roberts",
    "viewCount": 0
  },
  {
    "id": "12a8ff39-e65d-4677-83cf-9bcde3a00f2f",
    "name": "Logan and Natalie Baker",
    "viewCount": 0
  },
  {
    "id": "c2b4c531-c9ae-43dc-9de5-c26f2c6827ec",
    "name": "Julian and Layla Ramirez",
    "viewCount": 0
  },
  {
    "id": "7b623d9b-8b6c-4f6a-97b7-2bcd95ebeb66",
    "name": "Nathan and Avery Green",
    "viewCount": 0
  },
  {
    "id": "bcfd1b9a-b458-4e31-b1d9-7baf3d8410ea",
    "name": "Victoria and David Williams",
    "viewCount": 0
  },
  {
    "id": "81a2b1a4-e2b1-470e-a79d-df0b8b11f9cc",
    "name": "Emily and Jacob Miller",
    "viewCount": 0
  },
  {
    "id": "cc781cbd-5f3c-4178-b840-7e5e468ea01f",
    "name": "Cameron and Anna Jones",
    "viewCount": 0
  },
  {
    "id": "d6bb4b32-5052-411e-a2ec-f949c3efc41f",
    "name": "Jack and Lily Clark",
    "viewCount": 0
  },
  {
    "id": "d0cf7931-9c0f-42c1-a8d2-bc2a2c6d6d70",
    "name": "Elena and William Brown",
    "viewCount": 0
  },
  {
    "id": "25b44a29-459e-4181-b5da-ea1e8f45773b",
    "name": "Oliver and Mia Thomas",
    "viewCount": 0
  },
  {
    "id": "1946a0b1-8ff7-4327-b3f5-06d1d186f5e8",
    "name": "Maya and Liam Young",
    "viewCount": 0
  },
];